
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5524"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5524"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7mY6J", function(module, exports) {
"use strict";
var $55d9369d7c3ad500$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $55d9369d7c3ad500$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $55d9369d7c3ad500$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$55d9369d7c3ad500$var$__exportStar((parcelRequire("8UaGt")), module.exports);

$55d9369d7c3ad500$var$__exportStar((parcelRequire("jMfWA")), module.exports);

$55d9369d7c3ad500$var$__exportStar((parcelRequire("5O5Y5")), module.exports);

$55d9369d7c3ad500$var$__exportStar((parcelRequire("5RjQi")), module.exports);

$55d9369d7c3ad500$var$__exportStar((parcelRequire("lLoOu")), module.exports);

$55d9369d7c3ad500$var$__exportStar((parcelRequire("fcDle")), module.exports);

});
parcelRegister("8UaGt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callback = void 0;

var $jIy9w = parcelRequire("jIy9w");
const $67bbd7576b8c0e6f$var$callback = (target, propertyKey)=>{
    $jIy9w.ClassSubjectDef.getOrMakeFor(target.constructor).addCallback(propertyKey);
};
module.exports.callback = $67bbd7576b8c0e6f$var$callback;

});
parcelRegister("jIy9w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectSubjectDef = module.exports.ClassSubjectDef = module.exports.SubjectDef = void 0;

var $4MJ9U = parcelRequire("4MJ9U");

var $kDUoE = parcelRequire("kDUoE");

var $f4Kb1 = parcelRequire("f4Kb1");
const $e5ac9e5d628d6d68$var$SUBJECT_DEF_KEY = Symbol("__ecce__");
const $e5ac9e5d628d6d68$var$BASE_DEFAULT_PROPERTY_OPTIONS = Object.freeze({});
class $e5ac9e5d628d6d68$var$SubjectDef {
    getObserverFor(instance) {
        const observers = this.observers.get(instance);
        /* istanbul ignore if */ if (!observers) /*
                By the time we ever call this method, `applyToInstance` would have been
                invoked on instance, so this should never happen...
            */ throw new $4MJ9U.EcceError("SubjectDef had no Observers for an instance; probably a bug in ecce...");
        return observers;
    }
    applyToInstance(instance) {
        this.observers.set(instance, new $kDUoE.ObserverSet(this.name));
    }
    addObserver(instance, observer, options) {
        this.getObserverFor(instance).addObserver(observer, options);
    }
    removeObservers(instance, observer) {
        this.getObserverFor(instance).removeObserver(observer);
    }
    notify(instance) {
        this.getObserverFor(instance).notify();
    }
    static getFor(target) {
        var _a;
        return (_a = target[$e5ac9e5d628d6d68$var$SUBJECT_DEF_KEY]) !== null && _a !== void 0 ? _a : null;
    }
    constructor(_defaultPropertyOptions){
        this.observers = new WeakMap();
        this.defaultPropertyOptions = $e5ac9e5d628d6d68$var$BASE_DEFAULT_PROPERTY_OPTIONS;
    // TODO: Re-enabled once some options are present...
    // this.defaultPropertyOptions = defaultPropertyOptions
    // 	? Object.freeze({
    // 		...BASE_DEFAULT_PROPERTY_OPTIONS,
    // 		...defaultPropertyOptions,
    // 	})
    // 	: BASE_DEFAULT_PROPERTY_OPTIONS;
    }
}
module.exports.SubjectDef = $e5ac9e5d628d6d68$var$SubjectDef;
class $e5ac9e5d628d6d68$var$ClassSubjectDef extends $e5ac9e5d628d6d68$var$SubjectDef {
    static getOrMakeFor(constructor) {
        var _a;
        var _b;
        return (_a = (_b = constructor)[$e5ac9e5d628d6d68$var$SUBJECT_DEF_KEY]) !== null && _a !== void 0 ? _a : _b[$e5ac9e5d628d6d68$var$SUBJECT_DEF_KEY] = new $e5ac9e5d628d6d68$var$ClassSubjectDef(constructor.name, undefined);
    }
    addProperty(key, descriptor, options) {
        this.properties[key] = new $f4Kb1.PropertyDef(this, key, descriptor, options);
    }
    getProperty(key) {
        var _a;
        return (_a = this.properties[key]) !== null && _a !== void 0 ? _a : null;
    }
    addCallback(key) {
        var _a;
        ((_a = this.callbacks) !== null && _a !== void 0 ? _a : this.callbacks = new Set()).add(key);
    }
    decorated() {
        this.wasDecorated = true;
    }
    applyToInstance(instance) {
        super.applyToInstance(instance);
        Object.defineProperty(instance, $e5ac9e5d628d6d68$var$SUBJECT_DEF_KEY, {
            enumerable: false,
            configurable: false,
            writable: false,
            value: this
        });
        for(const key in this.properties)this.properties[key].applyToInstance(instance);
        if (this.callbacks) for (const key of this.callbacks){
            const originalMethod = instance[key];
            if (typeof originalMethod !== "function") throw new $4MJ9U.EcceError(`Cannot apply @callback to non-function member: "${this.name}.${String(key)}"`);
            instance[key] = originalMethod.bind(instance);
        }
        return instance;
    }
    constructor(name, defaultPropertyOptions){
        super(defaultPropertyOptions);
        this.name = name;
        this.source = "decorator";
        this.properties = {};
        this.callbacks = null;
        /**
         * Whether this subject def was handled by a @subject() decorator.
         */ this.wasDecorated = false;
        /*
            We want to emit a clear error message if @observable() or @callback are
            applied to members of a class without a @subject() decorator.

            As property / method decorators are invoked before class decorators, we
            have no way of knowing from those whether the class has the @subject()
            decorator or not.

            So, we set a timeout for next tick to check if the @subject() decorator was
            called, which will have set `wasDecorated` to true.

            This is a really ugly way of handling this, as it is basically impossible
            to ever catch this error. Ideally we would be able to throw this on
            construction of an invalid instance, but we will not have been able to
            proxy the class' constructor without the @subject() decorator...
        */ setTimeout(()=>{
            if (!this.wasDecorated) throw new $4MJ9U.EcceError(`Cannot use @observable() on a member of a class not decorated with @subject(): "${this.name}"`);
        });
    }
}
module.exports.ClassSubjectDef = $e5ac9e5d628d6d68$var$ClassSubjectDef;
class $e5ac9e5d628d6d68$var$ObjectSubjectDef extends $e5ac9e5d628d6d68$var$SubjectDef {
    static makeForInstance(instance, options) {
        const def = new $e5ac9e5d628d6d68$var$ObjectSubjectDef(options);
        const subject = {
            [$e5ac9e5d628d6d68$var$SUBJECT_DEF_KEY]: def
        };
        def.applyToInstance(subject);
        for(const key in instance){
            const prop = def.properties[key] = new $f4Kb1.PropertyDef(def, key, undefined, {});
            prop.applyToInstance(subject, instance);
        }
        return subject;
    }
    getProperty(key) {
        var _a;
        return (_a = this.properties[key]) !== null && _a !== void 0 ? _a : null;
    }
    constructor(options = {}){
        var _a;
        super(undefined);
        this.properties = {};
        this.name = (_a = options === null || options === void 0 ? void 0 : options.name) !== null && _a !== void 0 ? _a : "Object";
    }
}
module.exports.ObjectSubjectDef = $e5ac9e5d628d6d68$var$ObjectSubjectDef;

});
parcelRegister("4MJ9U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EcceError = void 0;
class $37beacb33ea70ffa$var$EcceError extends Error {
    constructor(message){
        super(message);
        this.name = "EcceError";
    }
}
module.exports.EcceError = $37beacb33ea70ffa$var$EcceError;

});

parcelRegister("kDUoE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObserverSet = void 0;

var $5Ymr2 = parcelRequire("5Ymr2");
class $f073325ef355eb88$var$ObserverSet {
    [Symbol.iterator]() {
        var _a, _b;
        return (_b = (_a = this.latentObservers) === null || _a === void 0 ? void 0 : _a[Symbol.iterator]()) !== null && _b !== void 0 ? _b : $f073325ef355eb88$var$ObserverSet.EMPTY_ITERATOR;
    }
    addObserver(observer, options) {
        var _a, _b;
        if (options === null || options === void 0 ? void 0 : options.immediate) {
            ((_a = this.immediateObservers) !== null && _a !== void 0 ? _a : this.immediateObservers = new Set()).add(observer);
            return;
        }
        ((_b = this.latentObservers) !== null && _b !== void 0 ? _b : this.latentObservers = new Set()).add(observer);
    }
    removeObserver(observer) {
        var _a;
        (_a = this.latentObservers) === null || _a === void 0 || _a.delete(observer);
    }
    notify() {
        var _a;
        (_a = this.immediateObservers) === null || _a === void 0 || _a.forEach((observer)=>observer());
        $f073325ef355eb88$var$ObserverSet.NOTIFIER.enqueue(this);
    }
    constructor(name){
        this.name = name;
        this.immediateObservers = null;
        this.latentObservers = null;
    }
}
module.exports.ObserverSet = $f073325ef355eb88$var$ObserverSet;
$f073325ef355eb88$var$ObserverSet.EMPTY_ITERATOR = {
    next: ()=>({
            done: true,
            value: undefined
        })
};
$f073325ef355eb88$var$ObserverSet.NOTIFIER = new $5Ymr2.Notifier();

});
parcelRegister("5Ymr2", function(module, exports) {
"use strict";
var $4593f578ce84562d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Notifier = void 0;

const $4593f578ce84562d$var$queue_microtask_1 = $4593f578ce84562d$var$__importDefault((parcelRequire("l9vOJ")));

var $4MJ9U = parcelRequire("4MJ9U");
class $4593f578ce84562d$var$Notifier {
    enqueue(set) {
        if (this.notificationQueue.has(set)) return;
        if (this.notificationTrace.has(set)) {
            const trace = [
                ...this.notificationTrace,
                set
            ].map((observer)=>`"${observer.name}"`).join(" -> ");
            throw new $4MJ9U.EcceError("Recursive observers: " + trace);
        }
        this.notificationQueue.add(set);
        if (!this.willNotifyThisTick) {
            this.willNotifyThisTick = true;
            (0, $4593f578ce84562d$var$queue_microtask_1.default)(()=>{
                try {
                    this.notify();
                } finally{
                    this.willNotifyThisTick = false;
                    this.notificationQueue.clear();
                    this.notificationTrace.clear();
                }
            });
        }
    }
    notify() {
        const toNotify = [
            ...this.notificationQueue
        ];
        this.notificationQueue.clear();
        for (const set of toNotify){
            this.notificationTrace.add(set);
            for (const observer of set){
                observer();
                /*
                    If notifying the observer resulted in more Observers being enqueued
                    for notification, notify them immediately. This allows us to catch
                    recursive observer chains.
                */ if (this.notificationQueue.size) this.notify();
            }
            this.notificationTrace.delete(set);
        }
    }
    constructor(){
        this.notificationQueue = new Set;
        this.notificationTrace = new Set;
        this.willNotifyThisTick = false;
    }
}
module.exports.Notifier = $4593f578ce84562d$var$Notifier;

});
parcelRegister("l9vOJ", function(module, exports) {
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ let $f6631e7adca48780$var$promise;
module.exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : $parcel$global) : (cb)=>($f6631e7adca48780$var$promise || ($f6631e7adca48780$var$promise = Promise.resolve())).then(cb).catch((err)=>setTimeout(()=>{
            throw err;
        }, 0));

});



parcelRegister("f4Kb1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertyDef = void 0;

var $kDUoE = parcelRequire("kDUoE");

var $4MJ9U = parcelRequire("4MJ9U");
/**
 * Defines an observable property.
 */ class $af9b0c81f87d47c4$var$PropertyDef {
    createObserversFor(instance) {
        this.observers.set(instance, new $kDUoE.ObserverSet(this.name));
    }
    getObserversFor(instance) {
        const observers = this.observers.get(instance);
        /* istanbul ignore if */ if (!observers) /*
                By the time we ever call this method, `applyToInstance` would have been
                invoked on instance, so this should never happen...
            */ throw new $4MJ9U.EcceError("ObservableProperty had no Observers for an instance; probably a bug in ecce...");
        return observers;
    }
    /**
     * Add an observer for this property on the passed instance.
     */ addObserver(instance, observer, options) {
        this.getObserversFor(instance).addObserver(observer, options);
    }
    /**
     * Remove an observer for this property on the passed instance.
     */ removeObserver(instance, observer) {
        this.getObserversFor(instance).removeObserver(observer);
    }
    /**
     * Notify this property's observers for the passed instance.
     */ notify(instance) {
        this.getObserversFor(instance).notify();
        this.subjectDef.notify(instance);
    }
    /**
     * @param subjectDef the owner of this property
     * @param key key of the property this defines
     * @param originalDescriptor original property descriptor for the property, if
     * 	one exists.
     */ constructor(subjectDef, key, originalDescriptor, _options){
        this.subjectDef = subjectDef;
        this.key = key;
        this.originalDescriptor = originalDescriptor;
        /**
         * Observers registered for this property, mapped by instance.
         */ this.observers = new WeakMap();
        this.name = `${subjectDef.name}.${String(key)}`;
        const descriptor = this.originalDescriptor;
        if (!descriptor) /*
                Without a descriptor, we have a simple value property.
                https://www.typescriptlang.org/docs/handbook/decorators.html#property-decorators.

                Overwrite the instance's original property with a new property which
                notifies the instance's property observers on set.
            */ this.applyToInstance = (instance, source)=>{
            this.createObserversFor(instance);
            let value = (source !== null && source !== void 0 ? source : instance)[this.key];
            Object.defineProperty(instance, this.key, {
                enumerable: true,
                get: ()=>value,
                set: (nextValue)=>{
                    value = nextValue;
                    this.notify(instance);
                }
            });
        };
        else /*
                With a descriptor, we have an accessor property.
                https://www.typescriptlang.org/docs/handbook/decorators.html#accessor-decorators.
            */ this.applyToInstance = (instance)=>{
            if (!(originalDescriptor === null || originalDescriptor === void 0 ? void 0 : originalDescriptor.set)) throw new $4MJ9U.EcceError(`Cannot use @observable() on a getter without a setter: "${this.subjectDef.name}.${String(this.key)}"`);
            this.createObserversFor(instance);
            // Setter must be bound to instance to allow mutation of #private members.
            const originalSetter = originalDescriptor.set.bind(instance);
            Object.defineProperty(instance, key, Object.assign(Object.assign({}, originalDescriptor), {
                set: (nextValue)=>{
                    originalSetter(nextValue);
                    this.notify(instance);
                }
            }));
        };
    }
}
module.exports.PropertyDef = $af9b0c81f87d47c4$var$PropertyDef;

});



parcelRegister("jMfWA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeSubject = void 0;

var $jIy9w = parcelRequire("jIy9w");
const $e65ede244a88b939$var$makeSubject = (object, options)=>$jIy9w.ObjectSubjectDef.makeForInstance(object, options);
module.exports.makeSubject = $e65ede244a88b939$var$makeSubject;

});

parcelRegister("5O5Y5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.observable = void 0;

var $4MJ9U = parcelRequire("4MJ9U");

var $jIy9w = parcelRequire("jIy9w");
const $43a640630f3b1175$var$observable = (options)=>(target, key, descriptor)=>{
        /*
        If we are passed a function, it is the class constructor, and we are dealing
        with a static member.

        If passed an object, it is the class' prototype, and we are dealing with
        an instance member.

        https://www.typescriptlang.org/docs/handbook/decorators.html#property-decorators
    */ if (typeof target === "function") throw new $4MJ9U.EcceError(`Static @observable() members are not yet supported: "${target.name}.${String(key)}"`);
        $jIy9w.ClassSubjectDef.getOrMakeFor(target.constructor).addProperty(key, descriptor, options);
    };
module.exports.observable = $43a640630f3b1175$var$observable;

});

parcelRegister("5RjQi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unobserve = module.exports.observe = void 0;

var $4MJ9U = parcelRequire("4MJ9U");

var $jIy9w = parcelRequire("jIy9w");

var $kp3qh = parcelRequire("kp3qh");
const $44414b46d8622049$var$getSubjectDefForObservation = (verb, subject)=>{
    var _a, _b;
    const def = $jIy9w.SubjectDef.getFor(subject);
    if (!def) {
        const ctorName = (_b = (_a = Object.getPrototypeOf(subject)) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name;
        // Bare object.
        if (!ctorName || ctorName === "Object") throw new $4MJ9U.EcceError(`Cannot ${verb} an object not created by subject().`);
        // Class instance.
        throw new $4MJ9U.EcceError(`Cannot ${verb} an instance of a class without a @subject() decorator: "${ctorName}".`);
    }
    return def;
};
const $44414b46d8622049$var$getPropertyForObservation = (verb, subject, key)=>{
    const def = $44414b46d8622049$var$getSubjectDefForObservation(verb, subject);
    const prop = def.getProperty(key);
    if (!prop) {
        if (def instanceof $jIy9w.ClassSubjectDef) throw new $4MJ9U.EcceError(`Cannot ${verb} a property without an @observable() decorator: "${def.name}.${String(key)}".`);
        throw new $4MJ9U.EcceError(`Cannot ${verb} non-existant property: "${def.name}.${String(key)}"`);
    }
    return prop;
};
const $44414b46d8622049$var$observe = (subject, keyOrObserver, observerOrOptions, options)=>{
    if (typeof observerOrOptions === "function" && (0, $kp3qh.isPropertyKey)(keyOrObserver)) {
        // Observing a single property
        $44414b46d8622049$var$getPropertyForObservation("observe", subject, keyOrObserver).addObserver(subject, observerOrOptions, options);
        return;
    }
    // Observing entire subject.
    $44414b46d8622049$var$getSubjectDefForObservation("observe", subject).addObserver(subject, keyOrObserver, options);
};
module.exports.observe = $44414b46d8622049$var$observe;
const $44414b46d8622049$var$unobserve = (subject, keyOrObserver, observer)=>{
    if (observer && (0, $kp3qh.isPropertyKey)(keyOrObserver)) {
        // Unobserving a single property.
        $44414b46d8622049$var$getPropertyForObservation("unobserve", subject, keyOrObserver).removeObserver(subject, observer);
        return;
    }
    $44414b46d8622049$var$getSubjectDefForObservation("unobserve", subject).removeObservers(subject, keyOrObserver);
};
module.exports.unobserve = $44414b46d8622049$var$unobserve;

});
parcelRegister("kp3qh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPropertyKey = void 0;
const $eda8cc2d533e5bb1$var$isPropertyKey = (x)=>{
    switch(typeof x){
        case "string":
        case "number":
        case "symbol":
            return true;
        default:
            return false;
    }
};
module.exports.isPropertyKey = $eda8cc2d533e5bb1$var$isPropertyKey;

});


parcelRegister("lLoOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fcDle", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.subject = void 0;

var $jIy9w = parcelRequire("jIy9w");
const $b1167e6312f954fe$var$subject = ()=>(target)=>{
        const def = $jIy9w.ClassSubjectDef.getOrMakeFor(target);
        def.decorated();
        const proxyCtor = new Proxy(target, {
            construct: (target, args)=>def.applyToInstance(new target(...args))
        });
        return proxyCtor;
    };
module.exports.subject = $b1167e6312f954fe$var$subject;

});


parcelRegister("fDLr8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSubject = void 0;

var $7mY6J = parcelRequire("7mY6J");

var $f6LVE = parcelRequire("f6LVE");

var $kp3qh = parcelRequire("kp3qh");
const $b62f4b76508a4ed1$var$useRerender = ()=>(0, $f6LVE.useReducer)(()=>({}), {})[1];
const $b62f4b76508a4ed1$var$useSubject = (subject, keyOrOptions, options)=>{
    const rerender = $b62f4b76508a4ed1$var$useRerender();
    (0, $f6LVE.useLayoutEffect)(()=>{
        // Observe a specific key.
        if ((0, $kp3qh.isPropertyKey)(keyOrOptions)) {
            (0, $7mY6J.observe)(subject, keyOrOptions, rerender, options);
            return ()=>{
                (0, $7mY6J.unobserve)(subject, keyOrOptions, rerender);
            };
        }
        // Observer entire subject.
        (0, $7mY6J.observe)(subject, rerender);
        return ()=>{
            (0, $7mY6J.unobserve)(subject, rerender);
        };
    }, [
        subject,
        keyOrOptions,
        options
    ]);
};
module.exports.useSubject = $b62f4b76508a4ed1$var$useSubject;

});
parcelRegister("f6LVE", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $affc9840322701bf$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $affc9840322701bf$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $affc9840322701bf$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $affc9840322701bf$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $affc9840322701bf$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $affc9840322701bf$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $affc9840322701bf$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $affc9840322701bf$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $affc9840322701bf$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $affc9840322701bf$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $affc9840322701bf$export$c052f6604b7d51fe; });

var $VqyUd = parcelRequire("VqyUd");
var $affc9840322701bf$var$t, $affc9840322701bf$var$r, $affc9840322701bf$var$u, $affc9840322701bf$var$i, $affc9840322701bf$var$o = 0, $affc9840322701bf$var$c = [], $affc9840322701bf$var$f = [], $affc9840322701bf$var$e = (0, $VqyUd.options).__b, $affc9840322701bf$var$a = (0, $VqyUd.options).__r, $affc9840322701bf$var$v = (0, $VqyUd.options).diffed, $affc9840322701bf$var$l = (0, $VqyUd.options).__c, $affc9840322701bf$var$m = (0, $VqyUd.options).unmount;
function $affc9840322701bf$var$d(t, u) {
    (0, $VqyUd.options).__h && (0, $VqyUd.options).__h($affc9840322701bf$var$r, t, $affc9840322701bf$var$o || u), $affc9840322701bf$var$o = 0;
    var i = $affc9840322701bf$var$r.__H || ($affc9840322701bf$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $affc9840322701bf$var$f
    }), i.__[t];
}
function $affc9840322701bf$export$60241385465d0a34(n) {
    return $affc9840322701bf$var$o = 1, $affc9840322701bf$export$13e3392192263954($affc9840322701bf$var$z, n);
}
function $affc9840322701bf$export$13e3392192263954(n, u, i) {
    var o = $affc9840322701bf$var$d($affc9840322701bf$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $affc9840322701bf$var$z(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $affc9840322701bf$var$r, !$affc9840322701bf$var$r.u)) {
        $affc9840322701bf$var$r.u = !0;
        var c = $affc9840322701bf$var$r.shouldComponentUpdate;
        $affc9840322701bf$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !!i && (!c || c.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $affc9840322701bf$export$6d9c69b0de29b591(u, i) {
    var o = $affc9840322701bf$var$d($affc9840322701bf$var$t++, 3);
    !(0, $VqyUd.options).__s && $affc9840322701bf$var$w(o.__H, i) && (o.__ = u, o.i = i, $affc9840322701bf$var$r.__H.__h.push(o));
}
function $affc9840322701bf$export$e5c5a5f917a5871c(u, i) {
    var o = $affc9840322701bf$var$d($affc9840322701bf$var$t++, 4);
    !(0, $VqyUd.options).__s && $affc9840322701bf$var$w(o.__H, i) && (o.__ = u, o.i = i, $affc9840322701bf$var$r.__h.push(o));
}
function $affc9840322701bf$export$b8f5890fc79d6aca(n) {
    return $affc9840322701bf$var$o = 5, $affc9840322701bf$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $affc9840322701bf$export$d5a552a76deda3c2(n, t, r) {
    $affc9840322701bf$var$o = 6, $affc9840322701bf$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $affc9840322701bf$export$1538c33de8887b59(n, r) {
    var u = $affc9840322701bf$var$d($affc9840322701bf$var$t++, 7);
    return $affc9840322701bf$var$w(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $affc9840322701bf$export$35808ee640e87ca7(n, t) {
    return $affc9840322701bf$var$o = 8, $affc9840322701bf$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $affc9840322701bf$export$fae74005e78b1a27(n) {
    var u = $affc9840322701bf$var$r.context[n.__c], i = $affc9840322701bf$var$d($affc9840322701bf$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($affc9840322701bf$var$r)), u.props.value) : n.__;
}
function $affc9840322701bf$export$dc8fbce3eb94dc1e(t, r) {
    (0, $VqyUd.options).useDebugValue && (0, $VqyUd.options).useDebugValue(r ? r(t) : t);
}
function $affc9840322701bf$export$c052f6604b7d51fe(n) {
    var u = $affc9840322701bf$var$d($affc9840322701bf$var$t++, 10), i = $affc9840322701bf$export$60241385465d0a34();
    return u.__ = n, $affc9840322701bf$var$r.componentDidCatch || ($affc9840322701bf$var$r.componentDidCatch = function(n) {
        u.__ && u.__(n), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $affc9840322701bf$var$b() {
    for(var t; t = $affc9840322701bf$var$c.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($affc9840322701bf$var$j), t.__H.__h.forEach($affc9840322701bf$var$k), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $VqyUd.options).__e(r, t.__v);
    }
}
(0, $VqyUd.options).__b = function(n) {
    $affc9840322701bf$var$r = null, $affc9840322701bf$var$e && $affc9840322701bf$var$e(n);
}, (0, $VqyUd.options).__r = function(n) {
    $affc9840322701bf$var$a && $affc9840322701bf$var$a(n), $affc9840322701bf$var$t = 0;
    var i = ($affc9840322701bf$var$r = n.__c).__H;
    i && ($affc9840322701bf$var$u === $affc9840322701bf$var$r ? (i.__h = [], $affc9840322701bf$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $affc9840322701bf$var$f, n.__N = n.i = void 0;
    })) : (i.__h.forEach($affc9840322701bf$var$j), i.__h.forEach($affc9840322701bf$var$k), i.__h = [])), $affc9840322701bf$var$u = $affc9840322701bf$var$r;
}, (0, $VqyUd.options).diffed = function(t) {
    $affc9840322701bf$var$v && $affc9840322701bf$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $affc9840322701bf$var$c.push(o) && $affc9840322701bf$var$i === (0, $VqyUd.options).requestAnimationFrame || (($affc9840322701bf$var$i = (0, $VqyUd.options).requestAnimationFrame) || function(n) {
        var t, r = function() {
            clearTimeout(u), $affc9840322701bf$var$g && cancelAnimationFrame(t), setTimeout(n);
        }, u = setTimeout(r, 100);
        $affc9840322701bf$var$g && (t = requestAnimationFrame(r));
    })($affc9840322701bf$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $affc9840322701bf$var$f && (n.__ = n.__V), n.i = void 0, n.__V = $affc9840322701bf$var$f;
    })), $affc9840322701bf$var$u = $affc9840322701bf$var$r = null;
}, (0, $VqyUd.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($affc9840322701bf$var$j), t.__h = t.__h.filter(function(n) {
                return !n.__ || $affc9840322701bf$var$k(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $VqyUd.options).__e(u, t.__v);
        }
    }), $affc9840322701bf$var$l && $affc9840322701bf$var$l(t, r);
}, (0, $VqyUd.options).unmount = function(t) {
    $affc9840322701bf$var$m && $affc9840322701bf$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $affc9840322701bf$var$j(n);
        } catch (n) {
            r = n;
        }
    }), r && (0, $VqyUd.options).__e(r, u.__v));
};
var $affc9840322701bf$var$g = "function" == typeof requestAnimationFrame;
function $affc9840322701bf$var$j(n) {
    var t = $affc9840322701bf$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $affc9840322701bf$var$r = t;
}
function $affc9840322701bf$var$k(n) {
    var t = $affc9840322701bf$var$r;
    n.__c = n.__(), $affc9840322701bf$var$r = t;
}
function $affc9840322701bf$var$w(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $affc9840322701bf$var$z(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});
parcelRegister("VqyUd", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $0ac9eda4fd52da3b$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $0ac9eda4fd52da3b$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $0ac9eda4fd52da3b$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $0ac9eda4fd52da3b$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $0ac9eda4fd52da3b$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $0ac9eda4fd52da3b$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $0ac9eda4fd52da3b$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $0ac9eda4fd52da3b$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $0ac9eda4fd52da3b$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $0ac9eda4fd52da3b$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "h", function () { return $0ac9eda4fd52da3b$export$c8a8987d4410bf2d; });
var $0ac9eda4fd52da3b$var$n, $0ac9eda4fd52da3b$export$41c562ebe57d11e2, $0ac9eda4fd52da3b$var$u, $0ac9eda4fd52da3b$export$a8257692ac88316c, $0ac9eda4fd52da3b$var$t, $0ac9eda4fd52da3b$var$o, $0ac9eda4fd52da3b$var$r, $0ac9eda4fd52da3b$var$f = {}, $0ac9eda4fd52da3b$var$e = [], $0ac9eda4fd52da3b$var$c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $0ac9eda4fd52da3b$var$s(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $0ac9eda4fd52da3b$var$a(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $0ac9eda4fd52da3b$export$c8a8987d4410bf2d(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $0ac9eda4fd52da3b$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $0ac9eda4fd52da3b$var$v(l, f, t, o, null);
}
function $0ac9eda4fd52da3b$var$v(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$0ac9eda4fd52da3b$var$u : r
    };
    return null == r && null != $0ac9eda4fd52da3b$export$41c562ebe57d11e2.vnode && $0ac9eda4fd52da3b$export$41c562ebe57d11e2.vnode(f), f;
}
function $0ac9eda4fd52da3b$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $0ac9eda4fd52da3b$export$ffb0004e005737fa(n) {
    return n.children;
}
function $0ac9eda4fd52da3b$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $0ac9eda4fd52da3b$var$_(n, l) {
    if (null == l) return n.__ ? $0ac9eda4fd52da3b$var$_(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $0ac9eda4fd52da3b$var$_(n) : null;
}
function $0ac9eda4fd52da3b$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $0ac9eda4fd52da3b$var$k(n);
    }
}
function $0ac9eda4fd52da3b$var$b(n) {
    (!n.__d && (n.__d = !0) && $0ac9eda4fd52da3b$var$t.push(n) && !$0ac9eda4fd52da3b$var$g.__r++ || $0ac9eda4fd52da3b$var$o !== $0ac9eda4fd52da3b$export$41c562ebe57d11e2.debounceRendering) && (($0ac9eda4fd52da3b$var$o = $0ac9eda4fd52da3b$export$41c562ebe57d11e2.debounceRendering) || setTimeout)($0ac9eda4fd52da3b$var$g);
}
function $0ac9eda4fd52da3b$var$g() {
    for(var n; $0ac9eda4fd52da3b$var$g.__r = $0ac9eda4fd52da3b$var$t.length;)n = $0ac9eda4fd52da3b$var$t.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $0ac9eda4fd52da3b$var$t = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $0ac9eda4fd52da3b$var$s({}, t)).__v = t.__v + 1, $0ac9eda4fd52da3b$var$j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $0ac9eda4fd52da3b$var$_(t) : o, t.__h), $0ac9eda4fd52da3b$var$z(u, t), t.__e != o && $0ac9eda4fd52da3b$var$k(t)));
    });
}
function $0ac9eda4fd52da3b$var$w(n, l, u, i, t, o, r, c, s, a) {
    var h, y, d, k, b, g, w, x = i && i.__k || $0ac9eda4fd52da3b$var$e, C = x.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (k = u.__k[h] = null == (k = l[h]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == typeof k ? $0ac9eda4fd52da3b$var$v(null, k, null, null, k) : Array.isArray(k) ? $0ac9eda4fd52da3b$var$v($0ac9eda4fd52da3b$export$ffb0004e005737fa, {
        children: k
    }, null, null, null) : k.__b > 0 ? $0ac9eda4fd52da3b$var$v(k.type, k.props, k.key, null, k.__v) : k)) {
        if (k.__ = u, k.__b = u.__b + 1, null === (d = x[h]) || d && k.key == d.key && k.type === d.type) x[h] = void 0;
        else for(y = 0; y < C; y++){
            if ((d = x[y]) && k.key == d.key && k.type === d.type) {
                x[y] = void 0;
                break;
            }
            d = null;
        }
        $0ac9eda4fd52da3b$var$j(n, k, d = d || $0ac9eda4fd52da3b$var$f, t, o, r, c, s, a), b = k.__e, (y = k.ref) && d.ref != y && (w || (w = []), d.ref && w.push(d.ref, null, k), w.push(y, k.__c || b, k)), null != b ? (null == g && (g = b), "function" == typeof k.type && k.__k === d.__k ? k.__d = s = $0ac9eda4fd52da3b$var$m(k, s, n) : s = $0ac9eda4fd52da3b$var$A(n, k, d, x, b, s), "function" == typeof u.type && (u.__d = s)) : s && d.__e == s && s.parentNode != n && (s = $0ac9eda4fd52da3b$var$_(d));
    }
    for(u.__e = g, h = C; h--;)null != x[h] && ("function" == typeof u.type && null != x[h].__e && x[h].__e == u.__d && (u.__d = $0ac9eda4fd52da3b$var$_(i, h + 1)), $0ac9eda4fd52da3b$var$N(x[h], x[h]));
    if (w) for(h = 0; h < w.length; h++)$0ac9eda4fd52da3b$var$M(w[h], w[++h], w[++h]);
}
function $0ac9eda4fd52da3b$var$m(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $0ac9eda4fd52da3b$var$m(i, l, u) : $0ac9eda4fd52da3b$var$A(u, i, i, t, i.__e, l));
    return l;
}
function $0ac9eda4fd52da3b$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $0ac9eda4fd52da3b$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $0ac9eda4fd52da3b$var$A(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $0ac9eda4fd52da3b$var$C(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $0ac9eda4fd52da3b$var$H(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $0ac9eda4fd52da3b$var$H(n, o, l[o], u[o], i);
}
function $0ac9eda4fd52da3b$var$$(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $0ac9eda4fd52da3b$var$c.test(l) ? u : u + "px";
}
function $0ac9eda4fd52da3b$var$H(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $0ac9eda4fd52da3b$var$$(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $0ac9eda4fd52da3b$var$$(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $0ac9eda4fd52da3b$var$T : $0ac9eda4fd52da3b$var$I, o) : n.removeEventListener(l, o ? $0ac9eda4fd52da3b$var$T : $0ac9eda4fd52da3b$var$I, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $0ac9eda4fd52da3b$var$I(n) {
    this.l[n.type + !1]($0ac9eda4fd52da3b$export$41c562ebe57d11e2.event ? $0ac9eda4fd52da3b$export$41c562ebe57d11e2.event(n) : n);
}
function $0ac9eda4fd52da3b$var$T(n) {
    this.l[n.type + !0]($0ac9eda4fd52da3b$export$41c562ebe57d11e2.event ? $0ac9eda4fd52da3b$export$41c562ebe57d11e2.event(n) : n);
}
function $0ac9eda4fd52da3b$var$j(n, u, i, t, o, r, f, e, c) {
    var a, h, v, y, _, k, b, g, m, x, A, C, $, H = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (a = $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__b) && a(u);
    try {
        n: if ("function" == typeof H) {
            if (g = u.props, m = (a = H.contextType) && t[a.__c], x = a ? m ? m.props.value : a.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in H && H.prototype.render ? u.__c = h = new H(g, x) : (u.__c = h = new $0ac9eda4fd52da3b$export$16fa2f45be04daa8(g, x), h.constructor = H, h.render = $0ac9eda4fd52da3b$var$O), m && m.sub(h), h.props = g, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != H.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $0ac9eda4fd52da3b$var$s({}, h.__s)), $0ac9eda4fd52da3b$var$s(h.__s, H.getDerivedStateFromProps(g, h.__s))), y = h.props, _ = h.state, v) null == H.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == H.getDerivedStateFromProps && g !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(g, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(g, h.__s, x) || u.__v === i.__v) {
                    h.props = g, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(g, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, _, k);
                });
            }
            if (h.context = x, h.props = g, h.__v = u, h.__P = n, A = $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__r, C = 0, "prototype" in H && H.prototype.render) h.state = h.__s, h.__d = !1, A && A(u), a = h.render(h.props, h.state, h.context);
            else do h.__d = !1, A && A(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
            while (h.__d && ++C < 25);
            h.state = h.__s, null != h.getChildContext && (t = $0ac9eda4fd52da3b$var$s($0ac9eda4fd52da3b$var$s({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, _)), $ = null != a && a.type === $0ac9eda4fd52da3b$export$ffb0004e005737fa && null == a.key ? a.props.children : a, $0ac9eda4fd52da3b$var$w(n, Array.isArray($) ? $ : [
                $
            ], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $0ac9eda4fd52da3b$var$L(i.__e, u, i, t, o, r, f, c);
        (a = $0ac9eda4fd52da3b$export$41c562ebe57d11e2.diffed) && a(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $0ac9eda4fd52da3b$var$z(n, u) {
    $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__c && $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $0ac9eda4fd52da3b$var$L(l, u, i, t, o, r, e, c) {
    var s, h, v, y = i.props, p = u.props, d = u.type, k = 0;
    if ("svg" === d && (o = !0), null != r) {
        for(; k < r.length; k++)if ((s = r[k]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, r[k] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
    }
    if (null === d) y === p || c && l.data === p || (l.data = p);
    else {
        if (r = r && $0ac9eda4fd52da3b$var$n.call(l.childNodes), h = (y = i.props || $0ac9eda4fd52da3b$var$f).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
            if (null != r) for(y = {}, k = 0; k < l.attributes.length; k++)y[l.attributes[k].name] = l.attributes[k].value;
            (v || h) && (v && (h && v.__html == h.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if ($0ac9eda4fd52da3b$var$C(l, p, y, o, c), v) u.__k = [];
        else if (k = u.props.children, $0ac9eda4fd52da3b$var$w(l, Array.isArray(k) ? k : [
            k
        ], u, i, t, o && "foreignObject" !== d, r, e, r ? r[0] : i.__k && $0ac9eda4fd52da3b$var$_(i, 0), c), null != r) for(k = r.length; k--;)null != r[k] && $0ac9eda4fd52da3b$var$a(r[k]);
        c || ("value" in p && void 0 !== (k = p.value) && (k !== l.value || "progress" === d && !k || "option" === d && k !== y.value) && $0ac9eda4fd52da3b$var$H(l, "value", k, y.value, !1), "checked" in p && void 0 !== (k = p.checked) && k !== l.checked && $0ac9eda4fd52da3b$var$H(l, "checked", k, y.checked, !1));
    }
    return l;
}
function $0ac9eda4fd52da3b$var$M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $0ac9eda4fd52da3b$var$N(n, u, i) {
    var t, o;
    if ($0ac9eda4fd52da3b$export$41c562ebe57d11e2.unmount && $0ac9eda4fd52da3b$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $0ac9eda4fd52da3b$var$M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $0ac9eda4fd52da3b$var$N(t[o], u, "function" != typeof n.type);
    i || null == n.__e || $0ac9eda4fd52da3b$var$a(n.__e), n.__e = n.__d = void 0;
}
function $0ac9eda4fd52da3b$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $0ac9eda4fd52da3b$export$b3890eb0ae9dca99(u, i, t) {
    var o, r, e;
    $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__ && $0ac9eda4fd52da3b$export$41c562ebe57d11e2.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, e = [], $0ac9eda4fd52da3b$var$j(i, u = (!o && t || i).__k = $0ac9eda4fd52da3b$export$c8a8987d4410bf2d($0ac9eda4fd52da3b$export$ffb0004e005737fa, null, [
        u
    ]), r || $0ac9eda4fd52da3b$var$f, $0ac9eda4fd52da3b$var$f, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $0ac9eda4fd52da3b$var$n.call(i.childNodes) : null, e, !o && t ? t : r ? r.__e : i.firstChild, o), $0ac9eda4fd52da3b$var$z(e, u);
}
function $0ac9eda4fd52da3b$export$fa8d919ba61d84db(n, l) {
    $0ac9eda4fd52da3b$export$b3890eb0ae9dca99(n, l, $0ac9eda4fd52da3b$export$fa8d919ba61d84db);
}
function $0ac9eda4fd52da3b$export$e530037191fcd5d7(l, u, i) {
    var t, o, r, f = $0ac9eda4fd52da3b$var$s({}, l.props);
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $0ac9eda4fd52da3b$var$n.call(arguments, 2) : i), $0ac9eda4fd52da3b$var$v(l.type, f, t || l.key, o || l.ref, null);
}
function $0ac9eda4fd52da3b$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $0ac9eda4fd52da3b$var$r++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($0ac9eda4fd52da3b$var$b);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$0ac9eda4fd52da3b$var$n = $0ac9eda4fd52da3b$var$e.slice, $0ac9eda4fd52da3b$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $0ac9eda4fd52da3b$var$u = 0, $0ac9eda4fd52da3b$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $0ac9eda4fd52da3b$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $0ac9eda4fd52da3b$var$s({}, this.state), "function" == typeof n && (n = n($0ac9eda4fd52da3b$var$s({}, u), this.props)), n && $0ac9eda4fd52da3b$var$s(u, n), null != n && this.__v && (l && this.__h.push(l), $0ac9eda4fd52da3b$var$b(this));
}, $0ac9eda4fd52da3b$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $0ac9eda4fd52da3b$var$b(this));
}, $0ac9eda4fd52da3b$export$16fa2f45be04daa8.prototype.render = $0ac9eda4fd52da3b$export$ffb0004e005737fa, $0ac9eda4fd52da3b$var$t = [], $0ac9eda4fd52da3b$var$g.__r = 0, $0ac9eda4fd52da3b$var$r = 0;

});



parcelRegister("iFBku", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updatePaymentMethodSetupResultSchema = module.exports.activateBillingSetupResultSchema = module.exports.activateBillingSetupResultWithoutCheckout = module.exports.activateBillingSetupResultWithCheckout = module.exports.freeagentTokenResultSchema = module.exports.loginRequestSchema = module.exports.resetPasswordRequestSchema = module.exports.initResetPasswordRequestSchema = module.exports.changePasswordRequestSchema = module.exports.verifyEmailRequestSchema = module.exports.signupResponseOkSchema = module.exports.signupResponseErrorSchema = module.exports.signupErrorTypeSchema = module.exports.invalidPasswordErrorTypeSchema = module.exports.signupRequestSchema = void 0;

var $9wYJ6 = parcelRequire("9wYJ6");
module.exports.signupRequestSchema = $9wYJ6.Type.Object({
    email: $9wYJ6.Type.String(),
    password: $9wYJ6.Type.String(),
    acceptTou: $9wYJ6.Type.Boolean(),
    acceptEula: $9wYJ6.Type.Boolean(),
    referredBy: $9wYJ6.Type.Optional($9wYJ6.Type.String())
});
module.exports.invalidPasswordErrorTypeSchema = $9wYJ6.Type.Union([
    $9wYJ6.Type.Literal("password-short"),
    $9wYJ6.Type.Literal("password-long")
]);
module.exports.signupErrorTypeSchema = $9wYJ6.Type.Union([
    module.exports.invalidPasswordErrorTypeSchema,
    $9wYJ6.Type.Literal("email-invalid"),
    $9wYJ6.Type.Literal("email-exists"),
    $9wYJ6.Type.Literal("email-long"),
    $9wYJ6.Type.Literal("email-free"),
    $9wYJ6.Type.Literal("eula"),
    $9wYJ6.Type.Literal("tou")
]);
module.exports.signupResponseErrorSchema = $9wYJ6.Type.Object({
    ok: $9wYJ6.Type.Literal(false),
    errors: $9wYJ6.Type.Array(module.exports.signupErrorTypeSchema)
});
module.exports.signupResponseOkSchema = $9wYJ6.Type.Object({
    ok: $9wYJ6.Type.Literal(true)
});
module.exports.verifyEmailRequestSchema = $9wYJ6.Type.Object({
    code: $9wYJ6.Type.String()
});
module.exports.changePasswordRequestSchema = $9wYJ6.Type.Object({
    oldPassword: $9wYJ6.Type.String(),
    newPassword: $9wYJ6.Type.String()
});
module.exports.initResetPasswordRequestSchema = $9wYJ6.Type.Object({
    email: $9wYJ6.Type.String()
});
module.exports.resetPasswordRequestSchema = $9wYJ6.Type.Object({
    password: $9wYJ6.Type.String()
});
module.exports.loginRequestSchema = $9wYJ6.Type.Object({
    email: $9wYJ6.Type.String(),
    password: $9wYJ6.Type.String()
}, {
    title: "PostSessionRequest"
});
module.exports.freeagentTokenResultSchema = $9wYJ6.Type.Union([
    $9wYJ6.Type.Object({
        ok: $9wYJ6.Type.Literal(true)
    }),
    $9wYJ6.Type.Object({
        ok: $9wYJ6.Type.Literal(false),
        statusCode: $9wYJ6.Type.Integer(),
        body: $9wYJ6.Type.String()
    })
], {
    title: "FreeagentTokenResult"
});
module.exports.activateBillingSetupResultWithCheckout = $9wYJ6.Type.Object({
    requiresCheckout: $9wYJ6.Type.Literal(true),
    checkoutSessionId: $9wYJ6.Type.String()
}, {
    title: "ActivateBillingSetupResult.WithCheckout"
});
module.exports.activateBillingSetupResultWithoutCheckout = $9wYJ6.Type.Object({
    requiresCheckout: $9wYJ6.Type.Literal(false)
}, {
    title: "ActivateBillingSetupResult.WithoutCheckout"
});
module.exports.activateBillingSetupResultSchema = $9wYJ6.Type.Union([
    module.exports.activateBillingSetupResultWithCheckout,
    module.exports.activateBillingSetupResultWithoutCheckout
], {
    title: "ActivateBillingSetupResult"
});
module.exports.updatePaymentMethodSetupResultSchema = $9wYJ6.Type.Object({
    checkoutSessionId: $9wYJ6.Type.String()
}, {
    title: "UpdatePaymentMethodSetupResult"
});

});
parcelRegister("9wYJ6", function(module, exports) {
"use strict";
/*--------------------------------------------------------------------------

@sinclair/typebox

The MIT License (MIT)

Copyright (c) 2022 Haydn Paterson (sinclair) <haydn.developer@gmail.com>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

---------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Type = module.exports.TypeBuilder = module.exports.Modifier = module.exports.Hint = module.exports.Kind = void 0;
// --------------------------------------------------------------------------
// Symbols
// --------------------------------------------------------------------------
module.exports.Kind = Symbol.for("TypeBox.Kind");
module.exports.Hint = Symbol.for("TypeBox.Hint");
module.exports.Modifier = Symbol.for("TypeBox.Modifier");
// --------------------------------------------------------------------------
// TypeBuilder
// --------------------------------------------------------------------------
let $6f06353b15e105cf$var$TypeOrdinal = 0;
class $6f06353b15e105cf$var$TypeBuilder {
    // ----------------------------------------------------------------------
    // Modifiers
    // ----------------------------------------------------------------------
    /** Creates a readonly optional property */ ReadonlyOptional(item) {
        return {
            [module.exports.Modifier]: "ReadonlyOptional",
            ...item
        };
    }
    /** Creates a readonly property */ Readonly(item) {
        return {
            [module.exports.Modifier]: "Readonly",
            ...item
        };
    }
    /** Creates a optional property */ Optional(item) {
        return {
            [module.exports.Modifier]: "Optional",
            ...item
        };
    }
    // ----------------------------------------------------------------------
    // Types
    // ----------------------------------------------------------------------
    /** Creates a any type */ Any(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Any"
        });
    }
    /** Creates a array type */ Array(items, options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Array",
            type: "array",
            items: items
        });
    }
    /** Creates a boolean type */ Boolean(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Boolean",
            type: "boolean"
        });
    }
    /** Creates a tuple type from this constructors parameters */ ConstructorParameters(schema, options = {}) {
        return this.Tuple([
            ...schema.parameters
        ], {
            ...options
        });
    }
    /** Creates a constructor type */ Constructor(parameters, returns, options = {}) {
        if (parameters[module.exports.Kind] === "Tuple") {
            const inner = parameters.items === undefined ? [] : parameters.items;
            return this.Create({
                ...options,
                [module.exports.Kind]: "Constructor",
                type: "constructor",
                parameters: inner,
                returns: returns
            });
        } else if (globalThis.Array.isArray(parameters)) return this.Create({
            ...options,
            [module.exports.Kind]: "Constructor",
            type: "constructor",
            parameters: parameters,
            returns: returns
        });
        else throw new Error("TypeBuilder.Constructor: Invalid parameters");
    }
    /** Creates a enum type */ Enum(item, options = {}) {
        const values = Object.keys(item).filter((key)=>isNaN(key)).map((key)=>item[key]);
        const anyOf = values.map((value)=>typeof value === "string" ? {
                [module.exports.Kind]: "Literal",
                type: "string",
                const: value
            } : {
                [module.exports.Kind]: "Literal",
                type: "number",
                const: value
            });
        return this.Create({
            ...options,
            [module.exports.Kind]: "Union",
            [module.exports.Hint]: "Enum",
            anyOf: anyOf
        });
    }
    /** Creates a function type */ Function(parameters, returns, options = {}) {
        if (parameters[module.exports.Kind] === "Tuple") {
            const inner = parameters.items === undefined ? [] : parameters.items;
            return this.Create({
                ...options,
                [module.exports.Kind]: "Function",
                type: "function",
                parameters: inner,
                returns: returns
            });
        } else if (globalThis.Array.isArray(parameters)) return this.Create({
            ...options,
            [module.exports.Kind]: "Function",
            type: "function",
            parameters: parameters,
            returns: returns
        });
        else throw new Error("TypeBuilder.Function: Invalid parameters");
    }
    /** Creates a type from this constructors instance type */ InstanceType(schema, options = {}) {
        return {
            ...options,
            ...this.Clone(schema.returns)
        };
    }
    /** Creates a integer type */ Integer(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Integer",
            type: "integer"
        });
    }
    /** Creates a intersect type. */ Intersect(objects, options = {}) {
        const isOptional = (schema)=>schema[module.exports.Modifier] && schema[module.exports.Modifier] === "Optional" || schema[module.exports.Modifier] === "ReadonlyOptional";
        const [required, optional] = [
            new Set(),
            new Set()
        ];
        for (const object of objects){
            for (const [key, schema] of Object.entries(object.properties))if (isOptional(schema)) optional.add(key);
        }
        for (const object of objects){
            for (const key of Object.keys(object.properties))if (!optional.has(key)) required.add(key);
        }
        const properties = {};
        for (const object of objects)for (const [key, schema] of Object.entries(object.properties))properties[key] = properties[key] === undefined ? schema : {
            [module.exports.Kind]: "Union",
            anyOf: [
                properties[key],
                {
                    ...schema
                }
            ]
        };
        if (required.size > 0) return this.Create({
            ...options,
            [module.exports.Kind]: "Object",
            type: "object",
            properties: properties,
            required: [
                ...required
            ]
        });
        else return this.Create({
            ...options,
            [module.exports.Kind]: "Object",
            type: "object",
            properties: properties
        });
    }
    /** Creates a keyof type */ KeyOf(object, options = {}) {
        const items = Object.keys(object.properties).map((key)=>this.Create({
                ...options,
                [module.exports.Kind]: "Literal",
                type: "string",
                const: key
            }));
        return this.Create({
            ...options,
            [module.exports.Kind]: "Union",
            [module.exports.Hint]: "KeyOf",
            anyOf: items
        });
    }
    /** Creates a literal type. */ Literal(value, options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Literal",
            const: value,
            type: typeof value
        });
    }
    /** Creates a null type */ Null(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Null",
            type: "null"
        });
    }
    /** Creates a number type */ Number(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Number",
            type: "number"
        });
    }
    /** Creates an object type with the given properties */ Object(properties, options = {}) {
        const property_names = Object.keys(properties);
        const optional = property_names.filter((name)=>{
            const property = properties[name];
            const modifier = property[module.exports.Modifier];
            return modifier && (modifier === "Optional" || modifier === "ReadonlyOptional");
        });
        const required = property_names.filter((name)=>!optional.includes(name));
        if (required.length > 0) return this.Create({
            ...options,
            [module.exports.Kind]: "Object",
            type: "object",
            properties: properties,
            required: required
        });
        else return this.Create({
            ...options,
            [module.exports.Kind]: "Object",
            type: "object",
            properties: properties
        });
    }
    /** Creates a new object whose properties are omitted from the given object */ Omit(schema, keys, options = {}) {
        const select = keys[module.exports.Kind] === "Union" ? keys.anyOf.map((schema)=>schema.const) : keys;
        const next = {
            ...this.Clone(schema),
            ...options,
            [module.exports.Hint]: "Omit"
        };
        next.required = next.required ? next.required.filter((key)=>!select.includes(key)) : undefined;
        for (const key of Object.keys(next.properties))if (select.includes(key)) delete next.properties[key];
        return this.Create(next);
    }
    /** Creates a tuple type from this functions parameters */ Parameters(schema, options = {}) {
        return module.exports.Type.Tuple(schema.parameters, {
            ...options
        });
    }
    /** Creates an object type whose properties are all optional */ Partial(schema, options = {}) {
        const next = {
            ...this.Clone(schema),
            ...options,
            [module.exports.Hint]: "Partial"
        };
        delete next.required;
        for (const key of Object.keys(next.properties)){
            const property = next.properties[key];
            const modifer = property[module.exports.Modifier];
            switch(modifer){
                case "ReadonlyOptional":
                    property[module.exports.Modifier] = "ReadonlyOptional";
                    break;
                case "Readonly":
                    property[module.exports.Modifier] = "ReadonlyOptional";
                    break;
                case "Optional":
                    property[module.exports.Modifier] = "Optional";
                    break;
                default:
                    property[module.exports.Modifier] = "Optional";
                    break;
            }
        }
        return this.Create(next);
    }
    /** Creates a object whose properties are picked from the given object */ Pick(schema, keys, options = {}) {
        const select = keys[module.exports.Kind] === "Union" ? keys.anyOf.map((schema)=>schema.const) : keys;
        const next = {
            ...this.Clone(schema),
            ...options,
            [module.exports.Hint]: "Pick"
        };
        next.required = next.required ? next.required.filter((key)=>select.includes(key)) : undefined;
        for (const key of Object.keys(next.properties))if (!select.includes(key)) delete next.properties[key];
        return this.Create(next);
    }
    /** Creates a promise type. This type cannot be represented in schema. */ Promise(item, options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Promise",
            type: "promise",
            item: item
        });
    }
    /** Creates a record type */ Record(key, value, options = {}) {
        // If string literal union return TObject with properties extracted from union.
        if (key[module.exports.Kind] === "Union") return this.Object(key.anyOf.reduce((acc, literal)=>{
            return {
                ...acc,
                [literal.const]: value
            };
        }, {}), {
            ...options,
            [module.exports.Hint]: "Record"
        });
        // otherwise return TRecord with patternProperties
        const pattern = key[module.exports.Kind] === "Number" ? "^(0|[1-9][0-9]*)$" : key[module.exports.Kind] === "String" && key.pattern ? key.pattern : "^.*$";
        return this.Create({
            ...options,
            [module.exports.Kind]: "Record",
            type: "object",
            patternProperties: {
                [pattern]: value
            },
            additionalProperties: false
        });
    }
    /** Creates a recursive object type */ Recursive(callback, options = {}) {
        if (options.$id === undefined) options.$id = `type-${$6f06353b15e105cf$var$TypeOrdinal++}`;
        const self = callback({
            [module.exports.Kind]: "Self",
            $ref: `${options.$id}`
        });
        self.$id = options.$id;
        return this.Create({
            ...options,
            ...self
        });
    }
    /** Creates a reference schema */ Ref(schema, options = {}) {
        if (schema.$id === undefined) throw Error("TypeBuilder.Ref: Referenced schema must specify an $id");
        return this.Create({
            ...options,
            [module.exports.Kind]: "Ref",
            $ref: schema.$id
        });
    }
    /** Creates a string type from a regular expression */ RegEx(regex, options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "String",
            type: "string",
            pattern: regex.source
        });
    }
    /** Creates an object type whose properties are all required */ Required(schema, options = {}) {
        const next = {
            ...this.Clone(schema),
            ...options,
            [module.exports.Hint]: "Required"
        };
        next.required = Object.keys(next.properties);
        for (const key of Object.keys(next.properties)){
            const property = next.properties[key];
            const modifier = property[module.exports.Modifier];
            switch(modifier){
                case "ReadonlyOptional":
                    property[module.exports.Modifier] = "Readonly";
                    break;
                case "Readonly":
                    property[module.exports.Modifier] = "Readonly";
                    break;
                case "Optional":
                    delete property[module.exports.Modifier];
                    break;
                default:
                    delete property[module.exports.Modifier];
                    break;
            }
        }
        return this.Create(next);
    }
    /** Creates a type from this functions return type */ ReturnType(schema, options = {}) {
        return {
            ...options,
            ...this.Clone(schema.returns)
        };
    }
    /** Removes Kind and Modifier symbol property keys from this schema */ Strict(schema) {
        return JSON.parse(JSON.stringify(schema));
    }
    /** Creates a string type */ String(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "String",
            type: "string"
        });
    }
    /** Creates a tuple type */ Tuple(items, options = {}) {
        const additionalItems = false;
        const minItems = items.length;
        const maxItems = items.length;
        const schema = items.length > 0 ? {
            ...options,
            [module.exports.Kind]: "Tuple",
            type: "array",
            items: items,
            additionalItems: additionalItems,
            minItems: minItems,
            maxItems: maxItems
        } : {
            ...options,
            [module.exports.Kind]: "Tuple",
            type: "array",
            minItems: minItems,
            maxItems: maxItems
        };
        return this.Create(schema);
    }
    /** Creates a undefined type */ Undefined(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Undefined",
            type: "object",
            specialized: "Undefined"
        });
    }
    /** Creates a union type */ Union(items, options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Union",
            anyOf: items
        });
    }
    /** Creates a Uint8Array type */ Uint8Array(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Uint8Array",
            type: "object",
            specialized: "Uint8Array"
        });
    }
    /** Creates an unknown type */ Unknown(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Unknown"
        });
    }
    /** Creates a user defined schema that infers as type T  */ Unsafe(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: options[module.exports.Kind] || "Unsafe"
        });
    }
    /** Creates a void type */ Void(options = {}) {
        return this.Create({
            ...options,
            [module.exports.Kind]: "Void",
            type: "null"
        });
    }
    /** Use this function to return TSchema with static and params omitted */ Create(schema) {
        return schema;
    }
    /** Clones the given value */ Clone(value) {
        const isObject = (object)=>typeof object === "object" && object !== null && !Array.isArray(object);
        const isArray = (object)=>typeof object === "object" && object !== null && Array.isArray(object);
        if (isObject(value)) return Object.keys(value).reduce((acc, key)=>({
                ...acc,
                [key]: this.Clone(value[key])
            }), Object.getOwnPropertySymbols(value).reduce((acc, key)=>({
                ...acc,
                [key]: this.Clone(value[key])
            }), {}));
        else if (isArray(value)) return value.map((item)=>this.Clone(item));
        else return value;
    }
}
module.exports.TypeBuilder = $6f06353b15e105cf$var$TypeBuilder;
/** JSON Schema Type Builder with Static Type Resolution for TypeScript */ module.exports.Type = new $6f06353b15e105cf$var$TypeBuilder();

});


parcelRegister("aKQ0E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PASSWORD_MAX_LENGTH = module.exports.PASSWORD_MIN_LENGTH = module.exports.USERNAME_MAX_LENGTH = void 0;
module.exports.USERNAME_MAX_LENGTH = 254;
module.exports.PASSWORD_MIN_LENGTH = 8;
module.exports.PASSWORD_MAX_LENGTH = 1000;

});

parcelRegister("fG7NL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adminDetailsSchema = module.exports.adminBuildDetails = module.exports.adminFreeAgentDetailsSchema = module.exports.adminUserDetailsSchema = module.exports.detailedTelemetrySchema = module.exports.detailedDailyTelemetrySchema = module.exports.adminActiveUserOverviewSchema = module.exports.collatedTelemetrySchema = module.exports.accountDetailsSchema = module.exports.accountBillingDetails = module.exports.invoiceDetailsSchema = module.exports.paymentStatusSchema = module.exports.failedPaymentDetailsSchema = module.exports.paymentMethodDetailsSchema = module.exports.paymentMethodBrandSchema = module.exports.BILLING_STATUSES = module.exports.billingStatusSchema = module.exports.userDetailsSchema = void 0;

var $9wYJ6 = parcelRequire("9wYJ6");
const $b6a0d484772b0661$var$nullable = (schema)=>$9wYJ6.Type.Union([
        schema,
        $9wYJ6.Type.Null()
    ]);
module.exports.userDetailsSchema = $9wYJ6.Type.Object({
    companyName: $9wYJ6.Type.String(),
    address: $9wYJ6.Type.String(),
    city: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    state: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    zip: $9wYJ6.Type.String(),
    country: $9wYJ6.Type.String(),
    sites: $9wYJ6.Type.Integer(),
    rfDevices: $9wYJ6.Type.Integer()
});
module.exports.billingStatusSchema = $9wYJ6.Type.Union([
    $9wYJ6.Type.Literal("beta"),
    $9wYJ6.Type.Literal("trial"),
    $9wYJ6.Type.Literal("subscribed"),
    $9wYJ6.Type.Literal("cancelled"),
    $9wYJ6.Type.Literal("failed")
]);
module.exports.BILLING_STATUSES = Object.freeze([
    "beta",
    "trial",
    "subscribed",
    "cancelled",
    "failed"
]);
module.exports.paymentMethodBrandSchema = $9wYJ6.Type.Union([
    $9wYJ6.Type.Literal("amex"),
    $9wYJ6.Type.Literal("diners"),
    $9wYJ6.Type.Literal("discover"),
    $9wYJ6.Type.Literal("jcb"),
    $9wYJ6.Type.Literal("mastercard"),
    $9wYJ6.Type.Literal("unionpay"),
    $9wYJ6.Type.Literal("visa"),
    $9wYJ6.Type.Literal("unknown")
], {
    title: "PaymentMethodBrand"
});
module.exports.paymentMethodDetailsSchema = $9wYJ6.Type.Object({
    brand: module.exports.paymentMethodBrandSchema,
    lastFourDigits: $9wYJ6.Type.String()
}, {
    title: "PaymentMethodDetails"
});
module.exports.failedPaymentDetailsSchema = $9wYJ6.Type.Object({
    reference: $9wYJ6.Type.String(),
    dollars: $9wYJ6.Type.Number(),
    reason: $9wYJ6.Type.String()
}, {
    title: "FailedPaymentDetails"
});
module.exports.paymentStatusSchema = $9wYJ6.Type.Union([
    $9wYJ6.Type.Literal("pending"),
    $9wYJ6.Type.Literal("paid"),
    $9wYJ6.Type.Literal("failed")
], {
    title: "PaymentStatus"
});
module.exports.invoiceDetailsSchema = $9wYJ6.Type.Object({
    id: $9wYJ6.Type.String(),
    reference: $9wYJ6.Type.String(),
    value: $9wYJ6.Type.Number(),
    currency: $9wYJ6.Type.String(),
    status: module.exports.paymentStatusSchema,
    failureReason: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    createdDate: $9wYJ6.Type.String({
        format: "date"
    }),
    paymentDate: $9wYJ6.Type.String({
        format: "date"
    })
}, {
    title: "InvoiceDetails"
});
module.exports.accountBillingDetails = $9wYJ6.Type.Object({
    stripePublicKey: $9wYJ6.Type.String(),
    billingStatus: module.exports.billingStatusSchema,
    dollarsPerDevice: $9wYJ6.Type.Number(),
    userCost: $9wYJ6.Type.Number(),
    paymentMethod: $9wYJ6.Type.Optional(module.exports.paymentMethodDetailsSchema),
    nextPaymentDate: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    licenseExpiresDate: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    evaluation: $9wYJ6.Type.Optional($9wYJ6.Type.Object({
        endDate: $9wYJ6.Type.String(),
        firstBillingDate: $9wYJ6.Type.String()
    })),
    failedPayment: $9wYJ6.Type.Optional(module.exports.failedPaymentDetailsSchema),
    invoices: $9wYJ6.Type.Array(module.exports.invoiceDetailsSchema)
}, {
    title: "AccountBillingDetails"
});
module.exports.accountDetailsSchema = $9wYJ6.Type.Object({
    email: $9wYJ6.Type.String(),
    activatedLicense: $9wYJ6.Type.Boolean(),
    verifiedEmail: $9wYJ6.Type.Boolean(),
    beta: $9wYJ6.Type.Boolean(),
    user: $9wYJ6.Type.Union([
        module.exports.userDetailsSchema,
        $9wYJ6.Type.Null()
    ]),
    licenseKey: $9wYJ6.Type.Union([
        $9wYJ6.Type.String(),
        $9wYJ6.Type.Null()
    ]),
    admin: $9wYJ6.Type.Boolean(),
    billing: module.exports.accountBillingDetails
}, {
    title: "AccountDetails"
});
module.exports.collatedTelemetrySchema = $9wYJ6.Type.Partial($9wYJ6.Type.Object({
    lastActiveDay: $9wYJ6.Type.Optional($9wYJ6.Type.Object({
        activeUsers: $9wYJ6.Type.Number(),
        date: $9wYJ6.Type.String()
    })),
    version: $9wYJ6.Type.String(),
    dataProvider: $9wYJ6.Type.String(),
    lastLogin: $9wYJ6.Type.Optional($9wYJ6.Type.Object({
        date: $9wYJ6.Type.String({
            format: "date"
        }),
        activeUsers: $9wYJ6.Type.Integer()
    }))
}), {
    title: "CollatedTelemetry"
});
module.exports.adminActiveUserOverviewSchema = $9wYJ6.Type.Intersect([
    $9wYJ6.Type.Object({
        id: $9wYJ6.Type.String(),
        email: $9wYJ6.Type.String(),
        companyName: $9wYJ6.Type.String(),
        address: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
        city: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
        state: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
        zip: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
        country: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
        phone: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
        rfDevices: $9wYJ6.Type.Optional($9wYJ6.Type.Integer()),
        sites: $9wYJ6.Type.Optional($9wYJ6.Type.Integer()),
        billingStatus: $9wYJ6.Type.Optional(module.exports.billingStatusSchema),
        evaluation: $9wYJ6.Type.Boolean(),
        lastSuccessfulValidation: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
        nextBillingDate: $9wYJ6.Type.Optional($9wYJ6.Type.String({
            format: "date"
        })),
        stripeCustomer: $9wYJ6.Type.Optional($9wYJ6.Type.String({
            format: "uri"
        })),
        freeagentContact: $9wYJ6.Type.Optional($9wYJ6.Type.String({
            format: "uri"
        }))
    }),
    module.exports.collatedTelemetrySchema
], {
    title: "AdminActiveUserOverview"
});
module.exports.detailedDailyTelemetrySchema = $9wYJ6.Type.Object({
    date: $9wYJ6.Type.String(),
    userIds: $9wYJ6.Type.Array($9wYJ6.Type.String())
});
module.exports.detailedTelemetrySchema = $9wYJ6.Type.Object({
    version: $b6a0d484772b0661$var$nullable($9wYJ6.Type.String()),
    dataProvider: $b6a0d484772b0661$var$nullable($9wYJ6.Type.String()),
    daily: $9wYJ6.Type.Record($9wYJ6.Type.String(), module.exports.detailedDailyTelemetrySchema)
});
module.exports.adminUserDetailsSchema = $9wYJ6.Type.Object({
    id: $9wYJ6.Type.String(),
    email: $9wYJ6.Type.String(),
    companyName: $9wYJ6.Type.String(),
    address: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    city: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    state: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    zip: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    country: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    phone: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    rfDevices: $9wYJ6.Type.Optional($9wYJ6.Type.Integer()),
    sites: $9wYJ6.Type.Optional($9wYJ6.Type.Integer()),
    billingStatus: $9wYJ6.Type.Optional(module.exports.billingStatusSchema),
    evaluation: $9wYJ6.Type.Boolean(),
    lastSuccessfulValidation: $9wYJ6.Type.Optional($9wYJ6.Type.String()),
    nextBillingDate: $9wYJ6.Type.Optional($9wYJ6.Type.String({
        format: "date"
    })),
    cost: $9wYJ6.Type.Union([
        $9wYJ6.Type.Number(),
        $9wYJ6.Type.Null()
    ]),
    freeagentContact: $9wYJ6.Type.Union([
        $9wYJ6.Type.String(),
        $9wYJ6.Type.Null()
    ]),
    stripeCustomer: $9wYJ6.Type.Union([
        $9wYJ6.Type.String(),
        $9wYJ6.Type.Null()
    ]),
    telemetry: $b6a0d484772b0661$var$nullable(module.exports.detailedTelemetrySchema),
    invoices: $9wYJ6.Type.Array(module.exports.invoiceDetailsSchema)
}, {
    title: "AdminUserDetails"
});
module.exports.adminFreeAgentDetailsSchema = $9wYJ6.Type.Object({
    oauthUrl: $9wYJ6.Type.String(),
    connected: $9wYJ6.Type.Boolean()
}, {
    title: "AdminFreeAgentDetails"
});
module.exports.adminBuildDetails = $9wYJ6.Type.Object({
    version: $9wYJ6.Type.String(),
    commit: $9wYJ6.Type.String()
});
module.exports.adminDetailsSchema = $9wYJ6.Type.Object({
    build: module.exports.adminBuildDetails,
    activeUsers: $9wYJ6.Type.Array(module.exports.adminActiveUserOverviewSchema),
    allUserEmailAddresses: $9wYJ6.Type.Array($9wYJ6.Type.String()),
    pendingBetaRequestEmailAddresses: $9wYJ6.Type.Array($9wYJ6.Type.String()),
    unactivatedUserEmailAddresses: $9wYJ6.Type.Array($9wYJ6.Type.String()),
    freeAgent: module.exports.adminFreeAgentDetailsSchema,
    enableDevTools: $9wYJ6.Type.Boolean()
}, {
    title: "AdminDetails"
});

});

parcelRegister("b1Ffx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.STRIPE_API_VERSION = void 0;
module.exports.STRIPE_API_VERSION = "2022-08-01";

});


var $VqyUd = parcelRequire("VqyUd");
var $5e197c2ea48466dd$var$o = 0;
function $5e197c2ea48466dd$export$34b9dba7ce09269b(_, e, n, t, f) {
    var l, s, u = {};
    for(s in e)"ref" == s ? l = e[s] : u[s] = e[s];
    var a = {
        type: _,
        props: u,
        key: n,
        ref: l,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$5e197c2ea48466dd$var$o,
        __source: f,
        __self: t
    };
    if ("function" == typeof _ && (l = _.defaultProps)) for(s in l)void 0 === u[s] && (u[s] = l[s]);
    return (0, $VqyUd.options).vnode && (0, $VqyUd.options).vnode(a), a;
}


var $de58f1ac2263029a$exports = {};
!function(t, e) {
    $de58f1ac2263029a$exports = e();
}($de58f1ac2263029a$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, g = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, f), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), f);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: f,
                y: c,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: h
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, v = "en", D = {};
    D[v] = M;
    var p = function(t) {
        return t instanceof _;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return v;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (v = i), i || !r && v;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, O = g;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match(l);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === $);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, h = O.p(t), $ = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, l = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, g = "set" + (this.$u ? "UTC" : "");
            switch(h){
                case c:
                    return r ? $(1, 0) : $(31, 11);
                case f:
                    return r ? $(1, M) : $(0, M + 1);
                case o:
                    var v = this.$locale().weekStart || 0, D = (y < v ? y + 7 : y) - v;
                    return $(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return l(g + "Hours", 0);
                case u:
                    return l(g + "Minutes", 1);
                case s:
                    return l(g + "Seconds", 2);
                case i:
                    return l(g + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), h = "set" + (this.$u ? "UTC" : ""), $ = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o], l = o === a ? this.$D + (e - this.$W) : e;
            if (o === f || o === c) {
                var y = this.clone().set(d, 1);
                y.$d[$](l), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else $ && this.$d[$](l);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, h) {
            var d, $ = this;
            r = Number(r);
            var l = O.p(h), y = function(t) {
                var e = w($);
                return O.w(e.date(e.date() + Math.round(t * r)), $);
            };
            if (l === f) return this.set(f, this.$M + r);
            if (l === c) return this.set(c, this.$y + r);
            if (l === a) return y(1);
            if (l === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[l] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || $;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, f = n.months, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, c = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, d = n.meridiem || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            }, l = {
                YY: String(this.$y).slice(-2),
                YYYY: this.$y,
                M: a + 1,
                MM: O.s(a + 1, 2, "0"),
                MMM: h(n.monthsShort, a, f, 3),
                MMMM: h(f, a),
                D: this.$D,
                DD: O.s(this.$D, 2, "0"),
                d: String(this.$W),
                dd: h(n.weekdaysMin, this.$W, o, 2),
                ddd: h(n.weekdaysShort, this.$W, o, 3),
                dddd: o[this.$W],
                H: String(s),
                HH: O.s(s, 2, "0"),
                h: c(1),
                hh: c(2),
                a: d(s, u, !0),
                A: d(s, u, !1),
                m: String(u),
                mm: O.s(u, 2, "0"),
                s: String(this.$s),
                ss: O.s(this.$s, 2, "0"),
                SSS: O.s(this.$ms, 3, "0"),
                Z: i
            };
            return r.replace(y, function(t, e) {
                return e || l[t] || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, $) {
            var l, y = O.p(d), M = w(r), m = (M.utcOffset() - this.utcOffset()) * e, g = this - M, v = O.m(this, M);
            return v = (l = {}, l[c] = v / 12, l[f] = v, l[h] = v / 3, l[o] = (g - m) / 6048e5, l[a] = (g - m) / 864e5, l[u] = g / n, l[s] = g / e, l[i] = g / t, l)[y] || g, $ ? v : O.a(v);
        }, m.daysInMonth = function() {
            return this.endOf(f).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), T = _.prototype;
    return w.prototype = T, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            f
        ],
        [
            "$y",
            c
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        T[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, _, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[v], w.Ls = D, w.p = {}, w;
});


var $f156be45b5981189$exports = {};
!function(r, e) {
    $f156be45b5981189$exports = e();
}($f156be45b5981189$exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});



var $VqyUd = parcelRequire("VqyUd");

var $8ea62fef91697031$exports = {};
"use strict";
var $8ea62fef91697031$var$__createBinding = $8ea62fef91697031$exports && $8ea62fef91697031$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ea62fef91697031$var$__exportStar = $8ea62fef91697031$exports && $8ea62fef91697031$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8ea62fef91697031$var$__createBinding(exports1, m, p);
};
Object.defineProperty($8ea62fef91697031$exports, "__esModule", {
    value: true
});

$8ea62fef91697031$var$__exportStar((parcelRequire("7mY6J")), $8ea62fef91697031$exports);

$8ea62fef91697031$var$__exportStar((parcelRequire("fDLr8")), $8ea62fef91697031$exports);



var $VqyUd = parcelRequire("VqyUd");
var $378f8733f7648194$var$EMPTY$1 = {};
function $378f8733f7648194$var$assign(obj, props) {
    // eslint-disable-next-line guard-for-in
    for(var i in props)obj[i] = props[i];
    return obj;
}
function $378f8733f7648194$export$78e3044358792147(url, route, opts) {
    var reg = /(?:\?([^#]*))?(#.*)?$/, c = url.match(reg), matches = {}, ret;
    if (c && c[1]) {
        var p = c[1].split("&");
        for(var i = 0; i < p.length; i++){
            var r = p[i].split("=");
            matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join("="));
        }
    }
    url = $378f8733f7648194$var$segmentize(url.replace(reg, ""));
    route = $378f8733f7648194$var$segmentize(route || "");
    var max = Math.max(url.length, route.length);
    for(var i$1 = 0; i$1 < max; i$1++){
        if (route[i$1] && route[i$1].charAt(0) === ":") {
            var param = route[i$1].replace(/(^:|[+*?]+$)/g, ""), flags = (route[i$1].match(/[+*?]+$/) || $378f8733f7648194$var$EMPTY$1)[0] || "", plus = ~flags.indexOf("+"), star = ~flags.indexOf("*"), val = url[i$1] || "";
            if (!val && !star && (flags.indexOf("?") < 0 || plus)) {
                ret = false;
                break;
            }
            matches[param] = decodeURIComponent(val);
            if (plus || star) {
                matches[param] = url.slice(i$1).map(decodeURIComponent).join("/");
                break;
            }
        } else if (route[i$1] !== url[i$1]) {
            ret = false;
            break;
        }
    }
    if (opts.default !== true && ret === false) return false;
    return matches;
}
function $378f8733f7648194$var$pathRankSort(a, b) {
    return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}
// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function $378f8733f7648194$var$prepareVNodeForRanking(vnode, index) {
    vnode.index = index;
    vnode.rank = $378f8733f7648194$var$rankChild(vnode);
    return vnode.props;
}
function $378f8733f7648194$var$segmentize(url) {
    return url.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $378f8733f7648194$var$rankSegment(segment) {
    return segment.charAt(0) == ":" ? 1 + "*+?".indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}
function $378f8733f7648194$var$rank(path) {
    return $378f8733f7648194$var$segmentize(path).map($378f8733f7648194$var$rankSegment).join("");
}
function $378f8733f7648194$var$rankChild(vnode) {
    return vnode.props.default ? 0 : $378f8733f7648194$var$rank(vnode.props.path);
}
var $378f8733f7648194$var$customHistory = null;
var $378f8733f7648194$var$ROUTERS = [];
var $378f8733f7648194$export$bae87ececa397a84 = [];
var $378f8733f7648194$var$EMPTY = {};
function $378f8733f7648194$var$setUrl(url, type) {
    if (type === void 0) type = "push";
    if ($378f8733f7648194$var$customHistory && $378f8733f7648194$var$customHistory[type]) $378f8733f7648194$var$customHistory[type](url);
    else if (typeof history !== "undefined" && history[type + "State"]) history[type + "State"](null, null, url);
}
function $378f8733f7648194$export$dc90482e4ef07afd() {
    var url;
    if ($378f8733f7648194$var$customHistory && $378f8733f7648194$var$customHistory.location) url = $378f8733f7648194$var$customHistory.location;
    else if ($378f8733f7648194$var$customHistory && $378f8733f7648194$var$customHistory.getCurrentLocation) url = $378f8733f7648194$var$customHistory.getCurrentLocation();
    else url = typeof location !== "undefined" ? location : $378f8733f7648194$var$EMPTY;
    return "" + (url.pathname || "") + (url.search || "");
}
function $378f8733f7648194$export$4cb887bfde2d34ca(url, replace) {
    if (replace === void 0) replace = false;
    if (typeof url !== "string" && url.url) {
        replace = url.replace;
        url = url.url;
    }
    // only push URL into history if we can handle it
    if ($378f8733f7648194$var$canRoute(url)) $378f8733f7648194$var$setUrl(url, replace ? "replace" : "push");
    return $378f8733f7648194$var$routeTo(url);
}
/** Check if the given URL can be handled by any router instances. */ function $378f8733f7648194$var$canRoute(url) {
    for(var i = $378f8733f7648194$var$ROUTERS.length; i--;){
        if ($378f8733f7648194$var$ROUTERS[i].canRoute(url)) return true;
    }
    return false;
}
/** Tell all router instances to handle the given URL.  */ function $378f8733f7648194$var$routeTo(url) {
    var didRoute = false;
    for(var i = 0; i < $378f8733f7648194$var$ROUTERS.length; i++)if ($378f8733f7648194$var$ROUTERS[i].routeTo(url) === true) didRoute = true;
    for(var i$1 = $378f8733f7648194$export$bae87ececa397a84.length; i$1--;)$378f8733f7648194$export$bae87ececa397a84[i$1](url);
    return didRoute;
}
function $378f8733f7648194$var$routeFromLink(node) {
    // only valid elements
    if (!node || !node.getAttribute) return;
    var href = node.getAttribute("href"), target = node.getAttribute("target");
    // ignore links with targets and non-path URLs
    if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) return;
    // attempt to route, if no match simply cede control to browser
    return $378f8733f7648194$export$4cb887bfde2d34ca(href);
}
function $378f8733f7648194$var$handleLinkClick(e) {
    if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) return;
    $378f8733f7648194$var$routeFromLink(e.currentTarget || e.target || this);
    return $378f8733f7648194$var$prevent(e);
}
function $378f8733f7648194$var$prevent(e) {
    if (e) {
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (e.stopPropagation) e.stopPropagation();
        e.preventDefault();
    }
    return false;
}
function $378f8733f7648194$var$delegateLinkHandler(e) {
    // ignore events the browser takes care of already:
    if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) return;
    var t = e.target;
    do if (String(t.nodeName).toUpperCase() === "A" && t.getAttribute("href")) {
        if (t.hasAttribute("native")) return;
        // if link is handled by the router, prevent browser defaults
        if ($378f8733f7648194$var$routeFromLink(t)) return $378f8733f7648194$var$prevent(e);
    }
    while (t = t.parentNode);
}
var $378f8733f7648194$var$eventListenersInitialized = false;
function $378f8733f7648194$var$initEventListeners() {
    if ($378f8733f7648194$var$eventListenersInitialized) return;
    if (typeof addEventListener === "function") {
        if (!$378f8733f7648194$var$customHistory) addEventListener("popstate", function() {
            $378f8733f7648194$var$routeTo($378f8733f7648194$export$dc90482e4ef07afd());
        });
        addEventListener("click", $378f8733f7648194$var$delegateLinkHandler);
    }
    $378f8733f7648194$var$eventListenersInitialized = true;
}
var $378f8733f7648194$export$55185c17a0fcbe46 = function(Component$$1) {
    function Router(props) {
        Component$$1.call(this, props);
        if (props.history) $378f8733f7648194$var$customHistory = props.history;
        this.state = {
            url: props.url || $378f8733f7648194$export$dc90482e4ef07afd()
        };
        $378f8733f7648194$var$initEventListeners();
    }
    if (Component$$1) Router.__proto__ = Component$$1;
    Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
    Router.prototype.constructor = Router;
    Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (props.static !== true) return true;
        return props.url !== this.props.url || props.onChange !== this.props.onChange;
    };
    /** Check if the given URL can be matched against any children */ Router.prototype.canRoute = function canRoute(url) {
        var children = (0, $VqyUd.toChildArray)(this.props.children);
        return this.getMatchingChildren(children, url, false).length > 0;
    };
    /** Re-render children with a new URL to match against. */ Router.prototype.routeTo = function routeTo(url) {
        this.setState({
            url: url
        });
        var didRoute = this.canRoute(url);
        // trigger a manual re-route if we're not in the middle of an update:
        if (!this.updating) this.forceUpdate();
        return didRoute;
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        $378f8733f7648194$var$ROUTERS.push(this);
        this.updating = true;
    };
    Router.prototype.componentDidMount = function componentDidMount() {
        var this$1 = this;
        if ($378f8733f7648194$var$customHistory) this.unlisten = $378f8733f7648194$var$customHistory.listen(function(location1) {
            this$1.routeTo("" + (location1.pathname || "") + (location1.search || ""));
        });
        this.updating = false;
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        if (typeof this.unlisten === "function") this.unlisten();
        $378f8733f7648194$var$ROUTERS.splice($378f8733f7648194$var$ROUTERS.indexOf(this), 1);
    };
    Router.prototype.componentWillUpdate = function componentWillUpdate() {
        this.updating = true;
    };
    Router.prototype.componentDidUpdate = function componentDidUpdate() {
        this.updating = false;
    };
    Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
        return children.filter($378f8733f7648194$var$prepareVNodeForRanking).sort($378f8733f7648194$var$pathRankSort).map(function(vnode) {
            var matches = $378f8733f7648194$export$78e3044358792147(url, vnode.props.path, vnode.props);
            if (matches) {
                if (invoke !== false) {
                    var newProps = {
                        url: url,
                        matches: matches
                    };
                    $378f8733f7648194$var$assign(newProps, matches);
                    delete newProps.ref;
                    delete newProps.key;
                    return (0, $VqyUd.cloneElement)(vnode, newProps);
                }
                return vnode;
            }
        }).filter(Boolean);
    };
    Router.prototype.render = function render(ref, ref$1) {
        var children = ref.children;
        var onChange = ref.onChange;
        var url = ref$1.url;
        var active = this.getMatchingChildren((0, $VqyUd.toChildArray)(children), url, true);
        var current = active[0] || null;
        var previous = this.previousUrl;
        if (url !== previous) {
            this.previousUrl = url;
            if (typeof onChange === "function") onChange({
                router: this,
                url: url,
                previous: previous,
                active: active,
                current: current
            });
        }
        return current;
    };
    return Router;
}((0, $VqyUd.Component));
var $378f8733f7648194$export$a6c7ac8248d6e38a = function(props) {
    return (0, $VqyUd.createElement)("a", $378f8733f7648194$var$assign({
        onClick: $378f8733f7648194$var$handleLinkClick
    }, props));
};
var $378f8733f7648194$export$e7b0ac011bb776c6 = function(props) {
    return (0, $VqyUd.createElement)(props.component, props);
};
$378f8733f7648194$export$55185c17a0fcbe46.subscribers = $378f8733f7648194$export$bae87ececa397a84;
$378f8733f7648194$export$55185c17a0fcbe46.getCurrentUrl = $378f8733f7648194$export$dc90482e4ef07afd;
$378f8733f7648194$export$55185c17a0fcbe46.route = $378f8733f7648194$export$4cb887bfde2d34ca;
$378f8733f7648194$export$55185c17a0fcbe46.Router = $378f8733f7648194$export$55185c17a0fcbe46;
$378f8733f7648194$export$55185c17a0fcbe46.Route = $378f8733f7648194$export$e7b0ac011bb776c6;
$378f8733f7648194$export$55185c17a0fcbe46.Link = $378f8733f7648194$export$a6c7ac8248d6e38a;
$378f8733f7648194$export$55185c17a0fcbe46.exec = $378f8733f7648194$export$78e3044358792147;
var $378f8733f7648194$export$2e2bcd8739ae039 = $378f8733f7648194$export$55185c17a0fcbe46;


var $3b7ab8236e0b6611$exports = {};
$parcel$export($3b7ab8236e0b6611$exports, "useAccountController", function () { return $f57fa0ee256b0db7$export$aaec80e085d54cbe; });
$parcel$export($3b7ab8236e0b6611$exports, "useAccountDetails", function () { return $f57fa0ee256b0db7$export$9976db6a0382a0c7; });
$parcel$export($3b7ab8236e0b6611$exports, "useAdminController", function () { return $f57fa0ee256b0db7$export$c05e53a76d53ff2d; });
$parcel$export($3b7ab8236e0b6611$exports, "useAdminDetails", function () { return $f57fa0ee256b0db7$export$4c949b1d75869f5a; });
$parcel$export($3b7ab8236e0b6611$exports, "useAuthController", function () { return $f57fa0ee256b0db7$export$2ddc77f16875382c; });
$parcel$export($3b7ab8236e0b6611$exports, "useBillingController", function () { return $f57fa0ee256b0db7$export$fae87f616b8b2f3c; });
$parcel$export($3b7ab8236e0b6611$exports, "useControllers", function () { return $f57fa0ee256b0db7$export$8b376ee89da7718b; });
$parcel$export($3b7ab8236e0b6611$exports, "useErrorController", function () { return $f57fa0ee256b0db7$export$e602918cb3d99338; });
var $ced247092cf431ef$exports = {};

$parcel$export($ced247092cf431ef$exports, "AccountController", function () { return $ced247092cf431ef$export$3a40b83c1282ee40; });
function $db82f5dd284aabac$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $f5c6df13714dee15$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $30fb72b9782bcd33$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $f5c6df13714dee15$export$20c20a422940e173)(receiver, privateMap, "get");
    return (0, $db82f5dd284aabac$export$184ff5d81c0e5775)(receiver, descriptor);
}


function $b3c39904e7028a8d$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $f519eca4b2e78dd4$export$e235798705076415(obj, privateMap, value) {
    (0, $b3c39904e7028a8d$export$6b10452b5ac97eba)(obj, privateMap);
    privateMap.set(obj, value);
}


function $a1888051128e48d8$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $5d238b5a663b7ba4$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $f5c6df13714dee15$export$20c20a422940e173)(receiver, privateMap, "set");
    (0, $a1888051128e48d8$export$b7b24cdba6bcb11c)(receiver, descriptor, value);
    return value;
}


function $5830e53916a6c4df$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



class $dfa398380817d4fd$export$8a9c04b0629a0419 extends Error {
    constructor(path){
        super("Unauthorized " + path);
        this.name = "401";
    }
}
class $dfa398380817d4fd$export$6d7c35f6d47c9072 extends Error {
    constructor(path){
        super("Forbidden " + path);
        this.name = "403";
    }
}
class $dfa398380817d4fd$export$dc890958d2b428da {
    async fetchRaw(method, path, body) {
        path = "/api" + path;
        const headers = {};
        if (body) headers["content-type"] = "application/json";
        const response = await fetch(path, {
            method: method,
            headers: headers,
            body: body && JSON.stringify(body)
        });
        switch(response.status){
            case 401:
                throw new $dfa398380817d4fd$export$8a9c04b0629a0419(path);
            case 403:
                throw new $dfa398380817d4fd$export$6d7c35f6d47c9072(path);
            default:
                return response;
        }
    }
    async fetch(method, path, body) {
        const response = await this.fetchRaw(method, path, body);
        if (!response.ok) throw new Error(`Bad response from ${method} ${path}: ${response.status} ${response.statusText}}`);
        return response.json();
    }
    async login(loginRequest) {
        try {
            await this.fetch("POST", "/session", loginRequest);
            return true;
        } catch (err) {
            if (err instanceof $dfa398380817d4fd$export$8a9c04b0629a0419) return false;
            throw err;
        }
    }
    async logout() {
        await this.fetch("DELETE", "/session");
    }
    async signup(request) {
        const response = await this.fetchRaw("POST", "/users", request);
        return response.json();
    }
    async changePassword(request) {
        const response = await this.fetchRaw("PUT", "/users/active/password", request);
        if (response.ok) return "ok";
        const body = await response.json();
        return body.error;
    }
    async verifyEmail(request) {
        const response = await this.fetchRaw("POST", "/users/active/verify-email", request);
        if (response.ok) return "ok";
        const body = await response.json();
        return body.error;
    }
    async resendVerificationEmail() {
        const response = await this.fetchRaw("POST", "/users/active/resend-verification-email");
        return response.ok;
    }
    async requestPasswordReset(request) {
        await this.fetch("POST", "/users/reset-password", request);
    }
    async checkPasswordResetCode(code) {
        const response = await this.fetchRaw("GET", `/users/reset-password/${code}`);
        return response.ok;
    }
    async resetPassword(code, password) {
        const response = await this.fetchRaw("POST", `/users/reset-password/${code}`, {
            password: password
        });
        if (response.ok) return "ok";
        const body = await response.json();
        return body.error;
    }
    getAccountDetails() {
        return this.fetch("GET", "/account");
    }
    async activateBilling() {
        return this.fetch("POST", "/billing");
    }
    async updatePaymentMethod() {
        return this.fetch("PUT", "/billing");
    }
    async cancelBilling() {
        return this.fetch("DELETE", "/billing");
    }
    async retryFailedPayment() {
        return this.fetch("POST", "/billing/retry");
    }
    async getAdmin() {
        const response = await this.fetchRaw("GET", "/admin");
        if (!response.ok) return null;
        return response.json();
    }
    async getPendingPayment() {
        const response = await this.fetchRaw("GET", "/billing/pending-payment");
        return response.ok;
    }
    async clientError(details) {
        try {
            await this.fetchRaw("POST", "/client-error", details);
        } catch  {
        // Bad times.
        }
    }
}




var $ced247092cf431ef$var$_state;
var $ced247092cf431ef$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ced247092cf431ef$export$3a40b83c1282ee40 = ($ced247092cf431ef$var$_state = /*#__PURE__*/ new WeakMap(), class AccountController {
    get state() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $ced247092cf431ef$var$_state);
    }
    set state(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $ced247092cf431ef$var$_state, value);
    }
    refreshDetails() {
        var _this_refreshPromise;
        return (_this_refreshPromise = this.refreshPromise) !== null && _this_refreshPromise !== void 0 ? _this_refreshPromise : this.refreshPromise = this.doRefreshDetails();
    }
    async doRefreshDetails() {
        this.state = {
            kind: "loading",
            details: null
        };
        try {
            const details = await this.api.getAccountDetails();
            this.state = {
                kind: "ok",
                details: details
            };
        } catch (err) {
            if (err instanceof (0, $dfa398380817d4fd$export$8a9c04b0629a0419)) {
                this.state = {
                    kind: "unauthorized",
                    details: null
                };
                return;
            }
            throw err;
        } finally{
            this.refreshPromise = null;
        }
    }
    async resendVerificationEmail() {
        const result = await this.api.resendVerificationEmail();
        if (!result) this.refreshDetails();
    }
    async verifyEmail(request) {
        const result = await this.api.verifyEmail(request);
        if (result === "ok") this.refreshDetails();
        return result;
    }
    constructor({ api: api }){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "api", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "refreshPromise", null);
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $ced247092cf431ef$var$_state, {
            writable: true,
            value: {
                kind: "loading",
                details: null
            }
        });
        this.api = api;
    }
});
$ced247092cf431ef$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $ced247092cf431ef$export$3a40b83c1282ee40.prototype, "state", null);
$ced247092cf431ef$export$3a40b83c1282ee40 = $ced247092cf431ef$var$__decorate([
    (0, $8ea62fef91697031$exports.subject)()
], $ced247092cf431ef$export$3a40b83c1282ee40);



class $e20cc98c4082f284$export$862a273d408fe7a1 {
    async login(request) {
        const success = await this.api.login(request);
        if (success) this.accountController.refreshDetails();
        return success;
    }
    async logout() {
        await this.api.logout();
        window.location.reload();
    }
    async signup(request) {
        const response = await this.api.signup({
            ...request,
            referredBy: this.referralController.referredBy
        });
        if (response.ok) this.accountController.refreshDetails();
        return response;
    }
    changePassword(request) {
        return this.api.changePassword(request);
    }
    requestPasswordReset(request) {
        return this.api.requestPasswordReset(request);
    }
    checkPasswordResetCode(code) {
        return this.api.checkPasswordResetCode(code);
    }
    resetPassword(code, password) {
        return this.api.resetPassword(code, password);
    }
    constructor({ api: api, accountController: accountController, referralController: referralController }){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "api", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "accountController", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "referralController", void 0);
        this.api = api;
        this.accountController = accountController;
        this.referralController = referralController;
    }
}




var $VqyUd = parcelRequire("VqyUd");

var $f6LVE = parcelRequire("f6LVE");

var $f6LVE = parcelRequire("f6LVE");

const $f2b6ead6de480949$export$e926676385687eaf = ({ children: children })=>{
    const errorController = (0, $f57fa0ee256b0db7$export$e602918cb3d99338)();
    const [error] = (0, $f6LVE.useErrorBoundary)();
    (0, $f6LVE.useEffect)(()=>{
        if (error) errorController.handleError(error, "component error boundary");
    }, [
        error,
        errorController
    ]);
    return children;
};



const $7d3f392fa48145f5$export$3dc27271f5d5c629 = (value, currency = "USD")=>new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency
    }).format(value);
const $7d3f392fa48145f5$export$3ae94a2503e890a1 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(date).format("D MMMM YYYY");
const $7d3f392fa48145f5$export$1431bc52824a265 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(date).toISOString().split("T")[0];


class $0a3e95917c2f7450$export$2970af845c2cbd28 extends Error {
    constructor(contextName, providerName){
        super(`${contextName} was null; missing <${providerName}>?`);
        this.name = "NullContextError";
    }
}


const $c64636a6d31161a0$export$83e74882c5df8fe1 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));



var $f6LVE = parcelRequire("f6LVE");
const $57ef02025d2ad4a3$export$a9c05560d717b4fe = (ref)=>{
    (0, $f6LVE.useLayoutEffect)(()=>{
        var _ref_current;
        (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (0, $f6LVE.useMemo)(()=>({
            refocus: ()=>{
                var _ref_current;
                return (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
            }
        }), [
        ref
    ]);
};



var $f6LVE = parcelRequire("f6LVE");
const $2f867275e97da052$var$BREAKPOINTS = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
const $2f867275e97da052$var$isBreakpoint = (breakpoint)=>{
    const minWidth = $2f867275e97da052$var$BREAKPOINTS[breakpoint];
    return window.innerWidth > minWidth;
};
const $2f867275e97da052$export$199d6754bdf4e1e3 = (breakpoint)=>{
    const [match, setMatch] = (0, $f6LVE.useState)($2f867275e97da052$var$isBreakpoint(breakpoint));
    (0, $f6LVE.useEffect)(()=>{
        const handleResize = ()=>{
            setMatch($2f867275e97da052$var$isBreakpoint(breakpoint));
        };
        handleResize();
        window.addEventListener("resize", handleResize, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        breakpoint
    ]);
    return match;
};



var $f6LVE = parcelRequire("f6LVE");
const $a53afc0516d42e77$export$fe4300aa8eebea86 = (fn)=>{
    const ref = (0, $f6LVE.useRef)();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
};


const $0252c182fb6e34bb$export$b931b78cbb3caf86 = (value)=>value === undefined || value === null;
const $0252c182fb6e34bb$export$f3318661327e642b = (value)=>value !== undefined && value !== null;





var $e2b39599c6d011e6$exports = {};

$parcel$export($e2b39599c6d011e6$exports, "ErrorController", function () { return $e2b39599c6d011e6$export$2f5b22783539ff2; });





var $e2b39599c6d011e6$var$_error;
var $e2b39599c6d011e6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e2b39599c6d011e6$export$2f5b22783539ff2 = ($e2b39599c6d011e6$var$_error = /*#__PURE__*/ new WeakMap(), class ErrorController {
    get error() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $e2b39599c6d011e6$var$_error);
    }
    set error(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $e2b39599c6d011e6$var$_error, value);
    }
    handleError(err, type) {
        const error = err instanceof Error ? err : new Error("(non-error) " + String(err));
        if (!this.shouldReportError(error)) return;
        this.error = error;
        this.api.clientError({
            type: type,
            path: window.location.pathname,
            name: this.error.name,
            message: this.error.message,
            stack: this.error.stack
        });
    }
    shouldReportError(error) {
        var _error_stack;
        if ((_error_stack = error.stack) === null || _error_stack === void 0 ? void 0 : _error_stack.includes("chrome-extension://")) return false;
        return true;
    }
    constructor({ api: api }){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "api", void 0);
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $e2b39599c6d011e6$var$_error, {
            writable: true,
            value: null
        });
        this.api = api;
        window.addEventListener("unhandledrejection", (ev)=>{
            console.error("unhandledrejection:", ev.reason); // eslint-disable-line no-console
            this.handleError(ev.reason, "unhandled rejection");
        });
        window.addEventListener("error", (ev)=>{
            console.error("error:", ev.error); // eslint-disable-line no-console
            this.handleError(ev.error, "uncaught exception");
        });
    }
});
$e2b39599c6d011e6$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $e2b39599c6d011e6$export$2f5b22783539ff2.prototype, "error", null);
$e2b39599c6d011e6$var$__decorate([
    (0, $8ea62fef91697031$exports.callback)
], $e2b39599c6d011e6$export$2f5b22783539ff2.prototype, "handleError", null);
$e2b39599c6d011e6$export$2f5b22783539ff2 = $e2b39599c6d011e6$var$__decorate([
    (0, $8ea62fef91697031$exports.subject)()
], $e2b39599c6d011e6$export$2f5b22783539ff2);


var $c1535f7b845fbcbc$exports = {};

$parcel$export($c1535f7b845fbcbc$exports, "BillingController", function () { return $c1535f7b845fbcbc$export$f543bd2595490e8a; });




var $c3415196ad8b3cb3$var$V3_URL = "https://js.stripe.com/v3";
var $c3415196ad8b3cb3$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $c3415196ad8b3cb3$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $c3415196ad8b3cb3$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($c3415196ad8b3cb3$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$c3415196ad8b3cb3$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $c3415196ad8b3cb3$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($c3415196ad8b3cb3$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $c3415196ad8b3cb3$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "1.38.1",
        startTime: startTime
    });
};
var $c3415196ad8b3cb3$var$stripePromise = null;
var $c3415196ad8b3cb3$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($c3415196ad8b3cb3$var$stripePromise !== null) return $c3415196ad8b3cb3$var$stripePromise;
    $c3415196ad8b3cb3$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($c3415196ad8b3cb3$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $c3415196ad8b3cb3$var$findScript();
            if (script && params) console.warn($c3415196ad8b3cb3$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $c3415196ad8b3cb3$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $c3415196ad8b3cb3$var$stripePromise;
};
var $c3415196ad8b3cb3$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $c3415196ad8b3cb3$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $c3415196ad8b3cb3$var$stripePromise$1 = Promise.resolve().then(function() {
    return $c3415196ad8b3cb3$var$loadScript(null);
});
var $c3415196ad8b3cb3$var$loadCalled = false;
$c3415196ad8b3cb3$var$stripePromise$1["catch"](function(err) {
    if (!$c3415196ad8b3cb3$var$loadCalled) console.warn(err);
});
var $c3415196ad8b3cb3$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $c3415196ad8b3cb3$var$loadCalled = true;
    var startTime = Date.now();
    return $c3415196ad8b3cb3$var$stripePromise$1.then(function(maybeStripe) {
        return $c3415196ad8b3cb3$var$initStripe(maybeStripe, args, startTime);
    });
};



var $1b8b27df5a28f85a$exports = {};
"use strict";
var $1b8b27df5a28f85a$var$__createBinding = $1b8b27df5a28f85a$exports && $1b8b27df5a28f85a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1b8b27df5a28f85a$var$__exportStar = $1b8b27df5a28f85a$exports && $1b8b27df5a28f85a$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1b8b27df5a28f85a$var$__createBinding(exports1, m, p);
};
Object.defineProperty($1b8b27df5a28f85a$exports, "__esModule", {
    value: true
});

$1b8b27df5a28f85a$var$__exportStar((parcelRequire("iFBku")), $1b8b27df5a28f85a$exports);

$1b8b27df5a28f85a$var$__exportStar((parcelRequire("aKQ0E")), $1b8b27df5a28f85a$exports);

$1b8b27df5a28f85a$var$__exportStar((parcelRequire("fG7NL")), $1b8b27df5a28f85a$exports);

$1b8b27df5a28f85a$var$__exportStar((parcelRequire("b1Ffx")), $1b8b27df5a28f85a$exports);



var $c1535f7b845fbcbc$var$_activateBillingLoading, $c1535f7b845fbcbc$var$_loadingStatus, $c1535f7b845fbcbc$var$_billingLoading, $c1535f7b845fbcbc$var$_paymentMethodLoading, $c1535f7b845fbcbc$var$_stripe;
var $c1535f7b845fbcbc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c1535f7b845fbcbc$export$f543bd2595490e8a = ($c1535f7b845fbcbc$var$_activateBillingLoading = /*#__PURE__*/ new WeakMap(), $c1535f7b845fbcbc$var$_loadingStatus = /*#__PURE__*/ new WeakMap(), $c1535f7b845fbcbc$var$_billingLoading = /*#__PURE__*/ new WeakMap(), $c1535f7b845fbcbc$var$_paymentMethodLoading = /*#__PURE__*/ new WeakMap(), $c1535f7b845fbcbc$var$_stripe = /*#__PURE__*/ new WeakMap(), class BillingController {
    get activateBillingLoading() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $c1535f7b845fbcbc$var$_activateBillingLoading);
    }
    set activateBillingLoading(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $c1535f7b845fbcbc$var$_activateBillingLoading, value);
    }
    get loadingStatus() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $c1535f7b845fbcbc$var$_loadingStatus);
    }
    set loadingStatus(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $c1535f7b845fbcbc$var$_loadingStatus, value);
    }
    get billingLoading() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $c1535f7b845fbcbc$var$_billingLoading);
    }
    set billingLoading(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $c1535f7b845fbcbc$var$_billingLoading, value);
    }
    get paymentMethodLoading() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $c1535f7b845fbcbc$var$_paymentMethodLoading);
    }
    set paymentMethodLoading(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $c1535f7b845fbcbc$var$_paymentMethodLoading, value);
    }
    async getStripeClient() {
        if (this.accountController.state.kind !== "ok") {
            (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $c1535f7b845fbcbc$var$_stripe, null);
            throw new Error(`Cannot get stripe controller in account state "${this.accountController.state.kind}"`);
        }
        if (!(0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $c1535f7b845fbcbc$var$_stripe)) {
            const { stripePublicKey: stripePublicKey } = this.accountController.state.details.billing;
            (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $c1535f7b845fbcbc$var$_stripe, await (0, $c3415196ad8b3cb3$export$de80f7562c3fd6b1)(stripePublicKey, {
                apiVersion: (0, $1b8b27df5a28f85a$exports.STRIPE_API_VERSION)
            }));
            if (!(0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $c1535f7b845fbcbc$var$_stripe)) throw new Error("loadStripe() resolved to null");
        }
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $c1535f7b845fbcbc$var$_stripe);
    }
    async activateBilling() {
        this.loadingStatus = "activate-billing";
        try {
            const result = await this.api.activateBilling();
            if (!result.requiresCheckout) {
                await this.accountController.refreshDetails();
                return;
            }
            const stripe = await this.getStripeClient();
            await stripe.redirectToCheckout({
                sessionId: result.checkoutSessionId
            });
        } finally{
            this.loadingStatus = false;
        }
    }
    async updatePaymentMethod() {
        this.loadingStatus = "payment-method";
        try {
            const result = await this.api.updatePaymentMethod();
            const stripe = await this.getStripeClient();
            await stripe.redirectToCheckout({
                sessionId: result.checkoutSessionId
            });
        } finally{
            this.loadingStatus = false;
        }
    }
    async cancelBilling() {
        this.loadingStatus = "cancel-billing";
        try {
            await this.api.cancelBilling();
            await this.accountController.refreshDetails();
        } finally{
            this.loadingStatus = false;
        }
    }
    async retryFailedPayment() {
        this.loadingStatus = "retry-failed-payment";
        try {
            await this.api.retryFailedPayment();
            await this.accountController.refreshDetails();
        } finally{
            this.loadingStatus = false;
        }
    }
    async waitForPendingPaymentsToComplete(signal) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) return;
        if (await this.api.getPendingPayment()) {
            await (0, $c64636a6d31161a0$export$83e74882c5df8fe1)(400);
            return this.waitForPendingPaymentsToComplete(signal);
        }
    }
    constructor({ api: api, accountController: accountController }){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "api", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "accountController", void 0);
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $c1535f7b845fbcbc$var$_activateBillingLoading, {
            writable: true,
            value: false
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $c1535f7b845fbcbc$var$_loadingStatus, {
            writable: true,
            value: false
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $c1535f7b845fbcbc$var$_billingLoading, {
            writable: true,
            value: false
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $c1535f7b845fbcbc$var$_paymentMethodLoading, {
            writable: true,
            value: false
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $c1535f7b845fbcbc$var$_stripe, {
            writable: true,
            value: null
        });
        this.api = api;
        this.accountController = accountController;
    }
});
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "activateBillingLoading", null);
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "loadingStatus", null);
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "billingLoading", null);
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "paymentMethodLoading", null);
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.callback)
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "activateBilling", null);
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.callback)
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "updatePaymentMethod", null);
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.callback)
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "cancelBilling", null);
$c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.callback)
], $c1535f7b845fbcbc$export$f543bd2595490e8a.prototype, "retryFailedPayment", null);
$c1535f7b845fbcbc$export$f543bd2595490e8a = $c1535f7b845fbcbc$var$__decorate([
    (0, $8ea62fef91697031$exports.subject)()
], $c1535f7b845fbcbc$export$f543bd2595490e8a);


var $e80d55d4784727b6$exports = {};

$parcel$export($e80d55d4784727b6$exports, "AdminController", function () { return $e80d55d4784727b6$export$c9bc273e9beeea2c; });





var $e80d55d4784727b6$var$_state, $e80d55d4784727b6$var$_devTools;
var $e80d55d4784727b6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e80d55d4784727b6$export$3f12484fd6c3dfbf = class AdminDevTools {
    async handleResponse(response) {
        if (response.ok) {
            alert("OK."); // eslint-disable-line no-alert
            await this.adminController.refreshData();
            return;
        }
        alert(`Error: ${response.status} ${response.statusText} ${JSON.stringify(await response.json(), null, 2)}`); // eslint-disable-line no-alert
    }
    async fakeData(companyName) {
        const response = await this.api.fetchRaw("POST", "/admin/dev/fake-data", {
            targetUser: this.targetUser,
            companyName: companyName
        });
        return this.handleResponse(response);
    }
    async setBillingStatus(billingStatus) {
        const response = await this.api.fetchRaw("POST", "/admin/dev/billing-status", {
            targetUser: this.targetUser,
            billingStatus: billingStatus
        });
        return this.handleResponse(response);
    }
    async runBillingCronJob(cronJobName) {
        const response = await this.api.fetchRaw("POST", "/admin/dev/billing-cron", {
            targetUser: this.targetUser,
            cronJobName: cronJobName
        });
        return this.handleResponse(response);
    }
    async resetAllBillingInformation() {
        const response = await this.api.fetchRaw("DELETE", "/admin/dev/billing", {
            targetUser: this.targetUser
        });
        return this.handleResponse(response);
    }
    async setLicenseExpires(days) {
        const response = await this.api.fetchRaw("POST", "/admin/dev/license-expires", {
            targetUser: this.targetUser,
            days: days
        });
        return this.handleResponse(response);
    }
    async setEvaluationEnd(days) {
        const response = await this.api.fetchRaw("POST", "/admin/dev/evaluation-end", {
            targetUser: this.targetUser,
            days: days
        });
        return this.handleResponse(response);
    }
    constructor(api, adminController, accountController){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "api", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "adminController", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "targetUser", void 0);
        this.api = api;
        this.adminController = adminController;
        if (accountController.state.kind !== "ok") throw new Error("Cannot load dev-tools for non-logged in user.");
        this.targetUser = accountController.state.details.email;
    }
};
$e80d55d4784727b6$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $e80d55d4784727b6$export$3f12484fd6c3dfbf.prototype, "targetUser", void 0);
$e80d55d4784727b6$var$__decorate([
    (0, $8ea62fef91697031$exports.callback)
], $e80d55d4784727b6$export$3f12484fd6c3dfbf.prototype, "resetAllBillingInformation", null);
$e80d55d4784727b6$export$3f12484fd6c3dfbf = $e80d55d4784727b6$var$__decorate([
    (0, $8ea62fef91697031$exports.subject)()
], $e80d55d4784727b6$export$3f12484fd6c3dfbf);
let $e80d55d4784727b6$export$c9bc273e9beeea2c = ($e80d55d4784727b6$var$_state = /*#__PURE__*/ new WeakMap(), $e80d55d4784727b6$var$_devTools = /*#__PURE__*/ new WeakMap(), class AdminController {
    get state() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $e80d55d4784727b6$var$_state);
    }
    set state(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $e80d55d4784727b6$var$_state, value);
    }
    async init() {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $e80d55d4784727b6$var$_devTools, null);
        if (this.state.kind !== "init" || this.accountController.state.kind !== "ok") return;
        this.state = {
            kind: "loading",
            details: null
        };
        const details = await this.api.getAdmin();
        if (!details) {
            window.location.href = "/";
            return;
        }
        this.state = {
            kind: "ok",
            details: details
        };
    }
    async getUserDetails(id) {
        return await this.api.fetch("GET", `/admin/users/${id}`);
    }
    async activateBillingFromBeta(user) {
        // eslint-disable-next-line no-alert
        if (!confirm(`Activate billing for ${user.companyName} (${user.email})?`)) return;
        const response = await this.api.fetchRaw("POST", "/admin/activate-billing-from-beta", {
            email: user.email
        });
        if (response.ok) return this.refreshData();
        const responseBody = await response.json();
        alert(`${response.status}: ${JSON.stringify(responseBody, null, 2)}`); // eslint-disable-line no-alert
    }
    get devTools() {
        var _this_state_details;
        if (!(0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $e80d55d4784727b6$var$_devTools) && ((_this_state_details = this.state.details) === null || _this_state_details === void 0 ? void 0 : _this_state_details.enableDevTools)) (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $e80d55d4784727b6$var$_devTools, new $e80d55d4784727b6$export$3f12484fd6c3dfbf(this.api, this, this.accountController));
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $e80d55d4784727b6$var$_devTools);
    }
    refreshData() {
        this.state = {
            kind: "init",
            details: null
        };
        return this.init();
    }
    async testFreeagentConnection() {
        const { ok: ok } = await this.api.fetch("GET", "/admin/test-freeagent-connection");
        return ok;
    }
    constructor({ api: api, accountController: accountController }){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "api", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "accountController", void 0);
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $e80d55d4784727b6$var$_state, {
            writable: true,
            value: {
                kind: "init",
                details: null
            }
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $e80d55d4784727b6$var$_devTools, {
            writable: true,
            value: null
        });
        this.api = api;
        this.accountController = accountController;
    }
});
$e80d55d4784727b6$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $e80d55d4784727b6$export$c9bc273e9beeea2c.prototype, "state", null);
$e80d55d4784727b6$export$c9bc273e9beeea2c = $e80d55d4784727b6$var$__decorate([
    (0, $8ea62fef91697031$exports.subject)()
], $e80d55d4784727b6$export$c9bc273e9beeea2c);



class $44fe338abcc94558$export$f2eee0e5ccea2e0a {
    constructor(){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "referredBy", void 0);
        const fromUrl = new URLSearchParams(window.location.search).get($44fe338abcc94558$export$f2eee0e5ccea2e0a.KEY);
        var _localStorage_getItem;
        if (fromUrl) {
            localStorage.setItem($44fe338abcc94558$export$f2eee0e5ccea2e0a.KEY, fromUrl);
            this.referredBy = fromUrl;
        } else this.referredBy = (_localStorage_getItem = localStorage.getItem($44fe338abcc94558$export$f2eee0e5ccea2e0a.KEY)) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : undefined;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($44fe338abcc94558$export$f2eee0e5ccea2e0a, "KEY", "referrer");




const $f57fa0ee256b0db7$export$bc06f20cebe0309b = ()=>{
    const api = new (0, $dfa398380817d4fd$export$dc890958d2b428da)();
    const accountController = new (0, $ced247092cf431ef$exports.AccountController)({
        api: api
    });
    const referralController = new (0, $44fe338abcc94558$export$f2eee0e5ccea2e0a)();
    const authController = new (0, $e20cc98c4082f284$export$862a273d408fe7a1)({
        api: api,
        accountController: accountController,
        referralController: referralController
    });
    const billingController = new (0, $c1535f7b845fbcbc$exports.BillingController)({
        api: api,
        accountController: accountController
    });
    const adminController = new (0, $e80d55d4784727b6$exports.AdminController)({
        api: api,
        accountController: accountController
    });
    const errorController = new (0, $e2b39599c6d011e6$exports.ErrorController)({
        api: api
    });
    return Object.freeze({
        accountController: accountController,
        authController: authController,
        billingController: billingController,
        adminController: adminController,
        errorController: errorController
    });
};
const $f57fa0ee256b0db7$var$controllersContext = (0, $VqyUd.createContext)(null);
const $f57fa0ee256b0db7$export$dc4621b70519de6a = ({ controllers: controllers, children: children })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($f57fa0ee256b0db7$var$controllersContext.Provider, {
        value: controllers,
        children: children
    });
const $f57fa0ee256b0db7$export$8b376ee89da7718b = ()=>{
    const ctx = (0, $f6LVE.useContext)($f57fa0ee256b0db7$var$controllersContext);
    if (!ctx) throw new (0, $0a3e95917c2f7450$export$2970af845c2cbd28)("globalControllersContext", "GlobalControllersProvider");
    return ctx;
};
const $f57fa0ee256b0db7$export$aaec80e085d54cbe = ()=>$f57fa0ee256b0db7$export$8b376ee89da7718b().accountController;
const $f57fa0ee256b0db7$export$9976db6a0382a0c7 = ()=>{
    const accountController = $f57fa0ee256b0db7$export$aaec80e085d54cbe();
    if (!accountController.state.details) throw new Error(`Cannot access AccountController details in state "${accountController.state.kind}"`);
    return accountController.state.details;
};
const $f57fa0ee256b0db7$export$2ddc77f16875382c = ()=>$f57fa0ee256b0db7$export$8b376ee89da7718b().authController;
const $f57fa0ee256b0db7$export$fae87f616b8b2f3c = ()=>$f57fa0ee256b0db7$export$8b376ee89da7718b().billingController;
const $f57fa0ee256b0db7$export$c05e53a76d53ff2d = ()=>$f57fa0ee256b0db7$export$8b376ee89da7718b().adminController;
const $f57fa0ee256b0db7$export$4c949b1d75869f5a = ()=>{
    const adminController = $f57fa0ee256b0db7$export$c05e53a76d53ff2d();
    if (!adminController.state.details) throw new Error(`Cannot access AdminController details in state "${adminController.state.kind}"`);
    return adminController.state.details;
};
const $f57fa0ee256b0db7$export$e602918cb3d99338 = ()=>$f57fa0ee256b0db7$export$8b376ee89da7718b().errorController;




$parcel$exportWildcard($3b7ab8236e0b6611$exports, $ced247092cf431ef$exports);
$parcel$exportWildcard($3b7ab8236e0b6611$exports, $c1535f7b845fbcbc$exports);
$parcel$exportWildcard($3b7ab8236e0b6611$exports, $e2b39599c6d011e6$exports);




var $ebf396bdcb3f9ccf$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $ebf396bdcb3f9ccf$exports) {
        classNames.default = classNames;
        $ebf396bdcb3f9ccf$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



const $2c8d3cee2ba76f85$export$2f6783294041cae1 = ({ className: className })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        class: className,
        "aria-hidden": "true",
        focusable: "false",
        "data-icon": "Bearing",
        role: "img",
        viewBox: "0 0 1730.0518 542.99512",
        version: "1.1",
        id: "bearing-logo",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("defs", {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("filter", {
                    id: "dropshadow",
                    height: "1.3",
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feGaussianBlur", {
                            in: "SourceAlpha",
                            stdDeviation: "4"
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feOffset", {
                            dx: "0",
                            dy: "4",
                            result: "offsetblur"
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feComponentTransfer", {
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feFuncA", {
                                type: "linear",
                                slope: "0.4"
                            })
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMerge", {
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {}),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                    in: "SourceGraphic"
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                style: "fill:#aaaaaa;fill-opacity:1;stroke:none;filter:url(#dropshadow)",
                d: "m 462.73933,207.50003 h 33.73 c 11.01,0 18.61,-10.83 14.86,-21.18 -4.93,-13.58 -7.55,-27.98 -7.55,-42.82 0,-14.84 2.62,-29.24 7.55,-42.82 3.76,-10.349989 -3.85,-21.179988 -14.86,-21.179988 h -33.73 c -7.01,0 -13.46,4.49 -15.41,11.229999 -4.89,16.979989 -7.53,34.649989 -7.53,52.769989 0,18.12 2.64,35.79 7.54,52.76 1.94,6.74 8.39,11.24 15.4,11.24 z",
                id: "wave-left-inner"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                style: "fill:#aaaaaa;fill-opacity:1;stroke:none;filter:url(#dropshadow)",
                d: "m 401.71933,38.840041 c 5.64,-10.62 -1.95,-23.34 -13.96,-23.34 h -35.33 c -6.27,0 -12.14,3.59 -14.74,9.31 -16.49,36.23 -25.89,76.339989 -25.89,118.689989 0,24.75 3.12,68.33 26.69,118.86 2.62,5.63 8.42,9.14 14.61,9.14 h 34.84 c 12.02,0 19.61,-12.74 13.95,-23.37 -49.78,-93.32 -16.71,-178.149989 -0.17,-209.289989 z",
                id: "wave-left-outer"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                style: "fill:#aaaaaa;fill-opacity:1;stroke:none;filter:url(#dropshadow)",
                d: "m 925.85933,24.790041 c -2.6,-5.71 -8.46,-9.29 -14.73,-9.29 h -35.42 c -11.98,0 -19.66,12.66 -14.02,23.25 18.27,34.290001 48.42,119.419989 0.28,209.229989 -5.72,10.68 1.8,23.52 13.91,23.52 h 35.23 c 6.27,0 12.13,-3.58 14.73,-9.29 16.53,-36.23 25.96,-76.35 25.96,-118.71 0,-42.36 -9.42,-82.479989 -25.94,-118.709989 z",
                id: "wave-right-outer"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                style: "fill:#aaaaaa;fill-opacity:1;stroke:none;filter:url(#dropshadow)",
                d: "m 800.85933,79.500042 h -33.73 c -11.01,0 -18.61,10.829999 -14.86,21.179988 4.93,13.58 7.55,27.98 7.55,42.82 0,14.84 -2.62,29.24 -7.55,42.82 -3.76,10.35 3.85,21.18 14.86,21.18 h 33.73 c 7.02,0 13.46,-4.49 15.41,-11.24 4.9,-16.97 7.53,-34.64 7.53,-52.76 0,-18.12 -2.64,-35.79 -7.54,-52.759989 -1.94,-6.749999 -8.39,-11.239999 -15.4,-11.239999 z",
                id: "wave-right-inner"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                id: "tower",
                style: "fill:#aaaaaa;fill-opacity:1;stroke:none;filter:url(#dropshadow)",
                d: "m 583.41933,335.50003 48.38,-116.19 48.38,116.19 z m 101.14,-155.88 c 7.05,-10.29 11.2,-22.71 11.2,-36.12 0,-35.35 -28.63,-63.999988 -63.96,-63.999988 -35.32,0 -63.96,28.649988 -63.96,63.999988 0,13.41 4.15,25.83 11.2,36.12 l -130.5,313.41 c -3.4,8.15 0.46,17.52 8.61,20.92 l 29.51,12.31 c 8.15,3.4 17.52,-0.46 20.91,-8.61 l 49.19,-118.15 h 150.07 l 49.2,118.15 c 3.4,8.16 12.76,12.01 20.91,8.61 l 29.51,-12.31 c 8.15,-3.4 12,-12.77 8.61,-20.92 z"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("g", {
                "aria-label": "BEARING",
                transform: "matrix(2.0658489,0,0,2.0658489,1675.9995,1448.3531)",
                style: "fill:#ffffff;fill-opacity:1;stroke:none;filter:url(#dropshadow)",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        d: "m -785.09013,-547.99491 v 51.28087 h 30.37478 q 15.28113,0 22.59358,-6.28121 7.40619,-6.37495 7.40619,-19.4061 0,-13.1249 -7.40619,-19.31236 -7.31245,-6.2812 -22.59358,-6.2812 z m 0,-57.56207 v 42.18718 h 28.03104 q 13.8749,0 20.62485,-5.15621 6.8437,-5.24996 6.8437,-15.93738 0,-10.59367 -6.8437,-15.84363 -6.74995,-5.24996 -20.62485,-5.24996 z m -18.93735,-15.56238 h 48.37463 q 21.65609,0 33.37475,8.99993 11.71867,8.99993 11.71867,25.59356 0,12.84365 -5.99996,20.43734 -5.99995,7.5937 -17.62487,9.46868 13.96865,2.99998 21.65609,12.56241 7.78119,9.46868 7.78119,23.71857 0,18.74986 -12.7499,28.96854 -12.74991,10.21867 -36.28098,10.21867 h -50.24962 z",
                        id: "letter-b"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        d: "m -672.30971,-621.11936 h 88.49934 v 15.93738 h -69.56198 v 41.43719 h 66.65575 v 15.93738 h -66.65575 v 50.71837 h 71.24947 v 15.93738 h -90.18683 z",
                        id: "letter-e"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        d: "m -362.56204,-546.77617 q 6.09371,2.06249 11.81241,8.81243 5.81246,6.74995 11.62492,18.56237 l 19.2186,38.24971 h -20.34359 l -17.90612,-35.90598 q -6.93745,-14.0624 -13.4999,-18.65611 -6.4687,-4.59372 -17.71862,-4.59372 h -20.62484 v 59.15581 h -18.93736 v -139.9677 h 42.74968 q 23.99982,0 35.81223,10.03117 11.81241,10.03118 11.81241,30.28102 0,13.21866 -6.18745,21.93734 -6.09371,8.71869 -17.81237,12.09366 z m -47.43714,-58.78081 v 49.68713 h 23.81232 q 13.6874,0 20.62484,-6.2812 7.0312,-6.37496 7.0312,-18.65612 0,-12.28115 -7.0312,-18.46861 -6.93744,-6.2812 -20.62484,-6.2812 z",
                        id: "letter-r"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        d: "m -295.53127,-621.11936 h 18.93736 v 139.9677 h -18.93736 z",
                        id: "letter-i"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        d: "m -238.9067,-621.11936 h 25.49981 l 62.06204,117.09287 v -117.09287 h 18.37486 v 139.9677 h -25.49981 l -62.06203,-117.09287 v 117.09287 h -18.37487 z",
                        id: "letter-n"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        d: "m 0.15399246,-501.12026 v -37.59347 H -30.783276 v -15.56238 h 49.687128 v 60.0933 q -10.9686677,7.78119 -24.1873189,11.81241 -13.2186511,3.93747 -28.2185391,3.93747 -32.812255,0 -51.374616,-19.12486 -18.468608,-19.2186 -18.468608,-53.4371 0,-34.31224 18.468608,-53.4371 18.562361,-19.21861 51.374616,-19.21861 13.687398,0 25.9685559,3.37498 12.3749075,3.37497 22.7810801,9.93743 v 20.15609 q -10.4999219,-8.90618 -22.3123336,-13.40615 -11.8124114,-4.49996 -24.8435644,-4.49996 -25.687308,0 -38.624711,14.34364 -12.843655,14.34364 -12.843655,42.74968 0,28.31229 12.843655,42.65593 12.937403,14.34365 38.624711,14.34365 10.031175,0 17.906116,-1.68749 7.8749414,-1.78124 14.15614446,-5.43746 z",
                        id: "letter-g"
                    })
                ]
            })
        ]
    });
const $2c8d3cee2ba76f85$export$dd38071655615b86 = ({ className: className, color: color = "default" })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))(className, "tower-logo", `tower-logo--${color}`),
        "aria-hidden": true,
        id: "svg136",
        version: "1.1",
        viewBox: "0 0 174.2016 155",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("defs", {
                id: "defs130",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("filter", {
                        id: "dropshadow",
                        height: "1.3",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feGaussianBlur", {
                                in: "SourceAlpha",
                                stdDeviation: "4",
                                id: "feGaussianBlur10"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feOffset", {
                                dx: "0",
                                dy: "4",
                                result: "offsetblur",
                                id: "feOffset12"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feComponentTransfer", {
                                id: "feComponentTransfer16",
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feFuncA", {
                                    type: "linear",
                                    slope: "0.4",
                                    id: "feFuncA14"
                                })
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMerge", {
                                id: "feMerge22",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        id: "feMergeNode18"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        in: "SourceGraphic",
                                        id: "feMergeNode20"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("filter", {
                        id: "filter75",
                        height: "1.3",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feGaussianBlur", {
                                in: "SourceAlpha",
                                stdDeviation: "4",
                                id: "feGaussianBlur61"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feOffset", {
                                dx: "0",
                                dy: "4",
                                result: "offsetblur",
                                id: "feOffset63"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feComponentTransfer", {
                                id: "feComponentTransfer67",
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feFuncA", {
                                    type: "linear",
                                    slope: "0.4",
                                    id: "feFuncA65"
                                })
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMerge", {
                                id: "feMerge73",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        id: "feMergeNode69"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        in: "SourceGraphic",
                                        id: "feMergeNode71"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("filter", {
                        id: "filter91",
                        height: "1.3",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feGaussianBlur", {
                                in: "SourceAlpha",
                                stdDeviation: "4",
                                id: "feGaussianBlur77"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feOffset", {
                                dx: "0",
                                dy: "4",
                                result: "offsetblur",
                                id: "feOffset79"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feComponentTransfer", {
                                id: "feComponentTransfer83",
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feFuncA", {
                                    type: "linear",
                                    slope: "0.4",
                                    id: "feFuncA81"
                                })
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMerge", {
                                id: "feMerge89",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        id: "feMergeNode85"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        in: "SourceGraphic",
                                        id: "feMergeNode87"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("filter", {
                        id: "filter107",
                        height: "1.3",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feGaussianBlur", {
                                in: "SourceAlpha",
                                stdDeviation: "4",
                                id: "feGaussianBlur93"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feOffset", {
                                dx: "0",
                                dy: "4",
                                result: "offsetblur",
                                id: "feOffset95"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feComponentTransfer", {
                                id: "feComponentTransfer99",
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feFuncA", {
                                    type: "linear",
                                    slope: "0.4",
                                    id: "feFuncA97"
                                })
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMerge", {
                                id: "feMerge105",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        id: "feMergeNode101"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        in: "SourceGraphic",
                                        id: "feMergeNode103"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("filter", {
                        id: "filter123",
                        height: "1.3",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feGaussianBlur", {
                                in: "SourceAlpha",
                                stdDeviation: "4",
                                id: "feGaussianBlur109"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feOffset", {
                                dx: "0",
                                dy: "4",
                                result: "offsetblur",
                                id: "feOffset111"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feComponentTransfer", {
                                id: "feComponentTransfer115",
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feFuncA", {
                                    type: "linear",
                                    slope: "0.4",
                                    id: "feFuncA113"
                                })
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMerge", {
                                id: "feMerge121",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        id: "feMergeNode117"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("feMergeNode", {
                                        in: "SourceGraphic",
                                        id: "feMergeNode119"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("g", {
                transform: "translate(-2.9997427,-1.2077167)",
                id: "layer1",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                        style: `fill:${color};fill-opacity:1;stroke:none;filter:url(#dropshadow)`,
                        d: "m 160.14,217.59999 h 33.73 c 11.01,0 18.61,-10.83 14.86,-21.18 -4.93,-13.58 -7.55,-27.98 -7.55,-42.82 0,-14.84 2.62,-29.24 7.55,-42.82 3.76,-10.34999 -3.85,-21.179991 -14.86,-21.179991 h -33.73 c -7.01,0 -13.46,4.49 -15.41,11.230001 -4.89,16.97999 -7.53,34.64999 -7.53,52.76999 0,18.12 2.64,35.79 7.54,52.76 1.94,6.74 8.39,11.24 15.4,11.24 z",
                        id: "wave-left-inner"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                        style: `fill:${color};fill-opacity:1;stroke:none;filter:url(#dropshadow)`,
                        d: "m 99.120001,48.939998 c 5.639999,-10.62 -1.95,-23.34 -13.96,-23.34 h -35.33 c -6.27,0 -12.14,3.59 -14.74,9.31 -16.49,36.23 -25.8900002,76.339992 -25.8900002,118.689992 0,24.75 3.1200002,68.33 26.6900002,118.86 2.62,5.63 8.42,9.14 14.61,9.14 h 34.84 c 12.02,0 19.609999,-12.74 13.95,-23.37 -49.78,-93.32 -16.71,-178.149992 -0.17,-209.289992 z",
                        id: "wave-left-outer"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                        style: `fill:${color};fill-opacity:1;stroke:none;filter:url(#dropshadow)`,
                        d: "m 623.26,34.889998 c -2.6,-5.71 -8.46,-9.29 -14.73,-9.29 h -35.42 c -11.98,0 -19.66,12.66 -14.02,23.25 18.27,34.290001 48.42,119.419992 0.28,209.229992 -5.72,10.68 1.8,23.52 13.91,23.52 h 35.23 c 6.27,0 12.13,-3.58 14.73,-9.29 16.53,-36.23 25.96,-76.35 25.96,-118.71 0,-42.36 -9.42,-82.479992 -25.94,-118.709992 z",
                        id: "wave-right-outer"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                        style: `fill:${color};fill-opacity:1;stroke:none;filter:url(#dropshadow)`,
                        d: "m 498.26,89.599999 h -33.73 c -11.01,0 -18.61,10.830001 -14.86,21.179991 4.93,13.58 7.55,27.98 7.55,42.82 0,14.84 -2.62,29.24 -7.55,42.82 -3.76,10.35 3.85,21.18 14.86,21.18 h 33.73 c 7.02,0 13.46,-4.49 15.41,-11.24 4.9,-16.97 7.53,-34.64 7.53,-52.76 0,-18.12 -2.64,-35.79 -7.54,-52.75999 -1.94,-6.750001 -8.39,-11.240001 -15.4,-11.240001 z",
                        id: "wave-right-inner"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                        transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                        id: "tower",
                        style: `fill:${color};fill-opacity:1;stroke:none;filter:url(#dropshadow)`,
                        d: "m 280.82,345.59999 48.38,-116.19 48.38,116.19 z m 101.14,-155.88 c 7.05,-10.29 11.2,-22.71 11.2,-36.12 0,-35.35 -28.63,-63.999991 -63.96,-63.999991 -35.32,0 -63.96,28.649991 -63.96,63.999991 0,13.41 4.15,25.83 11.2,36.12 l -130.5,313.41 c -3.4,8.15 0.46,17.52 8.61,20.92 l 29.51,12.31 c 8.15,3.4 17.52,-0.46 20.91,-8.61 l 49.19,-118.15 h 150.07 l 49.2,118.15 c 3.4,8.16 12.76,12.01 20.91,8.61 l 29.51,-12.31 c 8.15,-3.4 12,-12.77 8.61,-20.92 z"
                    })
                ]
            })
        ]
    });
};




var $VqyUd = parcelRequire("VqyUd");

const $768e8713fc5fc14b$export$7c6e2c02157bb7d2 = ({ tag: tag = "div", className: className, innerTag: innerTag = "div", innerClassName: innerClassName, width: width = "md", children: children })=>{
    return (0, $VqyUd.h)(tag, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("content", className),
        children: (0, $VqyUd.h)(innerTag, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("content__inner", `content__inner--${width}`, innerClassName),
            children: children
        })
    });
};



var $VqyUd = parcelRequire("VqyUd");


var $f6LVE = parcelRequire("f6LVE");

var $VqyUd = parcelRequire("VqyUd");
function $b71353478e820d05$var$S(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $b71353478e820d05$var$g(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $b71353478e820d05$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $b71353478e820d05$export$7c73462e0d25e514(n, t) {
    function e(n) {
        var e = this.props.ref, r = e == n.ref;
        return !r && e && (e.call ? e(null) : e.current = null), t ? !t(this.props, n) || !r : $b71353478e820d05$var$g(this.props, n);
    }
    function r(t) {
        return this.shouldComponentUpdate = e, (0, $VqyUd.createElement)(n, t);
    }
    return r.displayName = "Memo(" + (n.displayName || n.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r;
}
($b71353478e820d05$export$221d75b3f55bb0bd.prototype = new (0, $VqyUd.Component)).isPureReactComponent = !0, $b71353478e820d05$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $b71353478e820d05$var$g(this.props, n) || $b71353478e820d05$var$g(this.state, t);
};
var $b71353478e820d05$var$w = (0, $VqyUd.options).__b;
(0, $VqyUd.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $b71353478e820d05$var$w && $b71353478e820d05$var$w(n);
};
var $b71353478e820d05$var$x = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $b71353478e820d05$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $b71353478e820d05$var$S({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $b71353478e820d05$var$x, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $b71353478e820d05$var$N = function(n, t) {
    return null == n ? null : (0, $VqyUd.toChildArray)((0, $VqyUd.toChildArray)(n).map(t));
}, $b71353478e820d05$export$dca3b0875bd9a954 = {
    map: $b71353478e820d05$var$N,
    forEach: $b71353478e820d05$var$N,
    count: function(n) {
        return n ? (0, $VqyUd.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $VqyUd.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $VqyUd.toChildArray)
}, $b71353478e820d05$var$A = (0, $VqyUd.options).__e;
(0, $VqyUd.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $b71353478e820d05$var$A(n, t, e, r);
};
var $b71353478e820d05$var$O = (0, $VqyUd.options).unmount;
function $b71353478e820d05$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $b71353478e820d05$var$L(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $b71353478e820d05$export$488013bae63b21da(n) {
    var t, e, r;
    function u(u) {
        if (t || (t = n()).then(function(n) {
            e = n.default || n;
        }, function(n) {
            r = n;
        }), r) throw r;
        if (!e) throw t;
        return (0, $VqyUd.createElement)(e, u);
    }
    return u.displayName = "Lazy", u.__f = !0, u;
}
function $b71353478e820d05$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $VqyUd.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $b71353478e820d05$var$O && $b71353478e820d05$var$O(n);
}, ($b71353478e820d05$export$74bf444e3cd11ea5.prototype = new (0, $VqyUd.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $b71353478e820d05$var$L(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = function n(t, e, r) {
                    return t && (t.__v = null, t.__k = t.__k && t.__k.map(function(t) {
                        return n(t, e, r);
                    }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
                }(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $b71353478e820d05$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $b71353478e820d05$export$74bf444e3cd11ea5.prototype.render = function(n, t) {
    if (this.__b) {
        if (this.__v.__k) {
            var e = document.createElement("div"), r = this.__v.__k[0].__c;
            this.__v.__k[0] = function n(t, e, r) {
                return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function(n) {
                    "function" == typeof n.__c && n.__c();
                }), t.__c.__H = null), null != (t = $b71353478e820d05$var$S({}, t)).__c && (t.__c.__P === r && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function(t) {
                    return n(t, e, r);
                })), t;
            }(this.__b, e, r.__O = r.__P);
        }
        this.__b = null;
    }
    var u = t.__a && (0, $VqyUd.createElement)((0, $VqyUd.Fragment), null, n.fallback);
    return u && (u.__h = null), [
        (0, $VqyUd.createElement)((0, $VqyUd.Fragment), null, t.__a ? null : n.children),
        u
    ];
};
var $b71353478e820d05$var$F = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $b71353478e820d05$var$I(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $b71353478e820d05$var$M(n) {
    var t = this, e = n.i;
    t.componentWillUnmount = function() {
        (0, $VqyUd.render)(null, t.l), t.l = null, t.i = null;
    }, t.i && t.i !== e && t.componentWillUnmount(), n.__v ? (t.l || (t.i = e, t.l = {
        nodeType: 1,
        parentNode: e,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        insertBefore: function(n, e) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), t.i.removeChild(n);
        }
    }), (0, $VqyUd.render)((0, $VqyUd.createElement)($b71353478e820d05$var$I, {
        context: t.context
    }, n.__v), t.l)) : t.l && t.componentWillUnmount();
}
function $b71353478e820d05$export$d39a5bbd09211389(n, t) {
    var e = (0, $VqyUd.createElement)($b71353478e820d05$var$M, {
        __v: n,
        i: t
    });
    return e.containerInfo = t, e;
}
($b71353478e820d05$export$998bcd577473dd93.prototype = new (0, $VqyUd.Component)).__a = function(n) {
    var t = this, e = $b71353478e820d05$var$L(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $b71353478e820d05$var$F(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $b71353478e820d05$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $VqyUd.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $b71353478e820d05$export$998bcd577473dd93.prototype.componentDidUpdate = $b71353478e820d05$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $b71353478e820d05$var$F(n, e, t);
    });
};
var $b71353478e820d05$var$W = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $b71353478e820d05$var$P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $b71353478e820d05$var$$ = "undefined" != typeof document, $b71353478e820d05$var$j = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $b71353478e820d05$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $VqyUd.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $b71353478e820d05$export$fa8d919ba61d84db(n, t, e) {
    return (0, $VqyUd.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $VqyUd.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(n) {
    Object.defineProperty((0, $VqyUd.Component).prototype, n, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + n];
        },
        set: function(t) {
            Object.defineProperty(this, n, {
                configurable: !0,
                writable: !0,
                value: t
            });
        }
    });
});
var $b71353478e820d05$var$H = (0, $VqyUd.options).event;
function $b71353478e820d05$var$Z() {}
function $b71353478e820d05$var$Y() {
    return this.cancelBubble;
}
function $b71353478e820d05$var$q() {
    return this.defaultPrevented;
}
(0, $VqyUd.options).event = function(n) {
    return $b71353478e820d05$var$H && (n = $b71353478e820d05$var$H(n)), n.persist = $b71353478e820d05$var$Z, n.isPropagationStopped = $b71353478e820d05$var$Y, n.isDefaultPrevented = $b71353478e820d05$var$q, n.nativeEvent = n;
};
var $b71353478e820d05$var$G, $b71353478e820d05$var$J = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $b71353478e820d05$var$K = (0, $VqyUd.options).vnode;
(0, $VqyUd.options).vnode = function(n) {
    var t = n.type, e = n.props, r = e;
    if ("string" == typeof t) {
        var u = -1 === t.indexOf("-");
        for(var o in r = {}, e){
            var i = e[o];
            $b71353478e820d05$var$$ && "children" === o && "noscript" === t || "value" === o && "defaultValue" in e && null == i || ("defaultValue" === o && "value" in e && null == e.value ? o = "value" : "download" === o && !0 === i ? i = "" : /ondoubleclick/i.test(o) ? o = "ondblclick" : /^onchange(textarea|input)/i.test(o + t) && !$b71353478e820d05$var$j(e.type) ? o = "oninput" : /^onfocus$/i.test(o) ? o = "onfocusin" : /^onblur$/i.test(o) ? o = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(o) ? o = o.toLowerCase() : u && $b71353478e820d05$var$P.test(o) ? o = o.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === i && (i = void 0), /^oninput$/i.test(o) && (o = o.toLowerCase(), r[o] && (o = "oninputCapture")), r[o] = i);
        }
        "select" == t && r.multiple && Array.isArray(r.value) && (r.value = (0, $VqyUd.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = -1 != r.value.indexOf(n.props.value);
        })), "select" == t && null != r.defaultValue && (r.value = (0, $VqyUd.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(n.props.value) : r.defaultValue == n.props.value;
        })), n.props = r, e.class != e.className && ($b71353478e820d05$var$J.enumerable = "className" in e, null != e.className && (r.class = e.className), Object.defineProperty(r, "className", $b71353478e820d05$var$J));
    }
    n.$$typeof = $b71353478e820d05$var$W, $b71353478e820d05$var$K && $b71353478e820d05$var$K(n);
};
var $b71353478e820d05$var$Q = (0, $VqyUd.options).__r;
(0, $VqyUd.options).__r = function(n) {
    $b71353478e820d05$var$Q && $b71353478e820d05$var$Q(n), $b71353478e820d05$var$G = n.__c;
};
var $b71353478e820d05$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $b71353478e820d05$var$G.__n[n.__c].props.value;
            }
        }
    }
}, $b71353478e820d05$export$83d89fbfd8236492 = "17.0.2";
function $b71353478e820d05$export$d38cd72104c1f0e9(n) {
    return (0, $VqyUd.createElement).bind(null, n);
}
function $b71353478e820d05$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $b71353478e820d05$var$W;
}
function $b71353478e820d05$export$e530037191fcd5d7(n) {
    return $b71353478e820d05$export$a8257692ac88316c(n) ? (0, $VqyUd.cloneElement).apply(null, arguments) : n;
}
function $b71353478e820d05$export$502457920280e6be(n) {
    return !!n.__k && ((0, $VqyUd.render)(null, n), !0);
}
function $b71353478e820d05$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $b71353478e820d05$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $b71353478e820d05$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $b71353478e820d05$export$5f8d39834fd61797 = (0, $VqyUd.Fragment);
function $b71353478e820d05$export$7568632d0d33d16d(n) {
    n();
}
function $b71353478e820d05$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $b71353478e820d05$export$7b286972b8d8ccbf() {
    return [
        !1,
        $b71353478e820d05$export$7568632d0d33d16d
    ];
}
var $b71353478e820d05$export$aaabe4eda9ed9969 = (0, $f6LVE.useLayoutEffect);
function $b71353478e820d05$export$306c0aa65ff9ec16(t, u) {
    var o = u(), i = (0, $f6LVE.useState)({
        s: {
            __: o,
            h: u
        }
    }), l = i[0].s, c = i[1];
    return (0, $f6LVE.useLayoutEffect)(function() {
        l.__ = o, l.h = u, l.__ !== u() && c({
            s: l
        });
    }, [
        t,
        o,
        u
    ]), (0, $f6LVE.useEffect)(function() {
        return l.__ !== l.h() && c({
            s: l
        }), t(function() {
            l.__ !== l.h() && c({
                s: l
            });
        });
    }, [
        t
    ]), o;
}
var $b71353478e820d05$export$2e2bcd8739ae039 = {
    useState: (0, $f6LVE.useState),
    useReducer: (0, $f6LVE.useReducer),
    useEffect: (0, $f6LVE.useEffect),
    useLayoutEffect: (0, $f6LVE.useLayoutEffect),
    useInsertionEffect: (0, $f6LVE.useLayoutEffect),
    useTransition: $b71353478e820d05$export$7b286972b8d8ccbf,
    useDeferredValue: $b71353478e820d05$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $b71353478e820d05$export$306c0aa65ff9ec16,
    startTransition: $b71353478e820d05$export$7568632d0d33d16d,
    useRef: (0, $f6LVE.useRef),
    useImperativeHandle: (0, $f6LVE.useImperativeHandle),
    useMemo: (0, $f6LVE.useMemo),
    useCallback: (0, $f6LVE.useCallback),
    useContext: (0, $f6LVE.useContext),
    useDebugValue: (0, $f6LVE.useDebugValue),
    version: "17.0.2",
    Children: $b71353478e820d05$export$dca3b0875bd9a954,
    render: $b71353478e820d05$export$b3890eb0ae9dca99,
    hydrate: $b71353478e820d05$export$fa8d919ba61d84db,
    unmountComponentAtNode: $b71353478e820d05$export$502457920280e6be,
    createPortal: $b71353478e820d05$export$d39a5bbd09211389,
    createElement: (0, $VqyUd.createElement),
    createContext: (0, $VqyUd.createContext),
    createFactory: $b71353478e820d05$export$d38cd72104c1f0e9,
    cloneElement: $b71353478e820d05$export$e530037191fcd5d7,
    createRef: (0, $VqyUd.createRef),
    Fragment: (0, $VqyUd.Fragment),
    isValidElement: $b71353478e820d05$export$a8257692ac88316c,
    findDOMNode: $b71353478e820d05$export$466bfc07425424d5,
    Component: (0, $VqyUd.Component),
    PureComponent: $b71353478e820d05$export$221d75b3f55bb0bd,
    memo: $b71353478e820d05$export$7c73462e0d25e514,
    forwardRef: $b71353478e820d05$export$257a8862b851cb5b,
    flushSync: $b71353478e820d05$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $b71353478e820d05$export$c78a37762a8d58e1,
    StrictMode: (0, $VqyUd.Fragment),
    Suspense: $b71353478e820d05$export$74bf444e3cd11ea5,
    SuspenseList: $b71353478e820d05$export$998bcd577473dd93,
    lazy: $b71353478e820d05$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $b71353478e820d05$export$ae55be85d98224ed
};



var $f6LVE = parcelRequire("f6LVE");


var $VqyUd = parcelRequire("VqyUd");
const $2a0eabf503a7e085$var$ICONS = {
    "hamburger": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-menu-2",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "4",
                y1: "6",
                x2: "20",
                y2: "6"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "4",
                y1: "12",
                x2: "20",
                y2: "12"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "4",
                y1: "18",
                x2: "20",
                y2: "18"
            })
        ]
    }),
    "close": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-x",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    }),
    "error": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-alert-octagon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "12",
                y1: "8",
                x2: "12",
                y2: "12"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "12",
                y1: "16",
                x2: "12.01",
                y2: "16"
            })
        ]
    }),
    "warning": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-alert-triangle",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M12 9v2m0 4v.01"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
            })
        ]
    }),
    "success": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-circle-check",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "12",
                cy: "12",
                r: "9"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M9 12l2 2l4 -4"
            })
        ]
    }),
    "info": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-info-circle",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "12",
                cy: "12",
                r: "9"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "12",
                y1: "8",
                x2: "12.01",
                y2: "8"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("polyline", {
                points: "11 12 12 12 12 16 13 16"
            })
        ]
    }),
    "point": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-point",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            })
        ]
    }),
    "mail": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-mail",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("rect", {
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                rx: "2"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("polyline", {
                points: "3 7 12 13 21 7"
            })
        ]
    }),
    "tower": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": true,
        version: "1.1",
        viewBox: "0 0 174.2016 155",
        width: "24",
        height: "24",
        stroke: "currentColor",
        fill: "currentColor",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("g", {
            transform: "translate(-2.9997427,-1.2077167)",
            id: "layer1",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                    transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                    d: "m 160.14,217.59999 h 33.73 c 11.01,0 18.61,-10.83 14.86,-21.18 -4.93,-13.58 -7.55,-27.98 -7.55,-42.82 0,-14.84 2.62,-29.24 7.55,-42.82 3.76,-10.34999 -3.85,-21.179991 -14.86,-21.179991 h -33.73 c -7.01,0 -13.46,4.49 -15.41,11.230001 -4.89,16.97999 -7.53,34.64999 -7.53,52.76999 0,18.12 2.64,35.79 7.54,52.76 1.94,6.74 8.39,11.24 15.4,11.24 z",
                    id: "wave-left-inner"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                    transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                    d: "m 99.120001,48.939998 c 5.639999,-10.62 -1.95,-23.34 -13.96,-23.34 h -35.33 c -6.27,0 -12.14,3.59 -14.74,9.31 -16.49,36.23 -25.8900002,76.339992 -25.8900002,118.689992 0,24.75 3.1200002,68.33 26.6900002,118.86 2.62,5.63 8.42,9.14 14.61,9.14 h 34.84 c 12.02,0 19.609999,-12.74 13.95,-23.37 -49.78,-93.32 -16.71,-178.149992 -0.17,-209.289992 z",
                    id: "wave-left-outer"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                    transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                    d: "m 623.26,34.889998 c -2.6,-5.71 -8.46,-9.29 -14.73,-9.29 h -35.42 c -11.98,0 -19.66,12.66 -14.02,23.25 18.27,34.290001 48.42,119.419992 0.28,209.229992 -5.72,10.68 1.8,23.52 13.91,23.52 h 35.23 c 6.27,0 12.13,-3.58 14.73,-9.29 16.53,-36.23 25.96,-76.35 25.96,-118.71 0,-42.36 -9.42,-82.479992 -25.94,-118.709992 z",
                    id: "wave-right-outer"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                    transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                    d: "m 498.26,89.599999 h -33.73 c -11.01,0 -18.61,10.830001 -14.86,21.179991 4.93,13.58 7.55,27.98 7.55,42.82 0,14.84 -2.62,29.24 -7.55,42.82 -3.76,10.35 3.85,21.18 14.86,21.18 h 33.73 c 7.02,0 13.46,-4.49 15.41,-11.24 4.9,-16.97 7.53,-34.64 7.53,-52.76 0,-18.12 -2.64,-35.79 -7.54,-52.75999 -1.94,-6.750001 -8.39,-11.240001 -15.4,-11.240001 z",
                    id: "wave-right-inner"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                    transform: "matrix(0.26458333,0,0,0.26458333,2.9997427,1.2077173)",
                    id: "tower",
                    d: "m 280.82,345.59999 48.38,-116.19 48.38,116.19 z m 101.14,-155.88 c 7.05,-10.29 11.2,-22.71 11.2,-36.12 0,-35.35 -28.63,-63.999991 -63.96,-63.999991 -35.32,0 -63.96,28.649991 -63.96,63.999991 0,13.41 4.15,25.83 11.2,36.12 l -130.5,313.41 c -3.4,8.15 0.46,17.52 8.61,20.92 l 29.51,12.31 c 8.15,3.4 17.52,-0.46 20.91,-8.61 l 49.19,-118.15 h 150.07 l 49.2,118.15 c 3.4,8.16 12.76,12.01 20.91,8.61 l 29.51,-12.31 c 8.15,-3.4 12,-12.77 8.61,-20.92 z"
                })
            ]
        })
    }),
    "credit-card": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-credit-card",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("rect", {
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                rx: "3"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "3",
                y1: "10",
                x2: "21",
                y2: "10"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "7",
                y1: "15",
                x2: "7.01",
                y2: "15"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "11",
                y1: "15",
                x2: "13",
                y2: "15"
            })
        ]
    }),
    "key": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-key",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "8",
                cy: "15",
                r: "4"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "10.85",
                y1: "12.15",
                x2: "19",
                y2: "4"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "18",
                y1: "5",
                x2: "20",
                y2: "7"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "15",
                y1: "8",
                x2: "17",
                y2: "10"
            })
        ]
    }),
    "book": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-book",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "3",
                y1: "6",
                x2: "3",
                y2: "19"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "12",
                y1: "6",
                x2: "12",
                y2: "19"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "21",
                y1: "6",
                x2: "21",
                y2: "19"
            })
        ]
    }),
    "person": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-user",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
            })
        ]
    }),
    "arrow-left": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-arrow-left",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "5",
                y1: "12",
                x2: "11",
                y2: "18"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "5",
                y1: "12",
                x2: "11",
                y2: "6"
            })
        ]
    }),
    "copy": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-copy",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("rect", {
                x: "8",
                y: "8",
                width: "12",
                height: "12",
                rx: "2"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
            })
        ]
    }),
    "user": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-user",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
            })
        ]
    }),
    "freeagent": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 175 167.9",
        "enable-background": "new 0 0 175 167.9",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("polygon", {
                fill: "#77BC1F",
                points: "125.8,43.5 111.4,82.6 125.3,117.7 98.5,117.7 88.4,144.7 135.8,144.7 145.2,167.9 175,167.9 "
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                fill: "#007ABF",
                d: "M139.1,1.1C112-4.2,98.6,10.3,94,22.2c-0.9,2.3-2.1,5.4-8.4,22c-5.1-56-58.2-3.3-84.5-32.7 c-4.1,25.4,5,28.4,5,28.4c-2,8.2,6,17.2,12.6,16c5.9,27.4,63.5-12.1,49.9,32.6c-13,34-30.2,79.2-30.2,79.2h32.4 c0,0,45-120.6,47.6-126.2c3.5-7.5,14.7-10.4,23.7-4.1l11.6-32.1C147.6,3,142.8,1.9,139.1,1.1z M72.3,58.3 C62,43.5,35.9,64.5,30.3,47.8c-6.6,1.4-9-6.2-7.4-8.9c0,0-5.5-0.9-4.9-8.7C37.9,43.4,76.4,10.2,72.3,58.3z"
            })
        ]
    }),
    "stripe": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 384 512",
        fill: "#635bff",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
            d: "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.1 396.1 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
        })
    }),
    "tool": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-tool",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
            })
        ]
    }),
    "arrow-right": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-arrow-right",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "13",
                y1: "18",
                x2: "19",
                y2: "12"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "13",
                y1: "6",
                x2: "19",
                y2: "12"
            })
        ]
    }),
    "clock": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-clock",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "12",
                cy: "12",
                r: "9"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("polyline", {
                points: "12 7 12 12 15 15"
            })
        ]
    }),
    "refresh": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-reload",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1.002 7.935 1.007 9.425 4.747"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M20 4v5h-5"
            })
        ]
    }),
    "invoice": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-file-invoice",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M14 3v4a1 1 0 0 0 1 1h4"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "9",
                y1: "7",
                x2: "10",
                y2: "7"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "9",
                y1: "13",
                x2: "15",
                y2: "13"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "13",
                y1: "17",
                x2: "15",
                y2: "17"
            })
        ]
    }),
    "download": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-download",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("polyline", {
                points: "7 11 12 16 17 11"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("line", {
                x1: "12",
                y1: "4",
                x2: "12",
                y2: "16"
            })
        ]
    }),
    "rocket": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-rocket",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "15",
                cy: "9",
                r: "1"
            })
        ]
    }),
    "beta": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-beta",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M8 22v-14a4 4 0 0 1 4 -4h.5a3.5 3.5 0 0 1 0 7h-.5h.5a4.5 4.5 0 1 1 -4.5 4.5v-.5"
            })
        ]
    }),
    "gift": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "icon icon-tabler icon-tabler-receipt-2",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "stroke-width": "2",
        stroke: "currentColor",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
                d: "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5"
            })
        ]
    }),
    "phone": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("path", {
            d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
        })
    })
};
const $2a0eabf503a7e085$var$SIZES = {
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48,
    xxl: 64
};
const $2a0eabf503a7e085$export$f04a61298a47a40f = ({ className: className, icon: icon, size: size = "md" })=>{
    if (!icon) return null;
    const sizeProp = typeof size === "number" ? size : $2a0eabf503a7e085$var$SIZES[size];
    return (0, $VqyUd.cloneElement)($2a0eabf503a7e085$var$ICONS[icon], {
        class: className,
        "aria-hidden": true,
        width: sizeProp,
        height: sizeProp
    });
};






const $d6dd782797fe2e79$export$7f7cbe89f1eacd2 = ({ className: className, size: size = "lg", color: color = "light" })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: className,
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("spinner", "spinner--" + size, "spinner--" + color),
            viewBox: "0 0 100 100",
            xmlns: "http://www.w3.org/2000/svg",
            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("circle", {
                cx: "50",
                cy: "50",
                r: "45"
            })
        })
    });


const $9a1491f88e20bcdd$var$ButtonContent = ({ className: className, icon: icon, actionInProgress: actionInProgress, children: children })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("button__content", className),
        children: [
            !actionInProgress && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                        icon: icon
                    }),
                    children
                ]
            }),
            actionInProgress && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d6dd782797fe2e79$export$7f7cbe89f1eacd2), {
                size: "md"
            })
        ]
    });
const $9a1491f88e20bcdd$var$makeButtonClassName = (disabled, actionInProgress, variant = "default", fullWidth, className)=>(0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("button", "button--" + variant, className, {
        "button--disabled": disabled,
        "button--enabled": !disabled,
        "button--action-in-progress": actionInProgress,
        "button--full-width": fullWidth
    });
const $9a1491f88e20bcdd$export$353f5b6fc5456de1 = ({ className: className, innerClassName: innerClassName, icon: icon, variant: variant, fullWidth: fullWidth, disabled: disabled, actionInProgress: actionInProgress, visuallyHiddenLabel: visuallyHiddenLabel, children: children, ...props })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("button", {
        className: $9a1491f88e20bcdd$var$makeButtonClassName(disabled, actionInProgress, variant, fullWidth, className),
        draggable: false,
        disabled: disabled || actionInProgress,
        ...props,
        children: [
            variant === "icon" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                icon: icon
            }),
            variant !== "icon" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($9a1491f88e20bcdd$var$ButtonContent, {
                className: innerClassName,
                icon: icon,
                actionInProgress: actionInProgress,
                children: children
            }),
            visuallyHiddenLabel && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                className: "visually-hidden",
                children: visuallyHiddenLabel
            })
        ]
    });
const $9a1491f88e20bcdd$export$29d11c0fe2fc51d8 = ({ className: className, innerClassName: innerClassName, variant: variant, fullWidth: fullWidth, children: children, disabled: disabled, href: href, icon: icon, visuallyHiddenLabel: visuallyHiddenLabel, ...props })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
        className: $9a1491f88e20bcdd$var$makeButtonClassName(disabled, false, variant, fullWidth, className),
        href: disabled ? undefined : href,
        draggable: false,
        ...props,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($9a1491f88e20bcdd$var$ButtonContent, {
                className: innerClassName,
                icon: icon,
                children: children
            }),
            visuallyHiddenLabel && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                className: "visually-hidden",
                children: visuallyHiddenLabel
            })
        ]
    });
};
const $9a1491f88e20bcdd$export$f5b8910cec6cf069 = (0, $b71353478e820d05$export$257a8862b851cb5b)(({ className: className, onValueChange: onValueChange, onInput: onInput, ...props }, ref)=>{
    const handleInput = (0, $f6LVE.useMemo)(()=>{
        if (!onValueChange && !props.onChange && !onInput) return;
        return function(ev) {
            onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(ev.currentTarget.value);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onInput === null || onInput === void 0 ? void 0 : onInput(ev);
        };
    }, [
        onInput,
        onValueChange,
        props.onChange
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("input", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("input", className),
        onInput: handleInput
    });
});





const $35cc81e749a21589$export$2e0a83ec2e27ecbb = ({ className: className, size: size = "sm" })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("hr", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("divider", "divider--" + size, className)
    });



var $VqyUd = parcelRequire("VqyUd");
const $d3b17ce220e9921d$export$f102e87ccfb079d0 = ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: window.location.host
    });



const $09f8266e1bb4f56b$export$897b176220633e35 = ({ className: className, subject: subject, children: children })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
        className: className,
        href: `mailto:support@brng.net${subject ? `?subject=${subject}` : ""}`,
        children: children
    });




var $f6LVE = parcelRequire("f6LVE");


const $6620d597003ccb23$var$DURATIONS = {
    "sm": 200,
    "md": 400
};
const $6620d597003ccb23$export$1cfea591e85f6e12 = ({ className: className, open: open, duration: duration = "md", onTransitionComplete: onTransitionComplete, alwaysTransition: alwaysTransition = false, children: children })=>{
    const root = (0, $f6LVE.useRef)();
    const content = (0, $f6LVE.useRef)();
    const transition = (0, $f6LVE.useRef)();
    const [targetHeight, setTargetHeight] = (0, $f6LVE.useState)(0);
    const [firstTransition, setFirstTransition] = (0, $f6LVE.useState)(!alwaysTransition);
    const [status, setStatus] = (0, $f6LVE.useState)(open ? "open" : "closed");
    (0, $f6LVE.useEffect)(()=>{
        clearTimeout(transition.current);
        setTargetHeight(open ? content.current.scrollHeight : 0);
        setStatus("transitioning");
        transition.current = setTimeout(()=>{
            setStatus(open ? "open" : "closed");
            onTransitionComplete === null || onTransitionComplete === void 0 ? void 0 : onTransitionComplete(open);
            setFirstTransition(false);
        }, $6620d597003ccb23$var$DURATIONS[duration]);
    }, [
        open,
        children,
        onTransitionComplete,
        duration
    ]);
    const rootStyle = (0, $f6LVE.useMemo)(()=>({
            height: targetHeight,
            transition: firstTransition ? undefined : `height ${$6620d597003ccb23$var$DURATIONS[duration]}ms`
        }), [
        targetHeight,
        firstTransition,
        duration
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))(className, "expander"),
        ref: root,
        style: rootStyle,
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("expander__content", {
                "expander__content--visible": status !== "closed"
            }),
            ref: content,
            children: children
        })
    });
};



const $8143b26344ce82ab$export$b2bf131c9f9cce5d = ({ className: className, href: href, children: children })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
        className: className,
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: children
    });






var $VqyUd = parcelRequire("VqyUd");




var $VqyUd = parcelRequire("VqyUd");

const $7b33dd34c0380449$export$1c6175f3aa4394b7 = ({ id: id, className: className, tag: tag = "div", font: font = "sans", size: size = "md", align: align = "start", weight: weight = "normal", overImage: overImage, secondary: secondary, tooltip: tooltip, style: style, children: children })=>(0, $VqyUd.h)(tag, {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))(className, "typography", "typography--font-" + font, "typography--size-" + size, "typography--align-" + align, "typography--weight-" + weight, {
            "typography--over-image": overImage,
            "typography--secondary": secondary
        }),
        title: tooltip,
        style: style,
        children: children
    });
const $7b33dd34c0380449$export$95aa4184327d6b72 = ({ tag: tag = "span", className: className, children: children })=>(0, $VqyUd.h)(tag, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))(className, "typography--weight-bold"),
        children: children
    });
const $7b33dd34c0380449$var$HEADING_LEVEL_SIZES = {
    1: "xxl",
    2: "xl",
    3: "lg"
};
const $7b33dd34c0380449$export$a8a3e93435678ff9 = ({ level: level, children: children, ...props })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($7b33dd34c0380449$export$1c6175f3aa4394b7, {
        tag: "h" + level,
        size: $7b33dd34c0380449$var$HEADING_LEVEL_SIZES[level],
        font: level === 1 ? "display" : undefined,
        weight: "bold",
        ...props,
        children: children
    });




const $898f8d3f46342bff$export$2ddb90ad54e5f587 = ({ tag: tag = "div", className: className, padding: padding = "md", opaque: opaque, children: children })=>{
    return (0, $VqyUd.h)(tag, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("panel", "panel--pad-" + padding, {
            "panel--opaque": opaque
        }, className),
        children: children
    });
};
const $898f8d3f46342bff$export$86de09faaa70680d = ({ headingLevel: headingLevel = 2, icon: icon, title: title })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                className: "panel-title",
                level: headingLevel,
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                        icon: icon
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                        children: title
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {})
        ]
    });







var $f6LVE = parcelRequire("f6LVE");

var $f6LVE = parcelRequire("f6LVE");

function $d3621e821f58e4a2$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f388115d7631ba12$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f388115d7631ba12$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f388115d7631ba12$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3a9ba85c65932732$export$8960430cfd85939f = Math.max;
var $3a9ba85c65932732$export$96ec731ed4dcb222 = Math.min;
var $3a9ba85c65932732$export$2077e0241d6afd3c = Math.round;



function $0b871586c057410d$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $cdbe3925e6d5291c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $0b871586c057410d$export$2e2bcd8739ae039)());
}


function $8c050f357eba4061$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f388115d7631ba12$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3a9ba85c65932732$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3a9ba85c65932732$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f388115d7631ba12$export$45a5e7f76e0caa8d)(element) ? (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $cdbe3925e6d5291c$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $de68849545f9937f$export$2e2bcd8739ae039(node) {
    var win = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $51055f1ba66930a3$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $10c383ac12314d9a$export$2e2bcd8739ae039(node) {
    if (node === (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(node) || !(0, $f388115d7631ba12$export$1b3bfaa9684536aa)(node)) return (0, $de68849545f9937f$export$2e2bcd8739ae039)(node);
    else return (0, $51055f1ba66930a3$export$2e2bcd8739ae039)(node);
}


function $2f67ef60f286c40d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $7e24b7e896b8094f$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f388115d7631ba12$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $57a753c1140e94eb$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $8c050f357eba4061$export$2e2bcd8739ae039)((0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(element)).left + (0, $de68849545f9937f$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $99e5b7f09ba4bba1$export$2e2bcd8739ae039(element) {
    return (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $d5a6d831bca88fd9$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $d22e58a8c818d754$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3a9ba85c65932732$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3a9ba85c65932732$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d22e58a8c818d754$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f388115d7631ba12$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f388115d7631ba12$export$1b3bfaa9684536aa)(offsetParent) && $d22e58a8c818d754$var$isElementScaled(offsetParent);
    var documentElement = (0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $8c050f357eba4061$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $d5a6d831bca88fd9$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $10c383ac12314d9a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f388115d7631ba12$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $8c050f357eba4061$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $57a753c1140e94eb$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $8f0d59a63184084a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $8c050f357eba4061$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $bf5b95e60137b2bd$export$2e2bcd8739ae039(element) {
    if ((0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f388115d7631ba12$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $b5bbf267d7b18661$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f388115d7631ba12$export$1b3bfaa9684536aa)(node) && (0, $d5a6d831bca88fd9$export$2e2bcd8739ae039)(node)) return node;
    return $b5bbf267d7b18661$export$2e2bcd8739ae039((0, $bf5b95e60137b2bd$export$2e2bcd8739ae039)(node));
}





function $11be558277cf2ffa$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $b5bbf267d7b18661$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $d5a6d831bca88fd9$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($11be558277cf2ffa$export$2e2bcd8739ae039((0, $bf5b95e60137b2bd$export$2e2bcd8739ae039)(target)));
}







function $906567cfca9b23ac$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(element)) >= 0;
}




function $e6ac05295b7fca4e$var$getTrueOffsetParent(element) {
    if (!(0, $f388115d7631ba12$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e6ac05295b7fca4e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $0b871586c057410d$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $0b871586c057410d$export$2e2bcd8739ae039)());
    if (isIE && (0, $f388115d7631ba12$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $bf5b95e60137b2bd$export$2e2bcd8739ae039)(element);
    if ((0, $f388115d7631ba12$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f388115d7631ba12$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e6ac05295b7fca4e$export$2e2bcd8739ae039(element) {
    var window = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(element);
    var offsetParent = $e6ac05295b7fca4e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $906567cfca9b23ac$export$2e2bcd8739ae039)(offsetParent) && (0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $e6ac05295b7fca4e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $e6ac05295b7fca4e$var$getContainingBlock(element) || window;
}



var $dfdd9e7dc091e993$export$1e95b668f3b82d = "top";
var $dfdd9e7dc091e993$export$40e543e69a8b3fbb = "bottom";
var $dfdd9e7dc091e993$export$79ffe56a765070d2 = "right";
var $dfdd9e7dc091e993$export$eabcd2c8791e7bf4 = "left";
var $dfdd9e7dc091e993$export$dfb5619354ba860 = "auto";
var $dfdd9e7dc091e993$export$aec2ce47c367b8c3 = [
    $dfdd9e7dc091e993$export$1e95b668f3b82d,
    $dfdd9e7dc091e993$export$40e543e69a8b3fbb,
    $dfdd9e7dc091e993$export$79ffe56a765070d2,
    $dfdd9e7dc091e993$export$eabcd2c8791e7bf4
];
var $dfdd9e7dc091e993$export$b3571188c770cc5a = "start";
var $dfdd9e7dc091e993$export$bd5df0f255a350f8 = "end";
var $dfdd9e7dc091e993$export$390fd549c5303b4d = "clippingParents";
var $dfdd9e7dc091e993$export$d7b7311ec04a3e8f = "viewport";
var $dfdd9e7dc091e993$export$ae5ab1c730825774 = "popper";
var $dfdd9e7dc091e993$export$ca50aac9f3ba507f = "reference";
var $dfdd9e7dc091e993$export$368f9a87e87fa4e1 = /*#__PURE__*/ $dfdd9e7dc091e993$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $dfdd9e7dc091e993$export$b3571188c770cc5a,
        placement + "-" + $dfdd9e7dc091e993$export$bd5df0f255a350f8
    ]);
}, []);
var $dfdd9e7dc091e993$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($dfdd9e7dc091e993$export$aec2ce47c367b8c3, [
    $dfdd9e7dc091e993$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $dfdd9e7dc091e993$export$b3571188c770cc5a,
        placement + "-" + $dfdd9e7dc091e993$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $dfdd9e7dc091e993$export$421679a7c3d56e = "beforeRead";
var $dfdd9e7dc091e993$export$aafa59e2e03f2942 = "read";
var $dfdd9e7dc091e993$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $dfdd9e7dc091e993$export$c65e99957a05207c = "beforeMain";
var $dfdd9e7dc091e993$export$f22da7240b7add18 = "main";
var $dfdd9e7dc091e993$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $dfdd9e7dc091e993$export$8d4d2d70e7d46032 = "beforeWrite";
var $dfdd9e7dc091e993$export$68d8715fc104d294 = "write";
var $dfdd9e7dc091e993$export$70a6e5159acce2e6 = "afterWrite";
var $dfdd9e7dc091e993$export$d087d3878fdf71d5 = [
    $dfdd9e7dc091e993$export$421679a7c3d56e,
    $dfdd9e7dc091e993$export$aafa59e2e03f2942,
    $dfdd9e7dc091e993$export$6964f6c886723980,
    $dfdd9e7dc091e993$export$c65e99957a05207c,
    $dfdd9e7dc091e993$export$f22da7240b7add18,
    $dfdd9e7dc091e993$export$bab79516f2d662fe,
    $dfdd9e7dc091e993$export$8d4d2d70e7d46032,
    $dfdd9e7dc091e993$export$68d8715fc104d294,
    $dfdd9e7dc091e993$export$70a6e5159acce2e6
];


function $0b0e7420fe3bb740$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0b0e7420fe3bb740$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0b0e7420fe3bb740$var$order(modifiers); // order based on phase
    return (0, $dfdd9e7dc091e993$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6a155031375a7dd0$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $29bdf100f6dd4c95$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $0b77bc41e816972a$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $0b77bc41e816972a$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $0b77bc41e816972a$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $0b77bc41e816972a$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $0b77bc41e816972a$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0b77bc41e816972a$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $0b77bc41e816972a$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f388115d7631ba12$export$45a5e7f76e0caa8d)(reference) ? (0, $11be558277cf2ffa$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $11be558277cf2ffa$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $11be558277cf2ffa$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0b0e7420fe3bb740$export$2e2bcd8739ae039)((0, $29bdf100f6dd4c95$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$0b77bc41e816972a$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d22e58a8c818d754$export$2e2bcd8739ae039)(reference, (0, $e6ac05295b7fca4e$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $8f0d59a63184084a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6a155031375a7dd0$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0b77bc41e816972a$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0b77bc41e816972a$export$8f7491d57c8f97a9 = /*#__PURE__*/ $0b77bc41e816972a$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $73583d28b61ea5b1$var$passive = {
    passive: true
};
function $73583d28b61ea5b1$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $73583d28b61ea5b1$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $73583d28b61ea5b1$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $73583d28b61ea5b1$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $73583d28b61ea5b1$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $73583d28b61ea5b1$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $73583d28b61ea5b1$var$effect,
    data: {}
};



function $29f442e05bae5535$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $0261f69387ca62b9$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $7a0c5bfb003512d1$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $81c5c0c20e1cce18$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $29f442e05bae5535$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $0261f69387ca62b9$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $dfdd9e7dc091e993$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $dfdd9e7dc091e993$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $7a0c5bfb003512d1$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $dfdd9e7dc091e993$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $dfdd9e7dc091e993$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $2e370cc9996b7638$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $81c5c0c20e1cce18$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2e370cc9996b7638$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $2e370cc9996b7638$var$popperOffsets,
    data: {}
};










var $b743b7ec047b00d2$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $b743b7ec047b00d2$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3a9ba85c65932732$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3a9ba85c65932732$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $b743b7ec047b00d2$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4);
    var sideY = (0, $dfdd9e7dc091e993$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $e6ac05295b7fca4e$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(popper);
            if ((0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $dfdd9e7dc091e993$export$1e95b668f3b82d) || (placement === (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4) || placement === (0, $dfdd9e7dc091e993$export$79ffe56a765070d2)) && variation === (0, $dfdd9e7dc091e993$export$bd5df0f255a350f8)) {
            sideY = (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4) || (placement === (0, $dfdd9e7dc091e993$export$1e95b668f3b82d) || placement === (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb)) && variation === (0, $dfdd9e7dc091e993$export$bd5df0f255a350f8)) {
            sideX = (0, $dfdd9e7dc091e993$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $b743b7ec047b00d2$var$unsetSides);
    var _ref4 = roundOffsets === true ? $b743b7ec047b00d2$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $b743b7ec047b00d2$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $29f442e05bae5535$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $0261f69387ca62b9$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $b743b7ec047b00d2$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $b743b7ec047b00d2$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $b743b7ec047b00d2$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $b743b7ec047b00d2$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $170bacf3599f71f8$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f388115d7631ba12$export$1b3bfaa9684536aa)(element) || !(0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $170bacf3599f71f8$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f388115d7631ba12$export$1b3bfaa9684536aa)(element) || !(0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $170bacf3599f71f8$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $170bacf3599f71f8$var$applyStyles,
    effect: $170bacf3599f71f8$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $11abb32f4d94efc3$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $29f442e05bae5535$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4),
        (0, $dfdd9e7dc091e993$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4),
        (0, $dfdd9e7dc091e993$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $11abb32f4d94efc3$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $dfdd9e7dc091e993$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $11abb32f4d94efc3$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $11abb32f4d94efc3$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $11abb32f4d94efc3$var$offset
};


var $a0bc3ac8c7794e00$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $a0bc3ac8c7794e00$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $a0bc3ac8c7794e00$var$hash[matched];
    });
}



var $9f4159de636dc607$var$hash = {
    start: "end",
    end: "start"
};
function $9f4159de636dc607$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $9f4159de636dc607$var$hash[matched];
    });
}







function $68fb4f5f2b818ddc$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d3621e821f58e4a2$export$2e2bcd8739ae039)(element);
    var html = (0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $cdbe3925e6d5291c$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $57a753c1140e94eb$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f20a0bacfe2ef983$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $de68849545f9937f$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3a9ba85c65932732$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3a9ba85c65932732$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $57a753c1140e94eb$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3a9ba85c65932732$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $2a33f5f79dc78c2c$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f388115d7631ba12$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $8b050c80188b1e45$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $7766452e35a3f2c9$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $8c050f357eba4061$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $7766452e35a3f2c9$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $dfdd9e7dc091e993$export$d7b7311ec04a3e8f) ? (0, $8b050c80188b1e45$export$2e2bcd8739ae039)((0, $68fb4f5f2b818ddc$export$2e2bcd8739ae039)(element, strategy)) : (0, $f388115d7631ba12$export$45a5e7f76e0caa8d)(clippingParent) ? $7766452e35a3f2c9$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $8b050c80188b1e45$export$2e2bcd8739ae039)((0, $f20a0bacfe2ef983$export$2e2bcd8739ae039)((0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $7766452e35a3f2c9$var$getClippingParents(element) {
    var clippingParents = (0, $11be558277cf2ffa$export$2e2bcd8739ae039)((0, $bf5b95e60137b2bd$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $99e5b7f09ba4bba1$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f388115d7631ba12$export$1b3bfaa9684536aa)(element) ? (0, $e6ac05295b7fca4e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f388115d7631ba12$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f388115d7631ba12$export$45a5e7f76e0caa8d)(clippingParent) && (0, $2a33f5f79dc78c2c$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $2f67ef60f286c40d$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $7766452e35a3f2c9$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $7766452e35a3f2c9$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $7766452e35a3f2c9$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3a9ba85c65932732$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3a9ba85c65932732$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3a9ba85c65932732$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3a9ba85c65932732$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $7766452e35a3f2c9$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $d96e9c754762584e$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $f3d95802d078c9c2$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $d96e9c754762584e$export$2e2bcd8739ae039)(), paddingObject);
}


function $e346b48eabe87ff9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $0dc5ed671a1a090a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $dfdd9e7dc091e993$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $dfdd9e7dc091e993$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $dfdd9e7dc091e993$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $f3d95802d078c9c2$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e346b48eabe87ff9$export$2e2bcd8739ae039)(padding, (0, $dfdd9e7dc091e993$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $dfdd9e7dc091e993$export$ae5ab1c730825774) ? (0, $dfdd9e7dc091e993$export$ca50aac9f3ba507f) : (0, $dfdd9e7dc091e993$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $7766452e35a3f2c9$export$2e2bcd8739ae039)((0, $f388115d7631ba12$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $7e24b7e896b8094f$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $8c050f357eba4061$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $81c5c0c20e1cce18$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $8b050c80188b1e45$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $dfdd9e7dc091e993$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $dfdd9e7dc091e993$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $dfdd9e7dc091e993$export$79ffe56a765070d2),
                (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $dfdd9e7dc091e993$export$1e95b668f3b82d),
                (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $030ebaa6210b13dd$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $dfdd9e7dc091e993$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $0261f69387ca62b9$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $dfdd9e7dc091e993$export$368f9a87e87fa4e1) : (0, $dfdd9e7dc091e993$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $0261f69387ca62b9$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $dfdd9e7dc091e993$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $0dc5ed671a1a090a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $29f442e05bae5535$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a5ed61d9e8abbc1e$var$getExpandedFallbackPlacements(placement) {
    if ((0, $29f442e05bae5535$export$2e2bcd8739ae039)(placement) === (0, $dfdd9e7dc091e993$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $a0bc3ac8c7794e00$export$2e2bcd8739ae039)(placement);
    return [
        (0, $9f4159de636dc607$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $9f4159de636dc607$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a5ed61d9e8abbc1e$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $29f442e05bae5535$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $a0bc3ac8c7794e00$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a5ed61d9e8abbc1e$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $29f442e05bae5535$export$2e2bcd8739ae039)(placement) === (0, $dfdd9e7dc091e993$export$dfb5619354ba860) ? (0, $030ebaa6210b13dd$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $29f442e05bae5535$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $0261f69387ca62b9$export$2e2bcd8739ae039)(placement) === (0, $dfdd9e7dc091e993$export$b3571188c770cc5a);
        var isVertical = [
            (0, $dfdd9e7dc091e993$export$1e95b668f3b82d),
            (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $0dc5ed671a1a090a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $dfdd9e7dc091e993$export$79ffe56a765070d2) : (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb) : (0, $dfdd9e7dc091e993$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $a0bc3ac8c7794e00$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $a0bc3ac8c7794e00$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a5ed61d9e8abbc1e$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $a5ed61d9e8abbc1e$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $7e6e26fc92b5dbc5$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $64d5b5c14950b31c$export$f28d906d67a997f3(min, value, max) {
    return (0, $3a9ba85c65932732$export$8960430cfd85939f)(min, (0, $3a9ba85c65932732$export$96ec731ed4dcb222)(value, max));
}
function $64d5b5c14950b31c$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $64d5b5c14950b31c$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3e49c309b7ea7277$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $0dc5ed671a1a090a$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $29f442e05bae5535$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $0261f69387ca62b9$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $7a0c5bfb003512d1$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $7e6e26fc92b5dbc5$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $dfdd9e7dc091e993$export$1e95b668f3b82d) : (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb) : (0, $dfdd9e7dc091e993$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $dfdd9e7dc091e993$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $dfdd9e7dc091e993$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8f0d59a63184084a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $d96e9c754762584e$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $64d5b5c14950b31c$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $e6ac05295b7fca4e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $64d5b5c14950b31c$export$f28d906d67a997f3)(tether ? (0, $3a9ba85c65932732$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3a9ba85c65932732$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $dfdd9e7dc091e993$export$1e95b668f3b82d) : (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb) : (0, $dfdd9e7dc091e993$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $dfdd9e7dc091e993$export$1e95b668f3b82d),
            (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $64d5b5c14950b31c$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $64d5b5c14950b31c$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3e49c309b7ea7277$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3e49c309b7ea7277$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};












var $0155bd90563c0ce3$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $f3d95802d078c9c2$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e346b48eabe87ff9$export$2e2bcd8739ae039)(padding, (0, $dfdd9e7dc091e993$export$aec2ce47c367b8c3)));
};
function $0155bd90563c0ce3$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $29f442e05bae5535$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $7a0c5bfb003512d1$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4),
        (0, $dfdd9e7dc091e993$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0155bd90563c0ce3$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8f0d59a63184084a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $dfdd9e7dc091e993$export$1e95b668f3b82d) : (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb) : (0, $dfdd9e7dc091e993$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $e6ac05295b7fca4e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $64d5b5c14950b31c$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0155bd90563c0ce3$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $2a33f5f79dc78c2c$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0155bd90563c0ce3$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $0155bd90563c0ce3$var$arrow,
    effect: $0155bd90563c0ce3$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $c1aa32f9ebbf26f8$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $c1aa32f9ebbf26f8$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $dfdd9e7dc091e993$export$1e95b668f3b82d),
        (0, $dfdd9e7dc091e993$export$79ffe56a765070d2),
        (0, $dfdd9e7dc091e993$export$40e543e69a8b3fbb),
        (0, $dfdd9e7dc091e993$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $c1aa32f9ebbf26f8$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $0dc5ed671a1a090a$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $0dc5ed671a1a090a$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $c1aa32f9ebbf26f8$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $c1aa32f9ebbf26f8$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $c1aa32f9ebbf26f8$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $c1aa32f9ebbf26f8$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $c1aa32f9ebbf26f8$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $c1aa32f9ebbf26f8$var$hide
};




var $54bf6c970fa40c1d$export$d34966752335dd47 = [
    (0, $73583d28b61ea5b1$export$2e2bcd8739ae039),
    (0, $2e370cc9996b7638$export$2e2bcd8739ae039),
    (0, $b743b7ec047b00d2$export$2e2bcd8739ae039),
    (0, $170bacf3599f71f8$export$2e2bcd8739ae039),
    (0, $11abb32f4d94efc3$export$2e2bcd8739ae039),
    (0, $a5ed61d9e8abbc1e$export$2e2bcd8739ae039),
    (0, $3e49c309b7ea7277$export$2e2bcd8739ae039),
    (0, $0155bd90563c0ce3$export$2e2bcd8739ae039),
    (0, $c1aa32f9ebbf26f8$export$2e2bcd8739ae039)
];
var $54bf6c970fa40c1d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $0b77bc41e816972a$export$ed5e13716264f202)({
    defaultModifiers: $54bf6c970fa40c1d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $0b553faa294ca56d$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $0b553faa294ca56d$var$hasElementType = typeof Element !== "undefined";
var $0b553faa294ca56d$var$hasMap = typeof Map === "function";
var $0b553faa294ca56d$var$hasSet = typeof Set === "function";
var $0b553faa294ca56d$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $0b553faa294ca56d$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$0b553faa294ca56d$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($0b553faa294ca56d$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$0b553faa294ca56d$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($0b553faa294ca56d$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($0b553faa294ca56d$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($0b553faa294ca56d$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$0b553faa294ca56d$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$0b553faa294ca56d$exports = function isEqual(a, b) {
    try {
        return $0b553faa294ca56d$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $f6LVE = parcelRequire("f6LVE");
var $308f54069aae46ec$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $308f54069aae46ec$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $308f54069aae46ec$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $308f54069aae46ec$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $308f54069aae46ec$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $308f54069aae46ec$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $f6LVE.useLayoutEffect : $f6LVE.useEffect;


var $58e5e3ff4d4d60cf$var$EMPTY_MODIFIERS = [];
var $58e5e3ff4d4d60cf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $f6LVE.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $58e5e3ff4d4d60cf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $f6LVE.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $f6LVE.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $b71353478e820d05$export$cd75ccfd720a3cd4(function() {
                    setState({
                        styles: (0, $308f54069aae46ec$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $308f54069aae46ec$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $f6LVE.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0b553faa294ca56d$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $f6LVE.useRef();
    (0, $308f54069aae46ec$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $308f54069aae46ec$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $54bf6c970fa40c1d$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



const $03e6afbee7f1d555$export$5b6b19405a83ff9d = ({ className: className, anchor: anchor, open: open, placement: placement, children: children })=>{
    const [el, setEl] = (0, $f6LVE.useState)(null);
    const { styles: styles, attributes: attributes } = (0, $58e5e3ff4d4d60cf$export$f4d5bf230a36dd6e)(anchor, el, {
        placement: placement
    });
    const [visible, setVisible] = (0, $f6LVE.useState)(false);
    const [mouseOver, setMouseOver] = (0, $f6LVE.useState)(false);
    const handleMouseEnter = (0, $f6LVE.useCallback)(()=>{
        setMouseOver(true);
    }, []);
    const handleMouseLeave = (0, $f6LVE.useCallback)(()=>{
        setMouseOver(false);
    }, []);
    (0, $f6LVE.useEffect)(()=>{
        const shouldBeVisible = open || mouseOver;
        if (shouldBeVisible === visible) return;
        if (shouldBeVisible) {
            setVisible(true);
            return;
        }
        const timeout = setTimeout(()=>{
            setVisible(false);
        }, 50);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        mouseOver,
        open,
        visible
    ]);
    if (!open && !visible) return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        ref: setEl,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("popover", className),
        ...attributes.popper,
        style: styles.popper,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            children,
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                ...attributes.arrow,
                style: styles.arrow
            })
        ]
    });
};





var $VqyUd = parcelRequire("VqyUd");

var $VqyUd = parcelRequire("VqyUd");



const $cc5b2cce57e60c51$export$caec2af78bcc877f = ({ tag: tag = "div", className: className, innerClassName: innerClassName, severity: severity, icon: icon = severity, message: message, size: size = "lg", variant: variant = "default", children: children })=>{
    return (0, $VqyUd.h)(tag, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("alert", "alert--" + severity, "alert--" + size, "alert--" + variant, className),
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
            children: [
                typeof icon === "string" ? (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                    className: "alert__icon",
                    icon: icon !== null && icon !== void 0 ? icon : severity,
                    size: size
                }) : (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                    className: "alert__icon",
                    children: icon
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                    className: "alert__message",
                    size: size,
                    weight: "bold",
                    children: message
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("alert__content", innerClassName),
                    children: children
                })
            ]
        })
    });
};




var $f6LVE = parcelRequire("f6LVE");



var $99d1b3b5938d0885$var$_window_navigator;
const $99d1b3b5938d0885$var$clipboard = ($99d1b3b5938d0885$var$_window_navigator = window.navigator) === null || $99d1b3b5938d0885$var$_window_navigator === void 0 ? void 0 : $99d1b3b5938d0885$var$_window_navigator.clipboard;
const $99d1b3b5938d0885$export$e5ff2bc79de811b1 = ({ className: className, children: children })=>{
    const [copied, setCopied] = (0, $f6LVE.useState)(false);
    const copyableContentRef = (0, $f6LVE.useRef)(null);
    const handleClick = (0, $f6LVE.useCallback)(()=>{
        if (!$99d1b3b5938d0885$var$clipboard) return;
        const copyableContentEl = copyableContentRef.current;
        if (!copyableContentEl) return;
        const copyableText = copyableContentEl.innerText;
        $99d1b3b5938d0885$var$clipboard.writeText(copyableText).then(()=>setCopied(true));
    }, []);
    (0, $f6LVE.useEffect)(()=>{
        if (!copied) return;
        const timeout = setTimeout(()=>{
            setCopied(false);
        }, 1500);
        return ()=>{
            clearTimeout(timeout);
            setCopied(false);
        };
    }, [
        copied
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("copyable", className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                ref: copyableContentRef,
                children: children
            }),
            $99d1b3b5938d0885$var$clipboard && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                className: "copyable__button",
                icon: copied ? "success" : "copy",
                onClick: handleClick,
                children: copied ? "Copied" : "Copy"
            })
        ]
    });
};



var $VqyUd = parcelRequire("VqyUd");

var $f6LVE = parcelRequire("f6LVE");


const $51a49da4e18e6ef6$export$3657a1d9b6f67fde = ({ resendEmail: resendEmail })=>{
    const [sent, setSent] = (0, $f6LVE.useState)(false);
    const handleClick = (ev)=>{
        ev.preventDefault();
        resendEmail().then(()=>{
            setSent(true);
        });
    };
    (0, $f6LVE.useEffect)(()=>{
        if (!sent) return;
        const timeout = setTimeout(()=>{
            setSent(false);
        }, 2000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        sent
    ]);
    if (sent) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
        severity: "success",
        size: "md",
        message: "Email resent."
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                href: "#resend",
                onClick: handleClick,
                "data-native": true,
                children: "Resend the email"
            }),
            "."
        ]
    });
};
const $51a49da4e18e6ef6$export$a4360a83c01036a3 = ({ className: className, resendEmail: resendEmail })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("details", {
        className: className,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("summary", {
                children: "Didn't receive an email from us?"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "copy",
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                            children: "Check your spam or junk folder."
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($51a49da4e18e6ef6$export$3657a1d9b6f67fde, {
                                resendEmail: resendEmail
                            })
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $09f8266e1bb4f56b$export$897b176220633e35), {
                                    children: "Contact support"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            })
        ]
    });



var $VqyUd = parcelRequire("VqyUd");


var $VqyUd = parcelRequire("VqyUd");

var $f6LVE = parcelRequire("f6LVE");


const $c20181e0c06eda6d$export$a7fed597f4b8afd8 = ({ className: className, submitLabel: submitLabel = "Submit", onSubmit: onSubmit, children: children, disabled: disabled, header: header, footer: footer, secondaryActions: secondaryActions })=>{
    const handleSubmit = (0, $f6LVE.useCallback)((ev)=>{
        if (disabled) return;
        ev.preventDefault();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    }, [
        disabled,
        onSubmit
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("form", className),
        onSubmit: handleSubmit,
        children: [
            header && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    header,
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {
                        size: "sm"
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "form__fields",
                children: children
            }),
            footer && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {
                        size: "sm"
                    }),
                    footer
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {
                size: "sm"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "form__actions",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        className: "form__secondary-actions",
                        children: secondaryActions
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                        className: "form__submit-button",
                        type: "submit",
                        disabled: disabled,
                        children: submitLabel
                    })
                ]
            })
        ]
    });
};
const $c20181e0c06eda6d$export$56e87bf42978147a = ({ id: id, label: label, input: input, description: description })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "form-field",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("label", {
                className: "form-field__label",
                for: "id",
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                    size: "lg",
                    children: label
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "form-field__description",
                children: description
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "form-field__input",
                children: (0, $VqyUd.cloneElement)(input, {
                    id: id
                })
            })
        ]
    });



var $VqyUd = parcelRequire("VqyUd");


var $f6LVE = parcelRequire("f6LVE");



const $3a4c3e1810594c8c$var$PasswordFieldDescription = ({ touched: touched, valid: valid, message: message })=>{
    let severity = "info";
    if (valid) severity = "success";
    else if (touched) severity = "error";
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
        severity: severity,
        message: message,
        size: "md",
        icon: severity === "info" ? "point" : undefined
    });
};
const $3a4c3e1810594c8c$export$11620c714ec70a76 = ({ id: id, value: value, onValueChange: onValueChange, confirmValue: confirmValue, onConfirmValueChange: onConfirmValueChange, disabled: disabled, passwordInputRef: passwordInputRef })=>{
    const [passwordTouched, setPasswordTouched] = (0, $f6LVE.useState)(false);
    const handlePasswordBlur = (0, $f6LVE.useCallback)(()=>{
        setPasswordTouched(true);
    }, []);
    const passwordValid = value.length >= (0, $1b8b27df5a28f85a$exports.PASSWORD_MIN_LENGTH);
    const [confirmTouched, setConfirmTouched] = (0, $f6LVE.useState)(false);
    const handleConfirmBlur = (0, $f6LVE.useCallback)(()=>{
        setConfirmTouched(true);
    }, []);
    const [confirmValid, setConfirmValid] = (0, $f6LVE.useState)(false);
    const confirmInputRef = (0, $f6LVE.useRef)(null);
    (0, $f6LVE.useEffect)(()=>{
        const confirmInput = confirmInputRef.current;
        if (!confirmInput) throw new Error("Missing confirm input.");
        const nextConfirmValid = !!confirmValue.length && value === confirmValue;
        setConfirmValid(nextConfirmValid);
        confirmInput.setCustomValidity(nextConfirmValid ? "" : "Passwords must match");
    }, [
        value,
        confirmValue
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$56e87bf42978147a), {
                id: id + "Password",
                label: "Password",
                description: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($3a4c3e1810594c8c$var$PasswordFieldDescription, {
                    message: `At least ${(0, $1b8b27df5a28f85a$exports.PASSWORD_MIN_LENGTH)} characters long`,
                    touched: passwordTouched,
                    valid: passwordValid
                }),
                input: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                    ref: passwordInputRef,
                    type: "password",
                    autoComplete: "new-password",
                    value: value,
                    onValueChange: onValueChange,
                    minLength: (0, $1b8b27df5a28f85a$exports.PASSWORD_MIN_LENGTH),
                    maxLength: (0, $1b8b27df5a28f85a$exports.PASSWORD_MAX_LENGTH),
                    onBlur: handlePasswordBlur,
                    required: true,
                    disabled: disabled
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$56e87bf42978147a), {
                id: id + "Confirm",
                label: "Confirm Password",
                description: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($3a4c3e1810594c8c$var$PasswordFieldDescription, {
                    message: "Passwords must match",
                    touched: confirmTouched,
                    valid: confirmValid
                }),
                input: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                    ref: confirmInputRef,
                    type: "password",
                    autoComplete: "new-password",
                    value: confirmValue,
                    onValueChange: onConfirmValueChange,
                    minLength: (0, $1b8b27df5a28f85a$exports.PASSWORD_MIN_LENGTH),
                    maxLength: (0, $1b8b27df5a28f85a$exports.PASSWORD_MAX_LENGTH),
                    onBlur: handleConfirmBlur,
                    required: true,
                    disabled: disabled
                })
            })
        ]
    });
};



var $VqyUd = parcelRequire("VqyUd");

var $f6LVE = parcelRequire("f6LVE");



const $a880d0e8415e7802$export$2957fc44b3d2481 = ({ className: className, popoverClassName: popoverClassName, placement: placement, children: children })=>{
    const [anchor, setAnchor] = (0, $f6LVE.useState)(null);
    const [open, setOpen] = (0, $f6LVE.useState)(false);
    const handleMouseEnter = (0, $f6LVE.useCallback)(()=>{
        setOpen(true);
    }, []);
    const handleMouseLeave = (0, $f6LVE.useCallback)(()=>{
        setOpen(false);
    }, []);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("info-icon", className),
                ref: setAnchor,
                onMouseEnter: handleMouseEnter,
                onMouseEnterCapture: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onMouseLeaveCapture: handleMouseLeave,
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                    icon: "info",
                    className: "fg-brand"
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $03e6afbee7f1d555$export$5b6b19405a83ff9d), {
                className: popoverClassName,
                anchor: anchor,
                placement: placement,
                open: open,
                children: children
            })
        ]
    });
};









const $6142a1799cf62515$export$87ca8365be30c898 = ()=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    (0, $8ea62fef91697031$exports.useSubject)(accountController, "state");
    if (accountController.state.kind !== "loading") return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d6dd782797fe2e79$export$7f7cbe89f1eacd2), {
        className: "account-loading-spinner",
        size: "lg"
    });
};





var $VqyUd = parcelRequire("VqyUd");







const $f8b9ef8a0e39a5c9$var$getLastSeenClassName = (lastSeen)=>{
    if (!lastSeen) return undefined;
    const difference = (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))().diff(new Date(lastSeen), "day");
    if (difference <= 1) return "fg-good";
    if (difference <= 7) return "fg-warn";
    return "fg-bad";
};
const $f8b9ef8a0e39a5c9$export$587529144f113cfe = (p)=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))($f8b9ef8a0e39a5c9$var$getLastSeenClassName(p.date), p.className),
        children: (0, $7d3f392fa48145f5$export$1431bc52824a265)(p.date)
    });
};



const $1ba9adde318550f8$export$ec12bcfada7e9033 = (p)=>{
    const { activeUsers: activeUsers } = (0, $f57fa0ee256b0db7$export$4c949b1d75869f5a)();
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))(p.className, "activeUsersList"),
        children: activeUsers.map((user)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                    href: "/admin/users/" + user.id,
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                            tag: "span",
                            className: "activeUsersList__name",
                            weight: "bold",
                            size: "lg",
                            children: user.companyName
                        }),
                        user.lastSuccessfulValidation && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                            children: [
                                "\xa0",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f8b9ef8a0e39a5c9$export$587529144f113cfe), {
                                    className: "activeUsersList__lastSeen",
                                    date: user.lastSuccessfulValidation
                                })
                            ]
                        })
                    ]
                })
            }, user.id))
    });
};



var $VqyUd = parcelRequire("VqyUd");



var $f6LVE = parcelRequire("f6LVE");







const $9db818f2dc709656$var$getTableCellConfig = (cell)=>{
    switch(typeof cell){
        case "object":
            if ("value" in cell) return cell;
        // Fallthrough
        default:
            return {
                value: cell
            };
    }
};
const $9db818f2dc709656$export$54ec01a60f47d33d = ({ className: className, data: data, hide: hide })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("table", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("table", className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("thead", {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("tr", {
                    children: data.columns.map((column)=>{
                        if (hide === null || hide === void 0 ? void 0 : hide.includes(column)) return null;
                        return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("th", {
                            scope: "col",
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                weight: "bold",
                                children: column
                            })
                        }, column);
                    })
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("tbody", {
                children: data.rows.map((row, index)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("tr", {
                        children: data.columns.map((column)=>{
                            if (hide === null || hide === void 0 ? void 0 : hide.includes(column)) return null;
                            const cell = $9db818f2dc709656$var$getTableCellConfig(row[column]);
                            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                tag: "td",
                                className: cell.className,
                                font: typeof cell.value === "number" ? "mono" : "sans",
                                tooltip: cell.tooltip,
                                children: cell.value
                            }, column + index);
                        })
                    }, index))
            })
        ]
    });
};





const $7760e9d7085e495f$var$getBillingStatusLabel = (user)=>{
    if (user.evaluation) return "evaluation" + (user.billingStatus === "beta" ? " (beta)" : "");
    var _user_billingStatus;
    return (_user_billingStatus = user.billingStatus) !== null && _user_billingStatus !== void 0 ? _user_billingStatus : "trial";
};
const $7760e9d7085e495f$var$getBillingClassName = (user)=>{
    if (user.evaluation) return "fg-brand";
    switch(user.billingStatus){
        case "beta":
            return "fg-brand";
        case "cancelled":
            return "fg-warn";
        case "failed":
            return "fg-bad";
        case "subscribed":
            return "fg-good";
    }
};
const $7760e9d7085e495f$export$ef4e9e8580d6f0d8 = (p)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))($7760e9d7085e495f$var$getBillingClassName(p.user)),
        children: $7760e9d7085e495f$var$getBillingStatusLabel(p.user)
    });



const $99dc460396715621$var$NO_DATA = (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
    tag: "span",
    secondary: true,
    size: "sm",
    children: "No data"
});
const $99dc460396715621$var$Email = ({ email: email })=>{
    const [name, domain] = email.split("@");
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
        href: "mailto:" + email,
        children: [
            name,
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("wbr", {}),
            "@",
            domain
        ]
    });
};
const $99dc460396715621$var$HIDE = [
    "Next Billing",
    "Last Login"
];
const $99dc460396715621$export$cd9bfbaa1b680469 = ({ className: className })=>{
    const { activeUsers: activeUsers } = (0, $f57fa0ee256b0db7$export$4c949b1d75869f5a)();
    const data = (0, $f6LVE.useMemo)(()=>({
            columns: [
                "Company",
                "Email",
                "Billing",
                "Provider",
                "Devices",
                "Last Seen",
                "Users",
                "Version",
                "Last Login",
                "Next Billing"
            ],
            rows: activeUsers.sort((a, b)=>{
                const aRecent = !!a.lastSuccessfulValidation && (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))().diff(a.lastSuccessfulValidation, "months") >= 1;
                const bRecent = !!b.lastSuccessfulValidation && (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))().diff(b.lastSuccessfulValidation, "months") >= 1;
                if (aRecent === bRecent) return a.companyName.localeCompare(b.companyName);
                return aRecent ? 1 : -1;
            }).map((user)=>{
                var _user_dataProvider, _user_rfDevices, _user_sites, _user_version;
                return {
                    "Company": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                className: "active-users-view__company-and-info",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                        href: `/admin/users/${user.id}`,
                                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $a880d0e8415e7802$export$2957fc44b3d2481), {
                                            className: "active-users-view__info-icon",
                                            placement: "right-start",
                                            children: [
                                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                                    weight: "bold",
                                                    children: user.companyName
                                                }),
                                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                                                    children: [
                                                        "Next billing: ",
                                                        user.nextBillingDate ? (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(user.nextBillingDate) : $99dc460396715621$var$NO_DATA
                                                    ]
                                                }),
                                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                                                    children: [
                                                        "Last login: ",
                                                        user.lastLogin ? (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(user.lastLogin.date) : $99dc460396715621$var$NO_DATA
                                                    ]
                                                }),
                                                (!!user.stripeCustomer || !!user.freeagentContact) && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("hr", {}),
                                                user.sites && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                                                    children: [
                                                        "Sites: ",
                                                        user.sites
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                        children: user.companyName
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                className: "active-users-view__company-name",
                                children: user.companyName
                            })
                        ]
                    }),
                    "Email": (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($99dc460396715621$var$Email, {
                        email: user.email
                    }),
                    "Billing": !user.billingStatus ? $99dc460396715621$var$NO_DATA : (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7760e9d7085e495f$export$ef4e9e8580d6f0d8), {
                        user: user
                    }),
                    "Location": `${user.state ? user.state + ", " : ""}${user.country}`,
                    "Provider": (_user_dataProvider = user.dataProvider) !== null && _user_dataProvider !== void 0 ? _user_dataProvider : $99dc460396715621$var$NO_DATA,
                    "Devices": (_user_rfDevices = user.rfDevices) !== null && _user_rfDevices !== void 0 ? _user_rfDevices : $99dc460396715621$var$NO_DATA,
                    "Sites": (_user_sites = user.sites) !== null && _user_sites !== void 0 ? _user_sites : $99dc460396715621$var$NO_DATA,
                    "Last Seen": {
                        value: user.lastSuccessfulValidation ? (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f8b9ef8a0e39a5c9$export$587529144f113cfe), {
                            date: user.lastSuccessfulValidation
                        }) : $99dc460396715621$var$NO_DATA,
                        tooltip: user.lastSuccessfulValidation && (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(user.lastSuccessfulValidation).fromNow()
                    },
                    "Users": {
                        value: user.lastLogin ? (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                                    children: user.lastLogin.activeUsers
                                }),
                                " ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                    tag: "span",
                                    size: "sm",
                                    secondary: true,
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(user.lastLogin.date).format("D/MM")
                                })
                            ]
                        }) : $99dc460396715621$var$NO_DATA
                    },
                    "Version": (_user_version = user.version) !== null && _user_version !== void 0 ? _user_version : $99dc460396715621$var$NO_DATA,
                    "Last Login": user.lastLogin ? (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(user.lastLogin.date) : $99dc460396715621$var$NO_DATA,
                    "Next Billing": user.nextBillingDate ? (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(user.nextBillingDate) : $99dc460396715621$var$NO_DATA
                };
            })
        }), [
        activeUsers
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9db818f2dc709656$export$54ec01a60f47d33d), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("active-users-table", className),
        data: data,
        hide: $99dc460396715621$var$HIDE
    });
};



const $1dc40bf0067df39a$export$a73afe6a9b123780 = ()=>{
    const large = (0, $2f867275e97da052$export$199d6754bdf4e1e3)("md");
    return large ? (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $99dc460396715621$export$cd9bfbaa1b680469), {}) : (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $1ba9adde318550f8$export$ec12bcfada7e9033), {});
};










var $f6LVE = parcelRequire("f6LVE");





const $fd2fea4d33f18bf8$var$OldPasswordDescription = ({ result: result })=>{
    switch(result){
        case "bad-password":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                severity: "error",
                size: "md",
                message: "Password was incorrect"
            });
        default:
            return null;
    }
};
const $fd2fea4d33f18bf8$export$ef0ae802e3ecfb1 = ()=>{
    const authController = (0, $f57fa0ee256b0db7$export$2ddc77f16875382c)();
    const [oldPassword, setOldPassword] = (0, $f6LVE.useState)("");
    const [newPassword, setNewPassword] = (0, $f6LVE.useState)("");
    const [newPasswordConfirm, setNewPasswordConfirm] = (0, $f6LVE.useState)("");
    const [working, setWorking] = (0, $f6LVE.useState)(false);
    const [result, setResult] = (0, $f6LVE.useState)(null);
    const oldPasswordInputRef = (0, $f6LVE.useRef)(null);
    (0, $57ef02025d2ad4a3$export$a9c05560d717b4fe)(oldPasswordInputRef);
    const handleSubmit = ()=>{
        setWorking(true);
        setResult(null);
        authController.changePassword({
            oldPassword: oldPassword,
            newPassword: newPassword
        }).then((result)=>{
            setResult(result);
            switch(result){
                case "ok":
                    setOldPassword("");
                    setNewPassword("");
                    setNewPasswordConfirm("");
                    break;
                case "bad-password":
                    var _oldPasswordInputRef_current;
                    (_oldPasswordInputRef_current = oldPasswordInputRef.current) === null || _oldPasswordInputRef_current === void 0 ? void 0 : _oldPasswordInputRef_current.focus();
                    break;
            }
        }).finally(()=>{
            setWorking(false);
        });
    };
    if (result === "ok") return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "stack",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                className: "mrg-auto",
                severity: "success",
                message: "Password was changed",
                size: "lg"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                onClick: ()=>setResult(null),
                children: "OK"
            })
        ]
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$a7fed597f4b8afd8), {
        onSubmit: handleSubmit,
        submitLabel: "Change Password",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$56e87bf42978147a), {
                id: "changePasswordCurrent",
                label: "Current Password",
                description: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($fd2fea4d33f18bf8$var$OldPasswordDescription, {
                    result: result
                }),
                input: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                    ref: oldPasswordInputRef,
                    value: oldPassword,
                    onValueChange: setOldPassword,
                    type: "password",
                    required: true,
                    disabled: working
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $3a4c3e1810594c8c$export$11620c714ec70a76), {
                id: "changePasswordNew",
                value: newPassword,
                onValueChange: setNewPassword,
                confirmValue: newPasswordConfirm,
                onConfirmValueChange: setNewPasswordConfirm,
                disabled: working
            })
        ]
    });
};





var $f6LVE = parcelRequire("f6LVE");



const $c962298f4d60e43d$export$618c37ed564b5426 = ({ code: code })=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    const [status, setStatus] = (0, $f6LVE.useState)("init");
    (0, $f6LVE.useEffect)(()=>{
        if (status !== "init") return;
        setStatus("verifying");
        accountController.verifyEmail({
            code: code
        }).then((result)=>{
            switch(result){
                case "not-necessary":
                    (0, $378f8733f7648194$export$4cb887bfde2d34ca)("/");
                    return;
                default:
                    setStatus(result);
            }
        });
    }, [
        accountController,
        code,
        status
    ]);
    switch(status){
        case "verifying":
            return null;
        case "bad-code":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "stack",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                        severity: "error",
                        message: "Invalid link",
                        innerClassName: "copy",
                        size: "xl"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "Please check the email and try again."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "If you are having trouble verifying your email address, \xa0",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $09f8266e1bb4f56b$export$897b176220633e35), {
                                children: "contact support"
                            }),
                            "."
                        ]
                    })
                ]
            });
        case "ok":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "stack",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                        severity: "success",
                        message: "Email address verified!"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$29d11c0fe2fc51d8), {
                        href: "/",
                        children: "Return to Dashboard"
                    })
                ]
            });
    }
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
        children: code
    });
};



var $VqyUd = parcelRequire("VqyUd");


const $87020856e0aefa76$export$de97268a0e565029 = ({ fallback: fallback = "<your license key>" })=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    (0, $8ea62fef91697031$exports.useSubject)(accountController, "state");
    if (accountController.state.kind !== "ok") return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: fallback
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: accountController.state.details.licenseKey
    });
};




var $f6LVE = parcelRequire("f6LVE");




const $9a49b1b99f213b79$export$1f58f750f20f344b = ({ className: className, onLogIn: onLogIn })=>{
    const auth = (0, $f57fa0ee256b0db7$export$2ddc77f16875382c)();
    const [working, setWorking] = (0, $f6LVE.useState)(false);
    const [failed, setFailed] = (0, $f6LVE.useState)(false);
    const [email, setEmail] = (0, $f6LVE.useState)("");
    const [password, setPassword] = (0, $f6LVE.useState)("");
    const emailInputRef = (0, $f6LVE.useRef)(null);
    const { refocus: refocus } = (0, $57ef02025d2ad4a3$export$a9c05560d717b4fe)(emailInputRef);
    const handleSubmit = ()=>{
        if (working) return;
        setWorking(true);
        auth.login({
            email: email,
            password: password
        }).then((result)=>{
            if (result) {
                onLogIn === null || onLogIn === void 0 ? void 0 : onLogIn();
                return;
            }
            setWorking(false);
            setFailed(!result);
            setTimeout(()=>{
                refocus();
            });
        });
    };
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$a7fed597f4b8afd8), {
        className: className,
        submitLabel: "Log In",
        onSubmit: handleSubmit,
        disabled: working,
        secondaryActions: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
            size: "sm",
            secondary: true,
            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                href: "/reset-password",
                children: "Forgotten password?"
            })
        }),
        children: [
            failed && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                severity: "error",
                message: "Email address or password was incorrect.",
                size: "md"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$56e87bf42978147a), {
                id: "loginEmail",
                label: "Email Address",
                input: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                    ref: emailInputRef,
                    type: "email",
                    autoComplete: "email",
                    autocapitalize: "off",
                    value: email,
                    onValueChange: setEmail,
                    required: true,
                    disabled: working
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$56e87bf42978147a), {
                id: "loginPassword",
                label: "Password",
                input: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                    type: "password",
                    autoComplete: "current-password",
                    autoCapitalize: "off",
                    value: password,
                    onValueChange: setPassword,
                    required: true,
                    disabled: working
                })
            })
        ]
    });
};



var $VqyUd = parcelRequire("VqyUd");



var $f6LVE = parcelRequire("f6LVE");

var $73871698c3c60905$exports = {};
$parcel$export($73871698c3c60905$exports, "AdminUserRoute", function () { return $c1366b2994c00864$export$44904eddc13a0885; });
$parcel$export($73871698c3c60905$exports, "HomeRoute", function () { return $30aaa9e76d563dc4$export$48d3d184aade51b1; });
$parcel$export($73871698c3c60905$exports, "LoginRoute", function () { return $af7c1fd3414d19be$export$b4461a4f6a14f942; });
$parcel$export($73871698c3c60905$exports, "SignupRoute", function () { return $32ccc1b3fab5fe66$export$d6275cbf70a375ba; });
$parcel$export($73871698c3c60905$exports, "VerifyEmailRoute", function () { return $fdd3f71fcd90df48$export$91620953951fa2ae; });



var $f6LVE = parcelRequire("f6LVE");







var $VqyUd = parcelRequire("VqyUd");

var $9wYJ6 = parcelRequire("9wYJ6");
const $4491eda092b948d8$var$nullable = (schema)=>(0, $9wYJ6.Type).Union([
        schema,
        (0, $9wYJ6.Type).Null()
    ]);
const $4491eda092b948d8$export$2cdae4beecdfbe1e = (0, $9wYJ6.Type).Object({
    companyName: (0, $9wYJ6.Type).String(),
    address: (0, $9wYJ6.Type).String(),
    city: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    state: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    zip: (0, $9wYJ6.Type).String(),
    country: (0, $9wYJ6.Type).String(),
    sites: (0, $9wYJ6.Type).Integer(),
    rfDevices: (0, $9wYJ6.Type).Integer()
});
const $4491eda092b948d8$export$8b3df0d6eb41d036 = (0, $9wYJ6.Type).Union([
    (0, $9wYJ6.Type).Literal("beta"),
    (0, $9wYJ6.Type).Literal("trial"),
    (0, $9wYJ6.Type).Literal("subscribed"),
    (0, $9wYJ6.Type).Literal("cancelled"),
    (0, $9wYJ6.Type).Literal("failed")
]);
const $4491eda092b948d8$export$2a90d13f5a55a79e = Object.freeze([
    "beta",
    "trial",
    "subscribed",
    "cancelled",
    "failed"
]);
const $4491eda092b948d8$export$d1170d41621fcd26 = (0, $9wYJ6.Type).Union([
    (0, $9wYJ6.Type).Literal("amex"),
    (0, $9wYJ6.Type).Literal("diners"),
    (0, $9wYJ6.Type).Literal("discover"),
    (0, $9wYJ6.Type).Literal("jcb"),
    (0, $9wYJ6.Type).Literal("mastercard"),
    (0, $9wYJ6.Type).Literal("unionpay"),
    (0, $9wYJ6.Type).Literal("visa"),
    (0, $9wYJ6.Type).Literal("unknown")
], {
    title: "PaymentMethodBrand"
});
const $4491eda092b948d8$export$18636ec1f4a19d79 = (0, $9wYJ6.Type).Object({
    brand: $4491eda092b948d8$export$d1170d41621fcd26,
    lastFourDigits: (0, $9wYJ6.Type).String()
}, {
    title: "PaymentMethodDetails"
});
const $4491eda092b948d8$export$353af5c969a98280 = (0, $9wYJ6.Type).Object({
    reference: (0, $9wYJ6.Type).String(),
    dollars: (0, $9wYJ6.Type).Number(),
    reason: (0, $9wYJ6.Type).String()
}, {
    title: "FailedPaymentDetails"
});
const $4491eda092b948d8$export$ebd1310712e3e9e6 = (0, $9wYJ6.Type).Union([
    (0, $9wYJ6.Type).Literal("pending"),
    (0, $9wYJ6.Type).Literal("paid"),
    (0, $9wYJ6.Type).Literal("failed")
], {
    title: "PaymentStatus"
});
const $4491eda092b948d8$export$65e91147e3e0b5e1 = (0, $9wYJ6.Type).Object({
    id: (0, $9wYJ6.Type).String(),
    reference: (0, $9wYJ6.Type).String(),
    value: (0, $9wYJ6.Type).Number(),
    currency: (0, $9wYJ6.Type).String(),
    status: $4491eda092b948d8$export$ebd1310712e3e9e6,
    failureReason: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    createdDate: (0, $9wYJ6.Type).String({
        format: "date"
    }),
    paymentDate: (0, $9wYJ6.Type).String({
        format: "date"
    })
}, {
    title: "InvoiceDetails"
});
const $4491eda092b948d8$export$629be3fbf4846e0a = (0, $9wYJ6.Type).Object({
    stripePublicKey: (0, $9wYJ6.Type).String(),
    billingStatus: $4491eda092b948d8$export$8b3df0d6eb41d036,
    dollarsPerDevice: (0, $9wYJ6.Type).Number(),
    userCost: (0, $9wYJ6.Type).Number(),
    paymentMethod: (0, $9wYJ6.Type).Optional($4491eda092b948d8$export$18636ec1f4a19d79),
    nextPaymentDate: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    licenseExpiresDate: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    evaluation: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).Object({
        endDate: (0, $9wYJ6.Type).String(),
        firstBillingDate: (0, $9wYJ6.Type).String()
    })),
    failedPayment: (0, $9wYJ6.Type).Optional($4491eda092b948d8$export$353af5c969a98280),
    invoices: (0, $9wYJ6.Type).Array($4491eda092b948d8$export$65e91147e3e0b5e1)
}, {
    title: "AccountBillingDetails"
});
const $4491eda092b948d8$export$d36c2021d64142f7 = (0, $9wYJ6.Type).Object({
    email: (0, $9wYJ6.Type).String(),
    activatedLicense: (0, $9wYJ6.Type).Boolean(),
    verifiedEmail: (0, $9wYJ6.Type).Boolean(),
    beta: (0, $9wYJ6.Type).Boolean(),
    user: (0, $9wYJ6.Type).Union([
        $4491eda092b948d8$export$2cdae4beecdfbe1e,
        (0, $9wYJ6.Type).Null()
    ]),
    licenseKey: (0, $9wYJ6.Type).Union([
        (0, $9wYJ6.Type).String(),
        (0, $9wYJ6.Type).Null()
    ]),
    admin: (0, $9wYJ6.Type).Boolean(),
    billing: $4491eda092b948d8$export$629be3fbf4846e0a
}, {
    title: "AccountDetails"
});
const $4491eda092b948d8$export$650d153af2fa2966 = (0, $9wYJ6.Type).Partial((0, $9wYJ6.Type).Object({
    lastActiveDay: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).Object({
        activeUsers: (0, $9wYJ6.Type).Number(),
        date: (0, $9wYJ6.Type).String()
    })),
    version: (0, $9wYJ6.Type).String(),
    dataProvider: (0, $9wYJ6.Type).String(),
    lastLogin: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).Object({
        date: (0, $9wYJ6.Type).String({
            format: "date"
        }),
        activeUsers: (0, $9wYJ6.Type).Integer()
    }))
}), {
    title: "CollatedTelemetry"
});
const $4491eda092b948d8$export$157072ad86fc81be = (0, $9wYJ6.Type).Intersect([
    (0, $9wYJ6.Type).Object({
        id: (0, $9wYJ6.Type).String(),
        email: (0, $9wYJ6.Type).String(),
        companyName: (0, $9wYJ6.Type).String(),
        address: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
        city: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
        state: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
        zip: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
        country: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
        phone: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
        rfDevices: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).Integer()),
        sites: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).Integer()),
        billingStatus: (0, $9wYJ6.Type).Optional($4491eda092b948d8$export$8b3df0d6eb41d036),
        evaluation: (0, $9wYJ6.Type).Boolean(),
        lastSuccessfulValidation: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
        nextBillingDate: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String({
            format: "date"
        })),
        stripeCustomer: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String({
            format: "uri"
        })),
        freeagentContact: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String({
            format: "uri"
        }))
    }),
    $4491eda092b948d8$export$650d153af2fa2966
], {
    title: "AdminActiveUserOverview"
});
const $4491eda092b948d8$export$efc961be36e81f5f = (0, $9wYJ6.Type).Object({
    date: (0, $9wYJ6.Type).String(),
    userIds: (0, $9wYJ6.Type).Array((0, $9wYJ6.Type).String())
});
const $4491eda092b948d8$export$73662e9765f1db32 = (0, $9wYJ6.Type).Object({
    version: $4491eda092b948d8$var$nullable((0, $9wYJ6.Type).String()),
    dataProvider: $4491eda092b948d8$var$nullable((0, $9wYJ6.Type).String()),
    daily: (0, $9wYJ6.Type).Record((0, $9wYJ6.Type).String(), $4491eda092b948d8$export$efc961be36e81f5f)
});
const $4491eda092b948d8$export$b9ab34e74822177b = (0, $9wYJ6.Type).Object({
    id: (0, $9wYJ6.Type).String(),
    email: (0, $9wYJ6.Type).String(),
    companyName: (0, $9wYJ6.Type).String(),
    address: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    city: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    state: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    zip: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    country: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    phone: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    rfDevices: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).Integer()),
    sites: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).Integer()),
    billingStatus: (0, $9wYJ6.Type).Optional($4491eda092b948d8$export$8b3df0d6eb41d036),
    evaluation: (0, $9wYJ6.Type).Boolean(),
    lastSuccessfulValidation: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String()),
    nextBillingDate: (0, $9wYJ6.Type).Optional((0, $9wYJ6.Type).String({
        format: "date"
    })),
    cost: (0, $9wYJ6.Type).Union([
        (0, $9wYJ6.Type).Number(),
        (0, $9wYJ6.Type).Null()
    ]),
    freeagentContact: (0, $9wYJ6.Type).Union([
        (0, $9wYJ6.Type).String(),
        (0, $9wYJ6.Type).Null()
    ]),
    stripeCustomer: (0, $9wYJ6.Type).Union([
        (0, $9wYJ6.Type).String(),
        (0, $9wYJ6.Type).Null()
    ]),
    telemetry: $4491eda092b948d8$var$nullable($4491eda092b948d8$export$73662e9765f1db32),
    invoices: (0, $9wYJ6.Type).Array($4491eda092b948d8$export$65e91147e3e0b5e1)
}, {
    title: "AdminUserDetails"
});
const $4491eda092b948d8$export$d70eb422ca1671ad = (0, $9wYJ6.Type).Object({
    oauthUrl: (0, $9wYJ6.Type).String(),
    connected: (0, $9wYJ6.Type).Boolean()
}, {
    title: "AdminFreeAgentDetails"
});
const $4491eda092b948d8$export$279634bcbb35f92a = (0, $9wYJ6.Type).Object({
    version: (0, $9wYJ6.Type).String(),
    commit: (0, $9wYJ6.Type).String()
});
const $4491eda092b948d8$export$8bd9cb042b3cde2f = (0, $9wYJ6.Type).Object({
    build: $4491eda092b948d8$export$279634bcbb35f92a,
    activeUsers: (0, $9wYJ6.Type).Array($4491eda092b948d8$export$157072ad86fc81be),
    allUserEmailAddresses: (0, $9wYJ6.Type).Array((0, $9wYJ6.Type).String()),
    pendingBetaRequestEmailAddresses: (0, $9wYJ6.Type).Array((0, $9wYJ6.Type).String()),
    unactivatedUserEmailAddresses: (0, $9wYJ6.Type).Array((0, $9wYJ6.Type).String()),
    freeAgent: $4491eda092b948d8$export$d70eb422ca1671ad,
    enableDevTools: (0, $9wYJ6.Type).Boolean()
}, {
    title: "AdminDetails"
});





var $f6LVE = parcelRequire("f6LVE");







const $f6fb9d4486f21361$export$e7b94983f4222b90 = ({ className: className, innerClassName: innerClassName, title: title, icon: icon, children: children })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("admin-section", className),
        opaque: true,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("header", {
                className: "admin-section__header",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                        className: "admin-section__icon",
                        icon: icon,
                        size: "lg"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                        className: "admin-section__title",
                        level: 2,
                        children: title
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("admin-section__content", innerClassName),
                children: children
            })
        ]
    });



const $6c4b8b9ba186df31$var$DevGenerateFakeCompanyDataForm = ({ devTools: devTools })=>{
    const [companyName, setCompanyName] = (0, $f6LVE.useState)("");
    const handleSubmit = (ev)=>{
        ev.preventDefault();
        devTools.fakeData(companyName);
    };
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("form", {
        className: "horizontal-form",
        onSubmit: handleSubmit,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                value: companyName,
                onValueChange: setCompanyName,
                title: "Company Name",
                placeholder: "Company Name",
                required: true
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                type: "submit",
                children: "Generate Fake Company Data"
            })
        ]
    });
};
const $6c4b8b9ba186df31$var$DevSetBillingStatusForm = ({ devTools: devTools })=>{
    const [billingStatus, setBillingStatus] = (0, $f6LVE.useState)("beta");
    const handleSubmit = (ev)=>{
        ev.preventDefault();
        devTools.setBillingStatus(billingStatus);
    };
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("form", {
        className: "horizontal-form",
        onSubmit: handleSubmit,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("select", {
                value: billingStatus,
                onChange: (ev)=>setBillingStatus(ev.currentTarget.value),
                children: (0, $4491eda092b948d8$export$2a90d13f5a55a79e).map((billingStatus)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("option", {
                        value: billingStatus,
                        children: billingStatus
                    }, billingStatus))
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                type: "submit",
                children: "Set billing status"
            })
        ]
    });
};
const $6c4b8b9ba186df31$var$DevBillingCronRow = ({ devTools: devTools, field: field, days: days, cronJobName: cronJobName })=>{
    const handleLicenseExpiresClick = ()=>{
        switch(field){
            case "licenseExpires":
                devTools.setLicenseExpires(days);
                break;
            case "evaluationEnd":
                devTools.setEvaluationEnd(days);
                break;
        }
    };
    const handleCronJobClick = ()=>{
        if (cronJobName) devTools.runBillingCronJob(cronJobName);
    };
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "horizontal",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                onClick: handleLicenseExpiresClick,
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        font: "mono",
                        weight: "bold",
                        children: [
                            "user.",
                            field
                        ]
                    }),
                    "\xa0",
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        children: [
                            "in ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                                children: days
                            }),
                            " days"
                        ]
                    })
                ]
            }),
            cronJobName && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                        icon: "arrow-right"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                        onClick: handleCronJobClick,
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                children: "Run"
                            }),
                            "\xa0",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                font: "mono",
                                weight: "bold",
                                children: [
                                    cronJobName,
                                    "()"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $6c4b8b9ba186df31$export$1e9dd36382410e02 = ()=>{
    const adminController = (0, $f57fa0ee256b0db7$export$c05e53a76d53ff2d)();
    (0, $8ea62fef91697031$exports.useSubject)(adminController, "state");
    const large = (0, $2f867275e97da052$export$199d6754bdf4e1e3)("md");
    if (!large || adminController.state.kind !== "ok" || !adminController.devTools) return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f6fb9d4486f21361$export$e7b94983f4222b90), {
        className: "admin-dev-tools theme-page surface",
        title: "Dev Tools",
        icon: "tool",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("label", {
                            children: "Target user\xa0"
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("select", {
                            value: adminController.devTools.targetUser,
                            onChange: (ev)=>adminController.devTools.targetUser = ev.currentTarget.value,
                            children: adminController.state.details.allUserEmailAddresses.map((email)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("option", {
                                    value: email,
                                    children: email
                                }, email))
                        })
                    ]
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevGenerateFakeCompanyDataForm, {
                    devTools: adminController.devTools
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevSetBillingStatusForm, {
                    devTools: adminController.devTools
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevBillingCronRow, {
                    devTools: adminController.devTools,
                    field: "licenseExpires",
                    days: 5,
                    cronJobName: "renewBillingSetup"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevBillingCronRow, {
                    devTools: adminController.devTools,
                    field: "licenseExpires",
                    days: 2,
                    cronJobName: "renewBillingPayment"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevBillingCronRow, {
                    devTools: adminController.devTools,
                    field: "licenseExpires",
                    days: 0,
                    cronJobName: "expireLicenses"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevBillingCronRow, {
                    devTools: adminController.devTools,
                    field: "evaluationEnd",
                    days: (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))().add(3, "months").diff(new Date(), "days")
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevBillingCronRow, {
                    devTools: adminController.devTools,
                    field: "evaluationEnd",
                    days: 7,
                    cronJobName: "sendEvaluationPeriodWarningEmails"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($6c4b8b9ba186df31$var$DevBillingCronRow, {
                    devTools: adminController.devTools,
                    field: "evaluationEnd",
                    days: 0,
                    cronJobName: "endEvaluationPeriods"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                    onClick: adminController.devTools.resetAllBillingInformation,
                    children: "Reset all billing information"
                })
            ]
        })
    });
};





var $f6LVE = parcelRequire("f6LVE");



const $93aa5d026668a434$export$85edb5ee51c4d70b = ()=>{
    const adminController = (0, $f57fa0ee256b0db7$export$c05e53a76d53ff2d)();
    const { freeAgent: { connected: connected, oauthUrl: oauthUrl } } = (0, $f57fa0ee256b0db7$export$4c949b1d75869f5a)();
    const handleTestConnection = (0, $f6LVE.useCallback)(()=>{
        adminController.testFreeagentConnection().then((result)=>{
            // eslint-disable-next-line no-alert
            alert(result ? "Success" : "Failure!");
            if (!result) adminController.refreshData();
        });
    }, [
        adminController
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
        severity: connected ? "success" : "warning",
        message: connected ? "Connected to FreeAgent" : "Not connected to FreeAgent",
        children: [
            !connected && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$29d11c0fe2fc51d8), {
                href: oauthUrl,
                className: "mrg-auto",
                children: "Connect"
            }),
            connected && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                onClick: handleTestConnection,
                children: "Test connection"
            })
        ]
    });
};



const $63142ed19dc9d507$var$AdminHeader = ()=>{
    const { build: build } = (0, $f57fa0ee256b0db7$export$4c949b1d75869f5a)();
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("header", {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "flex-between flex-align-end",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                        level: 1,
                        children: "Admin"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        className: "mrg-t-auto",
                        size: "sm",
                        secondary: true,
                        children: [
                            "v",
                            build.version,
                            " (",
                            build.commit,
                            ")"
                        ]
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {
                size: "md"
            })
        ]
    });
};
const $63142ed19dc9d507$export$b25f57c16f88d7e0 = ()=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
        width: "full",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
            className: "admin-page stack",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($63142ed19dc9d507$var$AdminHeader, {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                    className: "admin-page__content",
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f6fb9d4486f21361$export$e7b94983f4222b90), {
                            title: "FreeAgent",
                            icon: "freeagent",
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $93aa5d026668a434$export$85edb5ee51c4d70b), {})
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f6fb9d4486f21361$export$e7b94983f4222b90), {
                            title: "Users",
                            icon: "user",
                            innerClassName: "admin-page__user-table",
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $1dc40bf0067df39a$export$a73afe6a9b123780), {})
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $6c4b8b9ba186df31$export$1e9dd36382410e02), {})
                    ]
                })
            ]
        })
    });
};


const $18e3945fd1ae2a95$export$4465eb1b2d3858c8 = (_)=>{
    const { adminController: adminController, accountController: accountController } = (0, $f57fa0ee256b0db7$export$8b376ee89da7718b)();
    (0, $8ea62fef91697031$exports.useSubject)(adminController, "state");
    (0, $8ea62fef91697031$exports.useSubject)(accountController, "state");
    (0, $f6LVE.useEffect)(()=>{
        if (accountController.state.kind === "unauthorized") {
            (0, $378f8733f7648194$export$4cb887bfde2d34ca)("/login");
            return;
        }
        if (accountController.state.kind === "ok") adminController.init();
    }, [
        accountController.state.kind,
        adminController
    ]);
    switch(adminController.state.kind){
        case "init":
        case "loading":
            return null;
        case "ok":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $63142ed19dc9d507$export$b25f57c16f88d7e0), {});
    }
};













const $ab8596abdfd6425b$var$NoData = ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "noData",
        children: "[ no data ]"
    });
const $ab8596abdfd6425b$export$1171cd935df7643a = (p)=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("table", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("keyValueTable", p.className),
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("tbody", {
            children: p.rows.filter((0, $0252c182fb6e34bb$export$f3318661327e642b)).map(({ key: key, value: value })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("tr", {
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("th", {
                            scope: "row",
                            children: key
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("td", {
                            children: (0, $0252c182fb6e34bb$export$b931b78cbb3caf86)(value) ? (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($ab8596abdfd6425b$var$NoData, {}) : value
                        })
                    ]
                }, key))
        })
    });
};




var $VqyUd = parcelRequire("VqyUd");





const $b2eb27efd79ea534$var$getInvoiceSeverity = (status, creditNode)=>{
    if (creditNode) return "success";
    switch(status){
        case "pending":
            return "info";
        case "paid":
            return "success";
        case "failed":
            return "error";
    }
};
const $b2eb27efd79ea534$var$getInvoiceIcon = (status, creditNote)=>{
    if (creditNote) return "gift";
    return status === "pending" ? "clock" : undefined;
};
const $b2eb27efd79ea534$var$InvoiceView = ({ invoice: invoice })=>{
    const data = [
        [
            "Issued",
            (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(invoice.createdDate)
        ],
        [
            invoice.status === "paid" ? "Paid" : "Due",
            (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(invoice.paymentDate)
        ]
    ];
    const creditNote = invoice.value < 0;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
        className: "invoice-view",
        innerClassName: "invoice-view__content",
        message: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
            className: "invoice-view__reference-and-value",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                    size: "lg",
                    children: invoice.reference
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                    size: "lg",
                    children: (0, $7d3f392fa48145f5$export$3dc27271f5d5c629)(invoice.value, invoice.currency)
                })
            ]
        }),
        icon: $b2eb27efd79ea534$var$getInvoiceIcon(invoice.status, creditNote),
        severity: $b2eb27efd79ea534$var$getInvoiceSeverity(invoice.status, creditNote),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        className: "invoice-view__details",
                        children: [
                            !creditNote && data.map(([key, value])=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                            weight: "bold",
                                            children: key
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                            children: value
                                        })
                                    ]
                                }, key)),
                            creditNote && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                weight: "bold",
                                className: "mrg-auto",
                                children: "Credit note"
                            })
                        ]
                    }),
                    invoice.failureReason && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        weight: "bold",
                        children: invoice.failureReason
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$29d11c0fe2fc51d8), {
                icon: "download",
                className: "invoice-view__download",
                href: `/api/billing/invoices/${invoice.id}`,
                target: "_blank",
                download: true,
                children: "PDF"
            })
        ]
    });
};
const $b2eb27efd79ea534$export$36d953148455edf2 = (p)=>{
    if (!p.invoices.length) return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("invoice-history-view", p.className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$86de09faaa70680d), {
                icon: "invoice",
                title: "Invoice History"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                className: "invoice-history-view__list",
                children: p.invoices.map((invoice)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($b2eb27efd79ea534$var$InvoiceView, {
                            invoice: invoice
                        })
                    }, invoice.id))
            })
        ]
    });
};


var $2b071fcb1afb030a$exports = {};

$parcel$export($2b071fcb1afb030a$exports, "AdminUserController", function () { return $2b071fcb1afb030a$export$6a710dfabfd1f56d; });



function $35cdb7639c014f21$export$ccedaf978f62b9dd(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $5cc67c74d4614491$export$1002c20f28174dbf(obj, privateSet) {
    (0, $b3c39904e7028a8d$export$6b10452b5ac97eba)(obj, privateSet);
    privateSet.add(obj);
}



var $2b071fcb1afb030a$var$_controllers, $2b071fcb1afb030a$var$_userId, $2b071fcb1afb030a$var$_user, $2b071fcb1afb030a$var$_error, $2b071fcb1afb030a$var$_init, $2b071fcb1afb030a$var$_AdminUserController;
var $2b071fcb1afb030a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2b071fcb1afb030a$export$6a710dfabfd1f56d = ($2b071fcb1afb030a$var$_controllers = /*#__PURE__*/ new WeakMap(), $2b071fcb1afb030a$var$_userId = /*#__PURE__*/ new WeakMap(), $2b071fcb1afb030a$var$_user = /*#__PURE__*/ new WeakMap(), $2b071fcb1afb030a$var$_error = /*#__PURE__*/ new WeakMap(), $2b071fcb1afb030a$var$_init = /*#__PURE__*/ new WeakSet(), $2b071fcb1afb030a$var$_AdminUserController = class AdminUserController {
    get user() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $2b071fcb1afb030a$var$_user);
    }
    set user(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $2b071fcb1afb030a$var$_user, value);
    }
    get error() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $2b071fcb1afb030a$var$_error);
    }
    set error(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $2b071fcb1afb030a$var$_error, value);
    }
    constructor(controllers, userId){
        (0, $5cc67c74d4614491$export$1002c20f28174dbf)(this, $2b071fcb1afb030a$var$_init);
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $2b071fcb1afb030a$var$_controllers, {
            writable: true,
            value: void 0
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $2b071fcb1afb030a$var$_userId, {
            writable: true,
            value: void 0
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $2b071fcb1afb030a$var$_user, {
            writable: true,
            value: null
        });
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $2b071fcb1afb030a$var$_error, {
            writable: true,
            value: null
        });
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $2b071fcb1afb030a$var$_controllers, controllers);
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $2b071fcb1afb030a$var$_userId, userId);
        (0, $35cdb7639c014f21$export$ccedaf978f62b9dd)(this, $2b071fcb1afb030a$var$_init, $2b071fcb1afb030a$var$init).call(this);
    }
}, $2b071fcb1afb030a$var$_AdminUserController);
$2b071fcb1afb030a$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $2b071fcb1afb030a$export$6a710dfabfd1f56d.prototype, "user", null);
$2b071fcb1afb030a$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $2b071fcb1afb030a$export$6a710dfabfd1f56d.prototype, "error", null);
$2b071fcb1afb030a$export$6a710dfabfd1f56d = $2b071fcb1afb030a$var$__decorate([
    (0, $8ea62fef91697031$exports.subject)()
], $2b071fcb1afb030a$export$6a710dfabfd1f56d);
async function $2b071fcb1afb030a$var$init() {
    try {
        this.user = await (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $2b071fcb1afb030a$var$_controllers).adminController.getUserDetails((0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $2b071fcb1afb030a$var$_userId));
    } catch (err) {
        this.error = err instanceof Error ? err.message : String(err);
    }
}



var $VqyUd = parcelRequire("VqyUd");



const $f972cf3465ce7583$var$getLinks = (user)=>[
        {
            icon: "mail",
            label: user.email,
            href: "mailto:" + user.email
        },
        {
            icon: "freeagent",
            label: "FreeAgent",
            href: user.freeagentContact,
            disabledTooltip: "No FreeAgent contact"
        },
        {
            icon: "stripe",
            label: "Stripe",
            href: user.stripeCustomer,
            disabledTooltip: "No Stripe customer"
        }
    ];
const $f972cf3465ce7583$export$76fcfc16fbce2e93 = (p)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))(p.className, "adminUserToolbar flow--md flex-wrap"),
        children: $f972cf3465ce7583$var$getLinks(p.user).map((p)=>{
            const content = (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                        icon: p.icon
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                        children: p.label
                    })
                ]
            });
            const cls = (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("flow--xs flex-align-center", {
                disabled: p.href === null
            });
            if (p.href) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                className: cls,
                href: p.href,
                children: content
            }, p.label);
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: cls,
                title: p.disabledTooltip,
                children: content
            }, p.label);
        })
    });



var $VqyUd = parcelRequire("VqyUd");


const $8f215dc168c5f2f1$var$getLines = (user)=>{
    return [
        user.address,
        user.city,
        user.state,
        user.country,
        user.zip
    ].filter((0, $0252c182fb6e34bb$export$f3318661327e642b));
};
const $8f215dc168c5f2f1$export$d13d1b2ce0f4bac6 = (p)=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("address", {
        className: p.className,
        children: [
            $8f215dc168c5f2f1$var$getLines(p.user).map((line)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                    children: [
                        line,
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {})
                    ]
                })),
            p.user.phone && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                className: "flow--sm flex-align-center",
                href: "tel:" + p.user.phone,
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                        icon: "phone",
                        size: "sm"
                    }),
                    p.user.phone
                ]
            })
        ]
    });
};









const $b396258aca809c9c$var$getRows = (user)=>{
    const rows = [
        {
            key: "Status",
            value: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7760e9d7085e495f$export$ef4e9e8580d6f0d8), {
                user: user
            })
        },
        (0, $0252c182fb6e34bb$export$f3318661327e642b)(user.nextBillingDate) ? {
            key: "Next billing",
            value: (0, $7d3f392fa48145f5$export$1431bc52824a265)(user.nextBillingDate)
        } : null,
        user.cost ? {
            key: "Amount",
            value: (0, $7d3f392fa48145f5$export$3dc27271f5d5c629)(user.cost)
        } : null
    ].filter((0, $0252c182fb6e34bb$export$f3318661327e642b));
    return rows;
};
const $b396258aca809c9c$export$751af27082c5ce71 = (p)=>{
    const admin = (0, $f57fa0ee256b0db7$export$c05e53a76d53ff2d)();
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("stack--sm", p.className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $ab8596abdfd6425b$export$1171cd935df7643a), {
                rows: $b396258aca809c9c$var$getRows(p.user)
            }),
            !p.user.evaluation && p.user.billingStatus === "beta" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                className: "theme-brand",
                icon: "credit-card",
                onClick: ()=>admin.activateBillingFromBeta(p.user),
                children: "Activate Billing"
            })
        ]
    });
};



/*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ 
/*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $8a2d8dea586d6b80$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $8a2d8dea586d6b80$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $8a2d8dea586d6b80$export$bcc6e673dfa14d36(v) {
    return $8a2d8dea586d6b80$export$837ba5c449269406($8a2d8dea586d6b80$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $8a2d8dea586d6b80$export$869b26d4e1bbdb63(v) {
    return $8a2d8dea586d6b80$export$837ba5c449269406($8a2d8dea586d6b80$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6(v) {
    return $8a2d8dea586d6b80$export$837ba5c449269406($8a2d8dea586d6b80$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $8a2d8dea586d6b80$export$dbf961a8d278dbef(v) {
    return $8a2d8dea586d6b80$export$837ba5c449269406($8a2d8dea586d6b80$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $8a2d8dea586d6b80$export$aa35ef1f24408ab9(v) {
    return $8a2d8dea586d6b80$export$837ba5c449269406($8a2d8dea586d6b80$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $8a2d8dea586d6b80$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $8a2d8dea586d6b80$var$hex = [
    ..."0123456789ABCDEF"
];
const $8a2d8dea586d6b80$var$h1 = (b)=>$8a2d8dea586d6b80$var$hex[b & 0xF];
const $8a2d8dea586d6b80$var$h2 = (b)=>$8a2d8dea586d6b80$var$hex[(b & 0xF0) >> 4] + $8a2d8dea586d6b80$var$hex[b & 0xF];
const $8a2d8dea586d6b80$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $8a2d8dea586d6b80$var$isShort = (v)=>$8a2d8dea586d6b80$var$eq(v.r) && $8a2d8dea586d6b80$var$eq(v.g) && $8a2d8dea586d6b80$var$eq(v.b) && $8a2d8dea586d6b80$var$eq(v.a);
function $8a2d8dea586d6b80$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $8a2d8dea586d6b80$var$map$1[str[1]] * 17,
            g: 255 & $8a2d8dea586d6b80$var$map$1[str[2]] * 17,
            b: 255 & $8a2d8dea586d6b80$var$map$1[str[3]] * 17,
            a: len === 5 ? $8a2d8dea586d6b80$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $8a2d8dea586d6b80$var$map$1[str[1]] << 4 | $8a2d8dea586d6b80$var$map$1[str[2]],
            g: $8a2d8dea586d6b80$var$map$1[str[3]] << 4 | $8a2d8dea586d6b80$var$map$1[str[4]],
            b: $8a2d8dea586d6b80$var$map$1[str[5]] << 4 | $8a2d8dea586d6b80$var$map$1[str[6]],
            a: len === 9 ? $8a2d8dea586d6b80$var$map$1[str[7]] << 4 | $8a2d8dea586d6b80$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $8a2d8dea586d6b80$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $8a2d8dea586d6b80$export$1b06654353ef9f67(v) {
    var f = $8a2d8dea586d6b80$var$isShort(v) ? $8a2d8dea586d6b80$var$h1 : $8a2d8dea586d6b80$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $8a2d8dea586d6b80$var$alpha(v.a, f) : undefined;
}
const $8a2d8dea586d6b80$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $8a2d8dea586d6b80$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $8a2d8dea586d6b80$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $8a2d8dea586d6b80$var$hwb2rgbn(h, w, b) {
    const rgb = $8a2d8dea586d6b80$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $8a2d8dea586d6b80$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $8a2d8dea586d6b80$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $8a2d8dea586d6b80$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $8a2d8dea586d6b80$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($8a2d8dea586d6b80$export$ed9bd8dcaeba14f6);
}
function $8a2d8dea586d6b80$export$4c15bd42559b811d(h, s, l) {
    return $8a2d8dea586d6b80$var$calln($8a2d8dea586d6b80$var$hsl2rgbn, h, s, l);
}
function $8a2d8dea586d6b80$export$e2710022c70fc9ee(h, w, b) {
    return $8a2d8dea586d6b80$var$calln($8a2d8dea586d6b80$var$hwb2rgbn, h, w, b);
}
function $8a2d8dea586d6b80$export$b785a357c84e4a04(h, s, v) {
    return $8a2d8dea586d6b80$var$calln($8a2d8dea586d6b80$var$hsv2rgbn, h, s, v);
}
function $8a2d8dea586d6b80$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $8a2d8dea586d6b80$export$5e91288c399be4f9(str) {
    const m = $8a2d8dea586d6b80$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $8a2d8dea586d6b80$export$bcc6e673dfa14d36(+m[5]) : $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $8a2d8dea586d6b80$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $8a2d8dea586d6b80$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === "hsv") v = $8a2d8dea586d6b80$export$b785a357c84e4a04(h, p1, p2);
    else v = $8a2d8dea586d6b80$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $8a2d8dea586d6b80$export$bb628a54ab399bc9(v, deg) {
    var h = $8a2d8dea586d6b80$export$b5ba70b240f8f7f(v);
    h[0] = $8a2d8dea586d6b80$var$hue(h[0] + deg);
    h = $8a2d8dea586d6b80$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $8a2d8dea586d6b80$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $8a2d8dea586d6b80$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $8a2d8dea586d6b80$export$aa35ef1f24408ab9(a[1]);
    const l = $8a2d8dea586d6b80$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$8a2d8dea586d6b80$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $8a2d8dea586d6b80$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $8a2d8dea586d6b80$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $8a2d8dea586d6b80$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($8a2d8dea586d6b80$var$names$1);
    const tkeys = Object.keys($8a2d8dea586d6b80$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $8a2d8dea586d6b80$var$map[k]);
        }
        k = parseInt($8a2d8dea586d6b80$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $8a2d8dea586d6b80$var$names;
function $8a2d8dea586d6b80$export$b2f06b640faad956(str) {
    if (!$8a2d8dea586d6b80$var$names) {
        $8a2d8dea586d6b80$var$names = $8a2d8dea586d6b80$var$unpack();
        $8a2d8dea586d6b80$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $8a2d8dea586d6b80$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $8a2d8dea586d6b80$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $8a2d8dea586d6b80$export$91aedb20f296e541(str) {
    const m = $8a2d8dea586d6b80$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $8a2d8dea586d6b80$export$bcc6e673dfa14d36(v) : $8a2d8dea586d6b80$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $8a2d8dea586d6b80$export$bcc6e673dfa14d36(r) : $8a2d8dea586d6b80$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $8a2d8dea586d6b80$export$bcc6e673dfa14d36(g) : $8a2d8dea586d6b80$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $8a2d8dea586d6b80$export$bcc6e673dfa14d36(b) : $8a2d8dea586d6b80$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $8a2d8dea586d6b80$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$8a2d8dea586d6b80$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $8a2d8dea586d6b80$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $8a2d8dea586d6b80$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $8a2d8dea586d6b80$var$interpolate(rgb1, rgb2, t) {
    const r = $8a2d8dea586d6b80$var$from($8a2d8dea586d6b80$export$dbf961a8d278dbef(rgb1.r));
    const g = $8a2d8dea586d6b80$var$from($8a2d8dea586d6b80$export$dbf961a8d278dbef(rgb1.g));
    const b = $8a2d8dea586d6b80$var$from($8a2d8dea586d6b80$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6($8a2d8dea586d6b80$var$to(r + t * ($8a2d8dea586d6b80$var$from($8a2d8dea586d6b80$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6($8a2d8dea586d6b80$var$to(g + t * ($8a2d8dea586d6b80$var$from($8a2d8dea586d6b80$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6($8a2d8dea586d6b80$var$to(b + t * ($8a2d8dea586d6b80$var$from($8a2d8dea586d6b80$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $8a2d8dea586d6b80$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $8a2d8dea586d6b80$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $8a2d8dea586d6b80$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $8a2d8dea586d6b80$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $8a2d8dea586d6b80$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $8a2d8dea586d6b80$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $8a2d8dea586d6b80$var$functionParse(str) {
    if (str.charAt(0) === "r") return $8a2d8dea586d6b80$export$91aedb20f296e541(str);
    return $8a2d8dea586d6b80$export$5e91288c399be4f9(str);
}
class $8a2d8dea586d6b80$export$892596cec99bc70e {
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $8a2d8dea586d6b80$var$clone(this._rgb);
        if (v) v.a = $8a2d8dea586d6b80$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $8a2d8dea586d6b80$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $8a2d8dea586d6b80$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $8a2d8dea586d6b80$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $8a2d8dea586d6b80$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $8a2d8dea586d6b80$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $8a2d8dea586d6b80$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $8a2d8dea586d6b80$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $8a2d8dea586d6b80$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $8a2d8dea586d6b80$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $8a2d8dea586d6b80$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $8a2d8dea586d6b80$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $8a2d8dea586d6b80$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $8a2d8dea586d6b80$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
    constructor(input){
        if (input instanceof $8a2d8dea586d6b80$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $8a2d8dea586d6b80$var$fromObject(input);
        else if (type === "string") v = $8a2d8dea586d6b80$export$625a38b961e8b5e9(input) || $8a2d8dea586d6b80$export$b2f06b640faad956(input) || $8a2d8dea586d6b80$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
}
function $8a2d8dea586d6b80$export$2e2bcd8739ae039(input) {
    return new $8a2d8dea586d6b80$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $be903a41cbfc2c2c$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $be903a41cbfc2c2c$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $be903a41cbfc2c2c$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $be903a41cbfc2c2c$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $be903a41cbfc2c2c$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $be903a41cbfc2c2c$export$39b482c5e57630a8(value) {
    return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $be903a41cbfc2c2c$export$c4ce752e73470fba(value, defaultValue) {
    return $be903a41cbfc2c2c$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $be903a41cbfc2c2c$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $be903a41cbfc2c2c$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
const $be903a41cbfc2c2c$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $be903a41cbfc2c2c$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $be903a41cbfc2c2c$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($be903a41cbfc2c2c$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($be903a41cbfc2c2c$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $be903a41cbfc2c2c$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $be903a41cbfc2c2c$export$d377dcb2b61d6c4e(source) {
    if ($be903a41cbfc2c2c$export$8b22cf2602fb60ce(source)) return source.map($be903a41cbfc2c2c$export$d377dcb2b61d6c4e);
    if ($be903a41cbfc2c2c$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $be903a41cbfc2c2c$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $be903a41cbfc2c2c$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $be903a41cbfc2c2c$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$be903a41cbfc2c2c$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($be903a41cbfc2c2c$export$23f2a1d2818174ef(tval) && $be903a41cbfc2c2c$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $be903a41cbfc2c2c$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $be903a41cbfc2c2c$export$d377dcb2b61d6c4e(sval);
}
function $be903a41cbfc2c2c$export$efca4cbe5dd06740(target, source, options) {
    const sources = $be903a41cbfc2c2c$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$be903a41cbfc2c2c$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $be903a41cbfc2c2c$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$be903a41cbfc2c2c$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $be903a41cbfc2c2c$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $be903a41cbfc2c2c$export$efca4cbe5dd06740(target, source, {
        merger: $be903a41cbfc2c2c$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $be903a41cbfc2c2c$export$317a3d46287192d8(key, target, source) {
    if (!$be903a41cbfc2c2c$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($be903a41cbfc2c2c$export$23f2a1d2818174ef(tval) && $be903a41cbfc2c2c$export$23f2a1d2818174ef(sval)) $be903a41cbfc2c2c$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $be903a41cbfc2c2c$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $be903a41cbfc2c2c$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    "": (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $be903a41cbfc2c2c$export$9d0e2d13d04f7070(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $be903a41cbfc2c2c$var$_getKeyResolver(key) {
    const keys = $be903a41cbfc2c2c$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $be903a41cbfc2c2c$export$2d1720544b23b823(obj, key) {
    const resolver = $be903a41cbfc2c2c$var$keyResolvers[key] || ($be903a41cbfc2c2c$var$keyResolvers[key] = $be903a41cbfc2c2c$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $be903a41cbfc2c2c$export$dda1d9f60106f0e9 = (value)=>typeof value !== "undefined";
const $be903a41cbfc2c2c$export$a93c5207d687da10 = (value)=>typeof value === "function";
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $be903a41cbfc2c2c$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $be903a41cbfc2c2c$export$f38c853ae54ed474(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $be903a41cbfc2c2c$export$56c0d5a1e737357d = Math.PI;
const $be903a41cbfc2c2c$export$971d5caa766a69d7 = 2 * $be903a41cbfc2c2c$export$56c0d5a1e737357d;
const $be903a41cbfc2c2c$export$d29e374196577086 = $be903a41cbfc2c2c$export$971d5caa766a69d7 + $be903a41cbfc2c2c$export$56c0d5a1e737357d;
const $be903a41cbfc2c2c$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $be903a41cbfc2c2c$export$53c86fa97d611818 = $be903a41cbfc2c2c$export$56c0d5a1e737357d / 180;
const $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd = $be903a41cbfc2c2c$export$56c0d5a1e737357d / 2;
const $be903a41cbfc2c2c$export$39c1cc7c062529d4 = $be903a41cbfc2c2c$export$56c0d5a1e737357d / 4;
const $be903a41cbfc2c2c$export$7a0bdf7d4a91ea88 = $be903a41cbfc2c2c$export$56c0d5a1e737357d * 2 / 3;
const $be903a41cbfc2c2c$export$9f4f30ee63539e24 = Math.log10;
const $be903a41cbfc2c2c$export$2408f22a0fab9ae5 = Math.sign;
function $be903a41cbfc2c2c$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $be903a41cbfc2c2c$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $be903a41cbfc2c2c$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($be903a41cbfc2c2c$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $be903a41cbfc2c2c$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $be903a41cbfc2c2c$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $be903a41cbfc2c2c$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $be903a41cbfc2c2c$export$625550452a3fa3ec(degrees) {
    return degrees * ($be903a41cbfc2c2c$export$56c0d5a1e737357d / 180);
}
function $be903a41cbfc2c2c$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $be903a41cbfc2c2c$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $be903a41cbfc2c2c$export$23ebac1979863676(x) {
    if (!$be903a41cbfc2c2c$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $be903a41cbfc2c2c$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $be903a41cbfc2c2c$export$56c0d5a1e737357d) angle += $be903a41cbfc2c2c$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $be903a41cbfc2c2c$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $be903a41cbfc2c2c$export$c18d01048907ea92(a, b) {
    return (a - b + $be903a41cbfc2c2c$export$d29e374196577086) % $be903a41cbfc2c2c$export$971d5caa766a69d7 - $be903a41cbfc2c2c$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $be903a41cbfc2c2c$export$28f7fcd39efa255(a) {
    return (a % $be903a41cbfc2c2c$export$971d5caa766a69d7 + $be903a41cbfc2c2c$export$971d5caa766a69d7) % $be903a41cbfc2c2c$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $be903a41cbfc2c2c$export$28f7fcd39efa255(angle);
    const s = $be903a41cbfc2c2c$export$28f7fcd39efa255(start);
    const e = $be903a41cbfc2c2c$export$28f7fcd39efa255(end);
    const angleToStart = $be903a41cbfc2c2c$export$28f7fcd39efa255(s - a);
    const angleToEnd = $be903a41cbfc2c2c$export$28f7fcd39efa255(e - a);
    const startToAngle = $be903a41cbfc2c2c$export$28f7fcd39efa255(a - s);
    const endToAngle = $be903a41cbfc2c2c$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $be903a41cbfc2c2c$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $be903a41cbfc2c2c$export$71cec2538cb2c617(value) {
    return $be903a41cbfc2c2c$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $be903a41cbfc2c2c$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $be903a41cbfc2c2c$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $be903a41cbfc2c2c$export$ef35774e6d314e91 = (table, key, value, last)=>$be903a41cbfc2c2c$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $be903a41cbfc2c2c$export$ebd11618f299a286 = (table, key, value)=>$be903a41cbfc2c2c$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $be903a41cbfc2c2c$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $be903a41cbfc2c2c$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $be903a41cbfc2c2c$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $be903a41cbfc2c2c$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $be903a41cbfc2c2c$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $be903a41cbfc2c2c$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $be903a41cbfc2c2c$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $be903a41cbfc2c2c$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $be903a41cbfc2c2c$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
/**
* Request animation polyfill
*/ const $be903a41cbfc2c2c$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $be903a41cbfc2c2c$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $be903a41cbfc2c2c$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $be903a41cbfc2c2c$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $be903a41cbfc2c2c$export$3c2fa207a37baaea = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $be903a41cbfc2c2c$export$ce26c07117d59d6a = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $be903a41cbfc2c2c$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $be903a41cbfc2c2c$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $be903a41cbfc2c2c$export$25ce5a424b770e84(Math.min($be903a41cbfc2c2c$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $be903a41cbfc2c2c$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $be903a41cbfc2c2c$export$25ce5a424b770e84(Math.max($be903a41cbfc2c2c$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $be903a41cbfc2c2c$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $be903a41cbfc2c2c$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $be903a41cbfc2c2c$var$atEdge = (t)=>t === 0 || t === 1;
const $be903a41cbfc2c2c$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $be903a41cbfc2c2c$export$971d5caa766a69d7 / p));
const $be903a41cbfc2c2c$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $be903a41cbfc2c2c$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $be903a41cbfc2c2c$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($be903a41cbfc2c2c$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$be903a41cbfc2c2c$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$be903a41cbfc2c2c$var$atEdge(t) ? t : $be903a41cbfc2c2c$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$be903a41cbfc2c2c$var$atEdge(t) ? t : $be903a41cbfc2c2c$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $be903a41cbfc2c2c$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $be903a41cbfc2c2c$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $be903a41cbfc2c2c$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $be903a41cbfc2c2c$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $be903a41cbfc2c2c$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $be903a41cbfc2c2c$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $be903a41cbfc2c2c$export$f96d196f7728bb5(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $be903a41cbfc2c2c$export$db3b6bfb95261072(value) {
    return $be903a41cbfc2c2c$export$f96d196f7728bb5(value) ? value : new (0, $8a2d8dea586d6b80$export$892596cec99bc70e)(value);
}
function $be903a41cbfc2c2c$export$738ab4df8bf92ae9(value) {
    return $be903a41cbfc2c2c$export$f96d196f7728bb5(value) ? value : new (0, $8a2d8dea586d6b80$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $be903a41cbfc2c2c$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $be903a41cbfc2c2c$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
function $be903a41cbfc2c2c$var$applyAnimationsDefaults(defaults) {
    defaults.set("animation", {
        delay: undefined,
        duration: 1000,
        easing: "easeOutQuart",
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe("animation", {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
    });
    defaults.set("animations", {
        colors: {
            type: "color",
            properties: $be903a41cbfc2c2c$var$colors
        },
        numbers: {
            type: "number",
            properties: $be903a41cbfc2c2c$var$numbers
        }
    });
    defaults.describe("animations", {
        _fallback: "animation"
    });
    defaults.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $be903a41cbfc2c2c$var$applyLayoutsDefaults(defaults) {
    defaults.set("layout", {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $be903a41cbfc2c2c$var$intlCache = new Map();
function $be903a41cbfc2c2c$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $be903a41cbfc2c2c$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $be903a41cbfc2c2c$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $be903a41cbfc2c2c$export$ae1af26003f05816(num, locale, options) {
    return $be903a41cbfc2c2c$var$getNumberFormat(locale, options).format(num);
}
const $be903a41cbfc2c2c$var$formatters = {
    values (value) {
        return $be903a41cbfc2c2c$export$8b22cf2602fb60ce(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $be903a41cbfc2c2c$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $be903a41cbfc2c2c$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $be903a41cbfc2c2c$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($be903a41cbfc2c2c$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $be903a41cbfc2c2c$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $be903a41cbfc2c2c$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $be903a41cbfc2c2c$export$91477dc880baac21 = {
    formatters: $be903a41cbfc2c2c$var$formatters
};
function $be903a41cbfc2c2c$var$applyScaleDefaults(defaults) {
    defaults.set("scale", {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: "ticks",
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $be903a41cbfc2c2c$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: false,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    });
    defaults.route("scale.ticks", "color", "", "color");
    defaults.route("scale.grid", "color", "", "borderColor");
    defaults.route("scale.border", "color", "", "borderColor");
    defaults.route("scale.title", "color", "", "color");
    defaults.describe("scale", {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
        _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
    });
    defaults.describe("scales", {
        _fallback: "scale"
    });
    defaults.describe("scale.ticks", {
        _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
        _indexable: (name)=>name !== "backdropPadding"
    });
}
const $be903a41cbfc2c2c$export$6559d589eb85fbb6 = Object.create(null);
const $be903a41cbfc2c2c$export$2e2af4578d910ddf = Object.create(null);
function $be903a41cbfc2c2c$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $be903a41cbfc2c2c$var$set(root, scope, values) {
    if (typeof scope === "string") return $be903a41cbfc2c2c$export$efca4cbe5dd06740($be903a41cbfc2c2c$var$getScope$1(root, scope), values);
    return $be903a41cbfc2c2c$export$efca4cbe5dd06740($be903a41cbfc2c2c$var$getScope$1(root, ""), scope);
}
class $be903a41cbfc2c2c$var$Defaults {
    set(scope, values) {
        return $be903a41cbfc2c2c$var$set(this, scope, values);
    }
    get(scope) {
        return $be903a41cbfc2c2c$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $be903a41cbfc2c2c$var$set($be903a41cbfc2c2c$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $be903a41cbfc2c2c$var$set($be903a41cbfc2c2c$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $be903a41cbfc2c2c$var$getScope$1(this, scope);
        const targetScopeObject = $be903a41cbfc2c2c$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($be903a41cbfc2c2c$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $be903a41cbfc2c2c$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$be903a41cbfc2c2c$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$be903a41cbfc2c2c$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$be903a41cbfc2c2c$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
}
var $be903a41cbfc2c2c$export$4368d992c4eafac0 = /* #__PURE__ */ new $be903a41cbfc2c2c$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $be903a41cbfc2c2c$var$applyAnimationsDefaults,
    $be903a41cbfc2c2c$var$applyLayoutsDefaults,
    $be903a41cbfc2c2c$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $be903a41cbfc2c2c$export$1a8f5705751d8277(font) {
    if (!font || $be903a41cbfc2c2c$export$342063e11d6c3cad(font.size) || $be903a41cbfc2c2c$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $be903a41cbfc2c2c$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$be903a41cbfc2c2c$export$8b22cf2602fb60ce(thing)) longest = $be903a41cbfc2c2c$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($be903a41cbfc2c2c$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$be903a41cbfc2c2c$export$8b22cf2602fb60ce(nestedThing)) longest = $be903a41cbfc2c2c$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $be903a41cbfc2c2c$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $be903a41cbfc2c2c$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $be903a41cbfc2c2c$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $be903a41cbfc2c2c$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $be903a41cbfc2c2c$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $be903a41cbfc2c2c$export$53c86fa97d611818;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $be903a41cbfc2c2c$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $be903a41cbfc2c2c$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $be903a41cbfc2c2c$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $be903a41cbfc2c2c$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $be903a41cbfc2c2c$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $be903a41cbfc2c2c$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $be903a41cbfc2c2c$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $be903a41cbfc2c2c$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $be903a41cbfc2c2c$export$56c0d5a1e737357d, rad - $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd, rad + $be903a41cbfc2c2c$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $be903a41cbfc2c2c$export$39c1cc7c062529d4;
        /* falls through */ case "rectRot":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $be903a41cbfc2c2c$export$39c1cc7c062529d4;
        /* falls through */ case "cross":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "star":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $be903a41cbfc2c2c$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $be903a41cbfc2c2c$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $be903a41cbfc2c2c$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $be903a41cbfc2c2c$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $be903a41cbfc2c2c$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$be903a41cbfc2c2c$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $be903a41cbfc2c2c$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $be903a41cbfc2c2c$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $be903a41cbfc2c2c$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $be903a41cbfc2c2c$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $be903a41cbfc2c2c$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $be903a41cbfc2c2c$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$be903a41cbfc2c2c$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $be903a41cbfc2c2c$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $be903a41cbfc2c2c$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $be903a41cbfc2c2c$export$56c0d5a1e737357d, $be903a41cbfc2c2c$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $be903a41cbfc2c2c$export$56c0d5a1e737357d, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $be903a41cbfc2c2c$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $be903a41cbfc2c2c$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $be903a41cbfc2c2c$export$8c78c7c36408ea29(value, size) {
    const matches = ("" + value).match($be903a41cbfc2c2c$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $be903a41cbfc2c2c$var$numberOrZero = (v)=>+v || 0;
function $be903a41cbfc2c2c$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $be903a41cbfc2c2c$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $be903a41cbfc2c2c$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$be903a41cbfc2c2c$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $be903a41cbfc2c2c$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $be903a41cbfc2c2c$export$d66dc83d8cfc8dd(value) {
    return $be903a41cbfc2c2c$export$21579262ef46735b(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $be903a41cbfc2c2c$export$92108d983e8ee699(value) {
    return $be903a41cbfc2c2c$export$21579262ef46735b(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca(value) {
    const obj = $be903a41cbfc2c2c$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $be903a41cbfc2c2c$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $be903a41cbfc2c2c$export$4368d992c4eafac0.font;
    let size = $be903a41cbfc2c2c$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $be903a41cbfc2c2c$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($be903a41cbfc2c2c$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $be903a41cbfc2c2c$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $be903a41cbfc2c2c$export$8c78c7c36408ea29($be903a41cbfc2c2c$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $be903a41cbfc2c2c$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $be903a41cbfc2c2c$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $be903a41cbfc2c2c$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $be903a41cbfc2c2c$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $be903a41cbfc2c2c$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $be903a41cbfc2c2c$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $be903a41cbfc2c2c$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $be903a41cbfc2c2c$export$a9c996f45e5784d0(scopes, prefixes = [
    ""
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === "undefined") fallback = $be903a41cbfc2c2c$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$be903a41cbfc2c2c$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $be903a41cbfc2c2c$var$_cached(target, prop, ()=>$be903a41cbfc2c2c$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $be903a41cbfc2c2c$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $be903a41cbfc2c2c$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $be903a41cbfc2c2c$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $be903a41cbfc2c2c$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$be903a41cbfc2c2c$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$be903a41cbfc2c2c$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $be903a41cbfc2c2c$var$_cached(target, prop, ()=>$be903a41cbfc2c2c$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $be903a41cbfc2c2c$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $be903a41cbfc2c2c$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $be903a41cbfc2c2c$var$readKey = (prefix, name)=>prefix ? prefix + $be903a41cbfc2c2c$export$a8550f7dbe79f93a(name) : name;
const $be903a41cbfc2c2c$var$needsSubResolver = (prop, value)=>$be903a41cbfc2c2c$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $be903a41cbfc2c2c$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === "constructor") return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $be903a41cbfc2c2c$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($be903a41cbfc2c2c$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $be903a41cbfc2c2c$var$_resolveScriptable(prop, value, target, receiver);
    if ($be903a41cbfc2c2c$export$8b22cf2602fb60ce(value) && value.length) value = $be903a41cbfc2c2c$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($be903a41cbfc2c2c$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $be903a41cbfc2c2c$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $be903a41cbfc2c2c$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($be903a41cbfc2c2c$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $be903a41cbfc2c2c$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $be903a41cbfc2c2c$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== "undefined" && isIndexable(prop)) return value[_context.index % value.length];
    else if ($be903a41cbfc2c2c$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $be903a41cbfc2c2c$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($be903a41cbfc2c2c$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $be903a41cbfc2c2c$var$resolveFallback(fallback, prop, value) {
    return $be903a41cbfc2c2c$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $be903a41cbfc2c2c$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $be903a41cbfc2c2c$export$2d1720544b23b823(parent, key) : undefined;
function $be903a41cbfc2c2c$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $be903a41cbfc2c2c$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $be903a41cbfc2c2c$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $be903a41cbfc2c2c$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $be903a41cbfc2c2c$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $be903a41cbfc2c2c$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== "undefined" && fallback !== prop) {
        key = $be903a41cbfc2c2c$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $be903a41cbfc2c2c$export$a9c996f45e5784d0(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$be903a41cbfc2c2c$var$subGetTarget(resolver, prop, value));
}
function $be903a41cbfc2c2c$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $be903a41cbfc2c2c$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $be903a41cbfc2c2c$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($be903a41cbfc2c2c$export$8b22cf2602fb60ce(target) && $be903a41cbfc2c2c$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $be903a41cbfc2c2c$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $be903a41cbfc2c2c$var$_resolve($be903a41cbfc2c2c$var$readKey(prefix, prop), scopes);
        if (typeof value !== "undefined") return $be903a41cbfc2c2c$var$needsSubResolver(prop, value) ? $be903a41cbfc2c2c$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $be903a41cbfc2c2c$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== "undefined") return value;
    }
}
function $be903a41cbfc2c2c$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $be903a41cbfc2c2c$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $be903a41cbfc2c2c$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $be903a41cbfc2c2c$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($be903a41cbfc2c2c$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $be903a41cbfc2c2c$var$EPSILON = Number.EPSILON || 1e-14;
const $be903a41cbfc2c2c$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $be903a41cbfc2c2c$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $be903a41cbfc2c2c$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $be903a41cbfc2c2c$export$158acd800e1ef08b(current, previous);
    const d12 = $be903a41cbfc2c2c$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $be903a41cbfc2c2c$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $be903a41cbfc2c2c$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $be903a41cbfc2c2c$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($be903a41cbfc2c2c$export$a05254e7c3aeba6e(deltaK[i], 0, $be903a41cbfc2c2c$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $be903a41cbfc2c2c$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $be903a41cbfc2c2c$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $be903a41cbfc2c2c$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $be903a41cbfc2c2c$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $be903a41cbfc2c2c$export$527e9aa3390079e9(points, indexAxis = "x") {
    const valueAxis = $be903a41cbfc2c2c$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $be903a41cbfc2c2c$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $be903a41cbfc2c2c$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $be903a41cbfc2c2c$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $be903a41cbfc2c2c$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $be903a41cbfc2c2c$var$monotoneAdjust(points, deltaK, mK);
    $be903a41cbfc2c2c$var$monotoneCompute(points, mK, indexAxis);
}
function $be903a41cbfc2c2c$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $be903a41cbfc2c2c$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $be903a41cbfc2c2c$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $be903a41cbfc2c2c$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $be903a41cbfc2c2c$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $be903a41cbfc2c2c$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $be903a41cbfc2c2c$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $be903a41cbfc2c2c$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $be903a41cbfc2c2c$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $be903a41cbfc2c2c$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $be903a41cbfc2c2c$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $be903a41cbfc2c2c$export$3a1a48c8f6ef640e() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $be903a41cbfc2c2c$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $be903a41cbfc2c2c$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $be903a41cbfc2c2c$export$a17c37559e1db147(el, property) {
    return $be903a41cbfc2c2c$var$getComputedStyle(el).getPropertyValue(property);
}
const $be903a41cbfc2c2c$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $be903a41cbfc2c2c$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $be903a41cbfc2c2c$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $be903a41cbfc2c2c$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $be903a41cbfc2c2c$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($be903a41cbfc2c2c$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $be903a41cbfc2c2c$export$df995fae86a55f06(event, chart) {
    if ("native" in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $be903a41cbfc2c2c$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $be903a41cbfc2c2c$var$getPositionedStyle(style, "padding");
    const borders = $be903a41cbfc2c2c$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $be903a41cbfc2c2c$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $be903a41cbfc2c2c$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $be903a41cbfc2c2c$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $be903a41cbfc2c2c$var$getComputedStyle(container);
            const containerBorder = $be903a41cbfc2c2c$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $be903a41cbfc2c2c$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $be903a41cbfc2c2c$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $be903a41cbfc2c2c$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $be903a41cbfc2c2c$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $be903a41cbfc2c2c$export$2ec5befb9e6c97d4
    };
}
const $be903a41cbfc2c2c$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $be903a41cbfc2c2c$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $be903a41cbfc2c2c$var$getComputedStyle(canvas);
    const margins = $be903a41cbfc2c2c$var$getPositionedStyle(style, "margin");
    const maxWidth = $be903a41cbfc2c2c$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $be903a41cbfc2c2c$export$2ec5befb9e6c97d4;
    const maxHeight = $be903a41cbfc2c2c$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $be903a41cbfc2c2c$export$2ec5befb9e6c97d4;
    const containerSize = $be903a41cbfc2c2c$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $be903a41cbfc2c2c$var$getPositionedStyle(style, "border", "width");
        const paddings = $be903a41cbfc2c2c$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $be903a41cbfc2c2c$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $be903a41cbfc2c2c$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $be903a41cbfc2c2c$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $be903a41cbfc2c2c$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $be903a41cbfc2c2c$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $be903a41cbfc2c2c$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($be903a41cbfc2c2c$export$3a1a48c8f6ef640e()) {
            window.addEventListener("test", null, options);
            window.removeEventListener("test", null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $be903a41cbfc2c2c$export$b4171a6734a65d42(element, property) {
    const value = $be903a41cbfc2c2c$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $be903a41cbfc2c2c$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $be903a41cbfc2c2c$export$8a5498727ef6be21(p1, cp1, t);
    const b = $be903a41cbfc2c2c$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $be903a41cbfc2c2c$export$8a5498727ef6be21(cp2, p2, t);
    const d = $be903a41cbfc2c2c$export$8a5498727ef6be21(a, b, t);
    const e = $be903a41cbfc2c2c$export$8a5498727ef6be21(b, c, t);
    return $be903a41cbfc2c2c$export$8a5498727ef6be21(d, e, t);
}
const $be903a41cbfc2c2c$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $be903a41cbfc2c2c$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $be903a41cbfc2c2c$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $be903a41cbfc2c2c$var$getRightToLeftAdapter(rectX, width) : $be903a41cbfc2c2c$var$getLeftToRightAdapter();
}
function $be903a41cbfc2c2c$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $be903a41cbfc2c2c$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $be903a41cbfc2c2c$var$propertyFn(property) {
    if (property === "angle") return {
        between: $be903a41cbfc2c2c$export$ffb5f4729a158638,
        compare: $be903a41cbfc2c2c$export$c18d01048907ea92,
        normalize: $be903a41cbfc2c2c$export$28f7fcd39efa255
    };
    return {
        between: $be903a41cbfc2c2c$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $be903a41cbfc2c2c$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $be903a41cbfc2c2c$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $be903a41cbfc2c2c$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $be903a41cbfc2c2c$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $be903a41cbfc2c2c$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $be903a41cbfc2c2c$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($be903a41cbfc2c2c$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($be903a41cbfc2c2c$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $be903a41cbfc2c2c$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $be903a41cbfc2c2c$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $be903a41cbfc2c2c$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $be903a41cbfc2c2c$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $be903a41cbfc2c2c$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $be903a41cbfc2c2c$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $be903a41cbfc2c2c$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $be903a41cbfc2c2c$var$splitByStyles(line, $be903a41cbfc2c2c$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $be903a41cbfc2c2c$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $be903a41cbfc2c2c$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $be903a41cbfc2c2c$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $be903a41cbfc2c2c$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $be903a41cbfc2c2c$var$readStyle(segmentOptions.setContext($be903a41cbfc2c2c$export$35e795649ee09318(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($be903a41cbfc2c2c$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $be903a41cbfc2c2c$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $be903a41cbfc2c2c$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$be903a41cbfc2c2c$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}



class $973c3913dfffaf2c$var$Animator {
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $be903a41cbfc2c2c$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
}
var $973c3913dfffaf2c$export$a424a0aa8f687495 = /* #__PURE__ */ new $973c3913dfffaf2c$var$Animator();
const $973c3913dfffaf2c$var$transparent = "transparent";
const $973c3913dfffaf2c$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $be903a41cbfc2c2c$export$db3b6bfb95261072)(from || $973c3913dfffaf2c$var$transparent);
        const c1 = c0.valid && (0, $be903a41cbfc2c2c$export$db3b6bfb95261072)(to || $973c3913dfffaf2c$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $973c3913dfffaf2c$export$c35d437ae5945fcd {
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $be903a41cbfc2c2c$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $be903a41cbfc2c2c$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $be903a41cbfc2c2c$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $be903a41cbfc2c2c$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $973c3913dfffaf2c$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $be903a41cbfc2c2c$export$f1e1789686576879)[cfg.easing] || (0, $be903a41cbfc2c2c$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
}
class $973c3913dfffaf2c$export$8ab227dac26677d {
    configure(config) {
        if (!(0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $be903a41cbfc2c2c$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $973c3913dfffaf2c$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $973c3913dfffaf2c$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $973c3913dfffaf2c$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $973c3913dfffaf2c$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
}
function $973c3913dfffaf2c$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $973c3913dfffaf2c$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $973c3913dfffaf2c$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $973c3913dfffaf2c$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $973c3913dfffaf2c$var$scaleClip(xScale, allowedOverflow);
    const y = $973c3913dfffaf2c$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $973c3913dfffaf2c$var$toClip(value) {
    let t, r, b, l;
    if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $973c3913dfffaf2c$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $973c3913dfffaf2c$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(value) === (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $973c3913dfffaf2c$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === "x" ? "x" : "y";
    const vAxisKey = vScale.axis === "x" ? "x" : "y";
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $973c3913dfffaf2c$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $973c3913dfffaf2c$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $973c3913dfffaf2c$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $973c3913dfffaf2c$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $973c3913dfffaf2c$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $973c3913dfffaf2c$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $973c3913dfffaf2c$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $973c3913dfffaf2c$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $973c3913dfffaf2c$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $973c3913dfffaf2c$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $973c3913dfffaf2c$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $973c3913dfffaf2c$var$createDatasetContext(parent, index) {
    return (0, $be903a41cbfc2c2c$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $973c3913dfffaf2c$var$createDataContext(parent, index, element) {
    return (0, $be903a41cbfc2c2c$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $973c3913dfffaf2c$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $973c3913dfffaf2c$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $973c3913dfffaf2c$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $973c3913dfffaf2c$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $973c3913dfffaf2c$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $973c3913dfffaf2c$export$75572ec5c55b4048 {
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $973c3913dfffaf2c$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled("filler")) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $973c3913dfffaf2c$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(dataset.xAxisID, $973c3913dfffaf2c$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(dataset.yAxisID, $973c3913dfffaf2c$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(dataset.rAxisID, $973c3913dfffaf2c$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $be903a41cbfc2c2c$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $973c3913dfffaf2c$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $973c3913dfffaf2c$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $be903a41cbfc2c2c$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $973c3913dfffaf2c$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $be903a41cbfc2c2c$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $973c3913dfffaf2c$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $973c3913dfffaf2c$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $973c3913dfffaf2c$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $973c3913dfffaf2c$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $be903a41cbfc2c2c$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $be903a41cbfc2c2c$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $973c3913dfffaf2c$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $973c3913dfffaf2c$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $973c3913dfffaf2c$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $973c3913dfffaf2c$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $973c3913dfffaf2c$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $973c3913dfffaf2c$var$toClip((0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(this.options.clip, $973c3913dfffaf2c$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $973c3913dfffaf2c$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $973c3913dfffaf2c$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $be903a41cbfc2c2c$export$dda1d9f60106f0e9)(index);
        if (cached) return $973c3913dfffaf2c$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $be903a41cbfc2c2c$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($973c3913dfffaf2c$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $973c3913dfffaf2c$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $973c3913dfffaf2c$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($973c3913dfffaf2c$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$973c3913dfffaf2c$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $973c3913dfffaf2c$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$75572ec5c55b4048, "defaults", {});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$75572ec5c55b4048, "datasetElementType", null);
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$75572ec5c55b4048, "dataElementType", null);
function $973c3913dfffaf2c$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $be903a41cbfc2c2c$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $973c3913dfffaf2c$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $973c3913dfffaf2c$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $be903a41cbfc2c2c$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $973c3913dfffaf2c$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $973c3913dfffaf2c$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $973c3913dfffaf2c$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $973c3913dfffaf2c$var$parseValue(entry, item, vScale, i) {
    if ((0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(entry)) $973c3913dfffaf2c$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $973c3913dfffaf2c$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($973c3913dfffaf2c$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $973c3913dfffaf2c$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $973c3913dfffaf2c$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $973c3913dfffaf2c$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $973c3913dfffaf2c$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $973c3913dfffaf2c$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$973c3913dfffaf2c$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$973c3913dfffaf2c$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $973c3913dfffaf2c$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $973c3913dfffaf2c$var$swap(edge, a, b);
        edge = $973c3913dfffaf2c$var$startEnd(edge, b, a);
    } else edge = $973c3913dfffaf2c$var$startEnd(edge, a, b);
    return edge;
}
function $973c3913dfffaf2c$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $973c3913dfffaf2c$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $973c3913dfffaf2c$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $973c3913dfffaf2c$export$e97d5dc64e999004 extends $973c3913dfffaf2c$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $973c3913dfffaf2c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $973c3913dfffaf2c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $be903a41cbfc2c2c$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($973c3913dfffaf2c$var$parseValue((0, $be903a41cbfc2c2c$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $973c3913dfffaf2c$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $973c3913dfffaf2c$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $973c3913dfffaf2c$var$setBorderSkipped(properties, options, stack, index);
            $973c3913dfffaf2c$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $973c3913dfffaf2c$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $973c3913dfffaf2c$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(value) !== (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $973c3913dfffaf2c$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $973c3913dfffaf2c$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $973c3913dfffaf2c$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e97d5dc64e999004, "id", "bar");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e97d5dc64e999004, "defaults", {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e97d5dc64e999004, "overrides", {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
});
class $973c3913dfffaf2c$export$19b5c4773f17abe extends $973c3913dfffaf2c$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$19b5c4773f17abe, "id", "bubble");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$19b5c4773f17abe, "defaults", {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$19b5c4773f17abe, "overrides", {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
});
function $973c3913dfffaf2c$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $be903a41cbfc2c2c$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $be903a41cbfc2c2c$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $be903a41cbfc2c2c$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $be903a41cbfc2c2c$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $be903a41cbfc2c2c$export$56c0d5a1e737357d) + (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $973c3913dfffaf2c$export$e04603e7d8b77172 extends $973c3913dfffaf2c$export$75572ec5c55b4048 {
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i)=>+(0, $be903a41cbfc2c2c$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $be903a41cbfc2c2c$export$971d5caa766a69d7);
        let max = -(0, $be903a41cbfc2c2c$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $be903a41cbfc2c2c$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $973c3913dfffaf2c$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $be903a41cbfc2c2c$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $be903a41cbfc2c2c$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $be903a41cbfc2c2c$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $be903a41cbfc2c2c$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e04603e7d8b77172, "id", "doughnut");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e04603e7d8b77172, "defaults", {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e04603e7d8b77172, "descriptors", {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e04603e7d8b77172, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                fontColor: color,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    }
});
class $973c3913dfffaf2c$export$3c9b5d28c11cbfd0 extends $973c3913dfffaf2c$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $be903a41cbfc2c2c$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $be903a41cbfc2c2c$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $be903a41cbfc2c2c$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$3c9b5d28c11cbfd0, "id", "line");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$3c9b5d28c11cbfd0, "defaults", {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$3c9b5d28c11cbfd0, "overrides", {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
});
class $973c3913dfffaf2c$export$2a270b3a0d973c85 extends $973c3913dfffaf2c$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $be903a41cbfc2c2c$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $be903a41cbfc2c2c$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $be903a41cbfc2c2c$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$2a270b3a0d973c85, "id", "polarArea");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$2a270b3a0d973c85, "defaults", {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$2a270b3a0d973c85, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                fontColor: color,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
});
class $973c3913dfffaf2c$export$b21a3f1286706191 extends $973c3913dfffaf2c$export$e04603e7d8b77172 {
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$b21a3f1286706191, "id", "pie");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$b21a3f1286706191, "defaults", {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
});
class $973c3913dfffaf2c$export$48dbc6ac651bf8be extends $973c3913dfffaf2c$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $be903a41cbfc2c2c$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$48dbc6ac651bf8be, "id", "radar");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$48dbc6ac651bf8be, "defaults", {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$48dbc6ac651bf8be, "overrides", {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
});
class $973c3913dfffaf2c$export$b2f2bae6713db87 extends $973c3913dfffaf2c$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + ")"
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $be903a41cbfc2c2c$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $be903a41cbfc2c2c$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $be903a41cbfc2c2c$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$b2f2bae6713db87, "id", "scatter");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$b2f2bae6713db87, "defaults", {
    datasetElementType: false,
    dataElementType: "point",
    showLine: false,
    fill: false
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$b2f2bae6713db87, "overrides", {
    interaction: {
        mode: "point"
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
});
var $973c3913dfffaf2c$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $973c3913dfffaf2c$export$e97d5dc64e999004,
    BubbleController: $973c3913dfffaf2c$export$19b5c4773f17abe,
    DoughnutController: $973c3913dfffaf2c$export$e04603e7d8b77172,
    LineController: $973c3913dfffaf2c$export$3c9b5d28c11cbfd0,
    PieController: $973c3913dfffaf2c$export$b21a3f1286706191,
    PolarAreaController: $973c3913dfffaf2c$export$2a270b3a0d973c85,
    RadarController: $973c3913dfffaf2c$export$48dbc6ac651bf8be,
    ScatterController: $973c3913dfffaf2c$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $973c3913dfffaf2c$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $973c3913dfffaf2c$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($973c3913dfffaf2c$var$DateAdapterBase.prototype, members);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $973c3913dfffaf2c$var$abstract();
    }
    parse() {
        return $973c3913dfffaf2c$var$abstract();
    }
    format() {
        return $973c3913dfffaf2c$var$abstract();
    }
    add() {
        return $973c3913dfffaf2c$var$abstract();
    }
    diff() {
        return $973c3913dfffaf2c$var$abstract();
    }
    startOf() {
        return $973c3913dfffaf2c$var$abstract();
    }
    endOf() {
        return $973c3913dfffaf2c$var$abstract();
    }
    constructor(options){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "options", void 0);
        this.options = options || {};
    }
}
var $973c3913dfffaf2c$export$f32766ea09ec8bc4 = {
    _date: $973c3913dfffaf2c$var$DateAdapterBase
};
function $973c3913dfffaf2c$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $be903a41cbfc2c2c$export$ebd11618f299a286) : (0, $be903a41cbfc2c2c$export$ef35774e6d314e91);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $973c3913dfffaf2c$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $973c3913dfffaf2c$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $973c3913dfffaf2c$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $973c3913dfffaf2c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $be903a41cbfc2c2c$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $973c3913dfffaf2c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $973c3913dfffaf2c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = (0, $be903a41cbfc2c2c$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $be903a41cbfc2c2c$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $973c3913dfffaf2c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $973c3913dfffaf2c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $973c3913dfffaf2c$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $973c3913dfffaf2c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $973c3913dfffaf2c$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $973c3913dfffaf2c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $973c3913dfffaf2c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $973c3913dfffaf2c$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $973c3913dfffaf2c$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $973c3913dfffaf2c$export$a13296960cae0384 = {
    evaluateInteractionItems: $973c3913dfffaf2c$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $be903a41cbfc2c2c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $973c3913dfffaf2c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $973c3913dfffaf2c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $be903a41cbfc2c2c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $973c3913dfffaf2c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $973c3913dfffaf2c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $be903a41cbfc2c2c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $973c3913dfffaf2c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $be903a41cbfc2c2c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $973c3913dfffaf2c$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $be903a41cbfc2c2c$export$df995fae86a55f06)(e, chart);
            return $973c3913dfffaf2c$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $be903a41cbfc2c2c$export$df995fae86a55f06)(e, chart);
            return $973c3913dfffaf2c$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $973c3913dfffaf2c$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $973c3913dfffaf2c$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $973c3913dfffaf2c$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$973c3913dfffaf2c$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $973c3913dfffaf2c$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $973c3913dfffaf2c$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $973c3913dfffaf2c$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$973c3913dfffaf2c$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $973c3913dfffaf2c$var$setLayoutDims(layouts, params) {
    const stacks = $973c3913dfffaf2c$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $973c3913dfffaf2c$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $973c3913dfffaf2c$var$wrapBoxes(boxes);
    const fullSize = $973c3913dfffaf2c$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $973c3913dfffaf2c$var$sortByWeight($973c3913dfffaf2c$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $973c3913dfffaf2c$var$sortByWeight($973c3913dfffaf2c$var$filterByPosition(layoutBoxes, "right"));
    const top = $973c3913dfffaf2c$var$sortByWeight($973c3913dfffaf2c$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $973c3913dfffaf2c$var$sortByWeight($973c3913dfffaf2c$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $973c3913dfffaf2c$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $973c3913dfffaf2c$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $973c3913dfffaf2c$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $973c3913dfffaf2c$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $973c3913dfffaf2c$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $973c3913dfffaf2c$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $973c3913dfffaf2c$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $973c3913dfffaf2c$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $973c3913dfffaf2c$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $973c3913dfffaf2c$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $973c3913dfffaf2c$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $973c3913dfffaf2c$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $973c3913dfffaf2c$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $973c3913dfffaf2c$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $973c3913dfffaf2c$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $973c3913dfffaf2c$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $973c3913dfffaf2c$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $be903a41cbfc2c2c$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $973c3913dfffaf2c$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $973c3913dfffaf2c$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $be903a41cbfc2c2c$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $973c3913dfffaf2c$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $973c3913dfffaf2c$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $973c3913dfffaf2c$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $973c3913dfffaf2c$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $973c3913dfffaf2c$var$updateMaxPadding(maxPadding, (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $973c3913dfffaf2c$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $973c3913dfffaf2c$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $973c3913dfffaf2c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($973c3913dfffaf2c$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $973c3913dfffaf2c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $973c3913dfffaf2c$var$handleMaxPadding(chartArea);
        $973c3913dfffaf2c$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $973c3913dfffaf2c$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $973c3913dfffaf2c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $973c3913dfffaf2c$export$a40a96b24b46cf35 extends $973c3913dfffaf2c$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $973c3913dfffaf2c$var$EXPANDO_KEY = "$chartjs";
const $973c3913dfffaf2c$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $973c3913dfffaf2c$var$isNullOrEmpty = (value)=>value === null || value === "";
function $973c3913dfffaf2c$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$973c3913dfffaf2c$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($973c3913dfffaf2c$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $be903a41cbfc2c2c$export$b4171a6734a65d42)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($973c3913dfffaf2c$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $be903a41cbfc2c2c$export$b4171a6734a65d42)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $973c3913dfffaf2c$var$eventListenerOptions = (0, $be903a41cbfc2c2c$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $973c3913dfffaf2c$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $973c3913dfffaf2c$var$eventListenerOptions);
}
function $973c3913dfffaf2c$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $973c3913dfffaf2c$var$eventListenerOptions);
}
function $973c3913dfffaf2c$var$fromNativeEvent(event, chart) {
    const type = $973c3913dfffaf2c$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $be903a41cbfc2c2c$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $973c3913dfffaf2c$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $973c3913dfffaf2c$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $973c3913dfffaf2c$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$973c3913dfffaf2c$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $973c3913dfffaf2c$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $973c3913dfffaf2c$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$973c3913dfffaf2c$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $973c3913dfffaf2c$var$drpListeningCharts = new Map();
let $973c3913dfffaf2c$var$oldDevicePixelRatio = 0;
function $973c3913dfffaf2c$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $973c3913dfffaf2c$var$oldDevicePixelRatio) return;
    $973c3913dfffaf2c$var$oldDevicePixelRatio = dpr;
    $973c3913dfffaf2c$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $973c3913dfffaf2c$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$973c3913dfffaf2c$var$drpListeningCharts.size) window.addEventListener("resize", $973c3913dfffaf2c$var$onWindowResize);
    $973c3913dfffaf2c$var$drpListeningCharts.set(chart, resize);
}
function $973c3913dfffaf2c$var$unlistenDevicePixelRatioChanges(chart) {
    $973c3913dfffaf2c$var$drpListeningCharts.delete(chart);
    if (!$973c3913dfffaf2c$var$drpListeningCharts.size) window.removeEventListener("resize", $973c3913dfffaf2c$var$onWindowResize);
}
function $973c3913dfffaf2c$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $be903a41cbfc2c2c$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $be903a41cbfc2c2c$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $973c3913dfffaf2c$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $973c3913dfffaf2c$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $973c3913dfffaf2c$var$unlistenDevicePixelRatioChanges(chart);
}
function $973c3913dfffaf2c$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $be903a41cbfc2c2c$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($973c3913dfffaf2c$var$fromNativeEvent(event, chart));
    }, chart);
    $973c3913dfffaf2c$var$addListener(canvas, type, proxy);
    return proxy;
}
class $973c3913dfffaf2c$export$f02da7f882cf6b2e extends $973c3913dfffaf2c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $973c3913dfffaf2c$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$973c3913dfffaf2c$var$EXPANDO_KEY]) return false;
        const initial = canvas[$973c3913dfffaf2c$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$973c3913dfffaf2c$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $973c3913dfffaf2c$var$createAttachObserver,
            detach: $973c3913dfffaf2c$var$createDetachObserver,
            resize: $973c3913dfffaf2c$var$createResizeObserver
        };
        const handler = handlers[type] || $973c3913dfffaf2c$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $973c3913dfffaf2c$var$releaseObserver,
            detach: $973c3913dfffaf2c$var$releaseObserver,
            resize: $973c3913dfffaf2c$var$releaseObserver
        };
        const handler = handlers[type] || $973c3913dfffaf2c$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $be903a41cbfc2c2c$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $be903a41cbfc2c2c$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $973c3913dfffaf2c$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $be903a41cbfc2c2c$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $973c3913dfffaf2c$export$a40a96b24b46cf35;
    return $973c3913dfffaf2c$export$f02da7f882cf6b2e;
}
class $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $be903a41cbfc2c2c$export$d141bba7fdc215a3)(this.x) && (0, $be903a41cbfc2c2c$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
    constructor(){
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "x", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "y", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "active", false);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "options", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "$animations", void 0);
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$db77ccec0bb4ccac, "defaults", {});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$db77ccec0bb4ccac, "defaultRoutes", undefined);
function $973c3913dfffaf2c$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $973c3913dfffaf2c$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $973c3913dfffaf2c$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $973c3913dfffaf2c$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $973c3913dfffaf2c$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $973c3913dfffaf2c$var$skip(ticks, newTicks, spacing, (0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$973c3913dfffaf2c$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $973c3913dfffaf2c$var$skip(ticks, newTicks, spacing, last, (0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $973c3913dfffaf2c$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $973c3913dfffaf2c$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $973c3913dfffaf2c$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $973c3913dfffaf2c$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $be903a41cbfc2c2c$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $973c3913dfffaf2c$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $973c3913dfffaf2c$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $973c3913dfffaf2c$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $973c3913dfffaf2c$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $973c3913dfffaf2c$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $973c3913dfffaf2c$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
const $973c3913dfffaf2c$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $973c3913dfffaf2c$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $973c3913dfffaf2c$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $973c3913dfffaf2c$var$garbageCollect(caches, length) {
    (0, $be903a41cbfc2c2c$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $973c3913dfffaf2c$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $973c3913dfffaf2c$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $973c3913dfffaf2c$var$createScaleContext(parent, scale) {
    return (0, $be903a41cbfc2c2c$export$35e795649ee09318)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $973c3913dfffaf2c$var$createTickContext(parent, index, tick) {
    return (0, $be903a41cbfc2c2c$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $973c3913dfffaf2c$var$titleAlign(align, position, reverse) {
    let ret = (0, $be903a41cbfc2c2c$export$3c2fa207a37baaea)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $973c3913dfffaf2c$var$reverseAlign(ret);
    return ret;
}
function $973c3913dfffaf2c$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $973c3913dfffaf2c$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $973c3913dfffaf2c$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === "left" ? -(0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd) : (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $973c3913dfffaf2c$export$d60cfc58d3c358b6 extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(min, (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(max, min)),
            max: (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(max, (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $be903a41cbfc2c2c$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $973c3913dfffaf2c$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $973c3913dfffaf2c$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $973c3913dfffaf2c$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $973c3913dfffaf2c$var$getTickMarkLength(options.grid) - tickOpts.padding - $973c3913dfffaf2c$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $be903a41cbfc2c2c$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $be903a41cbfc2c2c$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $973c3913dfffaf2c$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $973c3913dfffaf2c$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $973c3913dfffaf2c$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $973c3913dfffaf2c$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $973c3913dfffaf2c$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(label) && !(0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(label)) {
                width = (0, $be903a41cbfc2c2c$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(nestedLabel) && !(0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $be903a41cbfc2c2c$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $973c3913dfffaf2c$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $be903a41cbfc2c2c$export$71cec2538cb2c617)(this._alignToPixels ? (0, $be903a41cbfc2c2c$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $973c3913dfffaf2c$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $973c3913dfffaf2c$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $973c3913dfffaf2c$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $be903a41cbfc2c2c$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $973c3913dfffaf2c$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $be903a41cbfc2c2c$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $973c3913dfffaf2c$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                    case "inner":
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $be903a41cbfc2c2c$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $be903a41cbfc2c2c$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $be903a41cbfc2c2c$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $be903a41cbfc2c2c$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $be903a41cbfc2c2c$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $be903a41cbfc2c2c$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $be903a41cbfc2c2c$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(title.font);
        const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $973c3913dfffaf2c$var$titleArgs(this, offset, position, align);
        (0, $be903a41cbfc2c2c$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $973c3913dfffaf2c$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $973c3913dfffaf2c$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $be903a41cbfc2c2c$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
}
class $973c3913dfffaf2c$var$TypedRegistry {
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($973c3913dfffaf2c$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $973c3913dfffaf2c$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $be903a41cbfc2c2c$export$4368d992c4eafac0)[scope]) {
            delete (0, $be903a41cbfc2c2c$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $be903a41cbfc2c2c$export$6559d589eb85fbb6)[id];
        }
    }
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
}
function $973c3913dfffaf2c$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $be903a41cbfc2c2c$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $973c3913dfffaf2c$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $973c3913dfffaf2c$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $973c3913dfffaf2c$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $973c3913dfffaf2c$var$Registry {
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $be903a41cbfc2c2c$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $be903a41cbfc2c2c$export$a8550f7dbe79f93a)(method);
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
    constructor(){
        this.controllers = new $973c3913dfffaf2c$var$TypedRegistry($973c3913dfffaf2c$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $973c3913dfffaf2c$var$TypedRegistry($973c3913dfffaf2c$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $973c3913dfffaf2c$var$TypedRegistry(Object, "plugins");
        this.scales = new $973c3913dfffaf2c$var$TypedRegistry($973c3913dfffaf2c$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
}
var $973c3913dfffaf2c$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $973c3913dfffaf2c$var$Registry();
class $973c3913dfffaf2c$var$PluginService {
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $973c3913dfffaf2c$var$allPlugins(config);
        return options === false && !all ? [] : $973c3913dfffaf2c$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
    constructor(){
        this._init = [];
    }
}
function $973c3913dfffaf2c$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($973c3913dfffaf2c$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($973c3913dfffaf2c$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $973c3913dfffaf2c$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $973c3913dfffaf2c$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $973c3913dfffaf2c$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $973c3913dfffaf2c$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $973c3913dfffaf2c$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $973c3913dfffaf2c$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $973c3913dfffaf2c$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $973c3913dfffaf2c$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $973c3913dfffaf2c$var$idMatchesAxis(id) {
    if (id === "x" || id === "y" || id === "r") return id;
}
function $973c3913dfffaf2c$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $973c3913dfffaf2c$var$determineAxis(id, ...scaleOptions) {
    if ($973c3913dfffaf2c$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $973c3913dfffaf2c$var$axisFromPosition(opts.position) || id.length > 1 && $973c3913dfffaf2c$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $973c3913dfffaf2c$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + "AxisID"] === id) return {
        axis: axis
    };
}
function $973c3913dfffaf2c$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $973c3913dfffaf2c$var$getAxisFromDataset(id, "x", boundDs[0]) || $973c3913dfffaf2c$var$getAxisFromDataset(id, "y", boundDs[0]);
    }
    return {};
}
function $973c3913dfffaf2c$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $be903a41cbfc2c2c$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $973c3913dfffaf2c$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $973c3913dfffaf2c$var$determineAxis(id, scaleConf, $973c3913dfffaf2c$var$retrieveAxisFromDatasets(id, config), (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $973c3913dfffaf2c$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $be903a41cbfc2c2c$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $973c3913dfffaf2c$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $be903a41cbfc2c2c$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $973c3913dfffaf2c$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $be903a41cbfc2c2c$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $be903a41cbfc2c2c$export$555508cbc6add439)(scale, [
            (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).scales[scale.type],
            (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $973c3913dfffaf2c$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $973c3913dfffaf2c$var$mergeScaleConfig(config, options);
}
function $973c3913dfffaf2c$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $973c3913dfffaf2c$var$initConfig(config) {
    config = config || {};
    config.data = $973c3913dfffaf2c$var$initData(config.data);
    $973c3913dfffaf2c$var$initOptions(config);
    return config;
}
const $973c3913dfffaf2c$var$keyCache = new Map();
const $973c3913dfffaf2c$var$keysCached = new Set();
function $973c3913dfffaf2c$var$cachedKeys(cacheKey, generate) {
    let keys = $973c3913dfffaf2c$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $973c3913dfffaf2c$var$keyCache.set(cacheKey, keys);
        $973c3913dfffaf2c$var$keysCached.add(keys);
    }
    return keys;
}
const $973c3913dfffaf2c$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $be903a41cbfc2c2c$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $973c3913dfffaf2c$var$Config {
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $973c3913dfffaf2c$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $973c3913dfffaf2c$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $973c3913dfffaf2c$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $973c3913dfffaf2c$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $973c3913dfffaf2c$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $973c3913dfffaf2c$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$973c3913dfffaf2c$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$973c3913dfffaf2c$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$973c3913dfffaf2c$var$addIfFound(scopes, (0, $be903a41cbfc2c2c$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$973c3913dfffaf2c$var$addIfFound(scopes, (0, $be903a41cbfc2c2c$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$973c3913dfffaf2c$var$addIfFound(scopes, (0, $be903a41cbfc2c2c$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($973c3913dfffaf2c$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $be903a41cbfc2c2c$export$6559d589eb85fbb6)[type] || {},
            (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $be903a41cbfc2c2c$export$4368d992c4eafac0),
            (0, $be903a41cbfc2c2c$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $973c3913dfffaf2c$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($973c3913dfffaf2c$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $be903a41cbfc2c2c$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $be903a41cbfc2c2c$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $973c3913dfffaf2c$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(context) ? (0, $be903a41cbfc2c2c$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
    constructor(config){
        this._config = $973c3913dfffaf2c$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
}
function $973c3913dfffaf2c$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $be903a41cbfc2c2c$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $973c3913dfffaf2c$var$hasFunction = (value)=>(0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $be903a41cbfc2c2c$export$a93c5207d687da10)(value[key]));
function $973c3913dfffaf2c$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $be903a41cbfc2c2c$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $be903a41cbfc2c2c$export$a93c5207d687da10)(value) || $973c3913dfffaf2c$var$hasFunction(value)) || indexable && (0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $973c3913dfffaf2c$var$version = "4.4.3";
const $973c3913dfffaf2c$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $973c3913dfffaf2c$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $973c3913dfffaf2c$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $973c3913dfffaf2c$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $973c3913dfffaf2c$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $973c3913dfffaf2c$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $973c3913dfffaf2c$var$getCanvas(item) {
    if ((0, $be903a41cbfc2c2c$export$3a1a48c8f6ef640e)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $973c3913dfffaf2c$var$instances = {};
const $973c3913dfffaf2c$var$getChart = (key)=>{
    const canvas = $973c3913dfffaf2c$var$getCanvas(key);
    return Object.values($973c3913dfffaf2c$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $973c3913dfffaf2c$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $973c3913dfffaf2c$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
function $973c3913dfffaf2c$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $973c3913dfffaf2c$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $973c3913dfffaf2c$var$getSizeForArea(xScale, chartArea, "left"),
        right: $973c3913dfffaf2c$var$getSizeForArea(xScale, chartArea, "right"),
        top: $973c3913dfffaf2c$var$getSizeForArea(yScale, chartArea, "top"),
        bottom: $973c3913dfffaf2c$var$getSizeForArea(yScale, chartArea, "bottom")
    };
    return chartArea;
}
class $973c3913dfffaf2c$export$acaa6426d77a227e {
    static register(...items) {
        $973c3913dfffaf2c$export$4bb7493d241fd8a5.add(...items);
        $973c3913dfffaf2c$var$invalidatePlugins();
    }
    static unregister(...items) {
        $973c3913dfffaf2c$export$4bb7493d241fd8a5.remove(...items);
        $973c3913dfffaf2c$var$invalidatePlugins();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $973c3913dfffaf2c$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $be903a41cbfc2c2c$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $be903a41cbfc2c2c$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $973c3913dfffaf2c$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$973c3913dfffaf2c$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $be903a41cbfc2c2c$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $973c3913dfffaf2c$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $973c3913dfffaf2c$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $973c3913dfffaf2c$var$positionIsHorizontal(scaleOptions.position, axis) !== $973c3913dfffaf2c$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $973c3913dfffaf2c$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(scales, (scale)=>{
            $973c3913dfffaf2c$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $973c3913dfffaf2c$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($973c3913dfffaf2c$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $973c3913dfffaf2c$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $973c3913dfffaf2c$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $973c3913dfffaf2c$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $973c3913dfffaf2c$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $be903a41cbfc2c2c$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($973c3913dfffaf2c$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this.scales, (scale)=>{
            $973c3913dfffaf2c$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $be903a41cbfc2c2c$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $973c3913dfffaf2c$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $be903a41cbfc2c2c$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $be903a41cbfc2c2c$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($973c3913dfffaf2c$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$973c3913dfffaf2c$export$a424a0aa8f687495.running(this)) $973c3913dfffaf2c$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $973c3913dfffaf2c$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $973c3913dfffaf2c$var$getDatasetArea(meta, this.chartArea);
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $be903a41cbfc2c2c$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $be903a41cbfc2c2c$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $be903a41cbfc2c2c$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $973c3913dfffaf2c$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $be903a41cbfc2c2c$export$35e795649ee09318)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $be903a41cbfc2c2c$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $973c3913dfffaf2c$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $be903a41cbfc2c2c$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $973c3913dfffaf2c$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $be903a41cbfc2c2c$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $be903a41cbfc2c2c$export$f38c853ae54ed474)(e);
        const lastEvent = $973c3913dfffaf2c$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $be903a41cbfc2c2c$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
    constructor(item, userConfig){
        const config = this.config = new $973c3913dfffaf2c$var$Config(userConfig);
        const initialCanvas = $973c3913dfffaf2c$var$getCanvas(item);
        const existingChart = $973c3913dfffaf2c$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $973c3913dfffaf2c$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $be903a41cbfc2c2c$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $973c3913dfffaf2c$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $be903a41cbfc2c2c$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $973c3913dfffaf2c$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $973c3913dfffaf2c$export$a424a0aa8f687495.listen(this, "complete", $973c3913dfffaf2c$var$onAnimationsComplete);
        $973c3913dfffaf2c$export$a424a0aa8f687495.listen(this, "progress", $973c3913dfffaf2c$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$acaa6426d77a227e, "defaults", (0, $be903a41cbfc2c2c$export$4368d992c4eafac0));
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$acaa6426d77a227e, "instances", $973c3913dfffaf2c$var$instances);
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$acaa6426d77a227e, "overrides", (0, $be903a41cbfc2c2c$export$6559d589eb85fbb6));
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$acaa6426d77a227e, "registry", $973c3913dfffaf2c$export$4bb7493d241fd8a5);
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$acaa6426d77a227e, "version", $973c3913dfffaf2c$var$version);
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$acaa6426d77a227e, "getChart", $973c3913dfffaf2c$var$getChart);
function $973c3913dfffaf2c$var$invalidatePlugins() {
    return (0, $be903a41cbfc2c2c$export$d66501df72047452)($973c3913dfffaf2c$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $973c3913dfffaf2c$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd), startAngle - (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $973c3913dfffaf2c$var$toRadiusCorners(value) {
    return (0, $be903a41cbfc2c2c$export$21579262ef46735b)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $973c3913dfffaf2c$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $973c3913dfffaf2c$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $973c3913dfffaf2c$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $973c3913dfffaf2c$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $be903a41cbfc2c2c$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $973c3913dfffaf2c$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $973c3913dfffaf2c$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $973c3913dfffaf2c$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $973c3913dfffaf2c$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $973c3913dfffaf2c$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $973c3913dfffaf2c$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $973c3913dfffaf2c$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $973c3913dfffaf2c$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $973c3913dfffaf2c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $be903a41cbfc2c2c$export$971d5caa766a69d7) || (0, $be903a41cbfc2c2c$export$971d5caa766a69d7));
    }
    $973c3913dfffaf2c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $973c3913dfffaf2c$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $973c3913dfffaf2c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $be903a41cbfc2c2c$export$971d5caa766a69d7) || (0, $be903a41cbfc2c2c$export$971d5caa766a69d7));
    }
    if (inner) $973c3913dfffaf2c$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $973c3913dfffaf2c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $973c3913dfffaf2c$export$d48203c759d6a1fc extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $be903a41cbfc2c2c$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $be903a41cbfc2c2c$export$971d5caa766a69d7) || (0, $be903a41cbfc2c2c$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $be903a41cbfc2c2c$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $be903a41cbfc2c2c$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $be903a41cbfc2c2c$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $973c3913dfffaf2c$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $973c3913dfffaf2c$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
    constructor(cfg){
        super();
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "circumference", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "endAngle", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "fullCircles", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "innerRadius", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "outerRadius", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "pixelMargin", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "startAngle", void 0);
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$d48203c759d6a1fc, "id", "arc");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$d48203c759d6a1fc, "defaults", {
    borderAlign: "center",
    borderColor: "#fff",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$d48203c759d6a1fc, "defaultRoutes", {
    backgroundColor: "backgroundColor"
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$d48203c759d6a1fc, "descriptors", {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash"
});
function $973c3913dfffaf2c$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $973c3913dfffaf2c$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $973c3913dfffaf2c$var$getLineMethod(options) {
    if (options.stepped) return 0, $be903a41cbfc2c2c$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $be903a41cbfc2c2c$export$6554612db691658e;
    return $973c3913dfffaf2c$var$lineTo;
}
function $973c3913dfffaf2c$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $973c3913dfffaf2c$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $973c3913dfffaf2c$var$pathVars(points, segment, params);
    const lineMethod = $973c3913dfffaf2c$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $973c3913dfffaf2c$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $973c3913dfffaf2c$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $973c3913dfffaf2c$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $973c3913dfffaf2c$var$fastPathSegment : $973c3913dfffaf2c$var$pathSegment;
}
function $973c3913dfffaf2c$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $be903a41cbfc2c2c$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $be903a41cbfc2c2c$export$2f6ca3d3b1f80bf5;
    return 0, $be903a41cbfc2c2c$export$8a5498727ef6be21;
}
function $973c3913dfffaf2c$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $973c3913dfffaf2c$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $973c3913dfffaf2c$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $973c3913dfffaf2c$var$_getSegmentMethod(line);
    for (const segment of segments){
        $973c3913dfffaf2c$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $973c3913dfffaf2c$var$usePath2D = typeof Path2D === "function";
function $973c3913dfffaf2c$var$draw(ctx, line, start, count) {
    if ($973c3913dfffaf2c$var$usePath2D && !line.options.segment) $973c3913dfffaf2c$var$strokePathWithCache(ctx, line, start, count);
    else $973c3913dfffaf2c$var$strokePathDirect(ctx, line, start, count);
}
class $973c3913dfffaf2c$export$55e463fa7bcd3469 extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $be903a41cbfc2c2c$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $be903a41cbfc2c2c$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $be903a41cbfc2c2c$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $973c3913dfffaf2c$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $973c3913dfffaf2c$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $973c3913dfffaf2c$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $973c3913dfffaf2c$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$55e463fa7bcd3469, "id", "line");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$55e463fa7bcd3469, "defaults", {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$55e463fa7bcd3469, "defaultRoutes", {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$55e463fa7bcd3469, "descriptors", {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
});
function $973c3913dfffaf2c$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $973c3913dfffaf2c$export$bd159b522b230b7a extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $973c3913dfffaf2c$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $973c3913dfffaf2c$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $be903a41cbfc2c2c$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $be903a41cbfc2c2c$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
    constructor(cfg){
        super();
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "parsed", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "skip", void 0);
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "stop", void 0);
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$bd159b522b230b7a, "id", "point");
/**
   * @type {any}
   */ (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$bd159b522b230b7a, "defaults", {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
});
/**
   * @type {any}
   */ (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$bd159b522b230b7a, "defaultRoutes", {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
});
function $973c3913dfffaf2c$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $973c3913dfffaf2c$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(value, min, max);
}
function $973c3913dfffaf2c$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $be903a41cbfc2c2c$export$d66dc83d8cfc8dd)(value);
    return {
        t: $973c3913dfffaf2c$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $973c3913dfffaf2c$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $973c3913dfffaf2c$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $973c3913dfffaf2c$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $973c3913dfffaf2c$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $be903a41cbfc2c2c$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $973c3913dfffaf2c$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $973c3913dfffaf2c$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $973c3913dfffaf2c$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $973c3913dfffaf2c$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $973c3913dfffaf2c$var$boundingRects(bar) {
    const bounds = $973c3913dfffaf2c$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $973c3913dfffaf2c$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $973c3913dfffaf2c$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $973c3913dfffaf2c$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $973c3913dfffaf2c$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $973c3913dfffaf2c$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $973c3913dfffaf2c$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $973c3913dfffaf2c$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $973c3913dfffaf2c$export$a16ed71bf4b07672 extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $973c3913dfffaf2c$var$boundingRects(this);
        const addRectPath = $973c3913dfffaf2c$var$hasRadius(outer.radius) ? (0, $be903a41cbfc2c2c$export$1fbe638ecf81657e) : $973c3913dfffaf2c$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $973c3913dfffaf2c$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $973c3913dfffaf2c$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $973c3913dfffaf2c$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $973c3913dfffaf2c$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $973c3913dfffaf2c$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $973c3913dfffaf2c$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$a16ed71bf4b07672, "id", "bar");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$a16ed71bf4b07672, "defaults", {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: undefined
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$a16ed71bf4b07672, "defaultRoutes", {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
});
var $973c3913dfffaf2c$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $973c3913dfffaf2c$export$d48203c759d6a1fc,
    BarElement: $973c3913dfffaf2c$export$a16ed71bf4b07672,
    LineElement: $973c3913dfffaf2c$export$55e463fa7bcd3469,
    PointElement: $973c3913dfffaf2c$export$bd159b522b230b7a
});
const $973c3913dfffaf2c$var$BORDER_COLORS = [
    "rgb(54, 162, 235)",
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)" // grey
];
// Border colors with 50% transparency
const $973c3913dfffaf2c$var$BACKGROUND_COLORS = /* #__PURE__ */ $973c3913dfffaf2c$var$BORDER_COLORS.map((color)=>color.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function $973c3913dfffaf2c$var$getBorderColor(i) {
    return $973c3913dfffaf2c$var$BORDER_COLORS[i % $973c3913dfffaf2c$var$BORDER_COLORS.length];
}
function $973c3913dfffaf2c$var$getBackgroundColor(i) {
    return $973c3913dfffaf2c$var$BACKGROUND_COLORS[i % $973c3913dfffaf2c$var$BACKGROUND_COLORS.length];
}
function $973c3913dfffaf2c$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $973c3913dfffaf2c$var$getBorderColor(i);
    dataset.backgroundColor = $973c3913dfffaf2c$var$getBackgroundColor(i);
    return ++i;
}
function $973c3913dfffaf2c$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$973c3913dfffaf2c$var$getBorderColor(i++));
    return i;
}
function $973c3913dfffaf2c$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$973c3913dfffaf2c$var$getBackgroundColor(i++));
    return i;
}
function $973c3913dfffaf2c$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $973c3913dfffaf2c$export$e04603e7d8b77172) i = $973c3913dfffaf2c$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $973c3913dfffaf2c$export$2a270b3a0d973c85) i = $973c3913dfffaf2c$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $973c3913dfffaf2c$var$colorizeDefaultDataset(dataset, i);
    };
}
function $973c3913dfffaf2c$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $973c3913dfffaf2c$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var $973c3913dfffaf2c$export$c537fa0d021d010b = {
    id: "colors",
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        if (!options.forceOverride && ($973c3913dfffaf2c$var$containsColorsDefinitions(datasets) || $973c3913dfffaf2c$var$containsColorsDefinition(chartOptions) || elements && $973c3913dfffaf2c$var$containsColorsDefinitions(elements))) return;
        const colorizer = $973c3913dfffaf2c$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $973c3913dfffaf2c$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $973c3913dfffaf2c$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(minIndex) && !(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $973c3913dfffaf2c$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $973c3913dfffaf2c$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $973c3913dfffaf2c$var$cleanDecimatedDataset(dataset);
    });
}
function $973c3913dfffaf2c$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)((0, $be903a41cbfc2c2c$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)((0, $be903a41cbfc2c2c$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $973c3913dfffaf2c$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $973c3913dfffaf2c$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $be903a41cbfc2c2c$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $973c3913dfffaf2c$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $973c3913dfffaf2c$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $973c3913dfffaf2c$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $973c3913dfffaf2c$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $973c3913dfffaf2c$var$cleanDecimatedData(chart);
    }
};
function $973c3913dfffaf2c$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $973c3913dfffaf2c$var$_findSegmentEnd(start, end, points);
        const bounds = $973c3913dfffaf2c$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $be903a41cbfc2c2c$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $973c3913dfffaf2c$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $be903a41cbfc2c2c$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $973c3913dfffaf2c$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $973c3913dfffaf2c$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $973c3913dfffaf2c$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $be903a41cbfc2c2c$export$28f7fcd39efa255)(start);
        end = (0, $be903a41cbfc2c2c$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $973c3913dfffaf2c$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $973c3913dfffaf2c$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $973c3913dfffaf2c$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $973c3913dfffaf2c$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $973c3913dfffaf2c$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $973c3913dfffaf2c$var$_pointsFromSegments(boundary, line);
    return points.length ? new $973c3913dfffaf2c$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $973c3913dfffaf2c$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $973c3913dfffaf2c$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $973c3913dfffaf2c$var$_decodeFill(line, index, count) {
    const fill = $973c3913dfffaf2c$var$parseFillOption(line);
    if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $973c3913dfffaf2c$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $973c3913dfffaf2c$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $973c3913dfffaf2c$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $973c3913dfffaf2c$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $973c3913dfffaf2c$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $973c3913dfffaf2c$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $973c3913dfffaf2c$var$getLinesBelow(scale, index);
    linesBelow.push($973c3913dfffaf2c$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$973c3913dfffaf2c$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $973c3913dfffaf2c$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $973c3913dfffaf2c$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $973c3913dfffaf2c$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $973c3913dfffaf2c$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $973c3913dfffaf2c$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $973c3913dfffaf2c$var$simpleArc {
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $be903a41cbfc2c2c$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
}
function $973c3913dfffaf2c$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(fill)) return $973c3913dfffaf2c$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $973c3913dfffaf2c$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $973c3913dfffaf2c$var$computeBoundary(source);
    if (boundary instanceof $973c3913dfffaf2c$var$simpleArc) return boundary;
    return $973c3913dfffaf2c$var$_createBoundaryLine(boundary, line);
}
function $973c3913dfffaf2c$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $973c3913dfffaf2c$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $973c3913dfffaf2c$var$computeCircularBoundary(source);
    return $973c3913dfffaf2c$var$computeLinearBoundary(source);
}
function $973c3913dfffaf2c$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $973c3913dfffaf2c$var$_getTargetPixel(fill, scale);
    if ((0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $973c3913dfffaf2c$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $973c3913dfffaf2c$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $973c3913dfffaf2c$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $973c3913dfffaf2c$var$_drawfill(ctx, source, area) {
    const target = $973c3913dfffaf2c$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $be903a41cbfc2c2c$export$8743009a87fcb00f)(ctx, area);
        $973c3913dfffaf2c$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $be903a41cbfc2c2c$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $973c3913dfffaf2c$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $973c3913dfffaf2c$var$clipVertical(ctx, target, area.top);
        $973c3913dfffaf2c$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $973c3913dfffaf2c$var$clipVertical(ctx, target, area.bottom);
    }
    $973c3913dfffaf2c$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $973c3913dfffaf2c$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$973c3913dfffaf2c$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $973c3913dfffaf2c$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $973c3913dfffaf2c$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $973c3913dfffaf2c$var$clipBounds(ctx, scale, notShape && $973c3913dfffaf2c$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $973c3913dfffaf2c$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $973c3913dfffaf2c$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $973c3913dfffaf2c$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $973c3913dfffaf2c$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $973c3913dfffaf2c$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $973c3913dfffaf2c$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $973c3913dfffaf2c$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $973c3913dfffaf2c$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $973c3913dfffaf2c$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($973c3913dfffaf2c$var$_shouldApplyFill(source)) $973c3913dfffaf2c$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$973c3913dfffaf2c$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $973c3913dfffaf2c$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $973c3913dfffaf2c$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $973c3913dfffaf2c$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $973c3913dfffaf2c$var$Legend extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $973c3913dfffaf2c$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $973c3913dfffaf2c$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $be903a41cbfc2c2c$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $be903a41cbfc2c2c$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $be903a41cbfc2c2c$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $be903a41cbfc2c2c$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $973c3913dfffaf2c$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $be903a41cbfc2c2c$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $be903a41cbfc2c2c$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $be903a41cbfc2c2c$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $be903a41cbfc2c2c$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $be903a41cbfc2c2c$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $be903a41cbfc2c2c$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== "string") {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $973c3913dfffaf2c$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $be903a41cbfc2c2c$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $be903a41cbfc2c2c$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $be903a41cbfc2c2c$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $be903a41cbfc2c2c$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $be903a41cbfc2c2c$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$973c3913dfffaf2c$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $973c3913dfffaf2c$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $973c3913dfffaf2c$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $973c3913dfffaf2c$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $973c3913dfffaf2c$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $973c3913dfffaf2c$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== "string") legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $973c3913dfffaf2c$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== "string") itemHeight = $973c3913dfffaf2c$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $973c3913dfffaf2c$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $973c3913dfffaf2c$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $973c3913dfffaf2c$export$ed247974535929c7 = {
    id: "legend",
    _element: $973c3913dfffaf2c$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $973c3913dfffaf2c$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $973c3913dfffaf2c$var$Title extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $be903a41cbfc2c2c$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $be903a41cbfc2c2c$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $be903a41cbfc2c2c$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $be903a41cbfc2c2c$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $be903a41cbfc2c2c$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $be903a41cbfc2c2c$export$3c2fa207a37baaea)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $973c3913dfffaf2c$var$createTitle(chart, titleOpts) {
    const title = new $973c3913dfffaf2c$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $973c3913dfffaf2c$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $973c3913dfffaf2c$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $973c3913dfffaf2c$export$f99233281efd08a0 = {
    id: "title",
    _element: $973c3913dfffaf2c$var$Title,
    start (chart, _args, options) {
        $973c3913dfffaf2c$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $973c3913dfffaf2c$var$map = new WeakMap();
var $973c3913dfffaf2c$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $973c3913dfffaf2c$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.configure(chart, title, options);
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.addBox(chart, title);
        $973c3913dfffaf2c$var$map.set(chart, title);
    },
    stop (chart) {
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.removeBox(chart, $973c3913dfffaf2c$var$map.get(chart));
        $973c3913dfffaf2c$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $973c3913dfffaf2c$var$map.get(chart);
        $973c3913dfffaf2c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $973c3913dfffaf2c$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $be903a41cbfc2c2c$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $973c3913dfffaf2c$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $973c3913dfffaf2c$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $973c3913dfffaf2c$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $973c3913dfffaf2c$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $be903a41cbfc2c2c$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $be903a41cbfc2c2c$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $be903a41cbfc2c2c$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $be903a41cbfc2c2c$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $973c3913dfffaf2c$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $973c3913dfffaf2c$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $973c3913dfffaf2c$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($973c3913dfffaf2c$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $973c3913dfffaf2c$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $973c3913dfffaf2c$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $973c3913dfffaf2c$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $973c3913dfffaf2c$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $973c3913dfffaf2c$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $973c3913dfffaf2c$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $be903a41cbfc2c2c$export$92108d983e8ee699)(cornerRadius);
    let x = $973c3913dfffaf2c$var$alignX(size, xAlign);
    const y = $973c3913dfffaf2c$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $973c3913dfffaf2c$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $973c3913dfffaf2c$var$getBeforeAfterBodyLines(callback) {
    return $973c3913dfffaf2c$var$pushOrConcat([], $973c3913dfffaf2c$var$splitNewlines(callback));
}
function $973c3913dfffaf2c$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $be903a41cbfc2c2c$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $973c3913dfffaf2c$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $973c3913dfffaf2c$var$defaultCallbacks = {
    beforeTitle: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return "";
    },
    afterTitle: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    beforeBody: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    beforeLabel: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || "";
        if (label) label += ": ";
        const value = tooltipItem.formattedValue;
        if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    afterBody: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    beforeFooter: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    footer: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46),
    afterFooter: (0, $be903a41cbfc2c2c$export$cf2f7c5792f80b46)
};
function $973c3913dfffaf2c$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === "undefined") return $973c3913dfffaf2c$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $973c3913dfffaf2c$var$Tooltip extends $973c3913dfffaf2c$export$db77ccec0bb4ccac {
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $973c3913dfffaf2c$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $973c3913dfffaf2c$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $973c3913dfffaf2c$var$invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
        const title = $973c3913dfffaf2c$var$invokeCallbackWithFallback(callbacks, "title", this, context);
        const afterTitle = $973c3913dfffaf2c$var$invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
        let lines = [];
        lines = $973c3913dfffaf2c$var$pushOrConcat(lines, $973c3913dfffaf2c$var$splitNewlines(beforeTitle));
        lines = $973c3913dfffaf2c$var$pushOrConcat(lines, $973c3913dfffaf2c$var$splitNewlines(title));
        lines = $973c3913dfffaf2c$var$pushOrConcat(lines, $973c3913dfffaf2c$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $973c3913dfffaf2c$var$getBeforeAfterBodyLines($973c3913dfffaf2c$var$invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $973c3913dfffaf2c$var$overrideCallbacks(callbacks, context);
            $973c3913dfffaf2c$var$pushOrConcat(bodyItem.before, $973c3913dfffaf2c$var$splitNewlines($973c3913dfffaf2c$var$invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
            $973c3913dfffaf2c$var$pushOrConcat(bodyItem.lines, $973c3913dfffaf2c$var$invokeCallbackWithFallback(scoped, "label", this, context));
            $973c3913dfffaf2c$var$pushOrConcat(bodyItem.after, $973c3913dfffaf2c$var$splitNewlines($973c3913dfffaf2c$var$invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $973c3913dfffaf2c$var$getBeforeAfterBodyLines($973c3913dfffaf2c$var$invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $973c3913dfffaf2c$var$invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
        const footer = $973c3913dfffaf2c$var$invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
        const afterFooter = $973c3913dfffaf2c$var$invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
        let lines = [];
        lines = $973c3913dfffaf2c$var$pushOrConcat(lines, $973c3913dfffaf2c$var$splitNewlines(beforeFooter));
        lines = $973c3913dfffaf2c$var$pushOrConcat(lines, $973c3913dfffaf2c$var$splitNewlines(footer));
        lines = $973c3913dfffaf2c$var$pushOrConcat(lines, $973c3913dfffaf2c$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($973c3913dfffaf2c$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $973c3913dfffaf2c$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($973c3913dfffaf2c$var$invokeCallbackWithFallback(scoped, "labelColor", this, context));
            labelPointStyles.push($973c3913dfffaf2c$var$invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
            labelTextColors.push($973c3913dfffaf2c$var$invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $973c3913dfffaf2c$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $973c3913dfffaf2c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $973c3913dfffaf2c$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $973c3913dfffaf2c$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $be903a41cbfc2c2c$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $be903a41cbfc2c2c$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $973c3913dfffaf2c$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.bodyFont);
        const colorX = $973c3913dfffaf2c$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $be903a41cbfc2c2c$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $be903a41cbfc2c2c$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $be903a41cbfc2c2c$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $be903a41cbfc2c2c$export$92108d983e8ee699)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $be903a41cbfc2c2c$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $be903a41cbfc2c2c$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $be903a41cbfc2c2c$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $973c3913dfffaf2c$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $be903a41cbfc2c2c$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $be903a41cbfc2c2c$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $be903a41cbfc2c2c$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $be903a41cbfc2c2c$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $973c3913dfffaf2c$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $be903a41cbfc2c2c$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $973c3913dfffaf2c$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $973c3913dfffaf2c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $973c3913dfffaf2c$var$determineAlignment(chart, options, positionAndSize);
            const point = $973c3913dfffaf2c$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $be903a41cbfc2c2c$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $be903a41cbfc2c2c$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $be903a41cbfc2c2c$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $be903a41cbfc2c2c$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $973c3913dfffaf2c$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$var$Tooltip, "positioners", $973c3913dfffaf2c$var$positioners);
var $973c3913dfffaf2c$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $973c3913dfffaf2c$var$Tooltip,
    positioners: $973c3913dfffaf2c$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $973c3913dfffaf2c$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: $973c3913dfffaf2c$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $973c3913dfffaf2c$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $973c3913dfffaf2c$export$c537fa0d021d010b,
    Decimation: $973c3913dfffaf2c$export$be17f937e9aa7533,
    Filler: $973c3913dfffaf2c$export$d19ba4d812bed757,
    Legend: $973c3913dfffaf2c$export$ed247974535929c7,
    SubTitle: $973c3913dfffaf2c$export$d5c56664638992a4,
    Title: $973c3913dfffaf2c$export$f99233281efd08a0,
    Tooltip: $973c3913dfffaf2c$export$28c660c63b792dea
});
const $973c3913dfffaf2c$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $973c3913dfffaf2c$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $973c3913dfffaf2c$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $973c3913dfffaf2c$var$validIndex = (index, max)=>index === null ? null : (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $973c3913dfffaf2c$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $973c3913dfffaf2c$export$29e663ba4d09fe7 extends $973c3913dfffaf2c$export$d60cfc58d3c358b6 {
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $973c3913dfffaf2c$var$findOrAddLabel(labels, raw, (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $973c3913dfffaf2c$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $973c3913dfffaf2c$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$29e663ba4d09fe7, "id", "category");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$29e663ba4d09fe7, "defaults", {
    ticks: {
        callback: $973c3913dfffaf2c$var$_getLabelForValue
    }
});
function $973c3913dfffaf2c$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $be903a41cbfc2c2c$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $be903a41cbfc2c2c$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $be903a41cbfc2c2c$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $be903a41cbfc2c2c$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $be903a41cbfc2c2c$export$23ebac1979863676)(spacing), (0, $be903a41cbfc2c2c$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $be903a41cbfc2c2c$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $973c3913dfffaf2c$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $be903a41cbfc2c2c$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $973c3913dfffaf2c$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $973c3913dfffaf2c$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $973c3913dfffaf2c$var$LinearScaleBase extends $973c3913dfffaf2c$export$d60cfc58d3c358b6 {
    parse(raw, index) {
        if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $be903a41cbfc2c2c$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $973c3913dfffaf2c$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $be903a41cbfc2c2c$export$53a70dd1ebbae346)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $be903a41cbfc2c2c$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
}
class $973c3913dfffaf2c$export$e7f4e5e8656f0b93 extends $973c3913dfffaf2c$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e7f4e5e8656f0b93, "id", "linear");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$e7f4e5e8656f0b93, "defaults", {
    ticks: {
        callback: (0, $be903a41cbfc2c2c$export$91477dc880baac21).formatters.numeric
    }
});
const $973c3913dfffaf2c$var$log10Floor = (v)=>Math.floor((0, $be903a41cbfc2c2c$export$9f4f30ee63539e24)(v));
const $973c3913dfffaf2c$var$changeExponent = (v, m)=>Math.pow(10, $973c3913dfffaf2c$var$log10Floor(v) + m);
function $973c3913dfffaf2c$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $973c3913dfffaf2c$var$log10Floor(tickVal));
    return remain === 1;
}
function $973c3913dfffaf2c$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $973c3913dfffaf2c$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $973c3913dfffaf2c$var$log10Floor(range);
    while($973c3913dfffaf2c$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($973c3913dfffaf2c$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $973c3913dfffaf2c$var$log10Floor(min));
}
function $973c3913dfffaf2c$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $973c3913dfffaf2c$var$log10Floor(min);
    let exp = $973c3913dfffaf2c$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $973c3913dfffaf2c$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $be903a41cbfc2c2c$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $973c3913dfffaf2c$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $973c3913dfffaf2c$export$85295eaf7cb3ac3e extends $973c3913dfffaf2c$export$d60cfc58d3c358b6 {
    parse(raw, index) {
        const value = $973c3913dfffaf2c$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(this._userMin)) this.min = min === $973c3913dfffaf2c$var$changeExponent(this.min, 0) ? $973c3913dfffaf2c$var$changeExponent(this.min, -1) : $973c3913dfffaf2c$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($973c3913dfffaf2c$var$changeExponent(min, -1));
                setMax($973c3913dfffaf2c$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($973c3913dfffaf2c$var$changeExponent(max, -1));
        if (max <= 0) setMax($973c3913dfffaf2c$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $973c3913dfffaf2c$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $be903a41cbfc2c2c$export$53a70dd1ebbae346)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $be903a41cbfc2c2c$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $be903a41cbfc2c2c$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $be903a41cbfc2c2c$export$9f4f30ee63539e24)(this.max) - (0, $be903a41cbfc2c2c$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $be903a41cbfc2c2c$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$85295eaf7cb3ac3e, "id", "logarithmic");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$85295eaf7cb3ac3e, "defaults", {
    ticks: {
        callback: (0, $be903a41cbfc2c2c$export$91477dc880baac21).formatters.logarithmic,
        major: {
            enabled: true
        }
    }
});
function $973c3913dfffaf2c$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $be903a41cbfc2c2c$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $973c3913dfffaf2c$var$measureLabelSize(ctx, font, label) {
    label = (0, $be903a41cbfc2c2c$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $be903a41cbfc2c2c$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $973c3913dfffaf2c$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $973c3913dfffaf2c$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $be903a41cbfc2c2c$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(opts.font);
        const textSize = $973c3913dfffaf2c$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $be903a41cbfc2c2c$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $be903a41cbfc2c2c$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $973c3913dfffaf2c$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $973c3913dfffaf2c$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $973c3913dfffaf2c$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $973c3913dfffaf2c$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $973c3913dfffaf2c$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $973c3913dfffaf2c$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $be903a41cbfc2c2c$export$3a6d5c9ae78a2c08)((0, $be903a41cbfc2c2c$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd))));
    const y = $973c3913dfffaf2c$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $973c3913dfffaf2c$var$getTextAlignForAngle(angle);
    const left = $973c3913dfffaf2c$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $973c3913dfffaf2c$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $be903a41cbfc2c2c$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $be903a41cbfc2c2c$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $be903a41cbfc2c2c$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $be903a41cbfc2c2c$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $973c3913dfffaf2c$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $973c3913dfffaf2c$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $be903a41cbfc2c2c$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $973c3913dfffaf2c$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === "auto") {
            item.visible = $973c3913dfffaf2c$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $973c3913dfffaf2c$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $973c3913dfffaf2c$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $973c3913dfffaf2c$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $973c3913dfffaf2c$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $be903a41cbfc2c2c$export$92108d983e8ee699)(opts.borderRadius);
        const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $be903a41cbfc2c2c$export$1fbe638ecf81657e)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $973c3913dfffaf2c$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $973c3913dfffaf2c$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $be903a41cbfc2c2c$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $973c3913dfffaf2c$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $be903a41cbfc2c2c$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $973c3913dfffaf2c$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $973c3913dfffaf2c$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $973c3913dfffaf2c$var$createPointLabelContext(parent, index, label) {
    return (0, $be903a41cbfc2c2c$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $973c3913dfffaf2c$export$cfafc36d95386d38 extends $973c3913dfffaf2c$var$LinearScaleBase {
    setDimensions() {
        const padding = this._padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)($973c3913dfffaf2c$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $973c3913dfffaf2c$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $973c3913dfffaf2c$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $973c3913dfffaf2c$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $be903a41cbfc2c2c$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $be903a41cbfc2c2c$export$28f7fcd39efa255)(index * angleMultiplier + (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $973c3913dfffaf2c$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $be903a41cbfc2c2c$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $973c3913dfffaf2c$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $973c3913dfffaf2c$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $973c3913dfffaf2c$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $be903a41cbfc2c2c$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $be903a41cbfc2c2c$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $be903a41cbfc2c2c$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$cfafc36d95386d38, "id", "radialLinear");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$cfafc36d95386d38, "defaults", {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: (0, $be903a41cbfc2c2c$export$91477dc880baac21).formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$cfafc36d95386d38, "defaultRoutes", {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
});
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$cfafc36d95386d38, "descriptors", {
    angleLines: {
        _fallback: "grid"
    }
});
const $973c3913dfffaf2c$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $973c3913dfffaf2c$var$UNITS = /* #__PURE__ */ Object.keys($973c3913dfffaf2c$var$INTERVALS);
function $973c3913dfffaf2c$var$sorter(a, b) {
    return a - b;
}
function $973c3913dfffaf2c$var$parse(scale, input) {
    if ((0, $be903a41cbfc2c2c$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $be903a41cbfc2c2c$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $973c3913dfffaf2c$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $973c3913dfffaf2c$var$UNITS.length;
    for(let i = $973c3913dfffaf2c$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $973c3913dfffaf2c$var$INTERVALS[$973c3913dfffaf2c$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $973c3913dfffaf2c$var$UNITS[i];
    }
    return $973c3913dfffaf2c$var$UNITS[ilen - 1];
}
function $973c3913dfffaf2c$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $973c3913dfffaf2c$var$UNITS.length - 1; i >= $973c3913dfffaf2c$var$UNITS.indexOf(minUnit); i--){
        const unit = $973c3913dfffaf2c$var$UNITS[i];
        if ($973c3913dfffaf2c$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $973c3913dfffaf2c$var$UNITS[minUnit ? $973c3913dfffaf2c$var$UNITS.indexOf(minUnit) : 0];
}
function $973c3913dfffaf2c$var$determineMajorUnit(unit) {
    for(let i = $973c3913dfffaf2c$var$UNITS.indexOf(unit) + 1, ilen = $973c3913dfffaf2c$var$UNITS.length; i < ilen; ++i){
        if ($973c3913dfffaf2c$var$INTERVALS[$973c3913dfffaf2c$var$UNITS[i]].common) return $973c3913dfffaf2c$var$UNITS[i];
    }
}
function $973c3913dfffaf2c$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $be903a41cbfc2c2c$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $973c3913dfffaf2c$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $973c3913dfffaf2c$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $973c3913dfffaf2c$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $973c3913dfffaf2c$export$a894c72689ff3ec extends $973c3913dfffaf2c$export$d60cfc58d3c358b6 {
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $973c3913dfffaf2c$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $be903a41cbfc2c2c$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $973c3913dfffaf2c$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $be903a41cbfc2c2c$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $be903a41cbfc2c2c$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $973c3913dfffaf2c$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $973c3913dfffaf2c$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $973c3913dfffaf2c$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $973c3913dfffaf2c$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $be903a41cbfc2c2c$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $973c3913dfffaf2c$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $be903a41cbfc2c2c$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $be903a41cbfc2c2c$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$973c3913dfffaf2c$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $973c3913dfffaf2c$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($973c3913dfffaf2c$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $be903a41cbfc2c2c$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $be903a41cbfc2c2c$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $973c3913dfffaf2c$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($973c3913dfffaf2c$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $be903a41cbfc2c2c$export$71511d61b312f219)(values.sort($973c3913dfffaf2c$var$sorter));
    }
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$a894c72689ff3ec, "id", "time");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$a894c72689ff3ec, "defaults", {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        callback: false,
        major: {
            enabled: false
        }
    }
});
function $973c3913dfffaf2c$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $be903a41cbfc2c2c$export$ef35774e6d314e91)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $be903a41cbfc2c2c$export$ef35774e6d314e91)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $973c3913dfffaf2c$export$85df64a8eb6dc986 extends $973c3913dfffaf2c$export$a894c72689ff3ec {
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $973c3913dfffaf2c$var$interpolate(table, this.min);
        this._tableRange = $973c3913dfffaf2c$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($973c3913dfffaf2c$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $973c3913dfffaf2c$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
}
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$85df64a8eb6dc986, "id", "timeseries");
(0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)($973c3913dfffaf2c$export$85df64a8eb6dc986, "defaults", $973c3913dfffaf2c$export$a894c72689ff3ec.defaults);
var $973c3913dfffaf2c$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $973c3913dfffaf2c$export$29e663ba4d09fe7,
    LinearScale: $973c3913dfffaf2c$export$e7f4e5e8656f0b93,
    LogarithmicScale: $973c3913dfffaf2c$export$85295eaf7cb3ac3e,
    RadialLinearScale: $973c3913dfffaf2c$export$cfafc36d95386d38,
    TimeScale: $973c3913dfffaf2c$export$a894c72689ff3ec,
    TimeSeriesScale: $973c3913dfffaf2c$export$85df64a8eb6dc986
});
const $973c3913dfffaf2c$export$e8959e79e3af550f = [
    $973c3913dfffaf2c$export$a6506504f799c5d5,
    $973c3913dfffaf2c$export$7a5d735b2ab6389d,
    $973c3913dfffaf2c$export$8b3ca321c77fdea6,
    $973c3913dfffaf2c$export$bcac1c16f1530ec2
];



var $2981c0ad88f3571d$exports = {};
!function(e, t) {
    $2981c0ad88f3571d$exports = t();
}($2981c0ad88f3571d$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var a = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, f = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], h = function(e) {
        var t = o[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, u = function(e, t) {
        var n, r = o.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, d = {
        A: [
            i,
            function(e) {
                this.afternoon = u(e, !1);
            }
        ],
        a: [
            i,
            function(e) {
                this.afternoon = u(e, !0);
            }
        ],
        S: [
            /\d/,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            n,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            r,
            a("seconds")
        ],
        ss: [
            r,
            a("seconds")
        ],
        m: [
            r,
            a("minutes")
        ],
        mm: [
            r,
            a("minutes")
        ],
        H: [
            r,
            a("hours")
        ],
        h: [
            r,
            a("hours")
        ],
        HH: [
            r,
            a("hours")
        ],
        hh: [
            r,
            a("hours")
        ],
        D: [
            r,
            a("day")
        ],
        DD: [
            n,
            a("day")
        ],
        Do: [
            i,
            function(e) {
                var t = o.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        M: [
            r,
            a("month")
        ],
        MM: [
            n,
            a("month")
        ],
        MMM: [
            i,
            function(e) {
                var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            i,
            function(e) {
                var t = h("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            a("year")
        ],
        YY: [
            n,
            function(e) {
                this.year = s(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            a("year")
        ],
        Z: f,
        ZZ: f
    };
    function c(n) {
        var r, i;
        r = n, i = o && o.formats;
        for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = s.length, f = 0; f < a; f += 1){
            var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
            s[f] = l ? {
                regex: c,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = s[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, s = e.args;
            this.$u = r;
            var a = s[1];
            if ("string" == typeof a) {
                var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                        i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                        var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                        return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
            } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                s[1] = a[m - 1];
                var M = n.apply(this, s);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === l && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $cb00a0025a580828$exports = {};
!function(e, t) {
    $cb00a0025a580828$exports = t();
}($cb00a0025a580828$exports, function() {
    "use strict";
    return function(e, t, r) {
        var n = t.prototype, s = n.format;
        r.en.ordinal = function(e) {
            var t = [
                "th",
                "st",
                "nd",
                "rd"
            ], r = e % 100;
            return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
        }, n.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return s.bind(this)(e);
            var n = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return n.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return n.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return n.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return s.bind(this)(a);
        };
    };
});


var $d67d0f2691305a73$exports = {};
!function(t, n) {
    $d67d0f2691305a73$exports = n();
}($d67d0f2691305a73$exports, function() {
    "use strict";
    var t = "month", n = "quarter";
    return function(e, i) {
        var r = i.prototype;
        r.quarter = function(t) {
            return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
        };
        var s = r.add;
        r.add = function(e, i) {
            return e = Number(e), this.$utils().p(i) === n ? this.add(3 * e, t) : s.bind(this)(e, i);
        };
        var u = r.startOf;
        r.startOf = function(e, i) {
            var r = this.$utils(), s = !!r.u(i) || i;
            if (r.p(e) === n) {
                var o = this.quarter() - 1;
                return s ? this.month(3 * o).startOf(t).startOf("day") : this.month(3 * o + 2).endOf(t).endOf("day");
            }
            return u.bind(this)(e, i);
        };
    };
});


var $2067feb116c79187$exports = {};
!function(e, t) {
    $2067feb116c79187$exports = t();
}($2067feb116c79187$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $c5244f09f9582fc5$exports = {};
!function(e, t) {
    $c5244f09f9582fc5$exports = t();
}($c5244f09f9582fc5$exports, function() {
    "use strict";
    var e = "day";
    return function(t, i, s) {
        var a = function(t) {
            return t.add(4 - t.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
            return a(this).year();
        }, d.isoWeek = function(t) {
            if (!this.$utils().u(t)) return this.add(7 * (t - this.isoWeek()), e);
            var i, d, n, o, r = a(this), u = (i = this.isoWeekYear(), d = this.$u, n = (d ? s.utc : s)().year(i).startOf("year"), o = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (o += 7), n.add(o, e));
            return r.diff(u, "week") + 1;
        }, d.isoWeekday = function(e) {
            return this.$utils().u(e) ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
        };
        var n = d.startOf;
        d.startOf = function(e, t) {
            var i = this.$utils(), s = !!i.u(t) || t;
            return "isoweek" === i.p(e) ? s ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e, t);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($cb00a0025a580828$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($d67d0f2691305a73$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($2067feb116c79187$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($2981c0ad88f3571d$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($c5244f09f9582fc5$exports))));
var $3ce20339fd3ae564$var$FORMATS = {
    datetime: "MMM D, YYYY, h:mm:ss a",
    millisecond: "h:mm:ss.SSS a",
    second: "h:mm:ss a",
    minute: "h:mm a",
    hour: "hA",
    day: "MMM D",
    week: "ll",
    month: "MMM YYYY",
    quarter: "[Q]Q - YYYY",
    year: "YYYY"
};
(0, $973c3913dfffaf2c$export$f32766ea09ec8bc4)._date.override({
    //_id: 'dayjs', //DEBUG,
    formats: function formats() {
        return $3ce20339fd3ae564$var$FORMATS;
    },
    parse: function parse(value, format) {
        var valueType = typeof value;
        if (value === null || valueType === "undefined") return null;
        if (valueType === "string" && typeof format === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(value, format).isValid() ? (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(value, format).valueOf() : null;
        else if (!(value instanceof (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports))))) return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(value).isValid() ? (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(value).valueOf() : null;
        return null;
    },
    format: function format(time, _format) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(time).format(_format);
    },
    add: function add(time, amount, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(time).add(amount, unit).valueOf();
    },
    diff: function diff(max, min, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(max).diff((0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(min), unit);
    },
    startOf: function startOf(time, unit, weekday) {
        if (unit === "isoWeek") {
            // Ensure that weekday has a valid format
            //const formattedWeekday
            var validatedWeekday = typeof weekday === "number" && weekday > 0 && weekday < 7 ? weekday : 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(time).isoWeekday(validatedWeekday).startOf("day").valueOf();
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(time).startOf(unit).valueOf();
    },
    endOf: function endOf(time, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(time).endOf(unit).valueOf();
    }
});



(0, $973c3913dfffaf2c$export$acaa6426d77a227e).register(...(0, $973c3913dfffaf2c$export$e8959e79e3af550f));
var $7f0808a9188c35c8$export$2e2bcd8739ae039 = (0, $973c3913dfffaf2c$export$acaa6426d77a227e);




var $f6LVE = parcelRequire("f6LVE");


var $VqyUd = parcelRequire("VqyUd");
class $f09ab7b8c1e106ac$export$22b63ca7479b342c extends (0, $VqyUd.Component) {
    shouldComponentUpdate() {
        return false;
    }
    render(props) {
        return props === null || props === void 0 ? void 0 : props.children;
    }
}


(0, $973c3913dfffaf2c$export$acaa6426d77a227e).defaults.color = "#fff";
(0, $973c3913dfffaf2c$export$acaa6426d77a227e).defaults.borderColor = "#444";
const $7c6b146315e3e335$var$TELEMETRY_PERIODS = [
    14,
    28,
    56,
    "__ALL_TIME__"
];
const $7c6b146315e3e335$var$DEFAULT_TELEMETRY_PERIOD = 28;
const $7c6b146315e3e335$var$parseTelemetryPeriod = (value)=>{
    if (value === "__ALL_TIME__") return value;
    const int = parseInt(value, 10);
    if ($7c6b146315e3e335$var$TELEMETRY_PERIODS.includes(int)) return int;
    return $7c6b146315e3e335$var$DEFAULT_TELEMETRY_PERIOD;
};
const $7c6b146315e3e335$var$getPeriodStartDate = (allTelemetry, period)=>{
    if (typeof period === "number") return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))().subtract(period, "days");
    return (0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports)))(Object.keys(allTelemetry)[0]);
};
const $7c6b146315e3e335$var$findTelemetries = (allTelemetry, period)=>{
    const dailies = [];
    let date = $7c6b146315e3e335$var$getPeriodStartDate(allTelemetry, period);
    while(date.isBefore(Date.now())){
        const key = date.toISOString().split("T")[0];
        const daily = allTelemetry[key];
        // TODO: investigate missing data
        dailies.push(daily !== null && daily !== void 0 ? daily : {
            date: key,
            userIds: []
        }), date = date.add(1, "day");
    }
    return dailies;
};
const $7c6b146315e3e335$var$getData = (allTelemetry, period)=>{
    const telemetry = $7c6b146315e3e335$var$findTelemetries(allTelemetry, period);
    const userIds = [
        ...new Set(telemetry.flatMap((daily)=>daily.userIds))
    ];
    return {
        labels: telemetry.map((daily)=>(0, $7d3f392fa48145f5$export$1431bc52824a265)(daily.date)),
        datasets: userIds.map((userId)=>({
                label: userId.slice(-6),
                data: telemetry.map((daily)=>daily.userIds.includes(userId) ? 1 : 0),
                fill: true
            }))
    };
};
const $7c6b146315e3e335$var$AdminUserTelemetryPlot = (p)=>{
    const [root, setRoot] = (0, $f6LVE.useState)(null);
    const [period, setPeriod] = (0, $f6LVE.useState)($7c6b146315e3e335$var$DEFAULT_TELEMETRY_PERIOD);
    const [chart, setChart] = (0, $f6LVE.useState)(null);
    (0, $f6LVE.useEffect)(()=>{
        if (!root) return;
        const config = {
            type: "line",
            data: $7c6b146315e3e335$var$getData(p.telemetry.daily, $7c6b146315e3e335$var$DEFAULT_TELEMETRY_PERIOD),
            options: {
                scales: {
                    x: {
                        type: "timeseries"
                    },
                    y: {
                        stacked: true,
                        ticks: {
                            stepSize: 1
                        },
                        title: {
                            display: true,
                            text: "Users"
                        }
                    }
                }
            }
        };
        const chart = new (0, $973c3913dfffaf2c$export$acaa6426d77a227e)(root, config);
        setChart(chart);
        return ()=>{
            setChart(null);
            chart.destroy();
        };
    }, [
        root,
        p.telemetry
    ]);
    (0, $f6LVE.useEffect)(()=>{
        if (!chart) return;
        chart.data = $7c6b146315e3e335$var$getData(p.telemetry.daily, period);
        chart.update();
    }, [
        chart,
        p.telemetry,
        period
    ]);
    if (!Object.keys(p.telemetry.daily).length) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
        children: "[ no daily telemetry available ]"
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("select", {
                value: period,
                onChange: (ev)=>setPeriod($7c6b146315e3e335$var$parseTelemetryPeriod(ev.currentTarget.value)),
                children: $7c6b146315e3e335$var$TELEMETRY_PERIODS.map((period)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("option", {
                        value: period,
                        children: typeof period === "number" ? `${period} days` : "All Time"
                    }, period))
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f09ab7b8c1e106ac$export$22b63ca7479b342c), {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("canvas", {
                    ref: setRoot
                })
            })
        ]
    });
};
const $7c6b146315e3e335$export$e306302bed8722a = (p)=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($7c6b146315e3e335$var$AdminUserTelemetryPlot, {
        telemetry: p.telemetry
    });
};





const $103253bdac5a6384$var$getOverviewRows = (user)=>{
    var _user_telemetry, _user_telemetry1;
    return [
        {
            key: "Version",
            value: (_user_telemetry = user.telemetry) === null || _user_telemetry === void 0 ? void 0 : _user_telemetry.version
        },
        {
            key: "Provider",
            value: (_user_telemetry1 = user.telemetry) === null || _user_telemetry1 === void 0 ? void 0 : _user_telemetry1.dataProvider
        },
        {
            key: "Last Seen",
            value: user.lastSuccessfulValidation && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f8b9ef8a0e39a5c9$export$587529144f113cfe), {
                date: user.lastSuccessfulValidation
            })
        },
        {
            key: "Devices",
            value: user.rfDevices
        }
    ];
};
const $103253bdac5a6384$export$73595234ddedaacf = (p)=>{
    const controllers = (0, $f57fa0ee256b0db7$export$8b376ee89da7718b)();
    const controller = (0, $a53afc0516d42e77$export$fe4300aa8eebea86)(()=>new (0, $2b071fcb1afb030a$exports.AdminUserController)(controllers, p.userId));
    (0, $8ea62fef91697031$exports.useSubject)(controller);
    if (controller.error) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
        width: "sm",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
            severity: "error",
            message: controller.error
        })
    });
    if (!controller.user) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d6dd782797fe2e79$export$7f7cbe89f1eacd2), {});
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
        width: "lg",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
            className: "adminUserPage",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$86de09faaa70680d), {
                    icon: "user",
                    title: controller.user.companyName,
                    headingLevel: 1
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f972cf3465ce7583$export$76fcfc16fbce2e93), {
                    user: controller.user
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                    className: "details",
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $ab8596abdfd6425b$export$1171cd935df7643a), {
                            rows: $103253bdac5a6384$var$getOverviewRows(controller.user)
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $b396258aca809c9c$export$751af27082c5ce71), {
                            user: controller.user
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8f215dc168c5f2f1$export$d13d1b2ce0f4bac6), {
                            user: controller.user
                        })
                    ]
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                    children: controller.user.telemetry && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7c6b146315e3e335$export$e306302bed8722a), {
                        telemetry: controller.user.telemetry
                    })
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $b2eb27efd79ea534$export$36d953148455edf2), {
                        invoices: controller.user.invoices
                    })
                })
            ]
        })
    });
};




const $c1366b2994c00864$export$44904eddc13a0885 = ({ userId: userId })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $103253bdac5a6384$export$73595234ddedaacf), {
        userId: userId
    }, userId);
};






const $30aaa9e76d563dc4$export$48d3d184aade51b1 = (_)=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    (0, $8ea62fef91697031$exports.useSubject)(accountController, "state");
    switch(accountController.state.kind){
        case "loading":
            return null;
        case "ok":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $af1712d028ffe1e6$export$8c210df7ac193b9d), {});
        case "unauthorized":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $3978618e07c2bca6$export$12449a31c6671d53), {});
    }
};





const $af7c1fd3414d19be$var$handleLogIn = ()=>(0, $378f8733f7648194$export$4cb887bfde2d34ca)("/");
const $af7c1fd3414d19be$export$b4461a4f6a14f942 = (_)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $79675f4550d6b49e$export$f14c0e3f98d164c0), {
        onLogIn: $af7c1fd3414d19be$var$handleLogIn
    });


var $19817f615e72c7b6$exports = {};

$parcel$export($19817f615e72c7b6$exports, "RouteController", function () { return $19817f615e72c7b6$export$ebd56f3bd4f1f72f; });
$parcel$export($19817f615e72c7b6$exports, "RouteControllerProvider", function () { return $19817f615e72c7b6$export$8d9dbf712206b168; });
$parcel$export($19817f615e72c7b6$exports, "useRouteController", function () { return $19817f615e72c7b6$export$99d3ff43312dc267; });







var $VqyUd = parcelRequire("VqyUd");

var $f6LVE = parcelRequire("f6LVE");

var $19817f615e72c7b6$var$_url;
var $19817f615e72c7b6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $19817f615e72c7b6$export$ebd56f3bd4f1f72f = ($19817f615e72c7b6$var$_url = /*#__PURE__*/ new WeakMap(), class RouteController {
    get url() {
        return (0, $30fb72b9782bcd33$export$5a67b255b80ee4f2)(this, $19817f615e72c7b6$var$_url);
    }
    set url(value) {
        (0, $5d238b5a663b7ba4$export$268446c9779b3a21)(this, $19817f615e72c7b6$var$_url, value);
    }
    handleRouteChange(ev) {
        this.url = ev.url;
        const event = {
            url: ev.url,
            prevUrl: ev.previous
        };
        this.listeners.forEach((listener)=>listener(event));
    }
    onRouteChange(listener) {
        this.listeners.add(listener);
        return ()=>{
            this.listeners.delete(listener);
        };
    }
    constructor(){
        (0, $f519eca4b2e78dd4$export$e235798705076415)(this, $19817f615e72c7b6$var$_url, {
            writable: true,
            value: void 0
        });
        (0, $5830e53916a6c4df$export$1e71eb4bef00f6b0)(this, "listeners", new Set());
    }
});
$19817f615e72c7b6$var$__decorate([
    (0, $8ea62fef91697031$exports.observable)()
], $19817f615e72c7b6$export$ebd56f3bd4f1f72f.prototype, "url", null);
$19817f615e72c7b6$var$__decorate([
    (0, $8ea62fef91697031$exports.callback)
], $19817f615e72c7b6$export$ebd56f3bd4f1f72f.prototype, "handleRouteChange", null);
$19817f615e72c7b6$export$ebd56f3bd4f1f72f = $19817f615e72c7b6$var$__decorate([
    (0, $8ea62fef91697031$exports.subject)()
], $19817f615e72c7b6$export$ebd56f3bd4f1f72f);
const $19817f615e72c7b6$var$routeControllerContext = (0, $VqyUd.createContext)(null);
const $19817f615e72c7b6$export$8d9dbf712206b168 = ({ value: value, children: children })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($19817f615e72c7b6$var$routeControllerContext.Provider, {
        value: value,
        children: children
    });
};
const $19817f615e72c7b6$export$99d3ff43312dc267 = ()=>{
    const ctx = (0, $f6LVE.useContext)($19817f615e72c7b6$var$routeControllerContext);
    if (!ctx) throw new (0, $0a3e95917c2f7450$export$2970af845c2cbd28)("routeControllerContext", "RouteControllerProvider");
    return ctx;
};







const $a41f9ec2cca4e1a7$export$c9e27277d624b1c6 = ({ className: className, innerClassName: innerClassName, title: title, children: children })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
        innerClassName: "mrg-auto",
        width: "xs",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
            className: innerClassName,
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                    level: 1,
                    children: title
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {
                    size: "md"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                    className: className,
                    children: children
                })
            ]
        })
    });


const $32ccc1b3fab5fe66$var$handleSignUp = ()=>{
    (0, $378f8733f7648194$export$4cb887bfde2d34ca)("/");
};
const $32ccc1b3fab5fe66$export$d6275cbf70a375ba = (_)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $a41f9ec2cca4e1a7$export$c9e27277d624b1c6), {
        title: "Sign Up",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8bbdc1d1b43d2c33$export$cc15cfe224a6a69b), {
            onSignUp: $32ccc1b3fab5fe66$var$handleSignUp
        })
    });







const $fdd3f71fcd90df48$export$91620953951fa2ae = ({ code: code = "" })=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    (0, $8ea62fef91697031$exports.useSubject)(accountController, "state");
    if (accountController.state.kind === "unauthorized") return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
        innerClassName: "mrg-auto",
        width: "xs",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
            className: "stack",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                    level: 1,
                    children: "Log In"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a49b1b99f213b79$export$1f58f750f20f344b), {})
            ]
        })
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
        innerClassName: "mrg-auto",
        width: "xs",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
            className: "stack",
            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c962298f4d60e43d$export$618c37ed564b5426), {
                code: code
            })
        })
    });
};


$parcel$exportWildcard($73871698c3c60905$exports, $19817f615e72c7b6$exports);




const $5ba975c94b4f5d10$var$NavItems = ()=>{
    const account = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    (0, $8ea62fef91697031$exports.useSubject)(account, "state");
    const auth = (0, $f57fa0ee256b0db7$export$2ddc77f16875382c)();
    const handleLogOutClick = (0, $f6LVE.useCallback)((ev)=>{
        ev.preventDefault();
        auth.logout();
    }, [
        auth
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                    href: "/documentation",
                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        size: "lg",
                        align: "center",
                        children: "Documentation"
                    })
                })
            }),
            account.state.kind === "unauthorized" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                            href: "/signup",
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                size: "lg",
                                align: "center",
                                children: "Sign up"
                            })
                        })
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                            href: "/login",
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                size: "lg",
                                align: "center",
                                children: "Log in"
                            })
                        })
                    })
                ]
            }),
            account.state.kind === "ok" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                            href: "/",
                            "data-native": true,
                            onClick: handleLogOutClick,
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                size: "lg",
                                align: "center",
                                children: "Log out"
                            })
                        })
                    }),
                    account.state.details.admin && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                            href: "/admin",
                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                size: "lg",
                                align: "center",
                                children: "Admin"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $5ba975c94b4f5d10$export$ef8da11641c635de = ({ className: className })=>{
    const [hamburgerOpen, setHamburgerOpen] = (0, $f6LVE.useState)(false);
    const handleHamburgerClick = (0, $f6LVE.useCallback)(()=>{
        setHamburgerOpen((prev)=>!prev);
    }, []);
    const routeController = (0, $19817f615e72c7b6$exports.useRouteController)();
    (0, $f6LVE.useEffect)(()=>routeController.onRouteChange(()=>{
            setHamburgerOpen(false);
        }), [
        routeController
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("nav", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("nav-bar", className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("surface theme-panel"),
                innerClassName: "nav-bar__content",
                width: "lg",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        className: "nav-bar__banner",
                        role: "banner",
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                            href: "/",
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2c8d3cee2ba76f85$export$dd38071655615b86), {}),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                    tag: "h1",
                                    font: "display",
                                    size: "xl",
                                    children: "BEARING"
                                })
                            ]
                        })
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                className: "nav-bar__inline-menu",
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($5ba975c94b4f5d10$var$NavItems, {})
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                                className: "nav-bar__hamburger-button",
                                variant: "icon",
                                icon: hamburgerOpen ? "close" : "hamburger",
                                onClick: handleHamburgerClick,
                                visuallyHiddenLabel: hamburgerOpen ? "Close navigation menu" : "Open navigation menu"
                            })
                        ]
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $6620d597003ccb23$export$1cfea591e85f6e12), {
                className: "nav-bar__hamburger-menu",
                duration: "sm",
                open: hamburgerOpen,
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                    className: " theme-panel surface",
                    innerTag: "ul",
                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($5ba975c94b4f5d10$var$NavItems, {})
                })
            })
        ]
    });
};




var $f6LVE = parcelRequire("f6LVE");
var $02246fb8d981911f$exports = {};
/*! @license DOMPurify 2.3.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.4/LICENSE */ (function(global, factory) {
    $02246fb8d981911f$exports = factory();
})($02246fb8d981911f$exports, function() {
    "use strict";
    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== "undefined" && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return new (Function.prototype.bind.apply(Func, [
            null
        ].concat(_toConsumableArray(args))))();
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array) {
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === "string") {
                var lcElement = stringToLowerCase(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property = void 0;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ])) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
        }
        return fallbackValue;
    }
    var html = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    // SVG
    var svg = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    var svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "fedropshadow",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    var mathMl = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    var text = freeze([
        "#text"
    ]);
    var html$1 = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "xmlns",
        "slot"
    ]);
    var svg$1 = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    var mathMl$1 = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    var xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function _toConsumableArray$1(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    }
    var getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if ((typeof trustedTypes === "undefined" ? "undefined" : _typeof(trustedTypes)) !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = "data-tt-policy-suffix";
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html$$1) {
                    return html$$1;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "2.3.4";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === undefined ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        var getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        var getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        var getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            var template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML("") : "";
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === "function" && implementation && typeof implementation.createHTMLDocument !== "undefined" && documentMode !== 9;
        var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR, ERB_EXPR$$1 = ERB_EXPR, DATA_ATTR$$1 = DATA_ATTR, ARIA_ATTR$$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
        var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks? */ var SANITIZE_DOM = true;
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        var MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE = void 0;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        var transformCaseFunc = void 0;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement("form");
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || (typeof cfg === "undefined" ? "undefined" : _typeof(cfg)) !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? function(x) {
                return x;
            } : stringToLowerCase;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html);
                    addToSet(ALLOWED_ATTR, html$1);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg);
                    addToSet(ALLOWED_ATTR, svg$1);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg$1);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl);
                    addToSet(ALLOWED_ATTR, mathMl$1);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "desc",
            "title",
            "annotation-xml"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: HTML_NAMESPACE,
                tagName: "template"
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // Certain elements are allowed in both SVG and HTML
                // namespace. We need to specify them explicitly
                // so that they don't get erronously deleted from
                // HTML namespace.
                var commonSvgAndHTMLElements = addToSet({}, [
                    "title",
                    "style",
                    "font",
                    "a",
                    "script"
                ]);
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG or MathML). Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc = void 0;
            var leadingWhitespace = void 0;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml") // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? "" : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function");
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return (typeof Node === "undefined" ? "undefined" : _typeof(Node)) === "object" ? object instanceof Node : object && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content = void 0;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === "select" && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                    }
                }
                if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            if ((tagName === "noscript" || tagName === "noembed") && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$$1, " ");
                content = stringReplace(content, ERB_EXPR$$1, " ");
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ""))) ;
            else if (!value) ;
            else return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName.indexOf("-") > 0;
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr = void 0;
            var value = void 0;
            var lcName = void 0;
            var l = void 0;
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$$1, " ");
                    value = stringReplace(value, ERB_EXPR$$1, " ");
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode = void 0;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty, cfg) {
            var body = void 0;
            var importedNode = void 0;
            var currentNode = void 0;
            var oldNode = void 0;
            var returnNode = void 0;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                // eslint-disable-next-line no-negated-condition
                if (typeof dirty.toString !== "function") throw typeErrorCreate("toString is not a function");
                else {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                }
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === "object" || typeof window1.toStaticHTML === "function") {
                    if (typeof dirty === "string") return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) ;
            else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : emptyHTML;
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, " ");
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, " ");
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


const $646e054fc15adb54$export$54bb0dd98911e9d1 = ()=>{
    const [html, setHtml] = (0, $f6LVE.useState)(null);
    (0, $f6LVE.useEffect)(()=>{
        fetch("/RELEASE.html").then((res)=>res.ok ? res.text() : "<p>Error fetching release notes.</p>").then((html)=>setHtml({
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($02246fb8d981911f$exports))).sanitize(html)
            }));
    }, []);
    if (!html) return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        dangerouslySetInnerHTML: html
    });
};




var $f6LVE = parcelRequire("f6LVE");





const $8bbdc1d1b43d2c33$var$EmailDescription = ({ signupResponse: signupResponse, lastSubmittedValue: lastSubmittedValue })=>{
    if (!signupResponse || signupResponse.ok) return null;
    if (signupResponse.errors.includes("email-exists")) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
        severity: "error",
        message: "This email address is already registered",
        size: "md",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
            size: "sm",
            children: [
                "Did you mean to ",
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                    href: "/login",
                    children: "log in"
                }),
                "?"
            ]
        })
    });
    var _lastSubmittedValue_split_;
    if (signupResponse.errors.includes("email-free")) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
        severity: "error",
        message: `You can't use an email address from ${(_lastSubmittedValue_split_ = lastSubmittedValue.split("@")[1]) !== null && _lastSubmittedValue_split_ !== void 0 ? _lastSubmittedValue_split_ : "that domain"}.`,
        size: "md",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
            size: "sm",
            children: "Please use your company email address."
        })
    });
    return null;
};
const $8bbdc1d1b43d2c33$var$SUBMIT_LABEL = "Sign Up";
const $8bbdc1d1b43d2c33$export$cc15cfe224a6a69b = ({ className: className, onSignUp: onSignUp })=>{
    const authController = (0, $f57fa0ee256b0db7$export$2ddc77f16875382c)();
    const [email, setEmail] = (0, $f6LVE.useState)("");
    const [password, setPassword] = (0, $f6LVE.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $f6LVE.useState)("");
    const emailInputRef = (0, $f6LVE.useRef)(null);
    (0, $57ef02025d2ad4a3$export$a9c05560d717b4fe)(emailInputRef);
    const [working, setWorking] = (0, $f6LVE.useState)(false);
    const [response, setResponse] = (0, $f6LVE.useState)(null);
    const [lastSubmittedEmail, setLastSubmittedEmail] = (0, $f6LVE.useState)();
    const handleSubmit = ()=>{
        setWorking(true);
        setResponse(null);
        setLastSubmittedEmail(email);
        authController.signup({
            email: email,
            password: password,
            acceptTou: true,
            acceptEula: true
        }).then((response)=>{
            if (response.ok) {
                onSignUp === null || onSignUp === void 0 ? void 0 : onSignUp();
                return;
            }
            setResponse(response);
        }).finally(()=>{
            setWorking(false);
        });
    };
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$a7fed597f4b8afd8), {
        className: className,
        submitLabel: $8bbdc1d1b43d2c33$var$SUBMIT_LABEL,
        onSubmit: handleSubmit,
        disabled: working,
        header: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
            children: [
                "Currently, we ",
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                    children: "only"
                }),
                " support Powercode\xa9."
            ]
        }),
        footer: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
            size: "sm",
            children: [
                'By clicking "',
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                    children: $8bbdc1d1b43d2c33$var$SUBMIT_LABEL
                }),
                '", you agree to our ',
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                    href: "/about/terms-of-use",
                    target: "_blank",
                    children: "Terms of Use"
                }),
                " and the ",
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                    children: "Bearing"
                }),
                " software ",
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                    href: "/about/end-user-license-agreement",
                    target: "_blank",
                    children: "EULA"
                }),
                "."
            ]
        }),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$56e87bf42978147a), {
                id: "signupEmail",
                label: "Email Address",
                description: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($8bbdc1d1b43d2c33$var$EmailDescription, {
                    signupResponse: response,
                    lastSubmittedValue: lastSubmittedEmail !== null && lastSubmittedEmail !== void 0 ? lastSubmittedEmail : ""
                }),
                input: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                    ref: emailInputRef,
                    type: "email",
                    autoComplete: "email",
                    value: email,
                    onValueChange: setEmail,
                    required: true,
                    disabled: working
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $3a4c3e1810594c8c$export$11620c714ec70a76), {
                id: "signupPassword",
                value: password,
                onValueChange: setPassword,
                confirmValue: confirmPassword,
                onConfirmValueChange: setConfirmPassword,
                disabled: working
            })
        ]
    });
};





var $VqyUd = parcelRequire("VqyUd");


var $f6LVE = parcelRequire("f6LVE");



var $VqyUd = parcelRequire("VqyUd");





const $2400f212855531b5$export$55d0362933af7d75 = ({ innerClassName: innerClassName, home: home, title: title = "Dashboard", children: children })=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    (0, $8ea62fef91697031$exports.useSubject)(accountController, "state");
    switch(accountController.state.kind){
        case "loading":
            return null;
        case "unauthorized":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $79675f4550d6b49e$export$f14c0e3f98d164c0), {});
        case "ok":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
                    className: "mrg-auto dashboard-template",
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("header", {
                            className: "dashboard-template__header",
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                                    level: 1,
                                    children: title
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                    className: "dashboard-template__username",
                                    size: "sm",
                                    secondary: true,
                                    children: [
                                        "Logged in as ",
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                            children: accountController.state.details.email
                                        })
                                    ]
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {
                                    size: "md"
                                }),
                                !home && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                            href: "/",
                                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                                className: "dashboard-template__back-link",
                                                secondary: true,
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                                                        icon: "arrow-left"
                                                    }),
                                                    "Back to Dashboard"
                                                ]
                                            })
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {})
                                    ]
                                })
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                            className: innerClassName,
                            children: children
                        })
                    ]
                })
            });
    }
};



var $VqyUd = parcelRequire("VqyUd");

var $f6LVE = parcelRequire("f6LVE");




const $f8f2fbd3e2fc5bf6$var$AccountNotification = ({ message: message, severity: severity, icon: icon, children: children })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
        tag: "li",
        opaque: true,
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
            severity: severity,
            innerClassName: "copy",
            icon: icon,
            message: message,
            size: "lg",
            children: children
        })
    });
const $f8f2fbd3e2fc5bf6$export$e06504627e41ddac = ()=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    const { activatedLicense: activatedLicense, beta: beta, verifiedEmail: verifiedEmail, email: email, billing: billing } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    const notifications = (0, $f6LVE.useMemo)(()=>{
        const notifications = [];
        if (billing.billingStatus === "cancelled") notifications.push((0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($f8f2fbd3e2fc5bf6$var$AccountNotification, {
            severity: "warning",
            message: "Billing Cancelled",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "Your license will expire on ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                            children: (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.licenseExpiresDate)
                        }),
                        ",\xa0 when you will move back to the trial license."
                    ]
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "You can ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                            href: "/billing",
                            children: "reactivate billing"
                        }),
                        " at any time."
                    ]
                })
            ]
        }));
        if (billing.billingStatus === "failed") notifications.push((0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($f8f2fbd3e2fc5bf6$var$AccountNotification, {
            severity: "error",
            message: "Payment Failed",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "We were unable to take payment for your most recent invoice",
                        billing.failedPayment && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                            children: [
                                "\xa0",
                                billing.failedPayment.reference
                            ]
                        }),
                        ".",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {}),
                        "Please visit the ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                            href: "/billing",
                            children: "billing page"
                        }),
                        " to rectify the situation."
                    ]
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "If no action is taken, your license will expire on ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                            children: (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.licenseExpiresDate)
                        }),
                        "."
                    ]
                })
            ]
        }));
        if (!activatedLicense) notifications.push((0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($f8f2fbd3e2fc5bf6$var$AccountNotification, {
            severity: "info",
            message: "Welcome to Bearing!",
            icon: "tower",
            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                children: [
                    "Read our ",
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                        href: "/documentation/getting-started",
                        children: "Getting Started"
                    }),
                    " guide for instructions on how to get ",
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                        children: "Bearing"
                    }),
                    " up and running on your system."
                ]
            })
        }));
        if (!verifiedEmail) notifications.push((0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($f8f2fbd3e2fc5bf6$var$AccountNotification, {
            severity: "info",
            message: "Verify your email address",
            icon: "mail",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "We've sent an email to ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                            children: email
                        }),
                        ". Click the link in that email to verify your email address."
                    ]
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $51a49da4e18e6ef6$export$a4360a83c01036a3), {
                    resendEmail: ()=>accountController.resendVerificationEmail()
                })
            ]
        }));
        if (beta) notifications.push((0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($f8f2fbd3e2fc5bf6$var$AccountNotification, {
            severity: "info",
            icon: "beta",
            message: "Bearing is in beta",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "Thank you for participating in the ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                            children: "Bearing"
                        }),
                        " beta! During the beta period, ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                            children: "Bearing"
                        }),
                        " is free for unlimited use."
                    ]
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "If you have any suggestions, feedback or issues please ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $09f8266e1bb4f56b$export$897b176220633e35), {
                            children: "get in touch"
                        }),
                        "."
                    ]
                })
            ]
        }));
        else if (billing.billingStatus === "trial" && verifiedEmail && activatedLicense) notifications.push((0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($f8f2fbd3e2fc5bf6$var$AccountNotification, {
            severity: "info",
            message: "Free Trial",
            icon: "rocket",
            children: [
                billing.evaluation && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "Welcome to ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "Bearing"
                                }),
                                "!"
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "To let you get a feel for ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                                    children: "Bearing"
                                }),
                                " and its features, you have a 3 month evaluation period, during which you are able to use the full version of ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                                    children: "Bearing"
                                }),
                                " for free."
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "Your evaluation period ends on ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.evaluation.endDate)
                                }),
                                ". If you wish to continue using ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "Bearing"
                                }),
                                " after this date, you can ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                    href: "/billing",
                                    children: "activate billing"
                                }),
                                " on your account at any time."
                            ]
                        })
                    ]
                }),
                !billing.evaluation && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "Whilst on the ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "Free Trial"
                                }),
                                " you can view your 5 busiest sites."
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "To unlock all of ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "Bearing"
                                }),
                                "'s features, please ",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                    href: "/billing",
                                    children: "activate billing"
                                }),
                                " for your account."
                            ]
                        })
                    ]
                })
            ]
        }));
        return notifications;
    }, [
        accountController,
        activatedLicense,
        beta,
        billing.billingStatus,
        billing.evaluation,
        billing.failedPayment,
        billing.licenseExpiresDate,
        email,
        verifiedEmail
    ]);
    if (!notifications.length) return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                className: "stack--sm",
                children: notifications
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {})
        ]
    });
};





const $af1712d028ffe1e6$export$a398983943bbde23 = ()=>{
    const { user: user } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    if (!user) return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "user-details",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        className: "user-details__stats",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                className: "user-details__stats-value",
                                children: user.sites
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                className: "user-details__stats-label",
                                children: "sites"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                className: "user-details__stats-value",
                                children: user.rfDevices
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                className: "user-details__stats-label",
                                children: "devices"
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        className: "user-details__address",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                tag: "span",
                                weight: "bold",
                                size: "lg",
                                children: user.companyName
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {}),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                children: [
                                    user.address,
                                    ",",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {})
                                ]
                            }),
                            user.city && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                children: [
                                    user.city,
                                    ",",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {})
                                ]
                            }),
                            user.state && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                children: [
                                    user.state,
                                    ",",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {})
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                children: user.zip
                            })
                        ]
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {})
        ]
    });
};
const $af1712d028ffe1e6$export$6e5936ae24c08652 = ({ className: className, href: href, icon: icon, title: title, description: description, disabledDescription: disabledDescription, disabled: disabled })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$29d11c0fe2fc51d8), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("dashboard-link-button", className),
        innerClassName: "dashboard-link-button__layout",
        href: href,
        disabled: disabled,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2a0eabf503a7e085$export$f04a61298a47a40f), {
                className: "dashboard-link-button__icon",
                icon: icon,
                size: "xxl"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                className: "dashboard-link-button__title",
                size: "xl",
                children: title
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                className: "dashboard-link-button__description",
                size: "sm",
                children: disabled && disabledDescription || description
            })
        ]
    });
};
const $af1712d028ffe1e6$var$BillingDashboardLinkButton = ()=>{
    const { beta: beta, verifiedEmail: verifiedEmail, activatedLicense: activatedLicense } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    const [disabled, description] = (0, $f6LVE.useMemo)(()=>{
        if (beta) return [
            true,
            "Bearing is free during beta"
        ];
        if (!verifiedEmail) return [
            true,
            "Verify your email to enable billing"
        ];
        if (!activatedLicense) return [
            true,
            "Activate your license to enable billing"
        ];
        return [
            false,
            "Manage your payment details"
        ];
    }, [
        activatedLicense,
        beta,
        verifiedEmail
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($af1712d028ffe1e6$export$6e5936ae24c08652, {
        href: "/billing",
        icon: "credit-card",
        title: "Billing",
        description: description,
        disabled: disabled
    });
};
const $af1712d028ffe1e6$export$8c210df7ac193b9d = ()=>{
    const { licenseKey: licenseKey } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2400f212855531b5$export$55d0362933af7d75), {
        innerClassName: "dashboard-home",
        home: true,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f8f2fbd3e2fc5bf6$export$e06504627e41ddac), {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($af1712d028ffe1e6$export$a398983943bbde23, {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "dashboard-home__links",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($af1712d028ffe1e6$export$6e5936ae24c08652, {
                        href: "/documentation",
                        icon: "book",
                        title: "Documentation",
                        description: "How to install and use Bearing"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($af1712d028ffe1e6$export$6e5936ae24c08652, {
                        href: "/license",
                        icon: "key",
                        title: "License",
                        description: licenseKey ? "View your license key" : "Verify your email to get a license key",
                        disabled: !licenseKey
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($af1712d028ffe1e6$var$BillingDashboardLinkButton, {}),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($af1712d028ffe1e6$export$6e5936ae24c08652, {
                        href: "/account",
                        icon: "person",
                        title: "Account",
                        description: "Change your password"
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                size: "sm",
                children: [
                    "Review ",
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                        href: "/about/terms-of-use",
                        children: "Terms of Use"
                    }),
                    " or ",
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                        href: "/about/end-user-license-agreement",
                        children: "End User Licence Agreement"
                    })
                ]
            })
        ]
    });
};







const $3978618e07c2bca6$export$12449a31c6671d53 = ()=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "landing stack--lg",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "landing__background-image",
                "aria-hidden": true
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                tag: "header",
                innerClassName: "landing__header stack--lg",
                width: "lg",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2c8d3cee2ba76f85$export$2f6783294041cae1), {}),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        className: "landing__tagline",
                        font: "display",
                        size: "xxl",
                        align: "center",
                        overImage: true,
                        children: "Frequency Management software for WISPs"
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
                    className: "stack--lg",
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                            className: "stack",
                            size: "lg",
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                            children: "Bearing"
                                        }),
                                        " leverages your existing systems to make Radio Frequency Management simple. Once SNMP device probes are configured to return live frequency and channel width data for your devices, ",
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                            children: "Bearing"
                                        }),
                                        " flags up potential issues and shows spectrum overlay maps of your\xa0network."
                                    ]
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                            children: "Bearing"
                                        }),
                                        " will prompt you about missing data and our documentation can help you fill the\xa0gaps."
                                    ]
                                })
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                            className: "landing__feature-list",
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                    class: "landing__feature-item",
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2c8d3cee2ba76f85$export$dd38071655615b86), {
                                            color: "brand"
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                            children: "Easily visualize your spectrum usage for each\xa0site"
                                        })
                                    ]
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                    class: "landing__feature-item",
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2c8d3cee2ba76f85$export$dd38071655615b86), {
                                            color: "brand"
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                            children: "Identify potential interference and frequency\xa0overlap"
                                        })
                                    ]
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                    class: "landing__feature-item",
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2c8d3cee2ba76f85$export$dd38071655615b86), {
                                            color: "brand"
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                            children: "Assist with Sector and Backhaul\xa0alignment"
                                        })
                                    ]
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                    class: "landing__feature-item",
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2c8d3cee2ba76f85$export$dd38071655615b86), {
                                            color: "brand"
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                            children: "Co-location and multi-site spectrum\xa0usage"
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                            className: "landing__cta",
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$29d11c0fe2fc51d8), {
                                    className: "pad-md flex-1",
                                    href: "/login",
                                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                        size: "lg",
                                        align: "center",
                                        children: "Log in"
                                    })
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$29d11c0fe2fc51d8), {
                                    className: "pad-md flex-1",
                                    variant: "primary",
                                    href: "/signup",
                                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                        size: "lg",
                                        align: "center",
                                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                            children: "Sign up"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};







const $79675f4550d6b49e$export$f14c0e3f98d164c0 = ({ onLogIn: onLogIn })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $a41f9ec2cca4e1a7$export$c9e27277d624b1c6), {
        title: "Log In",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a49b1b99f213b79$export$1f58f750f20f344b), {
            onLogIn: onLogIn
        })
    });





var $f6LVE = parcelRequire("f6LVE");



const $c695bfe21dd16bdf$export$47d2b49ca69c05ba = ()=>{
    const billingController = (0, $f57fa0ee256b0db7$export$fae87f616b8b2f3c)();
    (0, $f6LVE.useEffect)(()=>{
        const abortController = new AbortController();
        billingController.waitForPendingPaymentsToComplete(abortController.signal).then(()=>{
            if (abortController.signal.aborted) return;
            (0, $378f8733f7648194$export$4cb887bfde2d34ca)("/billing", true);
        });
        return ()=>{
            abortController.abort();
        };
    }, [
        billingController
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "checkout-complete-page",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d6dd782797fe2e79$export$7f7cbe89f1eacd2), {
            size: "lg"
        })
    });
};











const $c889eb46d93c15cd$export$c120a0e80fd44ca6 = ()=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
        className: "error-page",
        width: "sm",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
            className: "error-page__content",
            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                severity: "error",
                message: "Something went wrong",
                innerClassName: "copy",
                size: "xl",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        tag: "p",
                        children: "Sorry, an error occurred while processing your request."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        tag: "p",
                        children: [
                            "Our team have been notified. If the issue persists, or you have any concerns, please ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $09f8266e1bb4f56b$export$897b176220633e35), {
                                children: "contact our support"
                            }),
                            "."
                        ]
                    })
                ]
            })
        })
    });
};








const $16c115adee61eae3$export$448accafd1a57971 = ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2400f212855531b5$export$55d0362933af7d75), {
        title: "Account",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                    level: 2,
                    children: "Change Password"
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                    width: "xs",
                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $fd2fea4d33f18bf8$export$ef0ae802e3ecfb1), {})
                })
            ]
        })
    });


const $28aedfb5278e02bb$export$a65ae8806155c633 = (_)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $16c115adee61eae3$export$448accafd1a57971), {});





var $VqyUd = parcelRequire("VqyUd");




var $VqyUd = parcelRequire("VqyUd");




const $73bd045c589a7299$export$b250bf0be6229d61 = ()=>{
    const { billing: billing, user: user } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    const billingController = (0, $f57fa0ee256b0db7$export$fae87f616b8b2f3c)();
    (0, $8ea62fef91697031$exports.useSubject)(billingController, "loadingStatus");
    switch(billing.billingStatus){
        case "beta":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                children: "Bearing is free during beta."
            });
        case "failed":
        case "subscribed":
            return null;
    }
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            billing.billingStatus === "trial" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
                tag: "section",
                className: "copy",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "You will be charged\xa0",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: (0, $7d3f392fa48145f5$export$3dc27271f5d5c629)(billing.dollarsPerDevice)
                            }),
                            "\xa0per device per month. You are currently using ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: user === null || user === void 0 ? void 0 : user.rfDevices
                            }),
                            " devices, so your initial payment will be ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: (0, $7d3f392fa48145f5$export$3dc27271f5d5c629)(billing.userCost)
                            }),
                            "."
                        ]
                    }),
                    billing.evaluation && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "Your first payment will be taken on ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.evaluation.firstBillingDate)
                            }),
                            ", after your evaluation period ends."
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        children: [
                            "You may wish to review the\xa0",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "Bearing"
                            }),
                            "\xa0",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                href: "/about/end-user-licence-agreement",
                                children: "End User Licence Agreement"
                            }),
                            " before proceeding."
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                        onClick: billingController.activateBilling,
                        fullWidth: true,
                        disabled: !!billingController.loadingStatus,
                        actionInProgress: billingController.loadingStatus === "activate-billing",
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                            size: "lg",
                            children: [
                                !billing.evaluation && `Pay ${(0, $7d3f392fa48145f5$export$3dc27271f5d5c629)(billing.userCost)} & `,
                                "Activate Billing"
                            ]
                        })
                    })
                ]
            }),
            billing.billingStatus === "cancelled" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
                tag: "section",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$86de09faaa70680d), {
                        icon: "credit-card",
                        title: "Reactivate Billing"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        children: [
                            "You can reactivate billing at any time. Billing will resume as usual on ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                                children: (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.nextPaymentDate)
                            }),
                            "."
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                        fullWidth: true,
                        onClick: billingController.activateBilling,
                        disabled: !!billingController.loadingStatus,
                        actionInProgress: billingController.loadingStatus === "activate-billing",
                        children: "Reactivate billing"
                    })
                ]
            })
        ]
    });
};














var $13a4ac71bbdae218$exports = {};
$13a4ac71bbdae218$exports = new URL("card-amex.50e8c488.svg", import.meta.url).toString();


var $2be1e19c7b29ab28$exports = {};
$2be1e19c7b29ab28$exports = new URL("card-mastercard.487f97ac.svg", import.meta.url).toString();


var $be2ed9d952853410$exports = {};
$be2ed9d952853410$exports = new URL("card-visa.1a546991.svg", import.meta.url).toString();


const $886986f1338db1d7$var$SOURCES = {
    amex: (/*@__PURE__*/$parcel$interopDefault($13a4ac71bbdae218$exports)),
    mastercard: (/*@__PURE__*/$parcel$interopDefault($2be1e19c7b29ab28$exports)),
    visa: (/*@__PURE__*/$parcel$interopDefault($be2ed9d952853410$exports))
};
const $886986f1338db1d7$export$c82978e1a79a1337 = ({ className: className, brand: brand })=>{
    const src = $886986f1338db1d7$var$SOURCES[brand];
    if (!src) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
        className: className,
        weight: "bold",
        size: "xl",
        children: brand.toUpperCase()
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("img", {
        className: className,
        src: src
    });
};



const $936acbf3c56969e4$export$769b6865db9774d4 = ({ className: className, brand: brand, lastFourDigits: lastFourDigits })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("credit-card", className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $886986f1338db1d7$export$c82978e1a79a1337), {
                className: "credit-card__logo",
                brand: brand
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                font: "mono",
                size: "sm",
                children: [
                    brand === "amex" ? "**** ****** *" : "**** **** **** ",
                    lastFourDigits
                ]
            })
        ]
    });





const $ab73e236b998789f$var$PaymentMethodView = ({ className: className, paymentMethod: paymentMethod })=>{
    const billingController = (0, $f57fa0ee256b0db7$export$fae87f616b8b2f3c)();
    (0, $8ea62fef91697031$exports.useSubject)(billingController, "loadingStatus");
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))(className, "payment-method-view"),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$86de09faaa70680d), {
                title: "Payment Method",
                headingLevel: 2,
                icon: "credit-card"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "payment-method-view__content",
                children: [
                    paymentMethod && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $936acbf3c56969e4$export$769b6865db9774d4), {
                        className: "payment-method-view__card",
                        brand: paymentMethod.brand,
                        lastFourDigits: paymentMethod.lastFourDigits
                    }),
                    !paymentMethod && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        className: "payment-method-view__no-payment-method",
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                            severity: "warning",
                            message: "No payment method registered."
                        })
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                        onClick: billingController.updatePaymentMethod,
                        actionInProgress: billingController.loadingStatus === "payment-method",
                        disabled: !!billingController.loadingStatus,
                        children: paymentMethod ? "Change payment method" : "Set payment method"
                    })
                ]
            })
        ]
    });
};
const $ab73e236b998789f$var$NextPaymentView = ({ className: className })=>{
    const { billing: billing } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    if (billing.billingStatus !== "subscribed") return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("next-payment-view", className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$86de09faaa70680d), {
                headingLevel: 2,
                icon: "clock",
                title: "Next payment"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "next-payment-view__info",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                children: "Your next payment is due on:"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                size: "xl",
                                weight: "bold",
                                children: (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.nextPaymentDate)
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                children: "Based on current usage, you will be charged:"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                size: "xl",
                                weight: "bold",
                                children: (0, $7d3f392fa48145f5$export$3dc27271f5d5c629)(billing.userCost)
                            })
                        ]
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$29d11c0fe2fc51d8), {
                href: "/billing/cancel",
                children: "Cancel billing"
            })
        ]
    });
};
const $ab73e236b998789f$var$RetryPaymentView = ({ className: className })=>{
    const { billing: billing } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    const billingController = (0, $f57fa0ee256b0db7$export$fae87f616b8b2f3c)();
    (0, $8ea62fef91697031$exports.useSubject)(billingController, "loadingStatus");
    if (billing.billingStatus !== "failed" || !billing.paymentMethod) return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("retry-payment-view", className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$86de09faaa70680d), {
                icon: "refresh",
                title: "Retry Payment"
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "retry-payment-view__info",
                children: billing.failedPayment && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                    size: "lg",
                    align: "center",
                    children: [
                        "Retry payment of ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                            children: (0, $7d3f392fa48145f5$export$3dc27271f5d5c629)(billing.failedPayment.dollars)
                        }),
                        "."
                    ]
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                onClick: billingController.retryFailedPayment,
                actionInProgress: billingController.loadingStatus === "retry-failed-payment",
                disabled: !!billingController.loadingStatus,
                fullWidth: true,
                children: "Retry payment"
            })
        ]
    });
};
const $ab73e236b998789f$export$536737454b75d56b = ()=>{
    const { billing: billing } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    if (billing.billingStatus !== "subscribed" && billing.billingStatus !== "failed") return null;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "active-billing-view",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($ab73e236b998789f$var$NextPaymentView, {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($ab73e236b998789f$var$RetryPaymentView, {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($ab73e236b998789f$var$PaymentMethodView, {
                paymentMethod: billing.paymentMethod
            })
        ]
    });
};




var $VqyUd = parcelRequire("VqyUd");




const $8ec17f6f6d07470a$export$2e0338fd5ea907bf = ()=>{
    var _billing_failedPayment, _billing_failedPayment1, _billing_failedPayment2;
    const { billing: billing } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    if (billing.billingStatus !== "failed") return null;
    var _billing_failedPayment_reason;
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $898f8d3f46342bff$export$2ddb90ad54e5f587), {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                    severity: "error",
                    message: (_billing_failedPayment_reason = (_billing_failedPayment = billing.failedPayment) === null || _billing_failedPayment === void 0 ? void 0 : _billing_failedPayment.reason) !== null && _billing_failedPayment_reason !== void 0 ? _billing_failedPayment_reason : "Payment Failed",
                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                        className: "copy",
                        children: [
                            ((_billing_failedPayment1 = billing.failedPayment) === null || _billing_failedPayment1 === void 0 ? void 0 : _billing_failedPayment1.reason) !== "No payment method available" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                                children: "Ensure funds are available and retry the payment, or update your payment method below."
                            }),
                            ((_billing_failedPayment2 = billing.failedPayment) === null || _billing_failedPayment2 === void 0 ? void 0 : _billing_failedPayment2.reason) === "No payment method available" && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We were unable to take payment for your most recent invoice because no payment method is registered for your account."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Choose a payment method below to retry the payment."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "If no action is taken, your license will expire on\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                                        children: (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.licenseExpiresDate)
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {})
        ]
    });
};


const $9b0e130cd824726f$export$775f8bc4a68f7387 = ()=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8ec17f6f6d07470a$export$2e0338fd5ea907bf), {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $73bd045c589a7299$export$b250bf0be6229d61), {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $ab73e236b998789f$export$536737454b75d56b), {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $b2eb27efd79ea534$export$36d953148455edf2), {
                invoices: (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)().billing.invoices
            })
        ]
    });
};
const $9b0e130cd824726f$export$1a42c8217fb6e907 = ()=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    (0, $8ea62fef91697031$exports.useSubject)(accountController, "state");
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2400f212855531b5$export$55d0362933af7d75), {
        title: "Billing",
        children: accountController.state.details && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($9b0e130cd824726f$export$775f8bc4a68f7387, {})
    });
};


const $840bbb50842d2fa5$export$9b947e07cda3a91e = (_)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9b0e130cd824726f$export$1a42c8217fb6e907), {});












const $db7a8f523c292948$export$45dc1d880974b76d = ()=>{
    const { billing: billing } = (0, $f57fa0ee256b0db7$export$9976db6a0382a0c7)();
    const billingController = (0, $f57fa0ee256b0db7$export$fae87f616b8b2f3c)();
    (0, $8ea62fef91697031$exports.useSubject)(billingController, "loadingStatus");
    const handleCancelClick = ()=>{
        billingController.cancelBilling().then(()=>{
            (0, $378f8733f7648194$export$4cb887bfde2d34ca)("/", true);
        });
    };
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2400f212855531b5$export$55d0362933af7d75), {
        title: "Cancel Billing",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                children: "If you proceed, no further payments will be taken."
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                children: [
                    "Your license will expire on ",
                    (0, $7d3f392fa48145f5$export$3ae94a2503e890a1)(billing.licenseExpiresDate),
                    "."
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$353f5b6fc5456de1), {
                onClick: handleCancelClick,
                actionInProgress: billingController.loadingStatus === "activate-billing",
                variant: "danger",
                fullWidth: true,
                children: "Cancel Billing"
            })
        ]
    });
};


const $2500b180fe7d2c85$export$6201b7194fef3ca3 = (_)=>{
    const accountController = (0, $f57fa0ee256b0db7$export$aaec80e085d54cbe)();
    if (accountController.state.kind === "unauthorized") {
        (0, $378f8733f7648194$export$4cb887bfde2d34ca)("/", true);
        return null;
    }
    if (accountController.state.kind !== "ok") return null;
    const { billing: billing } = accountController.state.details;
    if (billing.billingStatus !== "subscribed" && billing.billingStatus !== "failed") {
        (0, $378f8733f7648194$export$4cb887bfde2d34ca)("/billing", true);
        return null;
    }
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $db7a8f523c292948$export$45dc1d880974b76d), {});
};




const $f85626ba5d17224a$export$19bc9862cf8dc8fa = (_)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c695bfe21dd16bdf$export$47d2b49ca69c05ba), {});





var $VqyUd = parcelRequire("VqyUd");



var $7a360300fda1d057$exports = {};
$7a360300fda1d057$exports = new URL("aboutAlign.d9d43638.png", import.meta.url).toString();


var $6b8ff4a71ca79a7a$exports = {};
$6b8ff4a71ca79a7a$exports = new URL("aboutDashboard.b76631f0.png", import.meta.url).toString();


var $b28df34a50ba569b$exports = {};
$b28df34a50ba569b$exports = new URL("aboutMap.bac5be5d.png", import.meta.url).toString();


var $97a65455a0f6c19f$exports = {};
$97a65455a0f6c19f$exports = new URL("aboutSite.371760e3.png", import.meta.url).toString();


var $9f748bc8f8249f2c$exports = {};
$9f748bc8f8249f2c$exports = new URL("gatheringSnmp.a3fc779e.png", import.meta.url).toString();


const $c2ac93080ed1b35b$export$e86d578d3f4f42b6 = [
    {
        title: "Cookie Policy",
        order: "0",
        path: "cookie-policy",
        sections: [
            {
                title: "What are cookies?",
                href: "#what-are-cookies"
            },
            {
                title: "How do third parties use cookies on the brng.net Website?",
                href: "#how-do-third-parties-use-cookies-on-the-brngnet-website"
            },
            {
                title: "What are your cookies options?",
                href: "#what-are-your-cookies-options"
            },
            {
                title: "Where can I find more information about cookies?",
                href: "#where-can-i-find-more-information-about-cookies"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "This website, ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("span", {
                                class: "website-url",
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d3b17ce220e9921d$export$f102e87ccfb079d0), {})
                            }),
                            ' (the "Website"), is operated by ',
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "Estrella Systems Limited"
                            }),
                            "."
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                        id: "what-are-cookies",
                        children: "What are cookies?"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "Cookies are a small text files that are stored in your web browser that allows ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "brng.net"
                            }),
                            " or a third party to recognize you. Cookies can be used to collect, store and share bits of information about your activities across websites, including on ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "brng.net"
                            }),
                            ".."
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "Cookies might be used for the following purposes:"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                children: "To enable certain functions"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                children: "To provide analytics"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                children: "To store your preferences"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                children: "To enable ad delivery and behavioural advertising"
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "brng.net"
                            }),
                            " uses session cookies and persistent cookies. We only use persistent cookies to hide our note about which cookies we use!"
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "A session cookie is used to identify a particular visit to our Website. These cookies expire after a short time, or when you close your web browser after using our Website. We use these cookies to identify you during a single browsing session, such as when you log into our Website."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "A persistent cookie will remain on your devices for a set period of time specified in the cookie. We use these cookies where we need to identify you over a longer period of time. For example, we would use a persistent cookie if you asked that we keep you signed in."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                        id: "how-do-third-parties-use-cookies-on-the-brngnet-website",
                        children: [
                            "How do third parties use cookies on the ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "brng.net"
                            }),
                            " Website?"
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "Well, we don't let them."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "Third party companies like analytics companies and ad networks generally use cookies to collect user information."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "We thought you might not like that very much so we have not invited them to track you here."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                        id: "what-are-your-cookies-options",
                        children: "What are your cookies options?"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "If you don't like the idea of cookies or certain types of cookies, you can change your browser's settings to delete cookies that have already been set and to not accept new cookies. To learn more about how to do this, visit the help pages of your browser."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "Please note, however, that if you delete cookies or do not accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                        id: "where-can-i-find-more-information-about-cookies",
                        children: "Where can I find more information about cookies?"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "To learn more about cookies, please read ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8143b26344ce82ab$export$b2bf131c9f9cce5d), {
                                href: "https://www.cookieconsent.com/what-are-cookies/",
                                children: '"What Are Cookies"'
                            }),
                            "."
                        ]
                    })
                ]
            }),
        next: {
            title: "Privacy Policy",
            path: "privacy-policy"
        }
    },
    {
        title: "Privacy Policy",
        order: "10",
        path: "privacy-policy",
        sections: [
            {
                title: "Introduction",
                href: "#introduction"
            },
            {
                title: "The basis on which we process information about you",
                href: "#the-basis-on-which-we-process-information-about-you"
            },
            {
                title: "Specific uses of information you provide to us",
                href: "#specific-uses-of-information-you-provide-to-us"
            },
            {
                title: "Disclosure and sharing of your information",
                href: "#disclosure-and-sharing-of-your-information"
            },
            {
                title: "Control over your own information",
                href: "#control-over-your-own-information"
            },
            {
                title: "Other matters",
                href: "#other-matters"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "This is the privacy notice of ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "Estrella Systems Limited"
                            }),
                            '. In this document, "we", "our", or "us" refer to ',
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "Estrella Systems Limited"
                            }),
                            "."
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "We are company number 04597548 registered in England."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "Our registered office is at 4 Wychwood Drive, Milton-Under-Wychwood, Chipping Norton, Oxfordshire, OX7 6JA."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "introduction",
                                children: "Introduction"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "This privacy notice aims to inform you about how we collect and process any information that we collect from you, or that you provide to us. It covers information that could identify you (\u201Cpersonal information\u201D) and information that could not. In the context of the law and this notice, \u201Cprocess\u201D means collect, store, transfer, use or otherwise act on information. It tells you about your privacy rights and how the law protects you."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "We are committed to protecting your privacy and the confidentiality of your personal information. Our policy is not just an exercise in complying with the law, but a continuation of our respect for you and your personal information."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "We undertake to preserve the confidentiality of all information you provide to us, and hope that you reciprocate."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "Our policy complies with the Data Protection Act 2018 (Act) accordingly incorporating the EU General Data Protection Regulation (GDPR)."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "The law requires us to tell you about your rights and our obligations to you in regard to the processing and control of your personal data. We do this now, by requesting that you read the information provided at ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8143b26344ce82ab$export$b2bf131c9f9cce5d), {
                                        href: "http://www.knowyourprivacyrights.org",
                                        children: "http://www.knowyourprivacyrights.org"
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "Except as set out below, we do not share, or sell, or disclose to a third party, any information collected through our website."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Data we process"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We may collect, use, store and transfer different kinds of personal data about you. We have collated these into groups as follows:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Your identity includes information such as first name, last name, title, date of birth, and other identifiers that you may have provided at some time."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Your contact information includes information such as billing address, delivery address, email address, telephone numbers and any other information you have given to us for the purpose of communication or meeting."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Transaction data includes details about payments or communications to and from you and information about products and services you have purchased from us."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Technical data includes your internet protocol (IP) address, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform and other technology on the devices you use to access this website."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Your profile includes information such as your username and password, purchases or orders made by you, your interests, preferences, feedback and survey responses."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Marketing data includes your preferences in receiving marketing from us; communication preferences; responses and actions in relation to your use of our services."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We may aggregate anonymous data such as statistical or demographic data for any purpose. Anonymous data is data that does not identify you as an individual. Aggregated data may be derived from your personal data but is not considered personal information in law because it does not reveal your identity."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "For example, we may aggregate profile data to assess interest in a product or service."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "However, if we combine or connect aggregated data with your personal information so that it can identify you in any way, we treat the combined data as personal information and it will be used in accordance with this privacy notice."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "If you do not provide personal information we need"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Where we need to collect personal data by law, or under the terms of a contract we have with you, and you fail to provide that data when requested, we may not be able to perform that contract. In that case, we may have to stop providing a service to you. If so, we will notify you of this at the time."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "the-basis-on-which-we-process-information-about-you",
                                children: "The basis on which we process information about you"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "The law requires us to determine under which of six defined bases we process different categories of your personal information, and to notify you of the basis for each category."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "If a basis on which we process your personal information is no longer relevant then we shall immediately stop processing your data."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "If the basis changes then if required by law we shall notify you of the change and of any new basis under which we have determined that we can continue to process your information."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Information we process because we have a contractual obligation with you"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "When you create an account on our website, buy a product or service from us, or otherwise agree to our terms and conditions, a contract is formed between you and us."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "In order to carry out our obligations under that contract we must process the information you give us. Some of this information may be personal information."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We may use it in order to:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                        children: [
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "verify your identity for security purposes"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "sell products to you"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "provide you with our services"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "provide you with suggestions and advice on products, services and how to obtain the most from using our website."
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We process this information on the basis there is a contract between us, or that you have requested we use the information before we enter into a legal contract."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We shall continue to process this information until the contract between us ends or is terminated by either party under the terms of the contract."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Information we process with your consent"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Through certain actions when otherwise there is no contractual relationship between us, such as when you browse our website or ask us to provide you more information about our business, including our products and services, you provide your consent to us to process information that may be personal information."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Wherever possible, we aim to obtain your explicit consent to process this information, for example, by asking you to agree to our use of cookies."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If you have given us explicit permission to do so, we may from time to time pass your name and contact information to selected associates whom we consider may provide services or products you would find useful."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We continue to process your information on this basis until you withdraw your consent or it can be reasonably assumed that your consent no longer exists."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "You may withdraw your consent at any time by instructing us at ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                                href: "mailto:privacy@brng.net?subject=Withdrawing processing consent",
                                                children: "privacy@brng.net"
                                            }),
                                            ". However, if you do so, you may not be able to use our website or our services further."
                                        ]
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Information we process for the purposes of legitimate interests"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We may process information on the basis there is a legitimate interest, either to you or to us, of doing so."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Where we process your information on this basis, we do after having given careful consideration to:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                        children: [
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "whether the same objective could be achieved through other means"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "whether processing (or not processing) might cause you harm"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "whether you would expect us to process your data, and whether you would, in the round, consider it reasonable to do so"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "For example, we may process your data on this basis for the purposes of:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                        children: [
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "record-keeping for the proper and necessary administration of our business"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "responding to unsolicited communication from you to which we believe you would expect a response"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "protecting and asserting the legal rights of any party"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "insuring against or obtaining professional advice that is required to manage business risk"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "protecting your interests where we believe we have a duty to do so"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Information we process because we have a legal obligation"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Sometimes, we must process your information in order to comply with a statutory obligation."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "For example, we may be required to give information to legal authorities if they so request or if they have the proper authorisation such as a search warrant or court order."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "This may include your personal information."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "specific-uses-of-information-you-provide-to-us",
                                children: "Specific uses of information you provide to us"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Information provided on the understanding that it will be shared with a third party"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Our website allows you to post information with a view to that information being read, copied, downloaded, or used by other people."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Examples include:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                        children: [
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "posting a message our forum"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "tagging an image"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "clicking on an icon next to another visitor\u2019s message to convey your agreement, disagreement or thanks"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "In posting personal information, it is up to you to satisfy yourself about the privacy level of every person who might use it."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We do not specifically use this information except to allow it to be displayed or shared."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We do store it, and we reserve a right to use it in the future in any way we decide."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Once your information enters the public domain, we have no control over what any individual third party may do with it. We accept no responsibility for their actions at any time."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "Provided your request is reasonable and there is no legal basis for us to retain it, then at our discretion we may agree to your request to delete personal information that you have posted. You can make a request by contacting us at ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                                href: "mailto:privacy@brng.net?subject=Delete personal information",
                                                children: "privacy@brng.net"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Complaints regarding content on our website"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We attempt to moderate user generated content, but we are not always able to do so as soon as that content is published."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If you complain about any of the content on our website, we shall investigate your complaint."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If we feel it is justified or if we believe the law requires us to do so, we shall remove the content while we investigate."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Free speech is a fundamental right, so we have to make a judgment as to whose right will be obstructed: yours, or that of the person who posted the content that offends you."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If we think your complaint is vexatious or without any basis, we shall not correspond with you about it."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Information relating to your method of payment"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Payment information is never taken by us or transferred to us either through our website or otherwise. Our employees and contractors never have access to it."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "At the point of payment, you are transferred to a secure page on the website of Cardinity. That page may be branded to look like a page on our website, but it is not controlled by us."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Communicating with us"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "When you contact us, whether by telephone, through our website or by e-mail, we collect the data you have given to us in order to reply with the information you need."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We record your request and our reply in order to increase the efficiency of our business."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We keep personally identifiable information associated with your message, such as your name and email address so as to be able to track our communications with you to provide a high quality service."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Complaining"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "When we receive a complaint, we record all the information you have given to us."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We use that information to resolve your complaint."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If your complaint reasonably requires us to contact some other person, we may decide to give to that other person some of the information contained in your complaint. We do this as infrequently as possible, but it is a matter for our sole discretion as to whether we do give information, and if we do, what that information is."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We may also compile statistics showing information obtained from this source to assess the level of service we provide, but not in a way that could identify you or any other person."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Affiliate and business partner information"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "This is information given to us by you in your capacity as an affiliate of us or as a business partner."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "It allows us to recognise visitors that you have referred to us, and to credit to you commission due for such referrals. It also includes information that allows us to transfer commission to you."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "The information is not used for any other purpose."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We undertake to preserve the confidentiality of the information and of the terms of our relationship."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We expect any affiliate or partner to agree to reciprocate this policy. Use of information we collect through automated systems when you visit our website"
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Cookies"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Cookies are small text files that are placed on your computer's hard drive by your web browser when you visit any website. They allow information gathered on one web page to be stored until it is needed for use on another, allowing a website to provide you with a personalised experience and the website owner with statistics about how you use the website so that it can be improved."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Some cookies may last for a defined period of time, such as one day or until you close your browser. Others last indefinitely."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Your web browser should allow you to delete any you choose. It also should allow you to prevent or limit their use."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Our website uses cookies. They are placed by software that operates on our servers, and by software operated by third parties whose services we use."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "When you first visit our website, we ask you whether you wish us to use cookies. If you choose not to accept them, we shall not use them for your visit except to record that you have not consented to their use for any other purpose."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If you choose not to use cookies or you prevent their use through your browser settings, you will not be able to use all the functionality of our website."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We use cookies in the following ways:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                        children: [
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "to track how you use our website"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "to record whether you have seen specific messages we display on our website"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "to keep you signed in to our website"
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "We provide more information about the cookies we use in our ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                                href: "/about/cookie-policy",
                                                children: "cookie policy"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Personal identifiers from your browsing activity"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Requests by your web browser to our servers for web pages and other content on our website are recorded."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We record information such as your geographical location, your Internet service provider and your IP address. We also record information about the software you are using to browse our website, such as the type of computer or device and the screen resolution."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We use this information in aggregate to assess the popularity of the webpages on our website and how we perform in providing content to you."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If combined with other information we know about you from previous visits, the data possibly could be used to identify you personally, even if you are not signed in to our website."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "disclosure-and-sharing-of-your-information",
                                children: "Disclosure and sharing of your information"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Information we obtain from third parties"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Although we do not disclose your personal information to any third party (except as set out in this notice), we sometimes receive data that is indirectly made up from your personal information from third parties whose services we use."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Credit reference"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "To assist in combating fraud, we share information with credit reference agencies, so far as it relates to clients or customers who instruct their credit card issuer to cancel payment to us without having first provided an acceptable reason to us and given us the opportunity to refund their money."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Data may be processed outside the European Union"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Our websites are hosted in the United Kingdom."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We may also use outsourced services in countries outside the European Union from time to time in other aspects of our business."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Accordingly data obtained within the UK or any other country could be processed outside the European Union."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "control-over-your-own-information",
                                children: "Control over your own information"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Your duty to inform us of changes"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Access to your personal information"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "At any time you may review or update personally identifiable information that we hold about you, by signing in to your account on our website."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "To obtain a copy of any information that is not provided on our website you should contact us to make that request."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "After receiving the request, we will tell you when we expect to provide you with the information, and whether we require any fee for providing it to you."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Removal of your information"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If you wish us to remove personally identifiable information from our website, you should contact us to make your request."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "This may limit the service we can provide to you."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Verification of your information"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "When we receive any request to access, edit or delete personal identifiable information we shall first take reasonable steps to verify your identity before granting you access or otherwise taking any action. This is important to safeguard your information."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "other-matters",
                                children: "Other matters"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Use of site by children"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We do not sell products or provide services for purchase by children, nor do we market to children."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If you are under 18, you may use our website only with consent from a parent or guardian."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Encryption of data sent between us"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We use Secure Sockets Layer (SSL) certificates to verify our identity to your browser and to encrypt any data you give us."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Whenever information is transferred between us, you can check that it is done so using SSL by looking for a closed padlock symbol or other trust mark in your browser\u2019s URL bar or toolbar."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "How you can complain"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If you are not happy with our privacy policy or if you have any complaint then you should tell us."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "If a dispute is not settled then we hope you will agree to attempt to resolve it by engaging in good faith with us in a process of mediation or arbitration."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "If you are in any way dissatisfied about how we process your personal information, you have a right to lodge a complaint with the Information Commissioner's Office (ICO). This can be done at ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8143b26344ce82ab$export$b2bf131c9f9cce5d), {
                                                href: "https://ico.org.uk/make-a-complaint/",
                                                children: "https://ico.org.uk/make-a-complaint/"
                                            }),
                                            ". We would, however, appreciate the opportunity to talk to you about your concern before you approach the ICO."
                                        ]
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Retention period for personal data"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Except as otherwise mentioned in this privacy notice, we keep your personal information only for as long as required by us:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                        children: [
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "to provide you with the services you have requested;"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "to comply with other law, including for the period demanded by our tax authorities;"
                                                })
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                                    children: "to support a claim or defence in court."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Compliance with the law"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "Our privacy policy has been compiled so as to comply with the law of every country or legal jurisdiction in which we aim to do business. If you think it fails to satisfy the law of your jurisdiction, we should like to hear from you."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "However, ultimately it is your choice as to whether you wish to use our website."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        class: "numbered",
                                        children: "Review of this privacy policy"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We may update this privacy notice from time to time as necessary. The terms that apply to you are those posted here on our website on the day you use our website. We advise you to print a copy for your records."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "If you have any question regarding our privacy policy, please ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                                href: "mailto:privacy@brng.net?subject=Question regarding privacy policy",
                                                children: "contact us"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
        previous: {
            title: "Cookie Policy",
            path: "cookie-policy"
        },
        next: {
            title: "Terms of Use",
            path: "terms-of-use"
        }
    },
    {
        title: "Terms of Use",
        order: "20",
        path: "terms-of-use",
        sections: [
            {
                title: "Use of brng.net",
                href: "#use-of-brngnet"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                    children: [
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                            id: "use-of-brngnet",
                            children: "Use of brng.net"
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "If you continue to browse and use this website (",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d3b17ce220e9921d$export$f102e87ccfb079d0), {}),
                                "), you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern Estrella Systems Limited\u2019s relationship with you in relation to this website. If you disagree with any part of these terms and conditions, please do not use our website."
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "The term \u201C",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "Estrella Systems Limited"
                                }),
                                "\u201D or \u201C",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "us"
                                }),
                                "\u201D or \u201C",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "we"
                                }),
                                "\u201D refers to the owner of the website whose registered office is 4 Wychwood Drive, Milton-Under-Wychwood, Chipping Norton, OX7 6JA, England. Our company registration number is 04597548 registered in England. The term \u201C",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "you"
                                }),
                                "\u201D refers to the user or viewer of our website."
                            ]
                        }),
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                            children: [
                                "The use of this website is subject to the following terms of use:",
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                    children: [
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "The content of the pages of this website is for your general information and use only. It is subject to change without notice."
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: [
                                                "This website uses cookies. For further information please see our ",
                                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                                    href: "/about/privacy-policy",
                                                    children: "privacy policy"
                                                }),
                                                "."
                                            ]
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law."
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website meet your specific requirements."
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions."
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "All trademarks reproduced in this website, which are not the property of, or licensed to the operator, are acknowledged on the website."
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "Unauthorised use of this website may give rise to a claim for damages and/or be a criminal offence."
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "From time to time, this website may also include links to other websites. These links are provided for your convenience to provide further information. They do not signify that we endorse the website(s). We have no responsibility for the content of the linked website(s)."
                                        }),
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                            children: "Your use of this website and any dispute arising out of such use of the website is subject to the laws of England, Northern Ireland, Scotland and Wales."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
        previous: {
            title: "Privacy Policy",
            path: "privacy-policy"
        },
        next: {
            title: "End User Licence Agreement",
            path: "end-user-licence-agreement"
        }
    },
    {
        title: "End User Licence Agreement",
        order: "30",
        path: "end-user-licence-agreement",
        sections: [
            {
                title: "Definitions",
                href: "#definitions"
            },
            {
                title: "Commencement",
                href: "#commencement"
            },
            {
                title: "Licence",
                href: "#licence"
            },
            {
                title: "Licensee Warranties",
                href: "#licensee-warranties"
            },
            {
                title: "Licensor Warranties",
                href: "#licensor-warranties"
            },
            {
                title: "Acceptance",
                href: "#acceptance"
            },
            {
                title: "Payment and Invoices",
                href: "#payment-and-invoices"
            },
            {
                title: "Support Services",
                href: "#support-services"
            },
            {
                title: "Intellectual Property",
                href: "#intellectual-property"
            },
            {
                title: "Termination",
                href: "#termination"
            },
            {
                title: "Consequences of Termination",
                href: "#consequences-of-termination"
            },
            {
                title: "Export Control",
                href: "#export-control"
            },
            {
                title: "Assignment",
                href: "#assignment"
            },
            {
                title: "Limitations of Liability",
                href: "#limitations-of-liability"
            },
            {
                title: "General",
                href: "#general"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "PLEASE READ CAREFULLY BEFORE PROCEEDING WITH CREATING AN ACCOUNT, DOWNLOADING OR INSTALLING THIS SOFTWARE"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "This end-user licence agreement (\u201C",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "EULA"
                                    }),
                                    "\u201D) is a legal agreement between you and Estrella Systems Limited of 4 Wychwood Drive, Milton-Under-Wychwood, Chipping Norton, OX7 6JA, England, (\u201C",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "the Licensor"
                                    }),
                                    "\u201D) for a software application to collate and present data collected in respect of radio frequency devices which form telecommunications networks which facilitate wireless internet access (\u201C",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "the Software"
                                    }),
                                    "\u201D)."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "We licence use of the Software to you on the basis of this EULA. We do not sell the Software. We remain the owners of the Software at all times."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                children: "IMPORTANT NOTICE:"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "By downloading the Software from this website, and/or using the Software, you agree to the terms of this licence, which will legally bind you. The terms of this licence include, in particular, the privacy policy which appears at ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                                href: "/about/privacy-policy",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d3b17ce220e9921d$export$f102e87ccfb079d0), {}),
                                                    "/about/privacy-policy"
                                                ]
                                            }),
                                            " and limitations of liability as set out at clause 14 below."
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "If you do not agree to the terms of this licence, we do not license the Software to you and you must not create an account, download or use the Software and/or terminate the installation process by pressing any key other than \u201CY\u201D."
                                    })
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                    children: "Please print this EULA for and keep it in a safe place for your future reference."
                                })
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "definitions",
                                class: "numbered",
                                children: "Definitions"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "In this Agreement, unless the context otherwise requires, the following expressions have the following meanings:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dl", {
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Degraded"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "operation of the Software is limited to monitoring Access Points up to the Trial Limit"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Access Point"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "an electronic device designed to communicate from a Network Site (1) to  supply wireless internet connectivity to a member of the public, or (2) to or from another Network Site"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Documentation"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "such operating manuals, user instructions, technical literature, online help facilities, and other related materials for aiding the use and application of the Software, made available at the Website from time to time (if any)"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "End Users"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "operator(s) of the Software for the Licensee"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Intellectual Property Rights"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "patents, trade marks, internet domain names, service marks registered designs, database rights, applications for any of the foregoing, and  copyright, design rights, know-how, confidential information, trade and business names and other similar protected rights in any country"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Service Fees"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "licence fees and/or support fees payable by the Licensee as specified in an Order, and from month to month by the invoice of the Licensor"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Licence Key"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "a licence key issued by the Licensor to the Licensee which enables use of a single instance of the Software"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Licensed Materials"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the Software and the Documentation"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "the Licence"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the licence to Use the Software granted pursuant to clause 3"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Licensee Materials"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the Network Data and any other materials owned and/or controlled by the Licensee used in conjunction with the Software"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Minimum Equipment"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the hardware and software prerequisites to use the Software which includes a Linux based server supported by the Software as listed on the Website  , read only access to a MySQL database containing Network Data, and other such requirements listed on the Website, as may be updated from time to time and/or notified to the Licensee in writing from time to time"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Network Site"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "a single physical location comprising of one or more Access Points, whereby such Access Points are owned and/or controlled by the Licensee"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Order"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the order form published at the Website from which the Licensee orders one or more Licences Keys for the Software"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Product Description"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the product description of the Software published at the Website which sets out the functions, facilities and limitations and restrictions of the Software"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Network Data"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "a compatible database owned by the Licensee which stores radio frequency data in a format supported by the Software, which is collected by the Licensee, from  Access Points"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Server"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the Linux based server forming part of the Minimum Equipment"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Software"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the applications computer programs described in the Order in compiled form, and any modified or enhanced versions thereof which may be made available by the Licensor from time to time"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Support Period"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the period during which the Support Services shall be provided determined in accordance with clause 8"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Support Services"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the software support services to be provided by the Licensor pursuant to clause 8"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Term"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "the duration of the Licensee\u2019s permission to Use the Licensed Materials, namely one calendar month"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Trial Limit"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "up to 5 Access Points"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Use"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: "to copy, load and/or execute"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dt", {
                                                        children: "Website"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("dd", {
                                                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                                            href: "/",
                                                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d3b17ce220e9921d$export$f102e87ccfb079d0), {})
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "In this Agreement:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "reference to any statute or statutory provision includes a reference to that statute or statutory provision as from time to time amended extended or re-enacted;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "words importing the singular include the plural, words importing any gender include every gender and words importing persons include bodies corporate and unincorporate; and (in each case) vice versa;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the headings to the Clauses are for ease of reference only and shall not affect the interpretation or construction of this Agreement; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "in the event of an inconsistency or conflict between the terms of the Order and these terms, these terms shall prevail to the extent of the inconsistency or conflict."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "commencement",
                                class: "numbered",
                                children: "Commencement"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "This Agreement shall come into effect on the date that the Licensee first downloads and/or Uses the Software."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "The Licensor hereby:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "licenses the Licensee to Use the Software; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "undertakes to provide the Support Services for the Support Period in respect of the Software,"
                                                    }),
                                                    "upon the terms and conditions set out below and not further or otherwise."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "licence",
                                class: "numbered",
                                children: "Licence"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "This Agreement applies to each Licence Key purchased by the Licensee. You may not Use the Software other than with a Licence Key."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Licence Keys are locked to a single database which contains Network Data."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "A Licence Key entitles the Licensee to Use a single instance the Software:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "on a Server in object code form only;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "for the Term;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "to process the Licensee\u2019s own Network Data; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "for its own internal business purposes and shall not permit any third party to Use the Licensed Materials in any way."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "You shall keep exclusive possession and control of the Software and Licence Keys and shall effect and maintain adequate security measures to safeguard Licence Keys and the Software from access or use by any unauthorised person. Such security measures shall be no less stringent than the measures which the Licensee uses to protect its own confidential information or reasonable measures, whichever is the greater. You are not entitled to disassemble, decompile, reverse-engineer or create derivative works based on the whole or any part of the Software or attempt to do so other than where such actions cannot be prohibited."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "It is a condition of this Agreement that transmission of anonymous usage is enabled by the Licensee such the Licensor receives such data. A failure to permit transmission of such information, statistics and data shall be a repudiatory breach of this Agreement and this Agreement and all licences granted shall terminate automatically. Usage data required:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the name of the Licensee;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "country of operation;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the latitude, longitude of each Network Site;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "number of Network Sites contained in the Network Data;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "number of active Access Points;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "number of daily Bearing users;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "current Bearing version;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "current Powercode\xa9 version."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "licensee-warranties",
                                class: "numbered",
                                children: "Licensee Warranties"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "The Licensee hereby warrants and undertakes to:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "ensure its employees, its clients and any contractors cooperate with the Licensor in relation to the efficient supply of the Support Services and the operation of the Software for the purposes it was designed;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "promptly supply the Licensor with such information, data and documents as it may reasonably request for the proper performance of the Licensee\u2019s obligations under this Agreement, and be responsible for ensuring that such information is true, accurate and complete and not misleading in any material respect;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "take all reasonable steps to facilitate implementation, maintenance, operation of the Software as the Licensor may reasonably require;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "grant the Software only read only access to Network Data;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "ensure End Users comply with any security practices notified by the Licensor in writing from time to time; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "use all reasonable endeavours to prevent any unauthorised access to or use of the Software and, in the event of any such unauthorised access or use, promptly notify the Licensor."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensee acknowledges that the Licensor does not operate or exercise control over the Licensee\u2019s use of the Software. The Licensor does not accept any responsibility for the Licensee\u2019s operation of the Software. The Licensee accepts that it is responsible for its interpretation of the data presented by the Software, makes its own decisions in respect of such data will be interpreted and accepts any and all liability for such decisions."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensee shall implement its own backup regime to safeguard against any loss, corruption or interference with Network Data."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensee warrants that Network Data shall not be actionable or contrary to any rule of law, rules, regulations or laws to which the Software and/or Licensee Materials may be subject."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensee warrants that it has obtained all necessary consents, approvals and licenses for the use of any third-party property forming part of the Licensee Materials and the use of such third-party property will not infringe any Intellectual Property Rights belonging to any third-party or contravene any other law whatsoever."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "In the event of allegations of an infringement of clause 4.4 and/or clause 4.5 above, or if the Licensor reasonably suspects such an infringement has occurred, the Licensor may, giving notice to the Licensee and without liability, suspend availability of the Software pending clarification of such allegations or suspicion, and/or terminate this Agreement and all licence granted hereunder at any time thereafter."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Should the Licensee fail to perform any of its obligations under this Agreement, the Licensor shall not be responsible for any delay, loss, damage, cost increase or other consequence arising from such failure, and the Licensee shall pay for further services as may be required to address the said failure(s) at the rates set out in the then prevailing rate card of the Licensor."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Save as to the name of the contact and contact details of the representative of the Licensee registered on the Website for the purposes of obtaining a Licence, the Licensee will not supply any data relating to living individual to the Licensor. Personal data controlled by the Licensee which may be exchanged by the parties and processed by the Licensor shall be governed by a separate agreement."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "licensor-warranties",
                                class: "numbered",
                                children: "Licensor Warranties"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor warrants to the Licensee that the Software when delivered to the Licensee shall provide the facilities and functions described in the Product Description and the Documentation."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "The Licensee acknowledges that the Software is of such complexity that it may contain defects when delivered and the Licensee agrees that the Licensor\u2019s sole liability and the Licensee\u2019s sole remedy in respect of any defect, decided in the sole discretion of the Licensor, shall be:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "for the Licensor to provide correction of documented program errors which the Licensor\u2019s investigation indicates are caused by a defect in an unaltered version of the Software, and are not due to a defect or deficiency in, or a failure of the equipment upon which the Software is installed or interacts with, or incorrect configuration, operation or deployment of the Software by the Licensee; or"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "a refund of sums paid to the most recent invoice issued by the Licensor."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "All warranties given by the Licensor extend only to the Licensee and are for the Licensee\u2019s benefit only and no other person."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor gives no warranty or statement concerning the Minimum Equipment the Licensee may use in conjunction with the Licensed Materials."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor will not be liable for any loss arising out of or in connection with any failure by the Licensee to keep full and up-to-date security copies of Licensee Materials and the software the Licensee uses, in accordance with best computing practice."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "You will permit the Licensor to check use of the Licensed Materials by the Licensee at all reasonable times and for that purpose and the purpose of verifying the discharge of the Licensee\u2019s obligations and the Licensor shall be entitled to enter the premises to do so. The Licensee consents to the use of electronic devices and means for licence management, protect against infringement and/or abuse of the Licensor\u2019s Intellectual Property Rights and to receive information required to invoice the Licensee."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "acceptance",
                                class: "numbered",
                                children: "Acceptance"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "The Software shall be deemed to be accepted by the Licensee when it has been downloaded, received or installed, whichever is the earlier."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "payment-and-invoices",
                                class: "numbered",
                                children: "Payment and Invoices"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor shall be entitled to invoice the Licensee monthly in advance. There shall be no requirement for the Software to read Network Data in excess of the number of Access Points specified by the Trial Limit in the absence of payment of invoices."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Invoices shall be sent to the then current email address provided by the Licensee during registration."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "The Licensee shall pay the Service Fees invoiced upon request by automated means, to the payment provider nominated by the Licensor, with a valid debit or credit card registered to its account (\u201C",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                                children: "payment details"
                                            }),
                                            "\u201D). Should the payment details lapse or otherwise fail to pay the invoice, the payment will not be drawn and the Services shall be Degraded 3 days after the first attempt to draw payment, and without further notice to the Licensee following notification by email that the payment details have not successfully processed the payment."
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Service Fees are exclusive of Value Added Tax and any other tax duty or levy for which the Licensor is liable, which shall be paid by the Licensee at the rate and in the manner for the time being prescribed by law. All fees shall be payable without deduction or set-off, and shall be calculated in accordance with the Order and payable in US dollars."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor may increase Service Fees and/or any part of the charges or rates at any time by providing 60 days\u2019 written notice to the Licensee of the revised charges. Charges may be increased no more than once per annum during any 12 month period and such increase shall be no more than 10% of the prevailing rate charged."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "If the Licensee fails to pay any amount payable by it under this Agreement by its due date, the Licensee shall pay interest on the overdue amount to the date of actual payment, after, as well as before, judgment, at a rate of 8% per annum above the base rate from time to time of Barclays Bank Plc, and the Licensor may from time to time on 7 days\u2019 notice suspend part, parts or all of the Services while any sums remain outstanding from time to time and thereafter Degrade the services and/or terminate this Agreement upon a further 14 days\u2019 notice given in writing."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "support-services",
                                class: "numbered",
                                children: "Support Services"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Support Services are not available for Software used in conjunction with Licence Keys subject to the Trial Limit."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Support Period shall be the Term."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "Subject to the Licensee\u2019s continued compliance with the terms of this Agreement, the Licensor shall during the Support Period:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: [
                                                            "respond to requests for Support Services submitted to its support service made available at ",
                                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $09f8266e1bb4f56b$export$897b176220633e35), {
                                                                children: "support@brng.net"
                                                            }),
                                                            ";"
                                                        ]
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "use its reasonable endeavours to correct faults in the Software notified by the Licensee;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "provide the Licensee with documentation which the Licensor reasonably considers necessary to use modified, enhanced or replacement versions of or additions to the Software delivered to the Licensee from time to time; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "provide the Licensee with such technical advice by electronic mail only as may be necessary to resolve the Licensee\u2019s difficulties and queries to use the then current version of the Software or refer to the Documentation for resolution by the Licensee."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "You shall:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "use only the current version of the Software made available to the Licensee by the Licensor from time to time to qualify for Support Services;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "ensure that the Software is used on the equipment which meets the specifications  of the Minimum Equipment and use the Software in a proper and lawful manner by competent, suitably skilled and experienced and trained employees only who are experts in interpreting radio frequency data collected by Network Sites;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "notify each software fault to the Licensor as it arises and shall supply the Licensor with a documented example of the fault and any relevant circumstances under which it arose;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "cooperate fully with the Licensor in diagnosing any software fault and promptly supply the Licensor with such information and documents as it may reasonably request;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "make available to the Licensor free of charge all reasonable facilities and services which are required by the Licensor to enable it to provide the Support Services including without limitation memory dumps, telecommunications facilities, remote online access, reports and diagnostic data; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "not request permit or authorise anyone other than the Licensor to provide any support services in respect of the Software."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "The Support Services do not include:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "installation, customisation, programming, consulting and/or training;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "services to rectify a fault which cannot be reproduced by the Licensor;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "faults arising from modifications or alterations to the Software;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "faults which occur in environments which do not comply with the Minimum Equipment requirements or use of the latest version of the Software;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "attendance to faults caused by using the Software otherwise than where a material inconsistency exists with its stated functionality in the Product Description or Documentation;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "recovery or reconstruction of the Licensee\u2019s electronic data or records, corrupted or lost as a result of any fault in the Software or any other reason;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "support or maintenance of software accessories, peripheral devices, computer hardware systems, operating systems, databases, network connectivity, database connectivity, or any device and/or other software supplied by the Licensor;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "rectification of defects if the structure of the Network Data is changed after initial configuration. An End User may attempt to reinstall the Software;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "diagnosis or rectification of problems not attributable to the Software; or"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "loss or damage caused directly or indirectly by operator error or omission, "
                                                    })
                                                ]
                                            }),
                                            "and any service which is provided by the Licensor as a result of any of the foregoing shall be subject to additional charges at the Licensor\u2019s standard rates in accordance with its then prevailing rate card and charged in accordance with this Agreement."
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor does not warrant that Support Services will obtain the result requested or any particular result."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "No refund of any part of support charges shall be made on the termination of the licence to use the Software."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "No support services shall be provided while the Licensee is in default of any payment obligations or in breach of any term of this Agreement."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "intellectual-property",
                                class: "numbered",
                                children: "Intellectual Property"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensee acknowledges and agrees that any Intellectual Property Rights in the Licensed Materials and any subsequent modifications to them shall be and remain vested at a times in the Licensor and its third party licensors."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Subject to the terms of this Agreement, the Licensee grants to the Licensor during the term a non-exclusive, non-transferable and non-assignable royalty-free licence to use the Licensee Materials to supply the Support Services."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "If the Licensee shall suspect or become aware of any infringement of the Software, the Licensee shall promptly give written notice to the Licensor, and give such assistance to the Licensor in relation to such claim or action without charge."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensee shall indemnify the Licensor against any claims, proceedings, losses, liabilities, damages (including reasonable costs), charges and expenses of whatever nature arising out of or in connection with any claim or action relating to an infringement of any Intellectual Property Rights forming part of the Licensee Materials."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "termination",
                                class: "numbered",
                                children: "Termination"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "Either party may terminate this Agreement and/or all licences granted if:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the other party is in material breach of this Agreement;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the other party ceases to conduct business in the normal course, becomes subject to a voluntary arrangement under Section 1 of the Insolvency Act 1986, becomes unable to pay its debts within the meaning of Section 123 of the Insolvency Act 1986, has a receiver, manager, administrator or administrative receiver appointed over all or any part of its undertaking, assets or income, passes a resolution for its winding up (other than for the purpose of a bona fide reconstruction) or has a petition presented to any court for its winding up or for any administration order;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the other party commences negotiations with all or any class of its creditors with a view to rescheduling any of its debts, or makes a proposal for or enters into any compromise or arrangement with its creditors other than for the sole purpose of a scheme for a solvent amalgamation of that other party with one or more other companies or the solvent reconstruction of that other party;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the other party enters into any composition or arrangement (whether formal or informal) with its creditors, or"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "any event occurs, or proceeding is taken, with respect to the other party in any jurisdiction to which it is subject that has an effect equivalent or similar to any of the events mentioned in clause 10(a) to clause 10(d) (inclusive)."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor may terminate unpaid licences at any time without notice."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor may terminate this Agreement if it (1) ceases to continue to trade or maintain the Software, and/or (2) upon 60 days\u2019 in writing if it ceases to offer Support Services."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "consequences-of-termination",
                                class: "numbered",
                                children: "Consequences of Termination"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "Upon the expiry or termination of this Agreement for whatever reason:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "all licences granted hereunder shall terminate;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the Licensee shall cease using the Software forthwith and shall require its personnel to do likewise; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "the Licensee shall pay all sums due and payable to the Licensor immediately."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The rights and remedies provided under this Agreement are in addition to, and not exclusive of, any rights or remedies provided by law."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "export-control",
                                class: "numbered",
                                children: "Export Control"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "Neither party shall export, directly or indirectly, any technical data or information acquired from the other party under this Agreement (or any products, including software, incorporating any such data) in breach of any applicable laws or regulations, including the Export Control Act and United States export laws and regulations, to any country for which the government or any agency thereof at the time of export requires an export licence or other governmental approval without first obtaining such licence or approval."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "assignment",
                                class: "numbered",
                                children: "Assignment"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "This Agreement is personal to the Licensee and the Licensee shall not assign sublicense or otherwise transfer any part of Agreement or any of its rights or obligations hereunder whether in whole or in part without the prior written consent of the Licensor. The Licensor shall be entitled to assign and/or novate any part of this Agreement to any third party in its sole discretion."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "limitations-of-liability",
                                class: "numbered",
                                children: "Limitations of Liability"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "The following provisions set out the entire financial liability of the Parties including without limitation any liability for the acts or omissions of its employees, agents and sub-contractors in respect of:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "any breach of this Agreement howsoever arising; and"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "any use made by the Licensee of the Software and/or web application or any part of them;"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "any representation, misrepresentation (whether innocent or negligent), statement or tortious act or omission (including without limitation negligence) arising under or in connection with this Agreement."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Nothing in this clause 14 shall limit either Party's liability for death or personal injury resulting from negligence or for fraud, fraudulent misstatement or fraudulent misrepresentation under this Agreement."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Except as expressly provided in this Agreement (a) the Services are provided on an \u201Cas is\u201D basis, (b) the Licensee assumes responsibility for the results of use of the Software and for the conclusions drawn from such use, and (c) all warranties, conditions and other terms implied by statute or common law are to the fullest extent permitted by law are excluded."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: [
                                            "Neither Party shall be liable, (in contract, tort (including negligence) or for breach of statutory duty or in any other way) for:",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                                type: "a",
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "any loss of goodwill or reputation; or"
                                                    }),
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                        children: "any special, indirect or consequential loss,"
                                                    })
                                                ]
                                            }),
                                            "suffered or incurred by the other party arising out of or in connection with the use or provision of the Software or Support Services, or any other matter under this Agreement."
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The aggregate liability of the Licensor in respect of any loss or damage suffered by the Licensee and arising out of or in connection with this Agreement, whether in contract, tort (including negligence) or for breach of statutory duty or in any other way, shall not exceed the sum paid by the Licensee to the Licensor during the 12 month period before the events giving rise to the loss or damage."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The total aggregate liability of the Licensor in respect of any loss or damage suffered by the Licensee and arising out or in connection with this Agreement, whether in contract, tort (including negligence) or for breach of statutory duty shall be limited to the value of the services supplied by the Licensor and paid by the Licensee under this Agreement in the month preceding the date on which each the claim arose or \xa35,000, whichever is the lesser sum."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The provisions of this clause 14 shall continue to apply notwithstanding the termination or expiry of this Agreement for any reason or cause."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Notwithstanding anything else contained in this Agreement the Licensor shall not be liable to the Licensee for loss (whether direct or indirect) of profits, business or anticipated savings or for any indirect or consequential loss or damage whatsoever even if the Licensor shall have been advised of the possibility thereof and whether arising from tort (including negligence), breach of contract, breach of statutory duty, or otherwise howsoever."
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "general",
                                class: "numbered",
                                children: "General"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                class: "numbered",
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "This Agreement supersedes all prior agreements, arrangements and understandings between the parties in respect of the Software and the Documentation and constitutes the entire understanding between the parties concerning the subject matter of this Agreement (save that neither party seeks to exclude liability for any fraudulent pre-contractual misrepresentations on which the other party has relied.  Purchase orders issued by or on behalf of the Licensee shall be deemed to be for its administrative convenience only and not shall form part of or vary this Agreement. In the absence of the Licensee\u2019s agreement to this Agreement, the Licensee are not entitled to Use the Software."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensee warrants to the Licensor that by entering into this Agreement it has not relied on any warranty representation or undertaking save as expressly set out in this Agreement. No waiver or amendment of any provision of this Agreement shall be effective unless made by a written instrument signed by both parties."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "No forbearance, delay or indulgence by either party in enforcing the provisions of this Agreement shall prejudice or restrict the rights of that party nor shall any waiver of its rights operate as a waiver of any subsequent breach and no right power or remedy herein conferred upon or reserved for either party is exclusive of any other right power or remedy available to that party and each such right power or remedy shall be cumulative."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "All notices which are required to be given hereunder shall be in writing and shall be sent to the email address used to place the Order, last known email address of the party or such other address in England as the recipient may designate. Any such notice may be delivered personally or by first class pre-paid letter or facsimile transmission and shall be deemed to have been served if by hand when delivered if by first class post 48 hours after posting and if by email when dispatched."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Licensor shall be entitled to engage the services of subcontractors or agents to perform any of its obligations hereunder."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "This Agreement is subject to the special conditions (if any) contained in the Order hereto. In the event of any inconsistency between such special conditions and the other terms of this Agreement such special conditions shall prevail."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "The Contracts (Rights of Third Parties) Act 1999 shall not apply to this Agreement."
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "This Agreement shall be governed by and construed in accordance with the laws of England. The parties irrevocably submit to the exclusive jurisdiction of the Courts of England in respect contractual and non-contractual claims in each case."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
        previous: {
            title: "Terms of Use",
            path: "terms-of-use"
        }
    }
];
const $c2ac93080ed1b35b$export$7850f4d545d994c6 = [
    {
        title: "What is Bearing?",
        order: "0",
        path: "what-is-bearing",
        sections: [
            {
                title: "Frequency Management software for WISPs",
                href: "#frequency-management-software-for-wisps"
            },
            {
                title: "You don\u2019t just want to look at a map...",
                href: "#you-dont-just-want-to-look-at-a-map"
            },
            {
                title: "Out and about",
                href: "#out-and-about"
            },
            {
                title: "Free to get started",
                href: "#free-to-get-started"
            },
            {
                title: "You are in control",
                href: "#you-are-in-control"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "frequency-management-software-for-wisps",
                                children: "Frequency Management software for WISPs"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    "\xa0gives you insight into the configuration of your wireless network by making use of your existing data."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "You already have a map of your existing infrastructure, but\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    "\xa0overlays the frequencies and sectors of your equipment."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b28df34a50ba569b$exports))),
                                alt: "Map showing frequency overlay of network sites"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "Now you can see exactly what is going on in each frequency band. Positioning, coverage, frequency overlap issues..."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "you-dont-just-want-to-look-at-a-map",
                                children: "You don\u2019t just want to look at a map..."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6b8ff4a71ca79a7a$exports))),
                                alt: "Blurred dashboard with overview pulled forward"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    "\xa0shows you an overview of your network and lists any potential issues. The dashboard displays a breakdown of issues for each network site."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "You can take a look at each site and plan frequency use for your next access point / backhaul or figure out how to fix any issues raised."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($97a65455a0f6c19f$exports))),
                                alt: "Site spectrum and sector view"
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "out-and-about",
                                children: "Out and about"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "If you have ever found yourself up a tower aligning radios wishing you had a better landmark to aim for then this might help. Grab your phone and hunt for a better landmark using the site map."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7a360300fda1d057$exports))),
                                alt: "Checking for landmarks whilst on the move"
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "free-to-get-started",
                                children: "Free to get started"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Sign up for\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    "\xa0and you can use it for 3 months free. The 3 months doesn't start until you get\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    "\xa0up and running for the first time."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "After the first 3 months, if you like it, you can add payment details. You will be billed monthly in advance with no fixed contract giving you the option to cancel at any time."
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "If you decide you don't want to pay you can still use\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    "\xa0but you will be limited to your busiest 5 sites with the option to upgrade at any time."
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "you-are-in-control",
                                children: "You are in control"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " runs as a service installed on your own infrastructure. Beyond the minimum of information required for billing and service delivery / improvement you have complete control of your data and peace of mind that your customer data is not going anywhere."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "We have worked to make installing\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    "\xa0as easy as possible and we are continuing to work on providing new features all the time."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "We listen to our customers and strive deliver the tools you need to make your job easier. Frequency management is never going to be simple but we think we can help make it better."
                            })
                        ]
                    })
                ]
            }),
        next: {
            title: "Getting Started",
            path: "getting-started"
        }
    },
    {
        title: "Getting Started",
        order: "10",
        path: "getting-started",
        sections: [
            {
                title: "Requirements",
                href: "#requirements"
            },
            {
                title: "Installing Bearing",
                href: "#installing-bearing"
            },
            {
                title: "Next steps",
                href: "#next-steps"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "requirements",
                                children: "Requirements"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                children: "License Key"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "You will need a license key to install ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    ". To get a license key granting a free trial please signup ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                        href: "/signup",
                                        children: "here"
                                    }),
                                    ". You can upgrade to a full license at any point after installation by logging into your account."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                children: "Deployed on site"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " is deployed in your infrastructure, so you will need a linux server to install. ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " runs on x64 and makes use of systemd. We have tested on CentOS 8 and Ubuntu 20.04 & 18.04."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                children: "Integration"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " integrates with existing WISP management software (currently only Powercode\xa9 is supported) and requires Custom Reports permission on your Powercode\xa9 Portal. During installation, you will be prompted for connection details."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                children: "Licensing"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Internet access is required to manage billing and validate your license. The following information is sent to ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d3b17ce220e9921d$export$f102e87ccfb079d0), {}),
                                    ":"
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Company name"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Location of your company"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Area of operations (lat/lng of network sites)"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Number of Sites and RF devices in use"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Number of daily Bearing users"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Current Bearing version"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        children: "Current Powercode\xa9 version"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "installing-bearing",
                                children: "Installing Bearing"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Given the requirements above have been met, it\u2019s time to install and configure ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    ". If you log in we will populate your license key for you. From the command line of the server you would like to install ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " on run the following:"
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $99d1b3b5938d0885$export$e5ff2bc79de811b1), {
                                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("pre", {
                                    children: [
                                        "curl -sL ",
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d3b17ce220e9921d$export$f102e87ccfb079d0), {}),
                                        "/installer.sh?licenseKey=",
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $87020856e0aefa76$export$de97268a0e565029), {}),
                                        " -o bearing.sh && chmod u+x bearing.sh",
                                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {}),
                                        "sudo ./bearing.sh"
                                    ]
                                })
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " will install and start as a service."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                class: "highlight",
                                children: [
                                    "The post-installation message explains how to access ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " to complete installation."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "You can run:"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("pre", {
                                children: "sudo ./bearing.sh --help"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "To see more options."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "next-steps",
                                children: "Next steps"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        children: "Reverse proxy"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "After installation ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                                children: "Bearing"
                                            }),
                                            " runs on a non-standard port without SSL. In order to access ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                                children: "Bearing"
                                            }),
                                            " securely you should configure a reverse proxy such as nginx and acquire an SSL certificate. You should only access ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                                children: "Bearing"
                                            }),
                                            " using\xa0",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                                children: "https"
                                            }),
                                            "."
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "For information on configuring nginx with\xa0",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                                children: "https"
                                            }),
                                            "\xa0using ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8143b26344ce82ab$export$b2bf131c9f9cce5d), {
                                                href: "https://letsencrypt.org/",
                                                children: "Let's Encrypt"
                                            }),
                                            " we recommend the excellent tutorials by Digital Ocean ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $8143b26344ce82ab$export$b2bf131c9f9cce5d), {
                                                href: "https://www.digitalocean.com/community/tutorials/how-to-secure-nginx-with-let-s-encrypt-on-centos-8",
                                                children: "here"
                                            }),
                                            "."
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "Once you have your certificate installed and working you will need update your server block to forward to ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                                children: "Bearing"
                                            }),
                                            " similar to:"
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("pre", {
                                        children: [
                                            "server_name <yourdomain.net> <www.yourdomain.net>;",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {}),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {}),
                                            "location / ",
                                            "{",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {}),
                                            "\xa0\xa0\xa0\xa0proxy_pass http://127.0.0.1:4440;",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {}),
                                            "}",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("br", {})
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h3", {
                                        children: "Firewall"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: [
                                            "Your ",
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                                children: "Bearing"
                                            }),
                                            " server now looks like a regular web server, and you should lock down the firewall accordingly."
                                        ]
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                        children: "We recommend that you only allow inbound traffic on ports:"
                                    }),
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ul", {
                                        children: [
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                                        children: "80 (http)"
                                                    }),
                                                    " for Let's Encrypt certificate renewal"
                                                ]
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                                        children: "443 (https)"
                                                    }),
                                                    " for ",
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                                        children: "Bearing"
                                                    }),
                                                    " access"
                                                ]
                                            }),
                                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                                children: [
                                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                                        children: "22 (ssh)"
                                                    }),
                                                    " for server management (restricted to within the DMZ or by IP ranges)."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
        previous: {
            title: "What is Bearing?",
            path: "what-is-bearing"
        },
        next: {
            title: "Gathering Data",
            path: "gathering-data"
        }
    },
    {
        title: "Gathering Data",
        order: "20",
        path: "gathering-data",
        sections: [
            {
                title: "Nothing to see here",
                href: "#nothing-to-see-here"
            },
            {
                title: "Built in SNMP",
                href: "#built-in-snmp"
            },
            {
                title: "Frequency Band",
                href: "#frequency-band"
            },
            {
                title: "Frequency",
                href: "#frequency"
            },
            {
                title: "Channel Width",
                href: "#channel-width"
            },
            {
                title: "Azimuth (Access Points)",
                href: "#azimuth-access-points"
            },
            {
                title: "Azimuth (Backhaul)",
                href: "#azimuth-backhaul"
            },
            {
                title: "Sector Size",
                href: "#sector-size"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "nothing-to-see-here",
                                children: "Nothing to see here"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " is all about data. Specifically ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("strong", {
                                        children: "your"
                                    }),
                                    " data. Chances are that, after setting everything up, you have been able to login but you are seeing a lot of messages about missing data."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "The good news is that it should be pretty straight forward filling in the gaps. ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " provides a FAQ page which is linked by the ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "?"
                                    }),
                                    " in the missing data alerts."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "Currently we only integrate with Powercode\xa9 so all the information below relates to configuring data on your Powercode\xa9 portal."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "built-in-snmp",
                                children: "Built in SNMP"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " has built in SNMP polling to get data direct from your devices. This allows us to bypass Powercode\xa9's limitation of only using\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "STRING"
                                    }),
                                    "\xa0values."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Admin users can enable / disable SNMP polling in settings. The connection details are gathered from Powercode\xa9 so should be setup automatically. ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " should complete a first pass, identifying as many of your devices as possible within 30 minutes. If all of your devices are successfully identified then there is no need to add any SNMP probes to Powercode\xa9 manually."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($9f748bc8f8249f2c$exports))),
                                alt: "SNMP results for inventory"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "You can easily submit information to us (preferably with a MIB) for any devices that we don't recognise. We will add them to our database as quickly as possible. You can also add SNMP probes to Powercode\xa9 if you want to get up and running straight away."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "frequency-band",
                                children: "Frequency Band"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Only required if ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " SNMP is disabled or device could not be identified."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "By default ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " uses the value specified in\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Edit Equipment -> Equipment Specifics -> Frequency"
                                    }),
                                    "\xa0to populate this value."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: "If this value is not specified but the frequency SNMP is in place then frequency band is derived from the device frequency."
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "frequency",
                                children: "Frequency"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Only required if ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " SNMP is disabled or device could not be identified."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Current device frequency should be obtained using SNMP configured in Powercode under\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Equipment -> Probes"
                                    }),
                                    "."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "To correctly retrieve probe information ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " matches against the probe name. For Frequency the probe name should match\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "*Center Frequency*"
                                    }),
                                    ", for example:\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Ubiquiti 5.6 AP/SM - Center Frequency"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "channel-width",
                                children: "Channel Width"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Only required if ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " SNMP is disabled or device could not be identified."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Current device channel width should be obtained using SNMP configured in Powercode under\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Equipment -> Probes"
                                    }),
                                    "."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "To correctly retrieve probe information ",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " matches against the probe name. For Channel Width the probe name should match\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "*Channel Width*"
                                    }),
                                    ", for example:\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Ubiquiti 5.6 AP/SM - Channel Width"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "azimuth-access-points",
                                children: "Azimuth (Access Points)"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " uses the value specified in\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Edit Equipment -> Equipment Specifics -> Azimuth"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "azimuth-backhaul",
                                children: "Azimuth (Backhaul)"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Azimuth for backhaul devices is calculated based on the device relationships. When a backhaul pair is identified the azimuth is then calculated based on the\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Network Site -> Address -> Latitude/Longitude"
                                    }),
                                    "."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "Device pairs should be discovered using SNMP but will fall pack to\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Equpiment -> Parent/Child"
                                    }),
                                    "\xa0relationships in Powercode\xa9 if necessary."
                                ]
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "sector-size",
                                children: "Sector Size"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                        children: "Bearing"
                                    }),
                                    " uses the value specified in\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Edit Equipment -> Equipment Specifics -> Sector Size"
                                    }),
                                    "\xa0and\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Edit Equipment -> Equipment Specifics -> Custom Sector Size"
                                    }),
                                    "."
                                ]
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                                children: [
                                    "This only applies to\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("code", {
                                        children: "Antenna Type: Sector"
                                    }),
                                    ", omnidirectional antennas are represented as such."
                                ]
                            })
                        ]
                    })
                ]
            }),
        previous: {
            title: "Getting Started",
            path: "getting-started"
        },
        next: {
            title: "Updating Bearing",
            path: "updating-bearing"
        }
    },
    {
        title: "Updating Bearing",
        order: "30",
        path: "updating-bearing",
        sections: [
            {
                title: "Release Notes",
                href: "#release-notes"
            }
        ],
        content: ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            "To update ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                                children: "Bearing"
                            }),
                            " to the latest version, run:",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("pre", {
                                children: "sudo ./bearing.sh"
                            })
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("h2", {
                                id: "release-notes",
                                children: "Release Notes"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $646e054fc15adb54$export$54bb0dd98911e9d1), {})
                        ]
                    })
                ]
            }),
        previous: {
            title: "Gathering Data",
            path: "gathering-data"
        }
    }
];



var $VqyUd = parcelRequire("VqyUd");


var $f6LVE = parcelRequire("f6LVE");





const $0ea743bbe1f98944$export$5f2187b0913c1307 = ({ className: className, sidebar: sidebar, children: children })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("sidebar-template", className),
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "sidebar-template__sidebar",
                children: sidebar
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "sidebar-template__main",
                children: children
            })
        ]
    });
};




const $76acc8a3ee8a8ea2$var$scrollToHash = (smooth)=>{
    const id = window.location.hash.replace("#", "");
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    window.scrollTo({
        top: el.offsetTop - 64,
        behavior: smooth ? "smooth" : "auto"
    });
};
const $76acc8a3ee8a8ea2$var$DocumentationNav = ({ documentation: documentation, basePath: basePath, currentPath: currentPath })=>{
    const handleSectionClick = (0, $f6LVE.useCallback)(()=>{
        setTimeout(()=>$76acc8a3ee8a8ea2$var$scrollToHash(true));
    }, []);
    (0, $f6LVE.useEffect)(()=>{
        $76acc8a3ee8a8ea2$var$scrollToHash(false);
        const handleHashChange = ()=>{
            $76acc8a3ee8a8ea2$var$scrollToHash(false);
        };
        window.addEventListener("hashchange", handleHashChange);
        return ()=>{
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);
    (0, $f6LVE.useEffect)(()=>{
        window.scrollTo({
            top: 0
        });
    }, [
        currentPath
    ]);
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("nav", {
        className: "documentation-page__nav",
        children: documentation.map((doc)=>{
            const active = doc.path === currentPath;
            const uri = basePath + doc.path;
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("section", {
                className: "documentation-page__nav-section",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ebf396bdcb3f9ccf$exports)))("documentation-page__doc-link", {
                            "documentation-page__doc-link--active": active
                        }),
                        href: active ? undefined : uri,
                        children: doc.title
                    }),
                    active && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {}),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("ol", {
                                children: doc.sections.map((section)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("li", {
                                        className: "documentation-page__section-link",
                                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                            href: uri + section.href,
                                            onClick: handleSectionClick,
                                            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                                                children: section.title
                                            })
                                        })
                                    }, section.href))
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $35cc81e749a21589$export$2e0a83ec2e27ecbb), {})
                        ]
                    })
                ]
            }, doc.path);
        })
    });
};
const $76acc8a3ee8a8ea2$var$DocumentationPageContent = ({ currentPath: currentPath, documentation: documentation })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $VqyUd.Fragment), {
        children: documentation.map((doc)=>{
            if (doc.path !== currentPath) return null;
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                width: "md",
                className: "documentation-page__content copy",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$a8a3e93435678ff9), {
                        level: 1,
                        children: doc.title
                    }),
                    doc.content()
                ]
            }, doc.path);
        })
    });
};
const $76acc8a3ee8a8ea2$export$c02fd77fbe89d29f = (props)=>{
    const large = (0, $2f867275e97da052$export$199d6754bdf4e1e3)("md");
    if (!props.currentPath) {
        (0, $378f8733f7648194$export$4cb887bfde2d34ca)(props.basePath + props.documentation[0].path, true);
        return null;
    }
    if (large) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $0ea743bbe1f98944$export$5f2187b0913c1307), {
        className: "documentation-page",
        sidebar: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($76acc8a3ee8a8ea2$var$DocumentationNav, {
            ...props
        }),
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($76acc8a3ee8a8ea2$var$DocumentationPageContent, {
            ...props
        })
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
        className: "mobile-documentation-page",
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $768e8713fc5fc14b$export$7c6e2c02157bb7d2), {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($76acc8a3ee8a8ea2$var$DocumentationNav, {
                    ...props
                })
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($76acc8a3ee8a8ea2$var$DocumentationPageContent, {
                ...props
            })
        ]
    });
};




const $688f2f80ecd07521$export$6eb6383d61cb217 = ({ matches: matches })=>{
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $76acc8a3ee8a8ea2$export$c02fd77fbe89d29f), {
        documentation: (0, $c2ac93080ed1b35b$export$e86d578d3f4f42b6),
        currentPath: matches === null || matches === void 0 ? void 0 : matches.subPath,
        basePath: "/about/"
    });
};
const $688f2f80ecd07521$export$e7e6be814875dfe1 = ({ matches: matches })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $76acc8a3ee8a8ea2$export$c02fd77fbe89d29f), {
        documentation: (0, $c2ac93080ed1b35b$export$7850f4d545d994c6),
        currentPath: matches === null || matches === void 0 ? void 0 : matches.subPath,
        basePath: "/documentation/"
    });








const $1ddcaf0d4529d113$export$f8271819da77d398 = ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2400f212855531b5$export$55d0362933af7d75), {
        title: "License",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
            className: "copy",
            children: [
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                    children: [
                        "This is your license key. You will need it to activate your ",
                        (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                            children: "Bearing"
                        }),
                        " installation."
                    ]
                }),
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $99d1b3b5938d0885$export$e5ff2bc79de811b1), {
                    children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        tag: "pre",
                        size: "lg",
                        align: "center",
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $87020856e0aefa76$export$de97268a0e565029), {})
                    })
                })
            ]
        })
    });


const $b83df14fca0e89f2$export$1ad5e2dbff93dd0c = (_)=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $1ddcaf0d4529d113$export$f8271819da77d398), {});






var $f6LVE = parcelRequire("f6LVE");







const $d5f43a793d97d25d$var$DESCRIPTION_ID = "resetDescription";
const $d5f43a793d97d25d$var$InitPasswordReset = ()=>{
    const authController = (0, $f57fa0ee256b0db7$export$2ddc77f16875382c)();
    const [email, setEmail] = (0, $f6LVE.useState)("");
    const [working, setWorking] = (0, $f6LVE.useState)(false);
    const [submitted, setSubmitted] = (0, $f6LVE.useState)(false);
    const emailInputRef = (0, $f6LVE.useRef)(null);
    (0, $57ef02025d2ad4a3$export$a9c05560d717b4fe)(emailInputRef);
    const handleSubmit = ()=>{
        setWorking(true);
        return authController.requestPasswordReset({
            email: email
        }).then(()=>{
            setSubmitted(true);
        }).finally(()=>{
            setWorking(false);
        });
    };
    if (submitted) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
        size: "lg",
        severity: "success",
        message: "Password reset email sent.",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $51a49da4e18e6ef6$export$a4360a83c01036a3), {
            resendEmail: handleSubmit
        })
    });
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$a7fed597f4b8afd8), {
        onSubmit: handleSubmit,
        submitLabel: "Request Password Reset",
        disabled: working,
        header: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
            id: $d5f43a793d97d25d$var$DESCRIPTION_ID,
            tag: "p",
            children: [
                "Enter the email you use to log in to ",
                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$95aa4184327d6b72), {
                    children: "brng.net"
                }),
                ", and we will send instructions on how to reset your password."
            ]
        }),
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$56e87bf42978147a), {
            id: "resetEmailAddress",
            label: "Email Address",
            input: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a1491f88e20bcdd$export$f5b8910cec6cf069), {
                ref: emailInputRef,
                value: email,
                onValueChange: setEmail,
                "aria-describedby": $d5f43a793d97d25d$var$DESCRIPTION_ID,
                autoComplete: "email",
                disabled: working,
                required: true
            })
        })
    });
};
const $d5f43a793d97d25d$var$PasswordResetForm = ({ onSubmit: onSubmit })=>{
    const [password, setPassword] = (0, $f6LVE.useState)("");
    const [confirm, setConfirm] = (0, $f6LVE.useState)("");
    const [working, setWorking] = (0, $f6LVE.useState)(false);
    const passwordInputRef = (0, $f6LVE.useRef)(null);
    (0, $57ef02025d2ad4a3$export$a9c05560d717b4fe)(passwordInputRef);
    const handleSubmit = ()=>{
        setWorking(true);
        onSubmit(password).finally(()=>setWorking(false));
    };
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c20181e0c06eda6d$export$a7fed597f4b8afd8), {
        submitLabel: "Reset Password",
        onSubmit: handleSubmit,
        disabled: working,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                children: "Set your new password."
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $3a4c3e1810594c8c$export$11620c714ec70a76), {
                id: "resetPassword",
                passwordInputRef: passwordInputRef,
                value: password,
                onValueChange: setPassword,
                confirmValue: confirm,
                onConfirmValueChange: setConfirm,
                disabled: working
            })
        ]
    });
};
const $d5f43a793d97d25d$var$ApplyPasswordReset = ({ code: code })=>{
    const authController = (0, $f57fa0ee256b0db7$export$2ddc77f16875382c)();
    const [status, setStatus] = (0, $f6LVE.useState)("init");
    (0, $f6LVE.useEffect)(()=>{
        if (status !== "init") return;
        setStatus("checking-code");
        authController.checkPasswordResetCode(code).then((result)=>{
            setStatus(result ? "valid-code" : "bad-code");
        });
    }, [
        authController,
        code,
        status
    ]);
    const handleSubmit = (password)=>authController.resetPassword(code, password).then((result)=>{
            switch(result){
                case "ok":
                    setStatus("success");
                    return;
                case "bad-code":
                    setStatus("bad-code");
                    return;
            }
        });
    switch(status){
        case "init":
        case "checking-code":
            return null;
        case "bad-code":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "copy",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                        severity: "error",
                        message: "Invalid link",
                        size: "lg"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "Sorry, that link has expired, or is invalid. Double check the email, or ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                href: "/reset-password",
                                children: "try again"
                            }),
                            "."
                        ]
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: [
                            "If you are having trouble resetting your password, please ",
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $09f8266e1bb4f56b$export$897b176220633e35), {
                                children: "contact support"
                            }),
                            "."
                        ]
                    })
                ]
            });
        case "valid-code":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($d5f43a793d97d25d$var$PasswordResetForm, {
                onSubmit: handleSubmit
            });
        case "success":
            return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "copy",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $cc5b2cce57e60c51$export$caec2af78bcc877f), {
                        severity: "success",
                        message: "Password reset"
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("p", {
                        children: "You may now log in."
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $9a49b1b99f213b79$export$1f58f750f20f344b), {
                        onLogIn: ()=>(0, $378f8733f7648194$export$4cb887bfde2d34ca)("/")
                    })
                ]
            });
    }
};
const $d5f43a793d97d25d$export$b44239f84c8f0268 = ({ code: code })=>{
    if (!code) return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($d5f43a793d97d25d$var$InitPasswordReset, {});
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)($d5f43a793d97d25d$var$ApplyPasswordReset, {
        code: code
    });
};



const $c0f51ac09373f97f$export$2f71862eb326e04c = ({ code: code })=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $a41f9ec2cca4e1a7$export$c9e27277d624b1c6), {
        title: "Reset Password",
        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $d5f43a793d97d25d$export$b44239f84c8f0268), {
            code: code
        })
    });



const $ed3b14b8807e6f40$export$86fbec116b87613f = ()=>{
    const errorController = (0, $f57fa0ee256b0db7$export$e602918cb3d99338)();
    (0, $8ea62fef91697031$exports.useSubject)(errorController, "error");
    const routeController = (0, $a53afc0516d42e77$export$fe4300aa8eebea86)(()=>new (0, $19817f615e72c7b6$exports.RouteController)());
    return (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $19817f615e72c7b6$exports.RouteControllerProvider), {
        value: routeController,
        children: [
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                className: "app surface theme-page",
                children: [
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $5ba975c94b4f5d10$export$ef8da11641c635de), {
                        className: "app__head"
                    }),
                    errorController.error && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("main", {
                        className: "app__main",
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c889eb46d93c15cd$export$c120a0e80fd44ca6), {})
                    }),
                    !errorController.error && (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("main", {
                        className: "app__main",
                        children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $378f8733f7648194$export$55185c17a0fcbe46), {
                            onChange: routeController.handleRouteChange,
                            children: [
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $30aaa9e76d563dc4$export$48d3d184aade51b1), {
                                    path: "/"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $b83df14fca0e89f2$export$1ad5e2dbff93dd0c), {
                                    path: "/license"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $28aedfb5278e02bb$export$a65ae8806155c633), {
                                    path: "/account"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $840bbb50842d2fa5$export$9b947e07cda3a91e), {
                                    path: "/billing"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f85626ba5d17224a$export$19bc9862cf8dc8fa), {
                                    path: "/billing/checkout-complete"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $2500b180fe7d2c85$export$6201b7194fef3ca3), {
                                    path: "/billing/cancel"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $af7c1fd3414d19be$export$b4461a4f6a14f942), {
                                    path: "/login"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $32ccc1b3fab5fe66$export$d6275cbf70a375ba), {
                                    path: "/signup"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $fdd3f71fcd90df48$export$91620953951fa2ae), {
                                    path: "/verify-email/:code"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c0f51ac09373f97f$export$2f71862eb326e04c), {
                                    path: "/reset-password/:code?"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $688f2f80ecd07521$export$6eb6383d61cb217), {
                                    path: "/about/:subPath?"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $688f2f80ecd07521$export$e7e6be814875dfe1), {
                                    path: "/documentation/:subPath?"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $18e3945fd1ae2a95$export$4465eb1b2d3858c8), {
                                    path: "/admin"
                                }),
                                (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $c1366b2994c00864$export$44904eddc13a0885), {
                                    path: "/admin/users/:userId"
                                })
                            ]
                        })
                    }),
                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $7b33dd34c0380449$export$1c6175f3aa4394b7), {
                        tag: "footer",
                        className: "app__foot stack--sm",
                        align: "center",
                        children: [
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                                children: "\xa9Estrella Systems Ltd"
                            }),
                            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("div", {
                                children: [
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                        class: "pad-r-md",
                                        href: "/about/privacy-policy",
                                        children: "Privacy Policy"
                                    }),
                                    "\xa0\xa0|\xa0\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                        class: "pad-l-md pad-r-md",
                                        href: "/about/terms-of-use",
                                        children: "Terms of Use"
                                    }),
                                    "\xa0\xa0|\xa0\xa0",
                                    (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)("a", {
                                        class: "pad-l-md",
                                        href: "/about/cookie-policy",
                                        children: "Cookie Policy"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $6142a1799cf62515$export$87ca8365be30c898), {})
        ]
    });
};






(0, (/*@__PURE__*/$parcel$interopDefault($de58f1ac2263029a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($f156be45b5981189$exports))));
window.addEventListener("load", async ()=>{
    const globalControllers = (0, $f57fa0ee256b0db7$export$bc06f20cebe0309b)();
    await globalControllers.accountController.refreshDetails();
    const rootEl = document.getElementById("root");
    if (!rootEl) throw new Error("Missing #root.");
    const Root = ()=>(0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f57fa0ee256b0db7$export$dc4621b70519de6a), {
            controllers: globalControllers,
            children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $f2b6ead6de480949$export$e926676385687eaf), {
                children: (0, $5e197c2ea48466dd$export$34b9dba7ce09269b)((0, $ed3b14b8807e6f40$export$86fbec116b87613f), {})
            })
        });
    (0, $VqyUd.render)((0, $5e197c2ea48466dd$export$34b9dba7ce09269b)(Root, {}), rootEl);
});


//# sourceMappingURL=index.da7bd950.js.map
